
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j1gOA", function(module, exports) {

$parcel$export(module.exports, "isAdfContent", () => $785a6f66b73980d7$export$d801201dc544181);
$parcel$export(module.exports, "appendContent", () => $785a6f66b73980d7$export$a236f395afded7e0);
$parcel$export(module.exports, "encodeAdf", () => $785a6f66b73980d7$export$53ded0b846f45216);

var $b0F8r = parcelRequire("b0F8r");

var $b7FrM = parcelRequire("b7FrM");

var $lpRYt = parcelRequire("lpRYt");
const $785a6f66b73980d7$export$d801201dc544181 = (content)=>{
    /*
	This try-catch is a necessary guard rail against broken content to prevent higher level
	error boundaries from displaying the error and breaking the experience.
	*/ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $785a6f66b73980d7$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($785a6f66b73980d7$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $785a6f66b73980d7$var$pluginConfig = {
    linkify: {
        findFilepaths: $b0F8r.findFilepaths,
        isLinkInMatches: $b0F8r.isLinkInMatches
    },
    smartLinks: {
        regexStorage: $parcel$global.localStorage
    }
};
const $785a6f66b73980d7$export$3374c63d7715b4ce = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $785a6f66b73980d7$var$pluginConfig, false));
const $785a6f66b73980d7$var$streamingAdfEncoder = new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $lpRYt.AiMateMarkdownTransformer)(schema, $785a6f66b73980d7$var$pluginConfig, true));
const $785a6f66b73980d7$export$53ded0b846f45216 = (content, streaming = false)=>{
    if ($785a6f66b73980d7$export$d801201dc544181(content)) return content;
    return streaming ? $785a6f66b73980d7$var$streamingAdfEncoder.encode(content) : $785a6f66b73980d7$export$3374c63d7715b4ce.encode(content);
};

});
parcelRegister("lpRYt", function(module, exports) {

$parcel$export(module.exports, "AiMateMarkdownTransformer", () => $2d26328991932579$export$614853bf2169db97);

var $7KLhS = parcelRequire("7KLhS");

var $8iNK1 = parcelRequire("8iNK1");

var $aRZzN = parcelRequire("aRZzN");

var $4xvuZ = parcelRequire("4xvuZ");

var $kviC1 = parcelRequire("kviC1");

var $dh538 = parcelRequire("dh538");

var $aFrN0 = parcelRequire("aFrN0");

var $kVuPa = parcelRequire("kVuPa");

var $6RXI6 = parcelRequire("6RXI6");

var $3Jbpl = parcelRequire("3Jbpl");

var $j0P3F = parcelRequire("j0P3F");

var $dSj2z = parcelRequire("dSj2z");

var $1Ce64 = parcelRequire("1Ce64");

var $7ai6d = parcelRequire("7ai6d");

var $bCKHR = parcelRequire("bCKHR");
class $2d26328991932579$export$614853bf2169db97 extends (0, $aRZzN.MarkdownTransformer) {
    parse(content) {
        const node = this.parser.parse(content);
        if (!node) return new (0, $kviC1.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($7KLhS)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $bCKHR.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $6RXI6.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $aFrN0.default));
        if ((0, $dh538.fg)('rovo_enable_data_sculptor')) md.use((0, $kVuPa.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $dSj2z.createSmartLinksPlugin)(pluginConfig.smartLinks));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $j0P3F.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $8iNK1.markdownItTable));
            if ((0, $dh538.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $1Ce64.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $3Jbpl.default));
        const filter = (0, $bCKHR.filterSchemaMapping)(schema, (0, $7ai6d.mdToPmSchema));
        this.parser = new (0, $4xvuZ.MarkdownParser)(schema, md, filter);
    }
}

});
parcelRegister("aFrN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $eedc127a683be258$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");
const $eedc127a683be258$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $eedc127a683be258$var$citation = (state)=>{
    const tokens = [];
    // TODO: Remove the next two lines when rovo_chat_simplify_citation_logic enabled and cleaned up
    const citationIndexMap = {};
    let currentIndex = 1;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $eedc127a683be258$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($eedc127a683be258$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        if (!(0, $dh538.fg)('rovo_chat_simplify_citation_logic')) {
                            citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                        }
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $eedc127a683be258$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $eedc127a683be258$var$citation);

});

parcelRegister("kVuPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f34bd2edc9da4d$export$2e2bcd8739ae039);
const $85f34bd2edc9da4d$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $85f34bd2edc9da4d$var$dataSculptor = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $85f34bd2edc9da4d$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                citationToken.attrs = [
                    [
                        'localId',
                        'data-sculptor'
                    ],
                    [
                        'text',
                        'data-sculptor'
                    ],
                    [
                        'color',
                        'blue'
                    ]
                ];
                const parts = childToken.content.split($85f34bd2edc9da4d$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else tokenChildren.push(citationToken);
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $85f34bd2edc9da4d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $85f34bd2edc9da4d$var$dataSculptor);

});

parcelRegister("6RXI6", function(module, exports) {

$parcel$export(module.exports, "createLinkifyPlugin", () => $146b6bae45423f24$export$763ac077c9998026);

var $2jzd4 = parcelRequire("2jzd4");

var $4YzAy = parcelRequire("4YzAy");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $146b6bae45423f24$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $146b6bae45423f24$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $146b6bae45423f24$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $146b6bae45423f24$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2jzd4)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($146b6bae45423f24$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($146b6bae45423f24$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $4YzAy.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $146b6bae45423f24$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
const $146b6bae45423f24$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', $146b6bae45423f24$export$8cd7d1ec2e6808da(params));

});

parcelRegister("3Jbpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $536a5df99342df46$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $536a5df99342df46$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $536a5df99342df46$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $536a5df99342df46$var$createRule());
};

});

parcelRegister("j0P3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab169cc784e6afd4$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $ab169cc784e6afd4$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $ab169cc784e6afd4$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $ab169cc784e6afd4$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $ab169cc784e6afd4$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$ab169cc784e6afd4$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $ab169cc784e6afd4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $ab169cc784e6afd4$var$mentionLinks);

});

parcelRegister("dSj2z", function(module, exports) {

$parcel$export(module.exports, "createSmartLinksPlugin", () => $d5cccf701aceb868$export$9625a798761643ac);

var $gEMk1 = parcelRequire("gEMk1");
const $d5cccf701aceb868$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $d5cccf701aceb868$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
const $d5cccf701aceb868$var$linkRegex = {
    youtube: `${$d5cccf701aceb868$var$linkPatternStart}youtube\\.com${$d5cccf701aceb868$var$linkPatternEnd}`,
    youtubeShortUrl: `${$d5cccf701aceb868$var$linkPatternStart}youtu\\.be${$d5cccf701aceb868$var$linkPatternEnd}`,
    loomVideo: `${$d5cccf701aceb868$var$linkPatternStart}loom\\.com\\/share\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    figmaFile: `${$d5cccf701aceb868$var$linkPatternStart}figma\\.com\\/file\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$d5cccf701aceb868$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleDoc: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/edit${$d5cccf701aceb868$var$linkPatternEnd}`,
    googleForm: `${$d5cccf701aceb868$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$d5cccf701aceb868$var$linkPatternEnd}`,
    microsoftForm: `${$d5cccf701aceb868$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$d5cccf701aceb868$var$linkPatternEnd}`,
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$d5cccf701aceb868$var$linkPatternEnd}`
};
const $d5cccf701aceb868$var$supportedEmbedProviders = Object.values($d5cccf701aceb868$var$linkRegex).join('|');
const $d5cccf701aceb868$var$embedRegex = new RegExp($d5cccf701aceb868$var$supportedEmbedProviders, 'g');
const $d5cccf701aceb868$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$d5cccf701aceb868$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$d5cccf701aceb868$var$linkPatternEnd}`
];
const $d5cccf701aceb868$var$createSmartLinks = ({ regexStorage: regexStorage })=>(state)=>{
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        for (const token of state.tokens){
            let processedTokenChildren = [];
            embedMatches = [
                ...embedMatches,
                ...new Set(token.content?.trim().match($d5cccf701aceb868$var$embedRegex))
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $gEMk1.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        if (token.level <= 1 && $d5cccf701aceb868$var$embedInlineRegex.some((r)=>url.match(r))) {
                            outputToken.children = processedTokenChildren;
                            tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                            processedTokenChildren = [];
                            let embedToken = new state.Token('embedCard', '', 0);
                            embedToken.content = '';
                            embedToken.block = true;
                            embedToken.attrSet('url', url);
                            embedToken.attrSet('layout', 'center');
                            tokensToAppend.push(embedToken);
                            tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                            outputToken = new state.Token('inline', '', 0);
                            tokensToAppend.push(outputToken);
                            return;
                        }
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    processedTokenChildren.push(childToken);
                });
            }
            outputToken.children = processedTokenChildren;
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        if (embedMatches?.length) [
            ...new Set(embedMatches)
        ].forEach((match)=>{
            let embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $d5cccf701aceb868$export$9625a798761643ac = (params)=>(md)=>md.core.ruler.push('inlineCard', $d5cccf701aceb868$var$createSmartLinks(params));

});
parcelRegister("gEMk1", function(module, exports) {

$parcel$export(module.exports, "isSupportedByLinkingPlatform", () => $bf5d74ffdabdc3d2$export$4b1056d02426889c);
$parcel$export(module.exports, "hydrateLinkingPlatformCache", () => $bf5d74ffdabdc3d2$export$d08c351b3b4e4934);

var $csnse = parcelRequire("csnse");

var $lBWya = parcelRequire("lBWya");
const $bf5d74ffdabdc3d2$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $bf5d74ffdabdc3d2$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    const regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
const $bf5d74ffdabdc3d2$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $lBWya.LS_PROVIDER_KEY))}`);
    return '';
};
const $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $lBWya.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $bf5d74ffdabdc3d2$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerRegex = await $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd(baseUrl);
    $bf5d74ffdabdc3d2$export$5af966b3aa3b1d83(regexStorage, providerRegex);
};
const $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a = (data)=>{
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns.map((pattern)=>pattern.source);
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $bf5d74ffdabdc3d2$export$ab8eaff0f2d596bd = (0, $csnse.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $lBWya.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return !data ? '' : $bf5d74ffdabdc3d2$export$b7ac97ae80c7eb5a(data);
    } catch (error) {
        return '';
    }
});

});
parcelRegister("lBWya", function(module, exports) {

$parcel$export(module.exports, "PROVIDERS_API", () => $9088146284880a5b$export$57ad190cdc563df3);
$parcel$export(module.exports, "LS_PROVIDER_KEY", () => $9088146284880a5b$export$56bec2f197c16818);
const $9088146284880a5b$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $9088146284880a5b$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';

});



parcelRegister("1Ce64", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff6b0f828ae5055$export$2e2bcd8739ae039);
const $9ff6b0f828ae5055$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $9ff6b0f828ae5055$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $9ff6b0f828ae5055$var$tableBreakTags);

});

parcelRegister("7ai6d", function(module, exports) {

$parcel$export(module.exports, "pmToMd", () => $a1a032ec05100051$export$cd54a56af01ba875);
$parcel$export(module.exports, "mdToPmSchema", () => $a1a032ec05100051$export$eb83d753215c78a2);
const $a1a032ec05100051$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $a1a032ec05100051$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};

});

parcelRegister("bCKHR", function(module, exports) {

$parcel$export(module.exports, "filterSchemaMapping", () => $8bba972fb5d34921$export$155749302793c60c);
$parcel$export(module.exports, "enableSchemaPlugins", () => $8bba972fb5d34921$export$a1cf9d9b96e16789);

var $7ai6d = parcelRequire("7ai6d");
const $8bba972fb5d34921$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $8bba972fb5d34921$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $7ai6d.pmToMd){
        const key = k;
        for(const i in (0, $7ai6d.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $7ai6d.pmToMd)[key][idx]);
        }
    }
};

});



parcelRegister("gMgiH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95953690df38ef00a14db2c04a212acb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c36dc601e7874c68$var$_react = $c36dc601e7874c68$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c36dc601e7874c68$var$_feedback = $c36dc601e7874c68$var$_interopRequireDefault((parcelRequire("7yOcR")));

var $c36dc601e7874c68$var$_feedback2 = $c36dc601e7874c68$var$_interopRequireDefault((parcelRequire("41bOz")));
function $c36dc601e7874c68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "EditorFeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c36dc601e7874c68$var$FeedbackIcon = (props)=>/*#__PURE__*/ $c36dc601e7874c68$var$_react.default.createElement($c36dc601e7874c68$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $c36dc601e7874c68$var$_feedback2.default
    }, props));
$c36dc601e7874c68$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $c36dc601e7874c68$var$_default = module.exports.default = $c36dc601e7874c68$var$FeedbackIcon;

});

parcelRegister("3Opgu", function(module, exports) {

$parcel$export(module.exports, "SEARCH_AI_ANSWER_CACHE_KEY", () => $753d84ba93c687b7$export$fe340b7aba57733d);
$parcel$export(module.exports, "DEFAULT_EMPTY_NLP_SEARCH_STATE", () => $753d84ba93c687b7$export$fd2b85accaf97974);
$parcel$export(module.exports, "SearchAIDialog", () => $753d84ba93c687b7$export$effb3597bac74419);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $atveb = parcelRequire("atveb");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $2Rith = parcelRequire("2Rith");
var $fYQcF = parcelRequire("fYQcF");

var $e31DP = parcelRequire("e31DP");

var $epS7s = parcelRequire("epS7s");
var $7DA0P = parcelRequire("7DA0P");

var $4jIuc = parcelRequire("4jIuc");

var $kHyQH = parcelRequire("kHyQH");

var $f7lNm = parcelRequire("f7lNm");

var $aZJLt = parcelRequire("aZJLt");

var $2K9WG = parcelRequire("2K9WG");

var $9s72r = parcelRequire("9s72r");

var $9s72r = parcelRequire("9s72r");

var $kVdwy = parcelRequire("kVdwy");

var $01aV7 = parcelRequire("01aV7");

var $eRXI0 = parcelRequire("eRXI0");

var $2u6da = parcelRequire("2u6da");

var $4xTru = parcelRequire("4xTru");

var $iSCyZ = parcelRequire("iSCyZ");

var $1Kp2F = parcelRequire("1Kp2F");

var $9Fnx1 = parcelRequire("9Fnx1");

var $hv755 = parcelRequire("hv755");

var $4EDeh = parcelRequire("4EDeh");

var $dncbJ = parcelRequire("dncbJ");

var $7Zbm6 = parcelRequire("7Zbm6");

var $5jr3C = parcelRequire("5jr3C");

var $EQFBW = parcelRequire("EQFBW");
const $753d84ba93c687b7$var$searchAiDialogContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative' // this is for absolute positioned children
});
const $753d84ba93c687b7$export$fe340b7aba57733d = 'atlassian.search-dialog.ai-answer-component';
const $753d84ba93c687b7$export$fd2b85accaf97974 = {
    errorState: (0, $7Zbm6.NLPSearchErrorState).Default,
    format: null,
    disclaimer: null,
    nlpResults: [],
    uniqueSources: []
};
const $753d84ba93c687b7$var$SearchAIDialogComponent = ({ query: query, setQuery: setQuery, additionalQueryContext: additionalQueryContext, cloudId: cloudId, orgId: orgId, getAIAnswer: getAIAnswer, onNavigate: onNavigate, onClose: onClose, advancedSearchUrl: advancedSearchUrl, searchSessionId: searchSessionId, userDetails: userDetails, wrapper: wrapper, loadingWrapper: loadingWrapper, source: source = 'unknown', isReadingAids: isReadingAids = false, readingAidsOptions: readingAidsOptions, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, cardProviderProps: cardProviderProps, baseQuery: baseQuery = '', onLoad: onLoad, followUpsEnabled: followUpsEnabled, selectedFilters: selectedFilters, parsedFilters: parsedFilters, selectedProduct: selectedProduct, mappedProductFilter: mappedProductFilter, answerLoadingRef: answerLoadingRef, smartAnswersRoute: smartAnswersRoute, cardTemplate: cardTemplate = (0, $f7lNm.CardTemplate).DEFAULT, sourceProduct: sourceProduct, workspaceId: workspaceId, brand: brand = (0, $f7lNm.AiBrand).AI, closeParentDialog: closeParentDialog, callbacks: callbacks, isAdminHubAIEnabled: isAdminHubAIEnabled, definitionToggleEnabled: definitionToggleEnabled, showChatFollowUps: showChatFollowUps, showBookends: showBookends })=>{
    const intl = (0, $dBxQj.default)();
    const locale = intl.locale;
    const [loading, setLoading] = (0, $gwFzn.useState)(true);
    const [dwellTracked, setDwellTracked] = (0, $gwFzn.useState)(false);
    const partialResponseAbortControllerRef = (0, $gwFzn.useRef)();
    const [partialResponse, setPartialResponse] = (0, $gwFzn.useState)();
    const [queryReasoning, setQueryReasoning] = (0, $gwFzn.useState)();
    const [tabHasFocus, setTabHasFocus] = (0, $gwFzn.useState)(true);
    const [dwellTimer, setDwellTimer] = (0, $gwFzn.useState)(null);
    const [answerStreamed, setAnswerStreamed] = (0, $gwFzn.useState)(false);
    const [liked, setLiked] = (0, $gwFzn.useState)(undefined);
    const [likesDisabled, setLikesDisabled] = (0, $gwFzn.useState)(false);
    const [initialReported, setInitialReported] = (0, $gwFzn.useState)(undefined);
    const [nlpSearch, setData] = (0, $gwFzn.useState)($753d84ba93c687b7$export$fd2b85accaf97974);
    const filtersRef = (0, $gwFzn.useRef)(selectedFilters);
    const selectedProductRef = (0, $gwFzn.useRef)(selectedProduct);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const resultRef = (0, $gwFzn.useRef)(null);
    const initialLoadTs = (0, $gwFzn.useRef)(Date.now()).current;
    const loadedTsRef = (0, $gwFzn.useRef)();
    const dwellTimeRef = (0, $gwFzn.useRef)();
    const markLoadedTs = ()=>{
        loadedTsRef.current = Date.now();
        return loadedTsRef.current - initialLoadTs;
    };
    const startViewportDwell = ()=>{
        dwellTimeRef.current = Date.now();
    };
    const markViewportDwell = ()=>{
        if (dwellTimeRef.current) return Date.now() - dwellTimeRef.current;
        return 0;
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const sessionId = (0, $kHyQH.useSessionId)({
        userId: userDetails.id || '',
        cloudId: cloudId,
        source: source
    });
    const activityClient = (0, $e31DP.useActivityClient)('v3', 'people');
    const useKnowledgeDiscoveryTeamSearch = (0, $dh538.fg)('ai_use_kd_team_search');
    const useKnowledgeDiscoveryUserSearch = (0, $dh538.fg)('ai_use_kd_user_search');
    const renderCardByExperience = (0, $dh538.fg)('kd_smart_answers_render_by_experience');
    const isAnswered = !loading && nlpSearch.errorState === null;
    const hasError = !loading && !!nlpSearch.errorState && nlpSearch.errorState !== (0, $7Zbm6.NLPSearchErrorState).Default;
    const answerString = nlpSearch.nlpResults?.length ? nlpSearch.nlpResults[0].nlpResult : nlpSearch.nlpResult || '';
    const answerFormat = nlpSearch.format;
    const followUps = nlpSearch.nlpFollowUpResults?.followUps;
    const sources = nlpSearch.uniqueSources;
    const disclaimer = nlpSearch.disclaimer;
    const answerEditor = nlpSearch.nlpResultEditor;
    const extraAPIAnalyticsAttributes = nlpSearch.extraAPIAnalyticsAttributes;
    const answerCardType = isReadingAids ? 'definition' : smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON ? 'people' : smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM ? 'team' : smartAnswersRoute === (0, $f7lNm.QueryIntent).DATE ? 'date' : smartAnswersRoute === (0, $f7lNm.QueryIntent).LOCATION ? 'location' : 'SAIN';
    const commonAttributes = (0, $gwFzn.useMemo)(()=>({
            cloudId: cloudId,
            orgId: orgId ?? '',
            queryHash: (0, $01aV7.sha256Hash)(query),
            baseQueryHash: (0, $01aV7.sha256Hash)(baseQuery),
            query: query,
            appliedFilters: parsedFilters,
            searchSessionId: searchSessionId,
            source: source,
            answerString: answerString,
            answerLength: answerString.length,
            answerWordCount: answerString.split(/\s+/).length,
            answerFormat: answerFormat,
            answerCardType: answerCardType,
            sources: sources,
            followUps: followUps || [],
            errorState: nlpSearch.errorState,
            errorCode: nlpSearch.errorCode,
            extraAttributes: {
                featureGates: {
                    precomputedDefinitionsEnabled: (0, $dh538.fg)('kd_enable_precomputed_definitions')
                },
                ...extraAnalyticsAttributes,
                ...extraAPIAnalyticsAttributes
            },
            apiSource: 'assistance-service',
            workspaceId: workspaceId ?? '',
            sessionId: sessionId,
            brand: brand
        }), [
        cloudId,
        orgId,
        query,
        baseQuery,
        parsedFilters,
        searchSessionId,
        source,
        answerString,
        answerFormat,
        nlpSearch.errorState,
        nlpSearch.errorCode,
        extraAnalyticsAttributes,
        extraAPIAnalyticsAttributes,
        workspaceId,
        sessionId,
        brand,
        answerCardType,
        followUps,
        sources
    ]);
    const fireAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const onNavigateWithMouseEvent = (0, $gwFzn.useCallback)((event)=>{
        if (!event.ctrlKey && !event.metaKey) onNavigate();
    }, [
        onNavigate
    ]);
    const getAIAnswerFn = (0, $gwFzn.useCallback)(()=>{
        switch(smartAnswersRoute){
            case (0, $f7lNm.QueryIntent).PERSON:
                return (_args)=>useKnowledgeDiscoveryUserSearch ? (0, $9s72r.fetchPersonKnowledgeCardDataWithPostFiltering)({
                        tenantId: cloudId,
                        personQuery: query,
                        intl: intl,
                        sourceProduct: sourceProduct
                    }) : (0, $9s72r.fetchPersonKnowledgeCardData)({
                        tenantId: cloudId,
                        personQuery: query,
                        principalUserId: userDetails.id || '',
                        intl: intl
                    });
            case (0, $f7lNm.QueryIntent).TEAM:
                return (_args)=>useKnowledgeDiscoveryTeamSearch ? (0, $kVdwy.fetchTeamKnowledgeCardDataWithRanking)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct
                    }) : (0, $kVdwy.fetchTeamKnowledgeCardData)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        tenantId: cloudId,
                        teamQuery: query
                    });
            default:
        }
        return getAIAnswer;
    }, [
        getAIAnswer,
        smartAnswersRoute,
        query,
        orgId,
        cloudId,
        activityClient,
        useKnowledgeDiscoveryUserSearch,
        useKnowledgeDiscoveryTeamSearch,
        userDetails.id,
        intl,
        sourceProduct
    ]);
    const updateContextCache = (0, $gwFzn.useCallback)(({ collapsed: collapsed, liked: liked, reported: reported, recentWorkListExpanded: recentWorkListExpanded, sourcesExpanded: sourcesExpanded, fromFollowUp: fromFollowUp })=>{
        const currentCache = JSON.parse((0, $epS7s.getSessionItem)($753d84ba93c687b7$export$fe340b7aba57733d) || '{}');
        (0, $epS7s.setSessionItem)($753d84ba93c687b7$export$fe340b7aba57733d, JSON.stringify({
            query: query,
            additionalContext: additionalQueryContext || '',
            data: nlpSearch,
            collapsed: collapsed === undefined ? currentCache.collapsed : collapsed,
            liked: liked === undefined ? currentCache.liked : liked,
            reported: reported === undefined ? currentCache.reported : reported,
            fromFollowUp: fromFollowUp === undefined ? currentCache.fromFollowUp : fromFollowUp,
            recentWorkListExpanded: recentWorkListExpanded === undefined ? currentCache.recentWorkListExpanded : recentWorkListExpanded,
            sourcesExpanded: sourcesExpanded === undefined ? currentCache.sourcesExpanded : sourcesExpanded
        }));
    }, [
        query,
        additionalQueryContext,
        nlpSearch
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (answerLoadingRef) answerLoadingRef.current = !!loading;
    }, [
        loading,
        answerLoadingRef
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $1Kp2F.aiAnswerDialogMetric).start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    const handleIntersect = (entries)=>{
        entries.forEach((entry)=>{
            if (!loading && (isAnswered || hasError)) {
                if (entry.isIntersecting) {
                    startViewportDwell();
                    fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogViewed)({
                        ...commonAttributes
                    }));
                    if (smartAnswersRoute !== (0, $f7lNm.QueryIntent).TEAM && smartAnswersRoute !== (0, $f7lNm.QueryIntent).PERSON && !dwellTracked) {
                        const usageTimer = setTimeout(()=>{
                            setDwellTracked(true);
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $4jIuc.SAIN_USAGE_DWELL_THRESHOLD));
                        setDwellTimer(usageTimer);
                    }
                } else fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogHidden)({
                    ...commonAttributes
                }, markViewportDwell()));
            }
        });
    };
    (0, $gwFzn.useLayoutEffect)(()=>{
        const observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.3
        });
        if (resultRef.current && tabHasFocus) observer.observe(resultRef.current);
        return ()=>{
            observer?.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        resultRef,
        isAnswered,
        hasError,
        tabHasFocus
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const cached = JSON.parse((0, $epS7s.getSessionItem)($753d84ba93c687b7$export$fe340b7aba57733d) || '{}');
        if (cached?.query === query && cached?.additionalContext === additionalQueryContext) {
            setData(cached.data);
            if (cached.liked !== undefined) {
                setLiked(cached.liked);
                // if a like is cached, disable likes
                setLikesDisabled(true);
            }
            if (cached.reported !== undefined) setInitialReported(cached.reported);
            setLoading(false);
        } else {
            (0, $epS7s.deleteSessionItem)($753d84ba93c687b7$export$fe340b7aba57733d);
            setLoading(true);
            setLiked(undefined);
            setLikesDisabled(false);
            (0, $5jr3C.fetchAIAnswer)({
                cloudId: cloudId,
                locale: locale,
                query: query,
                additional_context: additionalQueryContext,
                source: source,
                followUpsEnabled: followUpsEnabled && !cached.fromFollowUp,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning
            });
        }
        filtersRef.current = selectedFilters;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        additionalQueryContext
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(filtersRef.current, selectedFilters) || !(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(selectedProductRef.current, selectedProduct)) {
            (0, $epS7s.deleteSessionItem)($753d84ba93c687b7$export$fe340b7aba57733d);
            setLoading(true);
            setLiked(undefined);
            setLikesDisabled(false);
            (0, $5jr3C.fetchAIAnswer)({
                cloudId: cloudId,
                locale: locale,
                query: query,
                source: source,
                followUpsEnabled: followUpsEnabled,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning
            });
        }
        filtersRef.current = selectedFilters;
        selectedProductRef.current = selectedProduct;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedFilters,
        selectedProduct
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isAnswered) {
            // if a person or team query returns no data don't log result shown
            const numAddtlWhoMatches = smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON ? (0, $EQFBW.getKnowledgeCardResultCount)({
                answerString: answerString
            }) : 0;
            if ((smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON || smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM) && (0, $EQFBW.getKnowledgeCardResultCount)({
                answerString: answerString
            }) < 1) {
                markLoadedTs();
                return;
            }
            fireAnalyticsEvent((0, $4xTru.onAIAnswerResultShown)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                extraAttributes: {
                    ...commonAttributes.extraAttributes,
                    multipleUserResultsShown: numAddtlWhoMatches > 0,
                    numAddtlWhoMatches: numAddtlWhoMatches,
                    isCuratedDefinition: !!answerEditor,
                    isPrecomputedDefinition: nlpSearch.customDefinitionType === (0, $7Zbm6.NLPSearchCustomDefinitionType).PRECOMPUTED
                }
            }));
            if (numAddtlWhoMatches > 0) fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
        } else if (hasError) fireAnalyticsEvent((0, $4xTru.onAIAnswerNotShown)({
            ...commonAttributes,
            isStreamed: answerStreamed,
            loadTime: markLoadedTs()
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        trackAIInteractionInit();
        fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogQueryIntent)(commonAttributes));
        if (!isReadingAids && query && smartAnswersRoute) fireAnalyticsEvent((0, $4xTru.onSmartAnswerRouteDetection)(commonAttributes, smartAnswersRoute));
        return ()=>{
            fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogHidden)({
                ...commonAttributes
            }, markViewportDwell()));
            fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogUnmount)({
                ...commonAttributes,
                isReadingAids: isReadingAids,
                sourceProduct: sourceProduct,
                dwellTime: loadedTsRef.current ? Date.now() - loadedTsRef.current : 0,
                loadTime: loadedTsRef.current ? loadedTsRef.current - initialLoadTs : Date.now() - initialLoadTs
            }));
            trackAIInteractionDismiss();
            if (!loadedTsRef.current) fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogDroppedOff)({
                ...commonAttributes
            }));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        const handleWindowBlurOrClose = ()=>{
            if (tabHasFocus && !loading && (isAnswered || hasError)) fireAnalyticsEvent((0, $4xTru.onAIAnswerDialogHidden)({
                ...commonAttributes
            }, markViewportDwell()));
            setTabHasFocus(false);
        };
        const handleWindowFocus = ()=>{
            setTabHasFocus(true);
        };
        const removeBlurListener = (0, $d8F95.bind)(window, {
            type: 'blur',
            listener: handleWindowBlurOrClose
        });
        const removeFocusListener = (0, $d8F95.bind)(window, {
            type: 'focus',
            listener: handleWindowFocus
        });
        const removeCloseListener = (0, $d8F95.bind)(window, {
            type: 'beforeunload',
            listener: handleWindowBlurOrClose
        });
        return ()=>{
            removeBlurListener();
            removeFocusListener();
            removeCloseListener();
            if (dwellTimer) clearTimeout(dwellTimer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tabHasFocus,
        loading
    ]);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (onLoad && !loading && (isAnswered || hasError)) onLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered,
        hasError
    ]);
    const AIDialogWrapper = wrapper ? wrapper : (0, $7DA0P.SearchDialog);
    const AILoadingWrapper = loadingWrapper ? loadingWrapper : (0, $2u6da.AIAnswerDefaultLoadingWrapper);
    const renderDefinition = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSCyZ.DefinitionAnswerCard), {});
    // SAIN in FPS
    const renderSearchPageSmartAnswer = ()=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)(AIDialogWrapper, {
            children: (0, $dh538.fg)('kd_sain_enable_expand_when_streaming') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4EDeh.SmartAnswerCard), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dncbJ.SmartAnswerCardWithoutStreamingExpand), {})
        });
    };
    const renderSearchPageKnowledgeCard = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)(AIDialogWrapper, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2K9WG.KnowledgeCard), {})
        });
    // Quick search and advanced search
    const renderDefaultSmartAnswer = ()=>{
        return (0, $dh538.fg)('kd_sain_enable_expand_when_streaming') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Fnx1.LegacySmartAnswerCard), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hv755.LegacySmartAnswerCardWithoutStreamingExpand), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper
        });
    };
    const renderDialog = ()=>{
        switch(cardTemplate){
            case (0, $f7lNm.CardTemplate).SMART_ANSWER:
            case (0, $f7lNm.CardTemplate).RIGHT_PANEL:
                return renderSearchPageSmartAnswer();
            // branch out SAIN in FPS
            default:
                return isReadingAids ? renderDefinition() : renderDefaultSmartAnswer();
        }
    };
    const renderExperience = ()=>{
        switch(smartAnswersRoute){
            case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
            case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
            case (0, $f7lNm.QueryIntent).DATE:
            case (0, $f7lNm.QueryIntent).LOCATION:
                return renderSearchPageSmartAnswer();
            case (0, $f7lNm.QueryIntent).PERSON:
            case (0, $f7lNm.QueryIntent).TEAM:
                return renderSearchPageKnowledgeCard();
            default:
                return isReadingAids ? renderDefinition() : renderDefaultSmartAnswer();
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eRXI0.AIAnswerContext).Provider, {
        value: {
            loading: loading,
            partialResponse: partialResponse,
            isAnswered: isAnswered,
            hasError: hasError,
            advancedSearchUrl: advancedSearchUrl,
            userDetails: userDetails,
            disclaimer: disclaimer,
            onNavigate: onNavigateWithMouseEvent,
            onClose: onClose,
            updateContextCache: updateContextCache,
            fireAnalyticsEvent: fireAnalyticsEvent,
            setQuery: setQuery,
            setData: setData,
            commonAttributes: commonAttributes,
            liked: liked,
            setLiked: setLiked,
            likesDisabled: likesDisabled,
            setLikesDisabled: setLikesDisabled,
            initialReported: initialReported,
            isReadingAids: isReadingAids,
            readingAidsOptions: readingAidsOptions,
            cardProviderProps: cardProviderProps,
            baseQuery: baseQuery,
            cardTemplate: cardTemplate,
            smartAnswersRoute: smartAnswersRoute,
            brand: brand,
            answerEditor: answerEditor,
            closeParentDialog: closeParentDialog,
            additionalQueryContext: additionalQueryContext,
            callbacks: callbacks,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            definitionToggleEnabled: definitionToggleEnabled,
            sourceProduct: sourceProduct,
            showChatFollowUps: showChatFollowUps,
            showBookends: showBookends ?? false,
            queryReasoning: queryReasoning
        },
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $753d84ba93c687b7$var$searchAiDialogContainerStyles,
                ref: resultRef,
                children: renderCardByExperience ? renderExperience() : renderDialog()
            }),
            !loading && (isAnswered || hasError) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Kp2F.MarkAIAnswerDialogMetricEnd), {})
        ]
    });
};
const $753d84ba93c687b7$export$effb3597bac74419 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>{
    const { definitionExperienceName: definitionExperienceName, isReadingAids: isReadingAids, source: source, sourceProduct: sourceProduct, sourceSubProduct: sourceSubProduct, smartAnswersRoute: smartAnswersRoute, userGeneratedAI: userGeneratedAI } = props;
    const getUnifiedAIExperienceName = (smartAnswersRoute)=>{
        switch(smartAnswersRoute){
            case (0, $f7lNm.QueryIntent).PERSON:
                return 'Person Card';
            case (0, $f7lNm.QueryIntent).TEAM:
                return 'Team Card';
            case (0, $f7lNm.QueryIntent).LOCATION:
                return 'Location Card';
            case (0, $f7lNm.QueryIntent).DATE:
                return 'Date Card';
            case (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY:
            case (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM:
            default:
                return 'Plain Text';
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aZJLt.ErrorBoundary), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
            config: {
                product: sourceProduct ?? 'unknown',
                subproduct: sourceSubProduct ?? 'unknown',
                aiFeatureName: isReadingAids ? 'aiDefinitions' : 'smartAnswers',
                aiExperienceName: isReadingAids ? definitionExperienceName : getUnifiedAIExperienceName(smartAnswersRoute),
                proactiveGeneratedAI: userGeneratedAI ? 0 : 1,
                userGeneratedAI: userGeneratedAI ? 1 : 0,
                isAIFeature: 1,
                source: source,
                channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($753d84ba93c687b7$var$SearchAIDialogComponent, {
                ...props
            })
        })
    });
});

});
parcelRegister("4jIuc", function(module, exports) {

$parcel$export(module.exports, "SAIN_USAGE_DWELL_THRESHOLD", () => $e3c814adee511225$export$a0cb7cf9977bca78);
$parcel$export(module.exports, "SainAction", () => $e3c814adee511225$export$c90526da16c2eaaa);
$parcel$export(module.exports, "useSAINUsageCriteriaMet", () => $e3c814adee511225$export$bf85f2c6a4e29d4e);

var $gwFzn = parcelRequire("gwFzn");

var $fYQcF = parcelRequire("fYQcF");

var $cqFuK = parcelRequire("cqFuK");
const $e3c814adee511225$export$a0cb7cf9977bca78 = 3000;
var $e3c814adee511225$export$c90526da16c2eaaa = /*#__PURE__*/ function(SainAction) {
    SainAction["SOURCE_CLICKED"] = "sourceLinkClicked";
    SainAction["POSITIVE_FEEDBACK_PROVIDED"] = "positiveFeedbackProvided";
    SainAction["NEGATIVE_FEEDBACK_PROVIDED"] = "negativeFeedbackProvided";
    SainAction["DWELL_REACHED"] = "dwellTimeReached";
    SainAction["COPY_CLICKED"] = "copyButtonClicked";
    SainAction["FOLLOWUP_CLICKED"] = "followupLinkClicked";
    SainAction["OPEN_CHAT_CLICKED"] = "openChatButtonClicked";
    SainAction["EXPAND_CLICKED"] = "expandButtonClicked";
    SainAction["TOPIC_CLICKED"] = "topicClicked";
    SainAction["RECENT_WORK_CLICKED"] = "recentWorkClicked";
    SainAction["COLLABORATOR_CLICKED"] = "collaboratorClicked";
    SainAction["VIEW_PROFILE_CLICKED"] = "viewProfileClicked";
    SainAction["TEAM_MEMBER_CLICKED"] = "teamMemberClicked";
    SainAction["VIEW_TEAM_PAGE_CLICKED"] = "viewTeamPageClicked";
    SainAction["REPORTING_LINES_CLICKED"] = "reportingLinesClicked";
    SainAction["PERSON_SELECTED"] = "cardClicked";
    SainAction["BOOKMARK_CLICKED"] = "bookmarkClicked";
    SainAction["CHAT_CLICKED"] = "chatClicked";
    SainAction["JIRA_ISSUE_CLICKED"] = "jiraIssueCardClicked";
    SainAction["SHOW_ON_GOOGLE_MAPS_CLICKED"] = "showOnGoogleMapsClicked";
    return SainAction;
}({});
const $e3c814adee511225$export$bf85f2c6a4e29d4e = ()=>{
    const { trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const fireSAINUsageEvent = (0, $gwFzn.useCallback)(({ metCriteria: metCriteria, dwellTime: dwellTime, commonAttributes: commonAttributes })=>{
        const sanitizedCommonAttributes = commonAttributes ? (0, $cqFuK.filterCommonAttributes)(commonAttributes) : {};
        if (metCriteria) {
            // If usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to false
            trackAIResultView({
                doesNotMeetMAUCriteria: false,
                attributes: {
                    dwellTime: dwellTime || 0,
                    mauEligibilityCriteria: metCriteria,
                    ...sanitizedCommonAttributes
                }
            });
            // In addition, emit an action/feedback event for the action that was met
            // (https://hello.atlassian.net/wiki/x/Vxb5DAE)
            switch(metCriteria){
                case "sourceLinkClicked":
                case "copyButtonClicked":
                case "followupLinkClicked":
                case "topicClicked":
                case "recentWorkClicked":
                case "collaboratorClicked":
                case "viewProfileClicked":
                case "teamMemberClicked":
                case "viewTeamPageClicked":
                case "openChatButtonClicked":
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case "positiveFeedbackProvided":
                    trackAIFeedbackSubmit('up', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case "negativeFeedbackProvided":
                    trackAIFeedbackSubmit('down', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                default:
                    break;
            }
        } else // If no usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to true
        trackAIResultView({
            doesNotMeetMAUCriteria: true,
            attributes: {
                dwellTime: dwellTime || 0,
                ...sanitizedCommonAttributes
            }
        });
    }, [
        trackAIResultView,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    return {
        fireSAINUsageEvent: fireSAINUsageEvent
    };
};

});

parcelRegister("kHyQH", function(module, exports) {

$parcel$export(module.exports, "useSessionId", () => $f342a64f1825e9b1$export$baca5c7d93c77000);

var $3rxD2 = parcelRequire("3rxD2");

var $gwFzn = parcelRequire("gwFzn");

var $7Zbm6 = parcelRequire("7Zbm6");

var $7Zbm6 = parcelRequire("7Zbm6");

var $5y8jR = parcelRequire("5y8jR");
const $f342a64f1825e9b1$export$ef87db6b11c89091 = ({ isReadingAids: isReadingAids, answerFormat: answerFormat, parsedType: parsedType })=>{
    if (isReadingAids) return 'definition';
    if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && parsedType === (0, $7Zbm6.NLPSearchJSONResultFormat).WHO) return 'people';
    if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && parsedType === (0, $7Zbm6.NLPSearchJSONResultFormat).WORK) return 'work';
    return 'SAIN';
};
const $f342a64f1825e9b1$export$3e9057828ebd5c7a = ({ answerFormat: answerFormat, answerString: answerString })=>{
    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).JSON) return undefined;
    return (0, $5y8jR.getTypedJSONResultDataAssistanceService)(answerString).parsedType;
};
const $f342a64f1825e9b1$export$baca5c7d93c77000 = ({ userId: userId, cloudId: cloudId, source: source })=>{
    return (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3rxD2))).createHash('sha256').update(`${userId}-${cloudId}-${Date.now().toString()}-${source}`).digest('hex'), [
        userId,
        cloudId,
        source
    ]);
};

});
parcelRegister("5y8jR", function(module, exports) {

$parcel$export(module.exports, "getTypedJSONResultData", () => $c97be5ff4a9e42e9$export$d905ae2a714518e8);
$parcel$export(module.exports, "getTypedJSONResultDataAssistanceService", () => $c97be5ff4a9e42e9$export$b273f870e024eb5d);

var $7Zbm6 = parcelRequire("7Zbm6");
const $c97be5ff4a9e42e9$export$d905ae2a714518e8 = (answerString)=>{
    const parsed = JSON.parse(answerString);
    if ('user_metadata' in parsed && !!parsed.user_metadata) return {
        parsedResult: parsed.user_metadata,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WHO
    };
    else if ('user_metadata_only_cards' in parsed && !!parsed.user_metadata_only_cards) return {
        parsedResult: parsed.user_metadata_only_cards,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).PERSON
    };
    else if ('user_metadata_with_activity' in parsed && !!parsed.user_metadata_with_activity) return {
        parsedResult: parsed.user_metadata_with_activity,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WORK
    };
    else if ('team_metadata' in parsed && !!parsed.team_metadata) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: parsed,
        parsedType: undefined
    };
};
const $c97be5ff4a9e42e9$var$mapRecentActivity = (activity)=>({
        title: activity.title,
        url: activity.url,
        containerName: activity.containerName,
        event: activity.event,
        timestamp: activity.timestamp,
        iconUrl: activity.iconUrl,
        contributors: activity.contributors.slice(0, $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW).map((contributor)=>({
                name: contributor.name,
                id: contributor.accountId
            })),
        othersCount: activity.othersCount
    });
const $c97be5ff4a9e42e9$var$mapTeam = (team)=>({
        name: team.displayName,
        avatarUrl: team.smallAvatarImageUrl,
        url: `/wiki/people/team/${team.id}`,
        memberCount: team.memberCount
    });
const $c97be5ff4a9e42e9$var$mapAdditionalMatch = (match)=>{
    return {
        name: match.name,
        avatar_url: match.avatar_url,
        profile_url: match.profile_url,
        job_title: match.title,
        email: match.email ?? ''
    };
};
// Collaborators, contributors and additional matches are expected to be at most 3
const $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW = 3;
const $c97be5ff4a9e42e9$export$b273f870e024eb5d = (answerString)=>{
    const parsed = JSON.parse(answerString);
    if ('enriched_activity_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_activity_output;
        return {
            parsedResult: [
                {
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    time: main_user_profile.time,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    recentActivity: main_user_profile.recent_activity.map($c97be5ff4a9e42e9$var$mapRecentActivity),
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    viewAllLink: main_user_profile.view_all_activity_url
                },
                ...additional_matches.slice(0, $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW).map((x)=>({
                        ...$c97be5ff4a9e42e9$var$mapAdditionalMatch(x),
                        recentActivity: [],
                        viewAllLink: ''
                    }))
            ],
            parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WORK
        };
    } else if ('enriched_profile_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_profile_output;
        return {
            parsedResult: [
                {
                    account_id: main_user_profile.user_base_data.account_id,
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    time: main_user_profile.time,
                    collaborators: main_user_profile.collaborators.slice(0, 6).map((user)=>({
                            name: user.name,
                            picture: user.avatar_url,
                            title: user.extended_profile?.job_title ?? null,
                            url: user.profile_url,
                            accountId: user.account_id,
                            department: user.extended_profile?.department ?? null,
                            email: user.email
                        })),
                    containers: main_user_profile.collaboration_spaces.map((container)=>({
                            name: container.name,
                            containerType: container.container_type,
                            url: container.url,
                            iconUrl: container.icon_url
                        })),
                    recentActivity: main_user_profile.recent_activity?.map($c97be5ff4a9e42e9$var$mapRecentActivity),
                    viewAllLink: main_user_profile.view_all_activity_url,
                    teams: main_user_profile.teams?.map($c97be5ff4a9e42e9$var$mapTeam)
                },
                ...additional_matches.slice(0, $c97be5ff4a9e42e9$var$MAX_OTHERS_TO_SHOW).map($c97be5ff4a9e42e9$var$mapAdditionalMatch)
            ],
            parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).WHO
        };
    } else if ('team_metadata' in parsed) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: {},
        parsedType: undefined
    };
};

});


parcelRegister("aZJLt", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $79c55f47bdc0a8b7$export$e926676385687eaf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $bg4YX = parcelRequire("bg4YX");

var $7DA0P = parcelRequire("7DA0P");

var $lJsaE = parcelRequire("lJsaE");

var $4Zqgi = parcelRequire("4Zqgi");

var $f7lNm = parcelRequire("f7lNm");

var $6bBOi = parcelRequire("6bBOi");

var $3DlFI = parcelRequire("3DlFI");
const $79c55f47bdc0a8b7$export$e926676385687eaf = ({ isReadingAids: isReadingAids, wrapper: wrapper, source: source, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const DefaultWrapper = isReadingAids ? (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $lJsaE.ReadingAidsPopupContainer), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lJsaE.ReadingAidsContainer), {
                children: props.children
            })
        }) : (0, $7DA0P.SearchDialog);
    const Wrapper = wrapper ? wrapper : DefaultWrapper;
    const logError = (0, $gwFzn.useCallback)((error)=>{
        // Currently we are in between deprecating UFOv1 and adopting react-UFO  for platform packages, so this is a temporary way for us to collect error logs
        // https://atlassian.slack.com/archives/C01AY8132S3/p1716509785878689
        const errorAttributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1)
        };
        createAnalyticsEvent({
            action: 'failed',
            actionSubject: 'aiAnswerDialog',
            source: source || 'unknown',
            eventType: 'track',
            attributes: errorAttributes
        }).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
        (0, $4Zqgi.logger).error(errorAttributes);
    }, [
        source,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bg4YX.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3DlFI.ErrorBoundaryFallbackText), {
                isReadingAids: isReadingAids,
                children: formatMessage((0, $6bBOi.messages).error_boundary_fallback_text)
            })
        }),
        onException: logError,
        children: children
    });
};

});
parcelRegister("lJsaE", function(module, exports) {

$parcel$export(module.exports, "ReadingAidsWrapper", () => $9e00ac4212e51388$export$e0e6dbd6257adb05);
$parcel$export(module.exports, "ReadingAidsContainer", () => $9e00ac4212e51388$export$a9f6f8fd5598a12e);
$parcel$export(module.exports, "ReadingAidsPopupContainer", () => $9e00ac4212e51388$export$f79f209cc21596d);
$parcel$export(module.exports, "EditDefinitionWrapper", () => $9e00ac4212e51388$export$92161330b4f919c7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $f7lNm = parcelRequire("f7lNm");

var $gwrgp = parcelRequire("gwrgp");
const $9e00ac4212e51388$export$e0e6dbd6257adb05 = (0, $gwrgp.default)("div", {
    target: "ea0qrrg0"
})({
    name: "0",
    styles: ""
});
const $9e00ac4212e51388$export$a9f6f8fd5598a12e = (0, $gwrgp.default)("div", {
    target: "ea0qrrg1"
})({
    position: 'relative',
    borderRadius: 'inherit',
    maxHeight: '650px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $f7lNm.READING_AIDS_DIALOG_WIDTH),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`,
    overflowX: 'hidden',
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    MsOverflowStyle: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-webkit-scrollbar': {
        display: 'none'
    }
});
const $9e00ac4212e51388$export$f79f209cc21596d = (0, $gwrgp.default)("div", {
    target: "ea0qrrg2"
})(({ isLoading: isLoading, continueAnimation: continueAnimation })=>({
        position: 'relative',
        borderRadius: '5px',
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $6fnsQ.N60A}, 0 0 1px ${0, $6fnsQ.N60A}`})`,
        padding: "var(--ds-space-025, 2px)",
        '@property --gradient-angle': {
            syntax: "'<angle>'",
            initialValue: '45deg',
            inherits: 'false'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes rotationAnimation': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '0%': {
                '--gradient-angle': '0deg'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '100%': {
                '--gradient-angle': '360deg'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animation: isLoading || continueAnimation ? 'rotationAnimation linear 3s infinite' : '',
        background: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        isLoading || continueAnimation ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : `var(--ds-surface-overlay, ${0, $6fnsQ.N0})`
    }));
const $9e00ac4212e51388$export$77fa03a2560d98a0 = /*#__PURE__*/ (0, $gwrgp.default)($9e00ac4212e51388$export$f79f209cc21596d, {
    target: "ea0qrrg3"
})({
    name: "1o98vh2",
    styles: "position:absolute;filter:blur(25px);opacity:0.5;height:100%;"
});
const $9e00ac4212e51388$export$3cf8906a98457d34 = (0, $gwrgp.default)("span", {
    target: "ea0qrrg4"
})({
    name: "0",
    styles: ""
});
const $9e00ac4212e51388$export$92161330b4f919c7 = (0, $gwrgp.default)("div", {
    target: "ea0qrrg5"
})({
    name: "1uut010",
    styles: "padding-top:0;padding-right:var(--ds-space-150, 12px);padding-bottom:0;padding-left:var(--ds-space-150, 12px);button{color:var(--ds-text-subtlest, #626F86);}"
});

});

parcelRegister("4Zqgi", function(module, exports) {

$parcel$export(module.exports, "logger", () => $2afb97bb773ddd18$export$af88d00dbe7f521);

var $97HEP = parcelRequire("97HEP");
const $2afb97bb773ddd18$var$error = async (error)=>{
    try {
        const SentryClient = await (0, $97HEP.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            // TODO bring in user, product and other meta data from the to be implmented state store
            // scope.setUser({ id: user?.id || UNKNOWN_TAG });
            // scope.setTag('product', primaryProduct || UNKNOWN_TAG);
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $2afb97bb773ddd18$export$af88d00dbe7f521 = {
    error: $2afb97bb773ddd18$var$error
};

});
parcelRegister("97HEP", function(module, exports) {

$parcel$export(module.exports, "getSentryClient", () => $effdb799a148a720$export$f553e8b08ef59d31);

var $3nPYZ = parcelRequire("3nPYZ");

var $1JvBr = parcelRequire("1JvBr");

var $g8CIJ = parcelRequire("g8CIJ");
let $effdb799a148a720$var$Sentry;
const $effdb799a148a720$var$beforeSend = (event)=>{
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    if (event.environment === 'development') return null;
    return event;
};

const $effdb799a148a720$export$f553e8b08ef59d31 = async ()=>{
    if (!$effdb799a148a720$var$Sentry) $effdb799a148a720$var$Sentry = (parcelRequire("eCurS")).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $g8CIJ.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $3nPYZ.PRODUCT_BUILD) || (0, $g8CIJ.UNKNOWN_TAG),
            environment: (0, $1JvBr.getEnvironment)(),
            beforeSend: $effdb799a148a720$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $effdb799a148a720$var$Sentry;
};

});
parcelRegister("3nPYZ", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_BUILD", () => $caff51da97cfcbcc$export$668f31ea3127f48f);
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $caff51da97cfcbcc$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;

});

parcelRegister("1JvBr", function(module, exports) {

$parcel$export(module.exports, "getEnvironment", () => $bfee5be0414bd1fa$export$57570b1603cf6adb);
const $bfee5be0414bd1fa$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};

});

parcelRegister("g8CIJ", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "UNKNOWN_TAG", () => $6ddb4d99fe6d7477$export$ea77880e3935182d);
// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
const $6ddb4d99fe6d7477$export$6faa4a850bc4d0ce = 'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';
const $6ddb4d99fe6d7477$export$ea77880e3935182d = 'unknown';

});

parcelRegister("eCurS", function(module, exports) {

let $aa4c3bc23bfd6abf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $aa4c3bc23bfd6abf$var$load("4hOv8"),
    $aa4c3bc23bfd6abf$var$load("fhU7k")
]).then(()=>parcelRequire('cJyjM'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});





parcelRegister("6bBOi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8af27037da6fd8cc$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $8af27037da6fd8cc$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    error_boundary_fallback_text: {
        id: "search_ai.error_boundary_fallback_text",
        defaultMessage: "Something went wrong. Try refreshing the page or trying again later."
    }
});

});

parcelRegister("3DlFI", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryFallbackText", () => $4a1b84b9c106623f$export$ba8940dfd066ccd2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $f7lNm = parcelRequire("f7lNm");

var $gwrgp = parcelRequire("gwrgp");
const $4a1b84b9c106623f$export$ba8940dfd066ccd2 = (0, $gwrgp.default)("div", {
    target: "eyw3yd30"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: props.isReadingAids ? `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 20px)"} ${"var(--ds-space-150, 12px)"}` : `${"var(--ds-space-250, 20px)"} ${"var(--ds-space-300, 24px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...props.isReadingAids ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            color: `var(--ds-text-accent-gray-bolder, ${0, $6fnsQ.N800})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(${0, $f7lNm.READING_AIDS_DIALOG_WIDTH} - 40px)`,
            maxHeight: '200px',
            overflowY: 'auto'
        } : {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            color: `var(--ds-text-accent-gray, ${0, $6fnsQ.N600})`,
            maxHeight: '417px',
            overflowY: 'auto',
            width: '100%'
        }
    }));

});


parcelRegister("2K9WG", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCard", () => $1b0a370bd67241fc$export$ab2444a256fc8a9b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eRXI0 = parcelRequire("eRXI0");

var $f7lNm = parcelRequire("f7lNm");

var $dsGxu = parcelRequire("dsGxu");

var $dUnDb = parcelRequire("dUnDb");
const $1b0a370bd67241fc$export$ab2444a256fc8a9b = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, smartAnswersRoute: smartAnswersRoute } = (0, $eRXI0.useAIAnswerContext)();
    if (isAnswered && !hasError) switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).TEAM:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dUnDb.TeamKnowledgeCard), {});
        case (0, $f7lNm.QueryIntent).PERSON:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dsGxu.PersonKnowledgeCard), {});
        default:
            return null;
    }
    return null;
};

});
parcelRegister("dsGxu", function(module, exports) {

$parcel$export(module.exports, "PersonKnowledgeCard", () => $15b9dd3fbe2aca4e$export$8cdcd522f66fdfa8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $7gpC4 = parcelRequire("7gpC4");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $yDu1E = parcelRequire("yDu1E");

var $2YIh2 = parcelRequire("2YIh2");

var $e31DP = parcelRequire("e31DP");

var $eRXI0 = parcelRequire("eRXI0");

var $jLyYG = parcelRequire("jLyYG");

var $7Zbm6 = parcelRequire("7Zbm6");

var $5y8jR = parcelRequire("5y8jR");

var $cVtio = parcelRequire("cVtio");

var $8UaTW = parcelRequire("8UaTW");

var $6vDlQ = parcelRequire("6vDlQ");

var $eAA5e = parcelRequire("eAA5e");

var $fJBWn = parcelRequire("fJBWn");

var $9s72r = parcelRequire("9s72r");

var $3OmGD = parcelRequire("3OmGD");

var $hACT7 = parcelRequire("hACT7");

var $3oSWM = parcelRequire("3oSWM");

var $gsbO5 = parcelRequire("gsbO5");

var $5iH4l = parcelRequire("5iH4l");
const $15b9dd3fbe2aca4e$var$ScrollableContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    margin: 'auto',
    marginBottom: 'space.100',
    display: 'flex'
});
const $15b9dd3fbe2aca4e$var$CardContainerStyles = (0, $ecnYn.xcss)({
    borderRadius: "var(--ds-border-radius-100, 4px)",
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $15b9dd3fbe2aca4e$var$PersonCardWrapperStyles = (0, $ecnYn.xcss)({
    width: '180px',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    height: '100%'
});
const $15b9dd3fbe2aca4e$var$USERS_SCROLL_OFFSET = 392;
const $15b9dd3fbe2aca4e$var$messages = (0, $2nPZH.defineMessages)({
    multiple_people_matches_header: {
        id: "search_ai.knowledge_cards.multiple_people_matches_header",
        defaultMessage: "People matches"
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    }
});
const $15b9dd3fbe2aca4e$var$TopicsNotRelevantCheckbox = ({ topicsNotRelevant: topicsNotRelevant, setTopicsNotRelevant: setTopicsNotRelevant })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const toggleTopicsNotRelevantCheckbox = (0, $gwFzn.useCallback)(()=>{
        setTopicsNotRelevant(!topicsNotRelevant);
    }, [
        setTopicsNotRelevant,
        topicsNotRelevant
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
        label: formatMessage($15b9dd3fbe2aca4e$var$messages.ai_answer_component_topics_not_relevant_checkbox_label),
        onChange: toggleTopicsNotRelevantCheckbox,
        isChecked: topicsNotRelevant
    });
};
const $15b9dd3fbe2aca4e$var$IndividualPersonKnowledgeCard = ({ feedbackOptions: feedbackOptions, primaryUser: primaryUser })=>{
    const { showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const [topicsNotRelevant, setTopicsNotRelevant] = (0, $gwFzn.useState)(false);
    const customFeedbackOptions = (0, $dh538.fg)('platform_search-ai_related-entities') ? {
        ...feedbackOptions,
        attributes: {
            ...feedbackOptions.attributes,
            topicsNotRelevant: topicsNotRelevant ? true : undefined
        },
        customContent: /*#__PURE__*/ (0, $7UHDa.jsx)($15b9dd3fbe2aca4e$var$TopicsNotRelevantCheckbox, {
            topicsNotRelevant: topicsNotRelevant,
            setTopicsNotRelevant: setTopicsNotRelevant
        })
    } : feedbackOptions;
    if (!primaryUser) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: customFeedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                xcss: $15b9dd3fbe2aca4e$var$CardContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hACT7.KnowledgeCardsHeader), {
                        type: (0, $gsbO5.KnowledgeCardsIntentType).PERSON,
                        accountId: primaryUser.account_id,
                        name: primaryUser.name,
                        email: primaryUser.email,
                        avatarUrl: primaryUser.avatar_url,
                        profileUrl: primaryUser.profile_url,
                        jobTitle: primaryUser.job_title,
                        department: primaryUser.department,
                        location: primaryUser.location,
                        time: primaryUser.time
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3oSWM.SeparatorLine), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3OmGD.KnowledgeCardsBody), {
                        type: (0, $gsbO5.KnowledgeCardsIntentType).PERSON,
                        currentUserId: primaryUser.account_id ?? '',
                        recommendedUsers: primaryUser.collaborators || [],
                        recentActivity: primaryUser.recentActivity || [],
                        profileUrl: primaryUser.profile_url || ''
                    })
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};
const $15b9dd3fbe2aca4e$export$8cdcd522f66fdfa8 = ()=>{
    const { commonAttributes: commonAttributes, userDetails: { id: requestingUserId }, setData: setData, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const activityClient = (0, $e31DP.useActivityClient)('v3', 'people');
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [selectedUser, setSelectedUser] = (0, $gwFzn.useState)();
    const [primaryUser, setPrimaryUser] = (0, $gwFzn.useState)();
    const { answerString: answerString, cloudId: cloudId } = commonAttributes;
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    const userResults = (0, $5y8jR.getTypedJSONResultData)(answerString).parsedResult;
    const ScrollWrapper = userResults.length > 3 ? (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $yDu1E.HorizontalScrollContainer), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $15b9dd3fbe2aca4e$var$ScrollableContainerStyles,
                children: props.children
            })
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    const getHandleSelectUser = (0, $gwFzn.useCallback)((index)=>()=>{
            setSelectedUser(index);
        }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (userResults.length === 1) setSelectedUser(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userResults
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const fetchData = async ()=>{
            if (selectedUser !== undefined) return (0, $9s72r.fetchPrimaryUserData)({
                accountId: userResults[selectedUser].id,
                tenantId: cloudId,
                requestingUserId: requestingUserId || '',
                activityClient: activityClient,
                locale: locale
            }).then((data)=>{
                setPrimaryUser(data);
            }).catch((error)=>{
                setData({
                    errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                    disclaimer: null,
                    format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                    nlpResults: [],
                    uniqueSources: [],
                    nlpFollowUpResults: null
                });
            });
        };
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedUser
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardShown)({
            ...commonAttributes,
            cardType: (0, $gsbO5.KnowledgeCardsIntentType).PERSON
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (userResults.length === 0) return null;
    if (selectedUser !== undefined || userResults.length === 1) return /*#__PURE__*/ (0, $7UHDa.jsx)($15b9dd3fbe2aca4e$var$IndividualPersonKnowledgeCard, {
        feedbackOptions: feedbackOptions,
        primaryUser: primaryUser
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            (0, $dh538.fg)('kd_smart_answers_update_person_carousel') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eAA5e.KnowledgeCarousel), {
                headingText: formatMessage($15b9dd3fbe2aca4e$var$messages.multiple_people_matches_header),
                scrollOffset: $15b9dd3fbe2aca4e$var$USERS_SCROLL_OFFSET,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    space: "space.200",
                    children: userResults.map((user, index)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            onClick: getHandleSelectUser(index),
                            xcss: $15b9dd3fbe2aca4e$var$PersonCardWrapperStyles,
                            testId: "person-knowledge-card-wrapper",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2YIh2.PersonCard), {
                                data: {
                                    id: user.id,
                                    name: user.name,
                                    jobTitle: user.title ?? '',
                                    avatarUrl: user.avatarUrl,
                                    localTime: (0, $5iH4l.formatTimeKnowledgeCard)({
                                        locale: locale,
                                        zoneInfo: user.zoneInfo
                                    }),
                                    location: user.location ?? ''
                                }
                            })
                        }, user.id))
                })
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)(ScrollWrapper, {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    space: "space.200",
                    children: userResults.map((user, index)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            onClick: getHandleSelectUser(index),
                            xcss: $15b9dd3fbe2aca4e$var$PersonCardWrapperStyles,
                            testId: "person-knowledge-card-wrapper",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2YIh2.PersonCard), {
                                data: {
                                    id: user.id,
                                    name: user.name,
                                    jobTitle: user.title ?? '',
                                    avatarUrl: user.avatarUrl,
                                    localTime: (0, $5iH4l.formatTimeKnowledgeCard)({
                                        locale: locale,
                                        zoneInfo: user.zoneInfo
                                    }),
                                    location: user.location ?? ''
                                }
                            })
                        }, user.id))
                })
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};

});
parcelRegister("yDu1E", function(module, exports) {

$parcel$export(module.exports, "HorizontalScrollContainer", () => $9c7756fe8b395d80$export$8e346a7c6ff89602);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $fVdiF = parcelRequire("fVdiF");

var $1qfLF = parcelRequire("1qfLF");

var $kiq1W = parcelRequire("kiq1W");

var $hNEaN = parcelRequire("hNEaN");

var $u9agA = parcelRequire("u9agA");

var $66n2Z = parcelRequire("66n2Z");
const $9c7756fe8b395d80$var$atlaskitCssStyles = {
    containerStyles: "_1e0c1txw _kqswh2mm _4cvr1h6o",
    hoverButtonStyle: "_kqswstnw _1pby1nn1 _80omtlke _4t3i1osq _1e0c1txw _4cvr1h6o"
};
const $9c7756fe8b395d80$var$leftStyle = null;
const $9c7756fe8b395d80$var$rightStyle = null;
const $9c7756fe8b395d80$var$scrollContainerStyle = null;
const $9c7756fe8b395d80$var$OFFSET = 250;
const $9c7756fe8b395d80$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $9c7756fe8b395d80$var$isScrollAtRight = (elem)=>elem ? // https://stackoverflow.com/questions/3898130/check-if-a-user-has-scrolled-to-the-bottom-not-just-the-window-but-any-element
    Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $9c7756fe8b395d80$export$8e346a7c6ff89602 = ({ children: children })=>{
    const ref = (0, $gwFzn.useRef)(null);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [shouldHideLeft, setShouldHideLeft] = (0, $gwFzn.useState)(false);
    const [shouldHideRight, setShouldHideRight] = (0, $gwFzn.useState)(false);
    const [onScroll] = (0, $fVdiF.default)(()=>{
        setShouldHideLeft($9c7756fe8b395d80$var$isScrollAtLeft(ref.current));
        setShouldHideRight($9c7756fe8b395d80$var$isScrollAtRight(ref.current));
    }, 10);
    (0, $gwFzn.useEffect)(()=>{
        setShouldHideLeft($9c7756fe8b395d80$var$isScrollAtLeft(ref.current));
        setShouldHideRight($9c7756fe8b395d80$var$isScrollAtRight(ref.current));
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        xcss: $9c7756fe8b395d80$var$atlaskitCssStyles.containerStyles,
        children: [
            !shouldHideLeft && /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $9c7756fe8b395d80$var$atlaskitCssStyles.hoverButtonStyle,
                    "_11q7gdee _1ltvidpf _1qn1u2gc"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kiq1W))), {
                            ...iconProps,
                            size: "small"
                        }),
                    isTooltipDisabled: true,
                    label: formatMessage((0, $66n2Z.messages).scrollLeft),
                    onClick: ()=>{
                        ref.current?.scrollBy({
                            top: 0,
                            left: -$9c7756fe8b395d80$var$OFFSET,
                            behavior: 'smooth'
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                ref: ref,
                onScroll: onScroll,
                className: (0, $35pXk.default)([
                    "_zulpu2gc _1ul91ob8 _1e0c1txw _1reo1wug _18m915vq"
                ]),
                children: children
            }),
            !shouldHideRight && /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $9c7756fe8b395d80$var$atlaskitCssStyles.hoverButtonStyle,
                    "_11q71y1v _1xi2idpf _1bcru2gc"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hNEaN))), {
                            ...iconProps,
                            size: "small"
                        }),
                    isTooltipDisabled: true,
                    label: formatMessage((0, $66n2Z.messages).scrollRight),
                    onClick: ()=>{
                        ref.current?.scrollBy({
                            top: 0,
                            left: $9c7756fe8b395d80$var$OFFSET,
                            behavior: 'smooth'
                        });
                    }
                })
            })
        ]
    });
};

});
parcelRegister("hNEaN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf562ccc4c791e7c$var$_react = $cf562ccc4c791e7c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $cf562ccc4c791e7c$var$_chevronRight = $cf562ccc4c791e7c$var$_interopRequireDefault((parcelRequire("6R5uz")));

var $cf562ccc4c791e7c$var$_chevronRightLarge = $cf562ccc4c791e7c$var$_interopRequireDefault((parcelRequire("dskUg")));
function $cf562ccc4c791e7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf562ccc4c791e7c$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $cf562ccc4c791e7c$var$_react.default.createElement($cf562ccc4c791e7c$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $cf562ccc4c791e7c$var$_chevronRightLarge.default
    }, props));
$cf562ccc4c791e7c$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $cf562ccc4c791e7c$var$_default = module.exports.default = $cf562ccc4c791e7c$var$ChevronRightIcon;

});

parcelRegister("66n2Z", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2e1f41273e93e29c$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $2e1f41273e93e29c$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    scrollLeft: {
        id: "horizontal-scroll-container.scroll-left",
        defaultMessage: "Scroll left"
    },
    scrollRight: {
        id: "horizontal-scroll-container.scroll-right",
        defaultMessage: "Scroll right"
    }
});

});


parcelRegister("2YIh2", function(module, exports) {

$parcel$export(module.exports, "PersonCard", () => $2fb19ef32ab04e83$export$4c094c8f61edecb4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $4JDbp = parcelRequire("4JDbp");

var $g91Ox = parcelRequire("g91Ox");
const $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT = 180;
const $2fb19ef32ab04e83$var$styles = {
    emptyLine: "_4t3igktf"
};
function $2fb19ef32ab04e83$export$4c094c8f61edecb4({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(0);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $g91Ox.PersonCardWrapper), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                        src: avatarUrl,
                        name: name,
                        size: width < $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                size: "medium",
                                weight: "medium",
                                align: "center",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                ...(0, $dh538.fg)('enable_text_cut_on_card_fix') ? {
                                    maxLines: 2
                                } : {
                                    maxLines: 1
                                },
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                xcss: $2fb19ef32ab04e83$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("g91Ox", function(module, exports) {

$parcel$export(module.exports, "PersonCardWrapper", () => $ead1b65abe4e11c5$export$a3474cd1dd8e70a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $gdv5Z = parcelRequire("gdv5Z");
const $ead1b65abe4e11c5$var$wrapperStyles = {
    root: "_2rkopd34 _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6dmuej _1bsb1osq _4t3i1osq _1ul91lit _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqswh2mm _9oik18uv _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $ead1b65abe4e11c5$export$a3474cd1dd8e70a = ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ead1b65abe4e11c5$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};

});


parcelRegister("jLyYG", function(module, exports) {

$parcel$export(module.exports, "useSmartAnswerCardFeedbackOptions", () => $62c12b100a19433b$export$7cac3b748a811283);

var $dh538 = parcelRequire("dh538");

var $fYQcF = parcelRequire("fYQcF");

var $4jIuc = parcelRequire("4jIuc");

var $cVtio = parcelRequire("cVtio");

var $f7lNm = parcelRequire("f7lNm");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");
function $62c12b100a19433b$export$7cac3b748a811283() {
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, updateContextCache: updateContextCache, userDetails: userDetails } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query, errorState: errorState, searchSessionId: searchSessionId, source: source, queryHash: queryHash, cloudId: cloudId, answerString: answerString } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const onLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $4xTru.onLikeButtonClick)(commonAttributes));
        if ((0, $dh538.fg)('kd_enable_new_usage_tracking')) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
        else trackAIFeedbackSubmit('up');
    };
    const onDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $4xTru.onDislikeButtonClick)(commonAttributes));
        if ((0, $dh538.fg)('kd_enable_new_usage_tracking')) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
        else trackAIFeedbackSubmit('down');
    };
    const feedbackAttributes = {
        searchSessionId: searchSessionId,
        source: source,
        queryHash: queryHash,
        cloudId: cloudId,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState
    };
    const feedbackAttributesWithConsent = {
        prompt: query,
        answer: answerString
    };
    const feedbackOptions = {
        attributes: feedbackAttributes,
        attributesWithConsent: feedbackAttributesWithConsent,
        entrypointId: (0, $f7lNm.FEEDBACK_ENTRYPOINT_ID_SAIN),
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        userDetails: userDetails
    };
    return feedbackOptions;
}

});
parcelRegister("4xTru", function(module, exports) {

$parcel$export(module.exports, "onAIAnswerDialogQueryIntent", () => $ff3ce01b804423d2$export$17e25c724e0ebb55);
$parcel$export(module.exports, "onAIAnswerDialogDroppedOff", () => $ff3ce01b804423d2$export$cae33476d80498a);
$parcel$export(module.exports, "onAIAnswerDialogHidden", () => $ff3ce01b804423d2$export$e1c446b3b8b22ff);
$parcel$export(module.exports, "onAIAnswerDialogViewed", () => $ff3ce01b804423d2$export$e9cccbc780a694f3);
$parcel$export(module.exports, "onAIAnswerLoadingDialogShown", () => $ff3ce01b804423d2$export$a43930cde520e30);
$parcel$export(module.exports, "onSmartAnswerRouteDetection", () => $ff3ce01b804423d2$export$67b8bcd639e29c44);
$parcel$export(module.exports, "onAIAnswerDialogUnmount", () => $ff3ce01b804423d2$export$c075b0a4ec670c87);
$parcel$export(module.exports, "onAIAnswerResultShown", () => $ff3ce01b804423d2$export$bc6497c5d340e00a);
$parcel$export(module.exports, "onNonGenerativeAIAnswerResultShown", () => $ff3ce01b804423d2$export$5a7faebf1192b4e4);
$parcel$export(module.exports, "onAIAnswerNotShown", () => $ff3ce01b804423d2$export$bd496fce1657ba31);
$parcel$export(module.exports, "aiAnswerExpandClicked", () => $ff3ce01b804423d2$export$a499208a458c0e59);
$parcel$export(module.exports, "aiAnswerCollapseClicked", () => $ff3ce01b804423d2$export$d5927f4d78af7f29);
$parcel$export(module.exports, "aiAnswerExpandShown", () => $ff3ce01b804423d2$export$9402fab525dc0906);
$parcel$export(module.exports, "onAIAnswerSourceClick", () => $ff3ce01b804423d2$export$aef55698754fc321);
$parcel$export(module.exports, "onAIAnswerReturnLinkClick", () => $ff3ce01b804423d2$export$e7233899affc4477);
$parcel$export(module.exports, "onLikeButtonClick", () => $ff3ce01b804423d2$export$5b155f527aff26b9);
$parcel$export(module.exports, "onDislikeButtonClick", () => $ff3ce01b804423d2$export$c4c8b81ee90e6af2);
$parcel$export(module.exports, "onFollowUpSuggestionClick", () => $ff3ce01b804423d2$export$f1956b3bd380b51e);
$parcel$export(module.exports, "onOpenChatButtonClick", () => $ff3ce01b804423d2$export$689a00fa0f31e3ff);
$parcel$export(module.exports, "onExpandButtonClicked", () => $ff3ce01b804423d2$export$e6174e7fdfd73609);
$parcel$export(module.exports, "onWhoPrimaryViewProfileClick", () => $ff3ce01b804423d2$export$924cae8b31b3ec43);
$parcel$export(module.exports, "onWhoPrimaryViewProfileContextMenuClick", () => $ff3ce01b804423d2$export$7bc7dfa120866cd2);
$parcel$export(module.exports, "onWhoPrimaryCoordinationPillClick", () => $ff3ce01b804423d2$export$da5ff760e0ba649b);
$parcel$export(module.exports, "onWhoPrimaryCoordinationPillContextMenuClick", () => $ff3ce01b804423d2$export$305f2a0f7fa9a25f);
$parcel$export(module.exports, "onWhoAdditionalMatchProfileClick", () => $ff3ce01b804423d2$export$4bb2ae9dc67cd713);
$parcel$export(module.exports, "onWhoAdditionalMatchProfileContextMenuClick", () => $ff3ce01b804423d2$export$caffb77a39b6cd1);
$parcel$export(module.exports, "onRecentWorkItemClick", () => $ff3ce01b804423d2$export$5c8be2d1a7dc557);
$parcel$export(module.exports, "onRecentWorkItemContextMenuClick", () => $ff3ce01b804423d2$export$440c60ade2f202a9);
$parcel$export(module.exports, "onRecentWorkLinkClick", () => $ff3ce01b804423d2$export$b22e9ed865dfbcfa);
$parcel$export(module.exports, "onRecentWorkLinkContextMenuClick", () => $ff3ce01b804423d2$export$3eb2378888745842);
$parcel$export(module.exports, "onCuratedDefinitionEditButtonClicked", () => $ff3ce01b804423d2$export$f32beb894f554d19);
$parcel$export(module.exports, "onCuratedDefinitionEditButtonShown", () => $ff3ce01b804423d2$export$9dee3cc92d823001);

var $01aV7 = parcelRequire("01aV7");

var $cqFuK = parcelRequire("cqFuK");
const $ff3ce01b804423d2$export$17e25c724e0ebb55 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'surfaced',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'queryIntent',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$cae33476d80498a = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dropoff',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$e1c446b3b8b22ff = (props, dwellTime)=>{
    const { query: query, source: source } = props;
    return {
        action: 'hidden',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            dwellTime: dwellTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$e9cccbc780a694f3 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$a43930cde520e30 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$67b8bcd639e29c44 = (props, smartAnswersRoute)=>{
    const { query: query, source: source } = props;
    return {
        action: 'classified',
        actionSubject: 'aiAnswerRoute',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            smartAnswersRoute: smartAnswersRoute
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$c075b0a4ec670c87 = ({ isReadingAids: isReadingAids, sourceProduct: sourceProduct, dwellTime: dwellTime, loadTime: loadTime, ...props })=>{
    const { query: query, source: source, searchSessionId: searchSessionId } = props;
    return {
        action: 'unmounted',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
            aiInteractionId: isReadingAids ? undefined : searchSessionId,
            aiInteractionType: isReadingAids ? undefined : 'searchSessionId',
            dwellTime: dwellTime,
            loadTime: loadTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$bc6497c5d340e00a = ({ isStreamed: isStreamed, loadTime: loadTime, ...props })=>{
    const { query: query, answerString: answerString, source: source, cloudId: cloudId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            cloudId: cloudId,
            isStreamed: isStreamed,
            loadTime: loadTime
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$5a7faebf1192b4e4 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerString: answerString })=>{
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$bd496fce1657ba31 = ({ isStreamed: isStreamed, loadTime: loadTime, ...props })=>{
    const { query: query, answerString: answerString, source: source, errorState: errorState } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerError',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            isStreamed: isStreamed,
            loadTime: loadTime,
            errorState: errorState
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$a499208a458c0e59 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$d5927f4d78af7f29 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCollapse',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$9402fab525dc0906 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$aef55698754fc321 = ({ sourceIndex: sourceIndex, isCitation: isCitation, hostname: hostname, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            sourceIndex: sourceIndex,
            isCitation: isCitation,
            ...hostname ? {
                metadata: {
                    hostname: hostname
                }
            } : {}
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$3dedd72888bd21a1 = ({ sourceIndex: sourceIndex, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            sourceIndex: sourceIndex
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$e6acda7cbaefba32 = ({ expanded: expanded, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            expanded: expanded
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$e7233899affc4477 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReturnLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$9daed4df08e246d1 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReportButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$f1956b3bd380b51e = ({ followUpString: followUpString, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiFollowUpSuggestion',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            followUpHash: (0, $01aV7.sha256Hash)(followUpString)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            followUpString: followUpString
        }
    };
};
const $ff3ce01b804423d2$export$689a00fa0f31e3ff = ({ experimentCohort: experimentCohort, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerOpenChatButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            experimentCohort: experimentCohort
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$e6174e7fdfd73609 = ({ expandButtonSource: expandButtonSource, ...props })=>{
    const { query: query } = props;
    return {
        action: 'clicked',
        actionSubject: 'expandButton',
        actionSubjectId: expandButtonSource,
        source: props.source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
const $ff3ce01b804423d2$export$924cae8b31b3ec43 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};
const $ff3ce01b804423d2$export$7bc7dfa120866cd2 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};
const $ff3ce01b804423d2$export$da5ff760e0ba649b = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};
const $ff3ce01b804423d2$export$305f2a0f7fa9a25f = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};
const $ff3ce01b804423d2$export$4bb2ae9dc67cd713 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};
const $ff3ce01b804423d2$export$caffb77a39b6cd1 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};
const $ff3ce01b804423d2$export$5c8be2d1a7dc557 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$440c60ade2f202a9 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$b22e9ed865dfbcfa = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$3eb2378888745842 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$f32beb894f554d19 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$ff4d21c4c98bfb06 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionNextButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $ff3ce01b804423d2$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $ff3ce01b804423d2$export$9dee3cc92d823001 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};

});


parcelRegister("8UaTW", function(module, exports) {

$parcel$export(module.exports, "AIAnswerBottomBookend", () => $0aa5eeefd6bd9a49$export$a36418c334084ee3);
/* ai-answer-bottom-bookend.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4vzBZ = parcelRequire("4vzBZ");

var $2Nwuj = parcelRequire("2Nwuj");

var $lAFHW = parcelRequire("lAFHW");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");

var $f7lNm = parcelRequire("f7lNm");

var $7lL49 = parcelRequire("7lL49");
const $0aa5eeefd6bd9a49$var$styles = {
    container: "_1doce4h9 _1il9nqa1 _1o3imuej _ca0qu2gc _n3tdu2gc"
};
function $0aa5eeefd6bd9a49$export$a36418c334084ee3() {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $0aa5eeefd6bd9a49$var$styles.container,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #626F86)",
                            spacing: "spacious"
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: (0, $f7lNm.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                size: "small",
                                children: formatMessage((0, $7lL49.messages).ai_answer_dialog_footer_content_quality_long)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: (0, $f7lNm.ATLASSIAN_ROVO_LINK),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                size: "small",
                                children: "Rovo"
                            })
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAFHW.RovoIcon), {
                            label: "",
                            appearance: "neutral",
                            size: "small"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("6vDlQ", function(module, exports) {

$parcel$export(module.exports, "AIAnswerTopBookend", () => $17c3e18e1d247f21$export$c9196fac1ab5688c);
/* ai-answer-top-bookend.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7hXDW = parcelRequire("7hXDW");

var $u9agA = parcelRequire("u9agA");

var $8s0lk = parcelRequire("8s0lk");
const $17c3e18e1d247f21$var$styles = {
    container: "_4t3i1ul9 _85i51b66"
};
const $17c3e18e1d247f21$var$messages = (0, $2nPZH.defineMessages)({
    heading: {
        id: "search_ai.ai_answer_top_bookend.heading",
        defaultMessage: "Overview"
    }
});
function $17c3e18e1d247f21$export$c9196fac1ab5688c({ showFeedbackButtons: showFeedbackButtons, feedbackOptions: feedbackOptions }) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $17c3e18e1d247f21$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                as: "h2",
                size: "xsmall",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$17c3e18e1d247f21$var$messages.heading
                })
            }),
            showFeedbackButtons ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8s0lk.AIFeedbackV2), {
                entrypointId: feedbackOptions.entrypointId,
                userDetails: feedbackOptions.userDetails,
                attributes: feedbackOptions.attributes,
                attributesWithConsent: feedbackOptions.attributesWithConsent,
                onLikeButtonClickHandler: feedbackOptions.onLikeButtonClickHandler,
                onDislikeButtonClickHandler: feedbackOptions.onDislikeButtonClickHandler,
                customContent: feedbackOptions.customContent,
                isCompact: true
            }) : null
        ]
    });
}

});
parcelRegister("8s0lk", function(module, exports) {

$parcel$export(module.exports, "AIFeedbackV2", () => $fb8ee5ddf0b7e055$export$204772be093f4012);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7gpC4 = parcelRequire("7gpC4");

var $6uGcC = parcelRequire("6uGcC");

var $eyWa4 = parcelRequire("eyWa4");

var $f7lNm = parcelRequire("f7lNm");

var $cVShq = parcelRequire("cVShq");

var $lKYSu = parcelRequire("lKYSu");

var $Ze1Cu = parcelRequire("Ze1Cu");

const $fb8ee5ddf0b7e055$var$AkFeedbackCollector = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i8OiN")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $fb8ee5ddf0b7e055$var$AkFeedbackFlag = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i8OiN")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $fb8ee5ddf0b7e055$export$204772be093f4012 = ({ isCompact: isCompact = false, entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike, customContent: // set like state from the outside
customContent })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const [showFeedbackModal, setFeedbackModal] = (0, $gwFzn.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const [hasConsent, setConsent] = (0, $gwFzn.useState)(false);
    const [liked, setLiked] = (0, $gwFzn.useState)(externalLike);
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $gwFzn.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Ze1Cu.AIAnswerFeedbackWrapper), {
                isCompact: isCompact,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cVShq.FeedbackButtons), {
                    setDisplayFlag: setDisplayFlag,
                    setFeedbackModal: setFeedbackModal,
                    onLikeButtonClickHandler: onLikeButtonClickHandler,
                    onDislikeButtonClickHandler: onDislikeButtonClickHandler,
                    liked: liked,
                    setLiked: setLiked
                })
            }),
            showFeedbackModal ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($fb8ee5ddf0b7e055$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>{
                        setFeedbackModal(false);
                    },
                    onSubmit: ()=>{
                        setDisplayFlag(true);
                    },
                    customContent: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $lKYSu.messages).ai_answer_component_report_consent_checkbox_label),
                                onChange: toggleConsentCheckbox,
                                isChecked: hasConsent
                            }) : undefined,
                            customContent
                        ]
                    }),
                    atlassianAccountId: userDetails.id,
                    name: userDetails.name,
                    entrypointId: entrypointId,
                    additionalFields: [
                        {
                            id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ],
                    feedbackTitle: formatMessage((0, $lKYSu.messages).ai_answer_component_report_modal_title),
                    feedbackTitleDetails: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Ze1Cu.AIAnswerReportDescriptionWrapper), {
                        children: formatMessage((0, $lKYSu.messages).ai_answer_component_report_summary_label)
                    }),
                    feedbackGroupLabels: {
                        empty: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_empty_option_share_label)
                        },
                        question: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_relevance_option_label)
                        },
                        comment: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: ''
                        },
                        bug: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: ''
                        },
                        suggestion: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_other_option_label)
                        }
                    },
                    summaryPlaceholder: formatMessage((0, $lKYSu.messages).ai_answer_component_summary_placeholder_label)
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($fb8ee5ddf0b7e055$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $lKYSu.messages).ai_answer_component_feedback_flag_description)
                    })
                })
            })
        ]
    });
};

});
parcelRegister("cVShq", function(module, exports) {

$parcel$export(module.exports, "FeedbackButtons", () => $f7d37ee6f062b97b$export$c633fc044a8b8981);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $9FnLD = parcelRequire("9FnLD");

var $cquOf = parcelRequire("cquOf");

var $6fnsQ = parcelRequire("6fnsQ");

var $3gadb = parcelRequire("3gadb");

var $lKYSu = parcelRequire("lKYSu");

var $Ze1Cu = parcelRequire("Ze1Cu");
// eslint-disable-next-line @typescript-eslint/ban-types
const $f7d37ee6f062b97b$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        position: 'top',
        content: tooltipContent,
        children: ({ onClick: onClick, ...tooltipProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                "aria-label": tooltipContent,
                spacing: 'none',
                appearance: isDisabled ? 'subtle-link' : 'subtle',
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Ze1Cu.FeedbackButtonIconWrapper), {
                    active: active,
                    ...testId && {
                        'data-testid': testId
                    },
                    isDisabled: isDisabled || false,
                    children: icon
                }),
                ...!isDisabled && {
                    onClick: onClickHandler
                },
                ...tooltipProps
            })
    });
};
const $f7d37ee6f062b97b$export$c633fc044a8b8981 = ({ liked: liked, setLiked: setLiked, setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [likesDisabled, setLikesDisabled] = (0, $gwFzn.useState)(false);
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        onLikeButtonClickHandler && onLikeButtonClickHandler();
    }, [
        setDisplayFlag,
        setLiked,
        onLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        onDislikeButtonClickHandler && onDislikeButtonClickHandler();
    }, [
        setFeedbackModal,
        setLiked,
        onDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($f7d37ee6f062b97b$var$FeedbackButton, {
                active: liked === true,
                onClick: likeButtonCallback,
                tooltipContent: formatMessage((0, $lKYSu.messages).ai_answer_component_like_button_tooltip),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                    label: "",
                    spacing: "spacious",
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                    LEGACY_fallbackIcon: (0, $cquOf.default)
                }),
                isDisabled: liked && likesDisabled,
                testId: "ai-answer-like-button"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($f7d37ee6f062b97b$var$FeedbackButton, {
                active: liked === false,
                onClick: dislikeButtonCallback,
                tooltipContent: formatMessage((0, $lKYSu.messages).ai_answer_component_dislike_button_tooltip),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Ze1Cu.Rotate180IconWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                        label: "",
                        spacing: "spacious",
                        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                        LEGACY_fallbackIcon: (0, $cquOf.default)
                    })
                }),
                isDisabled: !liked && likesDisabled,
                testId: "ai-answer-dislike-button"
            })
        ]
    });
};

});
parcelRegister("cquOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac168909bf44f28$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $6ac168909bf44f28$var$ThumbUpIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.25343 11.2414C8.91051 10.9653 8.47456 10.8 8 10.8H7C5.89543 10.8 5 11.6954 5 12.8V16.8C5 17.9046 5.89543 18.8 7 18.8H8C8.67485 18.8 9.27163 18.4657 9.63383 17.9538C10.2849 18.3768 10.7807 18.662 11.3054 18.8277C12.0107 19.0504 12.7452 19.0503 13.8834 19.05L14 19.05C15.0903 19.05 15.9813 18.8458 16.6904 18.4322C17.4092 18.0129 17.8817 17.4128 18.1854 16.7296C18.7507 15.4577 18.7503 13.8227 18.75 12.3982L18.75 12.3C18.75 11.5224 18.51 10.8745 17.9772 10.4585C17.4757 10.0669 16.8553 9.99471 16.337 10.021C15.9545 10.0404 15.5603 10.1174 15.1903 10.2181C15.3396 9.59744 15.3911 9.06134 15.3574 8.60069C15.2973 7.77936 14.9562 7.15144 14.3859 6.80924C13.8454 6.48496 13.2272 6.49699 12.7564 6.6704C12.3346 6.82578 11.75 7.23911 11.75 7.95222C11.75 9.50422 10.5995 10.64 9.25343 11.2414ZM9.98525 12.5558C11.5349 11.8264 13.1841 10.3475 13.2481 8.08854C13.256 8.08517 13.2649 8.08163 13.2749 8.07796C13.3978 8.03268 13.5296 8.04474 13.6141 8.09547C13.6688 8.12827 13.8277 8.25033 13.8614 8.71016C13.8966 9.19143 13.7825 9.9764 13.3037 11.1735C13.1901 11.4574 13.2602 11.7817 13.4809 11.9934C13.7015 12.205 14.0286 12.2615 14.3074 12.1362C14.8088 11.9109 15.6934 11.5555 16.413 11.5191C16.7697 11.501 16.9618 11.5688 17.0541 11.6408C17.115 11.6884 17.25 11.8276 17.25 12.3C17.25 13.8528 17.2363 15.1716 16.8147 16.1204C16.6183 16.5622 16.3408 16.8996 15.9346 17.1365C15.5187 17.3792 14.9098 17.55 14 17.55C12.7053 17.55 12.2155 17.5421 11.7571 17.3973C11.3369 17.2646 10.9234 17.0108 10 16.3982V12.8C10 12.7173 9.99499 12.6359 9.98525 12.5558ZM13.1916 8.1224C13.1904 8.12189 13.1946 8.11685 13.2077 8.10879C13.1994 8.11888 13.1928 8.12291 13.1916 8.1224ZM7 12.3H8C8.27614 12.3 8.5 12.5238 8.5 12.8V16.8C8.5 17.0761 8.27614 17.3 8 17.3H7C6.72386 17.3 6.5 17.0761 6.5 16.8V12.8C6.5 12.5238 6.72386 12.3 7 12.3Z",
            fill: "currentColor"
        })
    });
/**
 * __ThumbUpIcon__
 */ const $6ac168909bf44f28$var$ThumbUpIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $6ac168909bf44f28$var$ThumbUpIconGlyph
    });
var $6ac168909bf44f28$export$2e2bcd8739ae039 = $6ac168909bf44f28$var$ThumbUpIcon;

});

parcelRegister("lKYSu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9f9db0398a2d685d$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $9f9db0398a2d685d$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the response? Let us know what happened."
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    }
});

});

parcelRegister("Ze1Cu", function(module, exports) {

$parcel$export(module.exports, "AIAnswerFeedbackWrapper", () => $49ca0736ce81ccf3$export$71c5dacfc0533c82);
$parcel$export(module.exports, "AIAnswerReportDescriptionWrapper", () => $49ca0736ce81ccf3$export$8b91051e793e6316);
$parcel$export(module.exports, "Rotate180IconWrapper", () => $49ca0736ce81ccf3$export$8b5c58bc12f52d53);
$parcel$export(module.exports, "FeedbackButtonIconWrapper", () => $49ca0736ce81ccf3$export$5d384d799a8fb604);
/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 
var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $49ca0736ce81ccf3$export$71c5dacfc0533c82 = (0, $gwrgp.default)("div", {
    target: "exoplrc0"
})(({ isCompact: isCompact })=>({
        display: 'flex',
        alignItems: 'center',
        gap: isCompact ? "var(--ds-space-025, 2px)" : "var(--ds-space-100, 8px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: `var(--ds-text-accent-gray, ${0, $6fnsQ.N200})`,
        padding: isCompact ? 'unset' : `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`
    }));
const $49ca0736ce81ccf3$export$8b91051e793e6316 = (0, $gwrgp.default)("div", {
    target: "exoplrc1"
})({
    name: "etaml6",
    styles: "padding-bottom:var(--ds-space-200, 16px);"
});
const $49ca0736ce81ccf3$export$8b5c58bc12f52d53 = (0, $gwrgp.default)("span", {
    target: "exoplrc2"
})({
    name: "fn70mm",
    styles: "svg{transform:rotate(180deg);}"
});
const $49ca0736ce81ccf3$export$5d384d799a8fb604 = (0, $gwrgp.default)("span", {
    target: "exoplrc3"
})(({ active: active, isDisabled: isDisabled })=>({
        svg: {
            color: active ? (0, $6fnsQ.B300) : `${`var(--ds-text-subtlest, ${0, $6fnsQ.N200})`} !important`
        },
        cursor: isDisabled ? 'not-allowed' : 'default'
    }));

});


parcelRegister("i8OiN", function(module, exports) {

let $d34ffe4e69389cef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d34ffe4e69389cef$var$load("c6MKV"),
    $d34ffe4e69389cef$var$load("aZinD"),
    $d34ffe4e69389cef$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});



parcelRegister("eAA5e", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCarousel", () => $d44aca612cf62bf3$export$61c045a5252abd1d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fVdiF = parcelRequire("fVdiF");

var $1qfLF = parcelRequire("1qfLF");

var $bPdpL = parcelRequire("bPdpL");

var $5tOl1 = parcelRequire("5tOl1");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");
const $d44aca612cf62bf3$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $d44aca612cf62bf3$var$isScrollAtRight = (elem)=>elem ? Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $d44aca612cf62bf3$var$scrollContainerStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    whiteSpace: 'nowrap'
});
const $d44aca612cf62bf3$export$61c045a5252abd1d = ({ children: children, headingText: headingText, scrollOffset: scrollOffset })=>{
    const scrollContainerRef = (0, $gwFzn.useRef)(null);
    const [shouldHideLeft, setShouldHideLeft] = (0, $gwFzn.useState)(false);
    const [shouldHideRight, setShouldHideRight] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        setShouldHideLeft($d44aca612cf62bf3$var$isScrollAtLeft(scrollContainerRef.current));
        setShouldHideRight($d44aca612cf62bf3$var$isScrollAtRight(scrollContainerRef.current));
    }, []);
    const [onScroll] = (0, $fVdiF.default)(()=>{
        setShouldHideLeft($d44aca612cf62bf3$var$isScrollAtLeft(scrollContainerRef.current));
        setShouldHideRight($d44aca612cf62bf3$var$isScrollAtRight(scrollContainerRef.current));
    }, 10);
    const scrollLeft = ()=>{
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: -scrollOffset,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: scrollOffset,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        size: "large",
                        weight: "semibold",
                        children: headingText
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                        space: "space.050",
                        children: [
                            !shouldHideLeft && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                shape: "circle",
                                appearance: "subtle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                                isTooltipDisabled: true,
                                label: "",
                                onClick: scrollLeft,
                                spacing: "compact"
                            }),
                            !shouldHideRight && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                shape: "circle",
                                appearance: "subtle",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                                isTooltipDisabled: true,
                                label: "",
                                onClick: scrollRight,
                                spacing: "compact"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                ref: scrollContainerRef,
                onScroll: onScroll,
                xcss: $d44aca612cf62bf3$var$scrollContainerStyle,
                children: children
            })
        ]
    });
};

});

parcelRegister("fJBWn", function(module, exports) {

$parcel$export(module.exports, "onKnowledgeCardShown", () => $0ef9710cd4578c20$export$44d9aa4134474084);
$parcel$export(module.exports, "onKnowledgeCardLinkClick", () => $0ef9710cd4578c20$export$63a5aef02e499ea6);
$parcel$export(module.exports, "onNonGenerativeKnowledgeCardLinkClick", () => $0ef9710cd4578c20$export$89dd6b6e370100a2);

var $cqFuK = parcelRequire("cqFuK");
const $0ef9710cd4578c20$export$44d9aa4134474084 = (props)=>{
    const { source: source, cardType: cardType } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            cardType: cardType
        }
    };
};
const $0ef9710cd4578c20$export$63a5aef02e499ea6 = (props, location)=>{
    const { source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props),
            location: location
        }
    };
};
const $0ef9710cd4578c20$export$89dd6b6e370100a2 = (props)=>{
    const { answerString: answerString, brand: brand, query: query, queryHash: queryHash, searchSessionId: searchSessionId, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            brand: brand,
            queryHash: queryHash,
            searchSessionId: searchSessionId
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query
        }
    };
};

});

parcelRegister("9s72r", function(module, exports) {

$parcel$export(module.exports, "fetchPersonKnowledgeCardData", () => $95de468340d80197$export$42b7e838d0af0301);
$parcel$export(module.exports, "fetchPersonKnowledgeCardDataWithPostFiltering", () => $95de468340d80197$export$b40bb50f32e7d452);
$parcel$export(module.exports, "fetchPrimaryUserData", () => $95de468340d80197$export$3e632a26e137d79e);

var $5kTPO = parcelRequire("5kTPO");

var $7Zbm6 = parcelRequire("7Zbm6");

var $9EFEY = parcelRequire("9EFEY");

var $5iH4l = parcelRequire("5iH4l");

var $k5TLC = parcelRequire("k5TLC");
const $95de468340d80197$var$MAX_USERS = 10;
const $95de468340d80197$export$42b7e838d0af0301 = ({ personQuery: personQuery, principalUserId: principalUserId, tenantId: tenantId, intl: intl })=>{
    try {
        const requestParams = {
            context: {
                contextType: 'contributors',
                productKey: 'people',
                principalId: principalUserId,
                siteId: tenantId
            },
            includeGroups: false,
            includeTeams: false,
            includeUsers: true,
            maxNumberOfResults: $95de468340d80197$var$MAX_USERS,
            performSearchQueryOnly: true,
            query: personQuery
        };
        return (0, $5kTPO.default)(requestParams, intl).then((results)=>{
            const mappedResults = results.map((result)=>({
                    id: result.id,
                    name: result.name,
                    avatarUrl: result.avatarUrl,
                    title: result.title
                }));
            const finalResult = {
                user_metadata_only_cards: mappedResults
            };
            return {
                nlpSearch: {
                    nlpResult: JSON.stringify(finalResult),
                    uniqueSources: [],
                    disclaimer: null,
                    errorState: null,
                    format: (0, $7Zbm6.NLPSearchResultFormat).JSON
                }
            };
        }).catch((_error)=>{
            return Promise.resolve({
                nlpSearch: {
                    errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                    disclaimer: null,
                    format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                    uniqueSources: []
                }
            });
        });
    } catch (error) {
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    }
};
const $95de468340d80197$export$b40bb50f32e7d452 = ({ personQuery: personQuery, tenantId: tenantId, intl: intl, sourceProduct: sourceProduct })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $k5TLC.KnowledgeCardUserSearchQuery),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $k5TLC.KNOWLEDGE_CARD_USER_SEARCH_OPERATION_NAME)
    }).then(({ data: data, errors: errors })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error();
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON
            }
        };
    }).catch(()=>{
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $95de468340d80197$export$3e632a26e137d79e = ({ accountId: accountId, tenantId: tenantId, requestingUserId: requestingUserId, activityClient: activityClient, locale: locale })=>{
    const aggPromise = (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $k5TLC.KnowledgeCardPrimaryUserDataQuery),
        variables: {
            accountId: accountId,
            accountIdARI: `ari:cloud:identity::user/${accountId}`,
            tenantId: tenantId,
            requestingUserId: requestingUserId
        },
        operationName: (0, $k5TLC.KNOWLEDGE_CARD_PRIMARY_USER_OPERATION_NAME)
    });
    const activityPromise = activityClient.fetchActivities([
        100
    ], {
        limit: 50,
        actors: [
            `ari:cloud:identity::user/${accountId}`
        ]
    }, [
        'workedOn'
    ], false);
    return Promise.all([
        aggPromise,
        activityPromise
    ]).then(([aggResponse, activityResponse])=>{
        const primaryUserData = {
            account_id: accountId,
            name: aggResponse.data?.user.name || '',
            job_title: aggResponse.data?.user.extendedProfile?.jobTitle,
            profile_url: `/people/${accountId}`,
            avatar_url: aggResponse.data?.user.picture,
            email: aggResponse.data?.user.email,
            location: aggResponse.data?.user.extendedProfile?.location,
            department: aggResponse.data?.user.extendedProfile?.department,
            organization: aggResponse.data?.user.extendedProfile?.organization,
            time: aggResponse.data?.user.zoneinfo ? (0, $5iH4l.formatTimeKnowledgeCard)({
                locale: locale,
                zoneInfo: aggResponse.data.user.zoneinfo
            }) : undefined,
            collaborators: aggResponse.data?.smarts.recommendedUser.reduce((acc, node)=>{
                if ((0, $5iH4l.trimARI)(node.user.id) !== accountId) acc.push({
                    name: node.user.name,
                    picture: node.user.picture,
                    title: !!node.user.extendedProfile?.jobTitle ? node.user.extendedProfile.jobTitle : null,
                    url: !!node.user.id ? `/people/${(0, $5iH4l.trimARI)(node.user.id)}` : null,
                    accountId: node.user.id,
                    department: !!node.user.extendedProfile?.department ? node.user.extendedProfile.department : null,
                    email: !!node.user.email ? node.user.email : null
                });
                return acc;
            }, []),
            viewAllLink: `/people/${accountId}`,
            recentActivity: activityResponse.workedOn && activityResponse.workedOn.length > 0 ? (0, $5iH4l.sanitizeAndMapRecentWorkActivity)(activityResponse.workedOn) : []
        };
        return primaryUserData;
    });
};

});
parcelRegister("5iH4l", function(module, exports) {

$parcel$export(module.exports, "onEmailCopy", () => $8824b7954958f70c$export$f7dcb977daa6621d);
$parcel$export(module.exports, "trimARI", () => $8824b7954958f70c$export$10e7203252b63b0e);
$parcel$export(module.exports, "sanitizeAndMapRecentWorkActivity", () => $8824b7954958f70c$export$737fdf482f7ddb38);
$parcel$export(module.exports, "formatTimeKnowledgeCard", () => $8824b7954958f70c$export$b8d37f4ee3cee5b6);

var $4Zqgi = parcelRequire("4Zqgi");
const $8824b7954958f70c$export$f7dcb977daa6621d = (email)=>{
    // try catch is for the clipboard function
    try {
        navigator.clipboard.writeText(email);
    } catch (error) {
        (0, $4Zqgi.logger).error(error);
    }
};
function $8824b7954958f70c$export$10e7203252b63b0e(ari) {
    return ari.split('/').pop() || '';
}
const $8824b7954958f70c$var$MAX_CONTRIBUTORS = 3;
const $8824b7954958f70c$export$737fdf482f7ddb38 = (recentWork)=>{
    const uniqRecents = new Set();
    return recentWork.reduce((result, recentWorkItem)=>{
        const containerName = recentWorkItem.containers.length > 0 ? recentWorkItem.containers[0].name : recentWorkItem.object.product;
        // creating a key with the container name and title to
        // prevent the posibilty of multiple items with the same name
        const key = `${containerName}:${recentWorkItem.object.name || ''}`;
        if (uniqRecents.has(key)) return result;
        uniqRecents.add(key);
        const curRecentWorkItem = {
            title: recentWorkItem.object.name || '',
            url: recentWorkItem.object.url,
            containerName: containerName,
            event: recentWorkItem.eventType,
            timestamp: recentWorkItem.timestamp,
            iconUrl: !!recentWorkItem.object.icon ? recentWorkItem.object.icon.value : '',
            contributors: recentWorkItem.contributors.slice(0, 3).map((contributor)=>({
                    name: contributor.name,
                    id: contributor.accountId
                })),
            othersCount: recentWorkItem.contributors.length > $8824b7954958f70c$var$MAX_CONTRIBUTORS ? recentWorkItem.contributors.length - $8824b7954958f70c$var$MAX_CONTRIBUTORS : 0
        };
        return result.concat(curRecentWorkItem);
    }, []);
};
const $8824b7954958f70c$export$b8d37f4ee3cee5b6 = ({ locale: locale, zoneInfo: zoneInfo })=>{
    return zoneInfo ? new Date().toLocaleTimeString(locale, {
        timeZone: zoneInfo,
        hour: 'numeric',
        minute: 'numeric'
    }).replace(' ', '').toLowerCase() : undefined;
};

});

parcelRegister("k5TLC", function(module, exports) {

$parcel$export(module.exports, "KNOWLEDGE_CARD_USER_SEARCH_OPERATION_NAME", () => $d81d4d91e9de5856$export$5d21e0d2847bfa41);
$parcel$export(module.exports, "KnowledgeCardUserSearchQuery", () => $d81d4d91e9de5856$export$15ff3b6f089f4729);
$parcel$export(module.exports, "KNOWLEDGE_CARD_PRIMARY_USER_OPERATION_NAME", () => $d81d4d91e9de5856$export$4401a05b6c351189);
$parcel$export(module.exports, "KnowledgeCardPrimaryUserDataQuery", () => $d81d4d91e9de5856$export$10a5d89b90ea01b3);
const $d81d4d91e9de5856$export$5d21e0d2847bfa41 = 'KnowledgeCardUserSearchQuery';
const $d81d4d91e9de5856$export$15ff3b6f089f4729 = `
query ${$d81d4d91e9de5856$export$5d21e0d2847bfa41}($userQuery: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchUser (
        userQuery: $userQuery
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search User"){
      ... on KnowledgeDiscoveryUsers {
        users {
            name
            id
            avatarUrl
            title
            zoneInfo
            location
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $d81d4d91e9de5856$export$4401a05b6c351189 = 'KnowledgeCardPrimaryUserDataQuery';
const $d81d4d91e9de5856$export$10a5d89b90ea01b3 = `
    query ${$d81d4d91e9de5856$export$4401a05b6c351189}(
        $accountId: String!
        $accountIdARI: ID!
        $tenantId: String!
        $requestingUserId: String!
        ) {
        user(accountId: $accountIdARI) {
            id
            picture
            name
            accountStatus
            ... on AtlassianAccountUser {
                email
                zoneinfo
                extendedProfile {
                    jobTitle
                    department
                    organization
                    location
                }
            }
        }
        smarts {
            recommendedUser(recommendationsQuery: {
            context: {
                userId: $accountId, tenantId: $tenantId
            },
            modelRequestParams: {
                caller: "search-ai",
                experience: "CgUserNearbyUser"
            },
            requestingUserId: $requestingUserId,
            maxNumberOfResults: 8
            }
            ) {
            id
            user {
                id
                picture
                name
                accountStatus
                ... on AtlassianAccountUser {
                email
                extendedProfile {
                    jobTitle
                    department
                }
                }
            }
            }
        }
    }
`;

});


parcelRegister("3OmGD", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardsBody", () => $bf591491add50474$export$e450222df133e50b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $7hXDW = parcelRequire("7hXDW");

var $2Nwuj = parcelRequire("2Nwuj");

var $7bZ3i = parcelRequire("7bZ3i");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");
var $afneb = parcelRequire("afneb");

var $i6OUY = parcelRequire("i6OUY");

var $eRXI0 = parcelRequire("eRXI0");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $14qs9 = parcelRequire("14qs9");

var $7lL49 = parcelRequire("7lL49");

var $fJBWn = parcelRequire("fJBWn");

var $gUXWz = parcelRequire("gUXWz");

var $l6FRc = parcelRequire("l6FRc");

var $gsbO5 = parcelRequire("gsbO5");

var $5iH4l = parcelRequire("5iH4l");

var $gwrgp = parcelRequire("gwrgp");
const $bf591491add50474$var$BodyContainer = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $bf591491add50474$var$FullInlineStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $bf591491add50474$var$KnowledgeCardsContentStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050'
});
const $bf591491add50474$var$EmptyState = ({ text: text })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        paddingInline: "space.200",
        paddingBlock: "space.075",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            color: "color.text.subtle",
            children: text
        })
    });
};

const $bf591491add50474$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("5SHML")).then(({ HoverCard: HoverCard })=>({
            default: HoverCard
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
const $bf591491add50474$var$CardContainer = /*#__PURE__*/ (0, $gwrgp.default)((0, $afneb.default), {
    target: "exq8b6p0"
})({
    name: "1rra795",
    styles: "width:214px;height:236px;"
});
const $bf591491add50474$var$EXPANDED_MAX_ITEMS_SHOWN = 6;
const $bf591491add50474$var$MAX_ITEMS_SHOWN = 3;
const $bf591491add50474$export$e450222df133e50b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ type: type, currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: searcherId } } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $dBxQj.default)();
    const [isExpanded, setExpanded] = (0, $gwFzn.useState)(false);
    const isPerson = type === (0, $gsbO5.KnowledgeCardsIntentType).PERSON;
    const backupViewAllUrl = `https://hello.atlassian.net/people/${currentUserId}/work`;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $bf591491add50474$var$BodyContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                            grow: "fill",
                            space: "space.050",
                            xcss: $bf591491add50474$var$KnowledgeCardsContentStyles,
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                    paddingInlineStart: "space.200",
                                    paddingBlockStart: "space.150",
                                    paddingInlineEnd: "space.300",
                                    paddingBlockEnd: "space.075",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                                        spread: "space-between",
                                        alignBlock: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                                size: "xsmall",
                                                children: formatMessage((0, $7lL49.messages).knowledge_cards_recent_work_subheader)
                                            }),
                                            recentActivity.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                                                href: viewAllUrl || backupViewAllUrl,
                                                appearance: "subtle",
                                                onClick: ()=>{
                                                    fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'recent-work-view-all'));
                                                    fireSAINUsageEvent({
                                                        metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                                    color: "color.text.subtle",
                                                    children: formatMessage((0, $7lL49.messages).knowledge_cards_view_all_link)
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
                                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7bZ3i.SmartCardProvider), {
                                            children: !recentActivity.length ? /*#__PURE__*/ (0, $7UHDa.jsx)($bf591491add50474$var$EmptyState, {
                                                text: formatMessage((0, $7lL49.messages).knowledge_cards_recent_work_empty)
                                            }) : recentActivity.slice(0, !isExpanded ? $bf591491add50474$var$MAX_ITEMS_SHOWN : Math.min(recentActivity.length, $bf591491add50474$var$EXPANDED_MAX_ITEMS_SHOWN)).map((activity)=>/*#__PURE__*/ (0, $7UHDa.jsx)($bf591491add50474$var$HoverCard, {
                                                    url: activity.url,
                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gUXWz.KnowledgeCardsRow), {
                                                        primaryText: activity.title,
                                                        secondaryText: `${activity.containerName} \u{2022} ${(0, $i6OUY.descriptionHelper)({
                                                            currentUserId: searcherId || '',
                                                            event: activity.event,
                                                            contributors: activity.contributors,
                                                            othersCount: activity.othersCount,
                                                            formatMessage: formatMessage,
                                                            formatDate: formatDate,
                                                            timestamp: new Date(activity.timestamp)
                                                        })}`,
                                                        pictureUrl: activity.iconUrl,
                                                        type: (0, $gsbO5.KnowledgeCardsRowType).WORK,
                                                        onClick: ()=>{
                                                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'recent-work-item'));
                                                            fireSAINUsageEvent({
                                                                metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED
                                                            });
                                                            window.open(activity.url, '_self', 'noopener, noreferrer');
                                                        }
                                                    })
                                                }, `knowledge-card-activity-${activity.url}`))
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                            grow: "fill",
                            space: "space.050",
                            xcss: $bf591491add50474$var$KnowledgeCardsContentStyles,
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                    paddingInlineStart: "space.200",
                                    paddingBlockStart: "space.150",
                                    paddingInlineEnd: "space.150",
                                    paddingBlockEnd: "space.075",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                                        spread: "space-between",
                                        alignBlock: "center",
                                        xcss: $bf591491add50474$var$FullInlineStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                                size: "xsmall",
                                                children: isPerson ? formatMessage((0, $7lL49.messages).knowledge_cards_collaborators_subheader) : formatMessage((0, $7lL49.messages).knowledge_cards_team_members_subheader)
                                            }),
                                            recommendedUsers.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                                                href: isPerson ? `https://hello.atlassian.net/people/${currentUserId || ''}#workswith` : viewAllUrl || backupViewAllUrl,
                                                appearance: "subtle",
                                                onClick: ()=>{
                                                    if (isPerson) {
                                                        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'reporting-lines-link'));
                                                        fireSAINUsageEvent({
                                                            metCriteria: (0, $4jIuc.SainAction).REPORTING_LINES_CLICKED
                                                        });
                                                    } else {
                                                        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'recent-work-view-all'));
                                                        fireSAINUsageEvent({
                                                            metCriteria: (0, $4jIuc.SainAction).RECENT_WORK_CLICKED
                                                        });
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                                    color: "color.text.subtle",
                                                    children: formatMessage((0, $7lL49.messages).knowledge_cards_view_all_link)
                                                })
                                            })
                                        ]
                                    })
                                }),
                                !recommendedUsers.length ? /*#__PURE__*/ (0, $7UHDa.jsx)($bf591491add50474$var$EmptyState, {
                                    text: formatMessage(isPerson ? (0, $7lL49.messages).knowledge_cards_collaborators_empty : (0, $7lL49.messages).knowledge_cards_teammembers_empty)
                                }) : recommendedUsers.slice(0, !isExpanded ? $bf591491add50474$var$MAX_ITEMS_SHOWN : Math.min(recommendedUsers.length, $bf591491add50474$var$EXPANDED_MAX_ITEMS_SHOWN)).map((user)=>{
                                    const userUrl = `/people/${(0, $5iH4l.trimARI)(user.accountId || '')}`;
                                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                                        position: "bottom-end",
                                        // NOTE: In React 18, `styled(TooltipPrimitive)` does not work with this type
                                        // `styled(TooltipPrimitive)` may be better written as `(props: …) => <TooltipPrimitive css={…} {...props}>`
                                        component: $bf591491add50474$var$CardContainer,
                                        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l6FRc.PersonCard), {
                                            name: user.name,
                                            profilePicUrl: user.picture || '',
                                            jobTitle: user.title,
                                            profileUrl: user.url || userUrl,
                                            email: user.email
                                        }, user.accountId),
                                        children: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gUXWz.KnowledgeCardsRow), {
                                                primaryText: user.name,
                                                secondaryText: !!user.title || !!user.department ? [
                                                    user.title,
                                                    user.department
                                                ].filter((str)=>!!str).join(', ') : '',
                                                pictureUrl: user.picture || '',
                                                type: (0, $gsbO5.KnowledgeCardsRowType).PERSON,
                                                triggerProps: triggerProps,
                                                onClick: ()=>{
                                                    fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'user-list-item'));
                                                    fireSAINUsageEvent({
                                                        metCriteria: (0, $4jIuc.SainAction).TEAM_MEMBER_CLICKED
                                                    });
                                                    window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
                                                }
                                            })
                                    }, user.accountId);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    paddingInline: "space.200",
                    paddingBlockStart: "space.050",
                    paddingBlockEnd: "space.075",
                    children: recommendedUsers.length > $bf591491add50474$var$MAX_ITEMS_SHOWN || recentActivity.length > $bf591491add50474$var$MAX_ITEMS_SHOWN ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                        alignInline: "center",
                        space: "space.025",
                        children: isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                            href: profileUrl || '',
                            onClick: ()=>{
                                fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'footer-view-all'));
                                fireSAINUsageEvent({
                                    metCriteria: isPerson ? (0, $4jIuc.SainAction).VIEW_PROFILE_CLICKED : (0, $4jIuc.SainAction).VIEW_TEAM_PAGE_CLICKED
                                });
                            },
                            spacing: "compact",
                            appearance: "subtle",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                color: "color.text.subtlest",
                                weight: "medium",
                                children: isPerson ? formatMessage((0, $7lL49.messages).ai_answer_who_questions_view_profile) : formatMessage((0, $7lL49.messages).knowledge_cards_view_team)
                            })
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            onClick: ()=>{
                                setExpanded((e)=>!e);
                                fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'show-more'));
                                fireSAINUsageEvent({
                                    metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED
                                });
                            },
                            spacing: "compact",
                            appearance: "subtle",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                color: "color.text.subtlest",
                                weight: "medium",
                                children: formatMessage((0, $7lL49.messages).ai_answer_expand_button_label)
                            })
                        })
                    }) : null
                })
            ]
        })
    });
});

});
parcelRegister("i6OUY", function(module, exports) {

$parcel$export(module.exports, "descriptionHelper", () => $f0eed913fd2c0cbd$export$4d98da88c6a5014a);

var $6ZWwm = parcelRequire("6ZWwm");

var $3rf5d = parcelRequire("3rf5d");

var $5e9iX = parcelRequire("5e9iX");
const $f0eed913fd2c0cbd$export$4d98da88c6a5014a = ({ currentUserId: currentUserId, event: event, contributors: contributors, othersCount: othersCount, timestamp: timestamp, formatMessage: formatMessage, formatDate: formatDate })=>{
    const involvesCurrentUser = contributors.some((contributor)=>contributor.id === currentUserId);
    // If the event is singular with a single contributor
    if (contributors.length === 1) {
        const formattedDate = formatDate(timestamp, {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
        let message;
        switch(event){
            case 'created':
                message = involvesCurrentUser ? (0, $5e9iX.youSingularActivityMessages).created : (0, $5e9iX.otherSingularActivityMessages).created;
                break;
            case 'edited':
                message = involvesCurrentUser ? (0, $5e9iX.youSingularActivityMessages).edited : (0, $5e9iX.otherSingularActivityMessages).edited;
                break;
            case 'commented':
                message = involvesCurrentUser ? (0, $5e9iX.youSingularActivityMessages).commented : (0, $5e9iX.otherSingularActivityMessages).commented;
                break;
            case 'updated':
                message = involvesCurrentUser ? (0, $5e9iX.youSingularActivityMessages).updated : (0, $5e9iX.otherSingularActivityMessages).updated;
                break;
            case 'worked':
            default:
                message = involvesCurrentUser ? (0, $5e9iX.youSingularActivityMessages).worked : (0, $5e9iX.otherSingularActivityMessages).worked;
                break;
        }
        if ((0, $6ZWwm.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.today) : formatMessage(message.today, {
            name: contributors[0].name
        });
        else if ((0, $3rf5d.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.yesterday) : formatMessage(message.yesterday, {
            name: contributors[0].name
        });
        else return involvesCurrentUser ? formatMessage(message.otherTime, {
            time: formattedDate
        }) : formatMessage(message.yesterday, {
            name: contributors[0].name,
            time: formattedDate
        });
    } else if (involvesCurrentUser) {
        const contributorsWithoutCurrentUser = contributors.filter((contributor)=>contributor.id !== currentUserId);
        if (othersCount > 0) return formatMessage((0, $5e9iX.pluralActivityMessages).you.many, {
            name1: contributorsWithoutCurrentUser[0].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $5e9iX.pluralActivityMessages).you.double, {
            name1: contributorsWithoutCurrentUser[0].name
        }) : formatMessage((0, $5e9iX.pluralActivityMessages).you.triple, {
            name1: contributorsWithoutCurrentUser[0].name,
            name2: contributorsWithoutCurrentUser[1].name
        });
    } else {
        if (othersCount > 0) return formatMessage((0, $5e9iX.pluralActivityMessages).other.many, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $5e9iX.pluralActivityMessages).other.double, {
            name1: contributors[0].name,
            name2: contributors[1].name
        }) : formatMessage((0, $5e9iX.pluralActivityMessages).other.triple, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            name3: contributors[2].name
        });
    }
};

});
parcelRegister("5e9iX", function(module, exports) {

$parcel$export(module.exports, "youSingularActivityMessages", () => $febcadb8ebf037ac$export$97eb62906ce0e051);
$parcel$export(module.exports, "otherSingularActivityMessages", () => $febcadb8ebf037ac$export$fca5bc54abc98673);
$parcel$export(module.exports, "pluralActivityMessages", () => $febcadb8ebf037ac$export$b9d6808884fda53b);

var $2nPZH = parcelRequire("2nPZH");
const $febcadb8ebf037ac$var$youSingularWorkedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.today",
        defaultMessage: "You worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.yesterday",
        defaultMessage: "You worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.otherTime",
        defaultMessage: "You worked on this {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularCreatedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.today",
        defaultMessage: "You created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.yesterday",
        defaultMessage: "You created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.otherTime",
        defaultMessage: "You created this on {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularEditedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.today",
        defaultMessage: "You edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.yesterday",
        defaultMessage: "You edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.otherTime",
        defaultMessage: "You edited this on {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularCommentedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.today",
        defaultMessage: "You commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.yesterday",
        defaultMessage: "You commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.otherTime",
        defaultMessage: "You commented here on {time}"
    }
});
const $febcadb8ebf037ac$var$youSingularUpdatedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.today",
        defaultMessage: "You updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.yesterday",
        defaultMessage: "You updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.otherTime",
        defaultMessage: "You updated this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularWorkedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.today",
        defaultMessage: "{name} worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.yesterday",
        defaultMessage: "{name} worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.otherTime",
        defaultMessage: "{name} worked on this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularCreatedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.today",
        defaultMessage: "{name} created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.yesterday",
        defaultMessage: "{name} created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.otherTime",
        defaultMessage: "{name} created this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularEditedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.today",
        defaultMessage: "{name} edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.yesterday",
        defaultMessage: "{name} edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.otherTime",
        defaultMessage: "{name} edited this on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularCommentedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.today",
        defaultMessage: "{name} commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.yesterday",
        defaultMessage: "{name} commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.otherTime",
        defaultMessage: "{name} commented here on {time}"
    }
});
const $febcadb8ebf037ac$var$otherSingularUpdatedMessages = (0, $2nPZH.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.today",
        defaultMessage: "{name} updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.yesterday",
        defaultMessage: "{name} updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.otherTime",
        defaultMessage: "{name} updated this on {time}"
    }
});
const $febcadb8ebf037ac$var$youPluralActivityMessages = (0, $2nPZH.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.double",
        defaultMessage: "You and {name1} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.triple",
        defaultMessage: "You, {name1}, and {name2} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.many",
        defaultMessage: "You, {name1}, and {count} others have all worked on this"
    }
});
const $febcadb8ebf037ac$var$otherPluralActivityMessages = (0, $2nPZH.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.double",
        defaultMessage: "{name1} and {name2} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.triple",
        defaultMessage: "{name1}, {name2}, and {name3} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.many",
        defaultMessage: "{name1}, {name2}, and {count} others have all worked on this"
    }
});
const $febcadb8ebf037ac$export$97eb62906ce0e051 = {
    worked: $febcadb8ebf037ac$var$youSingularWorkedMessages,
    created: $febcadb8ebf037ac$var$youSingularCreatedMessages,
    edited: $febcadb8ebf037ac$var$youSingularEditedMessages,
    commented: $febcadb8ebf037ac$var$youSingularCommentedMessages,
    updated: $febcadb8ebf037ac$var$youSingularUpdatedMessages
};
const $febcadb8ebf037ac$export$fca5bc54abc98673 = {
    worked: $febcadb8ebf037ac$var$otherSingularWorkedMessages,
    created: $febcadb8ebf037ac$var$otherSingularCreatedMessages,
    edited: $febcadb8ebf037ac$var$otherSingularEditedMessages,
    commented: $febcadb8ebf037ac$var$otherSingularCommentedMessages,
    updated: $febcadb8ebf037ac$var$otherSingularUpdatedMessages
};
const $febcadb8ebf037ac$export$b9d6808884fda53b = {
    you: $febcadb8ebf037ac$var$youPluralActivityMessages,
    other: $febcadb8ebf037ac$var$otherPluralActivityMessages
};

});


parcelRegister("14qs9", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $e837949619d119e2$export$e926676385687eaf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bg4YX = parcelRequire("bg4YX");

var $4Zqgi = parcelRequire("4Zqgi");
const $e837949619d119e2$var$useLogException = ()=>{
    return (0, $gwFzn.useCallback)(async (error)=>{
        (0, $4Zqgi.logger).error(error);
    }, []);
};
const $e837949619d119e2$export$e926676385687eaf = (props)=>{
    const onException = $e837949619d119e2$var$useLogException();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bg4YX.ErrorBoundary), {
        ...props,
        onException: onException,
        children: props.children
    });
};

});

parcelRegister("gUXWz", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardsRow", () => $b374fd03230d789b$export$96be17c41f7933d9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $81TN7 = parcelRequire("81TN7");

var $gsbO5 = parcelRequire("gsbO5");
const $b374fd03230d789b$var$rowBox = (0, $ecnYn.xcss)({
    marginInlineEnd: 'space.100',
    borderRadius: '3px',
    ':hover': {
        background: "var(--ds-surface-hovered, #F1F2F4)",
        cursor: 'pointer'
    }
});
const $b374fd03230d789b$export$96be17c41f7933d9 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick })=>{
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $b374fd03230d789b$var$rowBox,
        paddingInline: "space.200",
        paddingBlock: "space.100",
        ...triggerProps,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                type === (0, $gsbO5.KnowledgeCardsRowType).PERSON ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $81TN7.PersonStyles), {
                    src: pictureUrl
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $81TN7.WorkStyles), {
                    src: pictureUrl
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            maxLines: 1,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                size: "xxsmall",
                                children: primaryText
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            maxLines: 1,
                            children: secondaryText
                        })
                    ]
                })
            ]
        })
    }));
};

});
parcelRegister("81TN7", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardsPicture", () => $0370817e1cefddd5$export$7f0e56320ea6e6ee);
$parcel$export(module.exports, "PersonStyles", () => $0370817e1cefddd5$export$bf503936295d1d98);
$parcel$export(module.exports, "WorkStyles", () => $0370817e1cefddd5$export$b32bf078e8b397e9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles

var $gwrgp = parcelRequire("gwrgp");
const $0370817e1cefddd5$export$7f0e56320ea6e6ee = (0, $gwrgp.default)("img", {
    target: "e1dumvdd0"
})({
    name: "1b2xgz7",
    styles: "border-radius:50%;width:120px;height:120px;"
});
const $0370817e1cefddd5$export$bf503936295d1d98 = (0, $gwrgp.default)("img", {
    target: "e1dumvdd1"
})({
    name: "osq1l7",
    styles: "border-radius:50%;width:32px;height:32px;"
});
const $0370817e1cefddd5$export$b32bf078e8b397e9 = (0, $gwrgp.default)("img", {
    target: "e1dumvdd2"
})({
    name: "9ixrit",
    styles: "border-radius:0;width:24px;height:24px;"
});

});

parcelRegister("gsbO5", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardsIntentType", () => $4b02fec73d358896$export$ba9062c439fa44bc);
$parcel$export(module.exports, "KnowledgeCardsRowType", () => $4b02fec73d358896$export$f6d5eb0487369ad6);
var $4b02fec73d358896$export$ba9062c439fa44bc = /*#__PURE__*/ function(KnowledgeCardsIntentType) {
    KnowledgeCardsIntentType["PERSON"] = "PERSON";
    KnowledgeCardsIntentType["TEAM"] = "TEAM";
    return KnowledgeCardsIntentType;
}({});
var $4b02fec73d358896$export$f6d5eb0487369ad6 = /*#__PURE__*/ function(KnowledgeCardsRowType) {
    KnowledgeCardsRowType["PERSON"] = "PERSON";
    KnowledgeCardsRowType["WORK"] = "WORK";
    return KnowledgeCardsRowType;
}({});

});


parcelRegister("l6FRc", function(module, exports) {

$parcel$export(module.exports, "PersonCard", () => $47360f70ea824d57$export$4c094c8f61edecb4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $esRft = parcelRequire("esRft");

var $1qfLF = parcelRequire("1qfLF");
var $7p4As = parcelRequire("7p4As");

var $ldfch = parcelRequire("ldfch");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $eRXI0 = parcelRequire("eRXI0");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $7lL49 = parcelRequire("7lL49");

var $fJBWn = parcelRequire("fJBWn");

var $5iH4l = parcelRequire("5iH4l");
const $47360f70ea824d57$var$wrapperXcss = (0, $ecnYn.xcss)({
    ':hover': {
        boxShadow: 'elevation.shadow.overlay',
        borderRadius: 'border.radius.200'
    }
});
const $47360f70ea824d57$var$cardXcss = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.raised',
    padding: 'space.200',
    width: '214px'
});
const $47360f70ea824d57$var$clickableCardXcss = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.raised',
    padding: 'space.200',
    width: '214px',
    cursor: 'pointer'
});
const $47360f70ea824d57$var$userNameXcss = (0, $ecnYn.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    textAlign: 'center',
    wordBreak: 'break-all',
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1
});
const $47360f70ea824d57$var$tooltip = (0, $ecnYn.xcss)({
    color: 'color.text.inverse',
    font: 'font.body.UNSAFE_small'
});
const $47360f70ea824d57$var$tooltipContainer = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: '3px',
    alignItems: 'center',
    zIndex: 'tooltip',
    position: 'absolute',
    left: 'space.025',
    bottom: 'space.negative.250',
    maxWidth: '240px',
    paddingBlock: 'space.025',
    paddingInline: 'space.075'
});
const $47360f70ea824d57$var$userSubheadingXcss = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    font: 'font.body',
    textAlign: 'center',
    wordBreak: 'break-all',
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47360f70ea824d57$var$tooltipOptions = {
    position: 'bottom'
};
const $47360f70ea824d57$export$4c094c8f61edecb4 = ({ name: name, profilePicUrl: profilePicUrl, jobTitle: jobTitle, profileUrl: profileUrl, email: email, isHoverState: isHoverState = true, onCardClick: onCardClick })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [tipState, setTipState] = (0, $gwFzn.useState)(false);
    const Wrapper = !isHoverState && !!onCardClick ? (props)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $47360f70ea824d57$var$wrapperXcss,
            onClick: ()=>{
                fireSAINUsageEvent({
                    metCriteria: (0, $4jIuc.SainAction).PERSON_SELECTED
                });
                fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'person-card-click'));
                onCardClick();
            },
            children: props.children
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            direction: "column",
            alignItems: "center",
            gap: "space.200",
            xcss: !isHoverState && !!onCardClick ? $47360f70ea824d57$var$clickableCardXcss : $47360f70ea824d57$var$cardXcss,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                        src: profilePicUrl,
                        size: "xlarge"
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    direction: "column",
                    alignItems: "center",
                    gap: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $47360f70ea824d57$var$userNameXcss,
                            children: name
                        }),
                        jobTitle && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $47360f70ea824d57$var$userSubheadingXcss,
                            children: jobTitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    gap: "space.050",
                    children: [
                        email && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                            icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
                                    ...props,
                                    color: "var(--ds-icon, #44546F)"
                                }),
                            onClick: ()=>{
                                fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'person-card-copy-email'));
                                fireSAINUsageEvent({
                                    metCriteria: (0, $4jIuc.SainAction).COPY_CLICKED
                                });
                                (0, $5iH4l.onEmailCopy)(email);
                            },
                            label: formatMessage((0, $7lL49.messages).knowledge_cards_copy_email_address),
                            onMouseEnter: ()=>setTipState(true),
                            onMouseLeave: ()=>setTipState(false),
                            isTooltipDisabled: isHoverState,
                            tooltip: $47360f70ea824d57$var$tooltipOptions
                        }),
                        profileUrl && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                            href: profileUrl,
                            target: "_blank",
                            onClick: ()=>{
                                fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'person-card-view-profile'));
                                fireSAINUsageEvent({
                                    metCriteria: (0, $4jIuc.SainAction).VIEW_PROFILE_CLICKED
                                });
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $7lL49.messages).ai_answer_who_questions_view_profile
                            })
                        }),
                        isHoverState && tipState && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $47360f70ea824d57$var$tooltipContainer,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $47360f70ea824d57$var$tooltip,
                                children: formatMessage((0, $7lL49.messages).knowledge_cards_copy_email_address)
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("5SHML", function(module, exports) {

let $4483f5c4ed609aef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4483f5c4ed609aef$var$load("iBa9k"),
    $4483f5c4ed609aef$var$load("hoLvO"),
    $4483f5c4ed609aef$var$load("2w2Fa"),
    $4483f5c4ed609aef$var$load("9QvHa"),
    $4483f5c4ed609aef$var$load("3ooAX"),
    $4483f5c4ed609aef$var$load("4lfDj"),
    $4483f5c4ed609aef$var$load("dTsOE"),
    $4483f5c4ed609aef$var$load("aZinD"),
    $4483f5c4ed609aef$var$load("5SiDe"),
    $4483f5c4ed609aef$var$load("EfTik")
]).then(()=>parcelRequire('1JhVb'));

});


parcelRegister("hACT7", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardsHeader", () => $bbf0cf0cd13efaa7$export$2e8e6b3277c86f1a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");
var $dE1p6 = parcelRequire("dE1p6");

var $7hXDW = parcelRequire("7hXDW");

var $5tOl1 = parcelRequire("5tOl1");

var $7O0l1 = parcelRequire("7O0l1");

var $ldfch = parcelRequire("ldfch");

var $kPml2 = parcelRequire("kPml2");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $alaek = parcelRequire("alaek");

var $eRXI0 = parcelRequire("eRXI0");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $7lL49 = parcelRequire("7lL49");

var $fJBWn = parcelRequire("fJBWn");

var $39EIK = parcelRequire("39EIK");

var $81TN7 = parcelRequire("81TN7");

var $gsbO5 = parcelRequire("gsbO5");

var $5iH4l = parcelRequire("5iH4l");
const $bbf0cf0cd13efaa7$var$KnowledgeCardsPersonHeaderWrapper = (0, $ecnYn.xcss)({
    padding: 'space.250'
});
const $bbf0cf0cd13efaa7$var$KnowledgeCardsTeamHeaderWrapper = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingBottom: 'space.150'
});
const $bbf0cf0cd13efaa7$var$KnowledgeCardsPrimaryInfoWrapper = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $bbf0cf0cd13efaa7$var$KnowledgeCardsButtonsWrapper = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $bbf0cf0cd13efaa7$export$2e8e6b3277c86f1a = ({ type: type, name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const isPerson = type === (0, $gsbO5.KnowledgeCardsIntentType).PERSON;
    const subText = isPerson ? [
        jobTitle,
        department
    ].filter((text)=>!!text).join(', ') : formatMessage((0, $7lL49.messages).knowledge_cards_team_subheader);
    const trimmedSubText = subText.length > 250 ? `${subText.slice(0, 250)}...` : subText;
    const timeAndLocationComponent = isPerson && (location || time) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
        size: "medium",
        color: "color.text.subtlest",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kPml2))), {
                    label: ""
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    space: "space.050",
                    children: [
                        location && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            children: location
                        }),
                        time && location && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            children: "\u2022"
                        }),
                        time && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            children: time
                        })
                    ]
                })
            ]
        })
    });
    const tooltipOptions = {
        position: 'bottom',
        content: formatMessage((0, $7lL49.messages).knowledge_cards_copy_email_address),
        hideTooltipOnClick: true
    };
    const { cloudId: cloudId, sessionId: sessionId } = commonAttributes;
    const showAITopics = isPerson && (0, $dh538.fg)('kd_topics_in_person_card');
    const viewText = isPerson ? (0, $7lL49.messages).ai_answer_who_questions_view_profile : (0, $7lL49.messages).knowledge_cards_view_team;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        space: "space.100",
        xcss: isPerson ? $bbf0cf0cd13efaa7$var$KnowledgeCardsPersonHeaderWrapper : $bbf0cf0cd13efaa7$var$KnowledgeCardsTeamHeaderWrapper,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                spread: "space-between",
                alignInline: "start",
                alignBlock: "center",
                grow: "fill",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        !isPerson && (0, $dh538.fg)('team-avatar-search-card') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $alaek.default), {
                            size: "xlarge",
                            src: avatarUrl || undefined,
                            name: name
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $81TN7.KnowledgeCardsPicture), {
                            src: avatarUrl || '',
                            alt: name
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $bbf0cf0cd13efaa7$var$KnowledgeCardsPrimaryInfoWrapper,
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                        size: "medium",
                                        children: name
                                    }),
                                    trimmedSubText && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                        size: "medium",
                                        color: "color.text.subtlest",
                                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                                            space: "space.100",
                                            alignBlock: "center",
                                            children: [
                                                isPerson && /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7O0l1))), {
                                                    label: ""
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                                    children: trimmedSubText
                                                })
                                            ]
                                        })
                                    }),
                                    timeAndLocationComponent,
                                    showAITopics && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $39EIK.KnowledgeCardsTopics), {
                                        cloudId: cloudId,
                                        userId: accountId ?? '',
                                        userName: name,
                                        sessionId: sessionId,
                                        fallbackSection: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                                        v2styles: true
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: "space.050",
                xcss: $bbf0cf0cd13efaa7$var$KnowledgeCardsButtonsWrapper,
                children: [
                    !!email && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldfch))), {
                                ...props,
                                color: "var(--ds-icon, #44546F)"
                            }),
                        label: formatMessage((0, $7lL49.messages).ai_answer_who_questions_hover_email_icon),
                        onClick: ()=>{
                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'header-copy-email'));
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).COPY_CLICKED
                            });
                            (0, $5iH4l.onEmailCopy)(email);
                        },
                        isTooltipDisabled: false,
                        tooltip: tooltipOptions
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dE1p6.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                        label: formatMessage(viewText),
                        href: profileUrl || '',
                        onClick: ()=>{
                            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)(commonAttributes, 'header-view-profile'));
                            fireSAINUsageEvent({
                                metCriteria: (0, $4jIuc.SainAction).VIEW_PROFILE_CLICKED
                            });
                        }
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("39EIK", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardsTopics", () => $7dad6b71e18043a2$export$71025593c3acaa9c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $aK1zu = parcelRequire("aK1zu");
// TODO pass layout spacing as a wrapper into the component to render conditionally only it topics are present
const $7dad6b71e18043a2$var$TopicsContainerStyles = (0, $ecnYn.xcss)({
});
const $7dad6b71e18043a2$export$71025593c3acaa9c = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $7dad6b71e18043a2$var$TopicsContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aK1zu.AITopicsByPerson), {
            ...props
        })
    });
};

});
parcelRegister("aK1zu", function(module, exports) {

$parcel$export(module.exports, "AITopicsByPerson", () => $f2ca90f947d8f2ff$export$98ee922d18019998);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1qfLF = parcelRequire("1qfLF");

var $7hXDW = parcelRequire("7hXDW");

var $fk6ei = parcelRequire("fk6ei");

var $ldIK0 = parcelRequire("ldIK0");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $14qs9 = parcelRequire("14qs9");

var $gt1E3 = parcelRequire("gt1E3");

var $ljjcE = parcelRequire("ljjcE");

var $9G2ji = parcelRequire("9G2ji");

var $gK4sy = parcelRequire("gK4sy");

var $bOthu = parcelRequire("bOthu");

var $bHyMQ = parcelRequire("bHyMQ");
const $f2ca90f947d8f2ff$var$AITopicsByPersonComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ userId: userId, userName: userName, cloudId: cloudId, sessionId: sessionId, fallbackSection: fallbackSection, v2styles: v2styles = false })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { aiRelatedTopics: aiRelatedTopics, fetchRelatedTopics: fetchRelatedTopics, showTopics: showTopics } = (0, $bHyMQ.useRelatedTopics)();
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const [showMore, setShowMore] = (0, $gwFzn.useState)(false);
    const { breakElems: breakElems } = (0, $bOthu.useTopicBreakElems)(wrapperRef, showTopics);
    const personCardSurfaceEnabled = true;
    const shadowTrafficEnabled = !personCardSurfaceEnabled;
    const onBadgeClickHandler = (topicId)=>{
        fireAnalyticsEvent((0, $9G2ji.onRelatedEntityClick)({
            clickedEntityId: topicId,
            clickedEntityType: 'topic',
            principalEntityType: (0, $ljjcE.RelatedEntityType).USER,
            principalEntityId: userId,
            sessionId: sessionId,
            location: 'personCard'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).TOPIC_CLICKED
        });
    };
    (0, $gwFzn.useEffect)(()=>{
        fetchRelatedTopics({
            entityId: userId,
            principalEntityType: (0, $ljjcE.RelatedEntityType).USER,
            cloudId: cloudId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (showTopics && !shadowTrafficEnabled) fireAnalyticsEvent((0, $9G2ji.onSurfaceShown)({
            principalEntityId: userId,
            principalEntityType: (0, $ljjcE.RelatedEntityType).USER,
            relatedTopics: aiRelatedTopics.map((topic)=>topic.id),
            sessionId: sessionId,
            location: 'personCard'
        }));
    }, [
        showTopics,
        shadowTrafficEnabled,
        aiRelatedTopics,
        userId,
        fireAnalyticsEvent,
        sessionId
    ]);
    const firstName = userName.split(' ')[0];
    if (shadowTrafficEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: fallbackSection
    });
    return showTopics ? v2styles ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    ref: wrapperRef,
                    space: "space.100",
                    rowSpace: "space.100",
                    alignBlock: "center",
                    shouldWrap: true,
                    children: [
                        (breakElems < 0 ? aiRelatedTopics : aiRelatedTopics.slice(0, Math.max(1, breakElems))).map((topic)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gt1E3.KnowledgeBadge), {
                                name: topic.name,
                                url: `/wiki/topics/${topic.id}`,
                                onBadgeClick: ()=>onBadgeClickHandler(topic.id)
                            }, topic.id)),
                        breakElems < aiRelatedTopics.length ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            onClick: ()=>setShowMore((s)=>!s),
                            icon: showMore ? (0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))) : (0, (/*@__PURE__*/$parcel$interopDefault($ldIK0))),
                            label: "Expand",
                            spacing: "compact"
                        }) : null
                    ]
                }),
                showMore && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    paddingBlockStart: "space.025",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                        space: "space.100",
                        shouldWrap: true,
                        children: aiRelatedTopics.slice(breakElems).map((topic)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gt1E3.KnowledgeBadge), {
                                name: topic.name,
                                url: `/wiki/topics/${topic.id}`,
                                onBadgeClick: ()=>onBadgeClickHandler(topic.id)
                            }, topic.id))
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        paddingBlockStart: "space.200",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                    size: "xxsmall",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $gK4sy.messages).ai_topics_surface_header_person,
                        values: {
                            userName: firstName
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    space: "space.100",
                    rowSpace: "space.100",
                    shouldWrap: true,
                    children: aiRelatedTopics.map((topic)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gt1E3.KnowledgeBadge), {
                            name: topic.name,
                            url: `/wiki/topics/${topic.id}`,
                            onBadgeClick: ()=>onBadgeClickHandler(topic.id)
                        }, topic.id))
                })
            ]
        })
    }) : null;
});
const $f2ca90f947d8f2ff$export$98ee922d18019998 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($f2ca90f947d8f2ff$var$AITopicsByPersonComponent, {
            ...props
        })
    });

});
parcelRegister("gt1E3", function(module, exports) {

$parcel$export(module.exports, "KnowledgeBadge", () => $a961c4b2c45e1091$export$7e867bde3d2da523);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eEA8O = parcelRequire("eEA8O");

var $dQMPp = parcelRequire("dQMPp");

var $9D6Kx = parcelRequire("9D6Kx");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");
const $a961c4b2c45e1091$var$knowledgeBadgeStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    border: `1px ${"var(--ds-border, #091E4224)"} solid`,
    borderRadius: 'border.radius.100',
    backgroundColor: 'color.background.input'
});
const $a961c4b2c45e1091$var$buttonLinkStyles = (0, $ecnYn.xcss)({
    padding: 'space.025',
    marginLeft: 'space.025',
    marginRight: 'space.050'
});
const $a961c4b2c45e1091$export$7e867bde3d2da523 = ({ name: name, url: url, onBadgeClick: onBadgeClick = ()=>{} })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $a961c4b2c45e1091$var$knowledgeBadgeStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
            href: url,
            appearance: "subtle",
            onClick: ()=>{
                onBadgeClick();
            },
            spacing: "none",
            target: "_blank",
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center",
                xcss: $a961c4b2c45e1091$var$buttonLinkStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9D6Kx))),
                        label: "",
                        appearance: "blue",
                        size: "16"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        children: name
                    })
                ]
            })
        })
    });

});

parcelRegister("ljjcE", function(module, exports) {

$parcel$export(module.exports, "RelatedEntitiesResult", () => $c248d8b701eab912$export$e11ed46440979a9c);
$parcel$export(module.exports, "RelatedEntityType", () => $c248d8b701eab912$export$ee18e55fb2f84827);
var $c248d8b701eab912$export$e11ed46440979a9c = /*#__PURE__*/ function(RelatedEntitiesResult) {
    RelatedEntitiesResult["KnowledgeDiscoveryRelatedEntityConnection"] = "KnowledgeDiscoveryRelatedEntityConnection";
    RelatedEntitiesResult["QueryError"] = "QueryError";
    return RelatedEntitiesResult;
}({});
var $c248d8b701eab912$export$ee18e55fb2f84827 = /*#__PURE__*/ function(RelatedEntityType) {
    RelatedEntityType["KEY_PHRASE"] = "KEY_PHRASE";
    RelatedEntityType["TOPIC"] = "TOPIC";
    RelatedEntityType["USER"] = "USER";
    RelatedEntityType["CONFLUENCE_DOCUMENT"] = "CONFLUENCE_DOCUMENT";
    RelatedEntityType["CONFLUENCE_PAGE"] = "CONFLUENCE_PAGE";
    RelatedEntityType["CONFLUENCE_BLOGPOST"] = "CONFLUENCE_BLOGPOST";
    return RelatedEntityType;
}({});

});

parcelRegister("9G2ji", function(module, exports) {

$parcel$export(module.exports, "onSurfaceShown", () => $05b7c5f82bab1534$export$1e54b1f2535dc14e);
$parcel$export(module.exports, "onRelatedEntityClick", () => $05b7c5f82bab1534$export$9eff5105a9d90d9e);
$parcel$export(module.exports, "onSentimentClick", () => $05b7c5f82bab1534$export$c5c4147343613b24);

var $4Zqgi = parcelRequire("4Zqgi");
const $05b7c5f82bab1534$export$1e54b1f2535dc14e = (surfaceAttributes)=>{
    try {
        return {
            action: 'shown',
            actionSubjectId: 'aiTopic',
            actionSubject: 'surface',
            eventType: 'track',
            attributes: {
                ...surfaceAttributes
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error(error);
        return {};
    }
};
const $05b7c5f82bab1534$export$9eff5105a9d90d9e = (entityClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: 'relatedEntity',
            eventType: 'ui',
            attributes: {
                ...entityClickAttributes
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error(error);
        return {};
    }
};
const $05b7c5f82bab1534$export$c5c4147343613b24 = (sentimentClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: sentimentClickAttributes.sentiment === 'positive' ? 'likeButton' : 'dislikeButton',
            eventType: 'ui',
            attributes: {
                ...sentimentClickAttributes
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error(error);
        return {};
    }
};

});

parcelRegister("gK4sy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $35af8e7a3997192d$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $35af8e7a3997192d$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    ai_topics_surface_header_user: {
        id: "search_ai.ai_topics.surface.header",
        defaultMessage: "Topics this person knows about"
    },
    ai_topics_surface_header_generic: {
        id: "search_ai.ai_topics.related_topics.header",
        defaultMessage: "Related topics"
    },
    ai_topics_surface_header_person: {
        id: "search_ai.ai_topics.surface.person_header",
        defaultMessage: "Topics {userName} knows about"
    },
    ai_topics_surface_header_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.header_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.footer_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_content_may_vary: {
        id: "search_ai.ai_topics.related_topics.footer_content_may_vary",
        defaultMessage: "Content quality may vary"
    },
    ai_topics_surface_footer_powered_by_ai: {
        id: "search_ai.ai_topics.related_topics.footer_powered_by_ai",
        defaultMessage: "Powered by AI"
    },
    ai_topics_user_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.user",
        defaultMessage: "Are these topics correctly associated with this user?"
    },
    ai_topics_page_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.page",
        defaultMessage: "Do these topics accurately reflect the contents of this page?"
    },
    ai_topics_page_feedback_button_text: {
        id: "search_ai.ai_topics.feedback.prompt.button",
        defaultMessage: "Submit feedback"
    },
    ai_topics_profile_feedback_text: {
        id: "search_ai.ai_topics.profile.prompt",
        defaultMessage: "Do these topics look accurate for this person?"
    },
    ai_topics_card_header_text: {
        id: "search_ai.ai_topics.card.header",
        defaultMessage: "Topics related to \"{searchQuery}\""
    },
    ai_topics_card_feedback_prompt: {
        id: "search_ai.ai_topics.card.feedback_prompt",
        defaultMessage: "Are these relevant to your search?"
    },
    ai_topics_rovo_branding_text: {
        id: "search_ai.ai_topics.rovo_branding_text",
        defaultMessage: "Rovo"
    }
});

});

parcelRegister("bOthu", function(module, exports) {

$parcel$export(module.exports, "useTopicBreakElems", () => $82ce7495e580fd3f$export$6e050707ceb5a52f);

var $gwFzn = parcelRequire("gwFzn");
const $82ce7495e580fd3f$var$BUTTON_WIDTH = 20;
const $82ce7495e580fd3f$var$PADDING_BLOCK_END = 16;
const $82ce7495e580fd3f$var$TOPIC_INLINE_SPACE = 8;
const $82ce7495e580fd3f$export$6e050707ceb5a52f = (wrapperRef, showTopics)=>{
    const [breakElems, setBreakElems] = (0, $gwFzn.useState)(-1);
    const [topicLengths, setTopicLengths] = (0, $gwFzn.useState)([]);
    (0, $gwFzn.useEffect)(()=>{
        const observer = new ResizeObserver((topics)=>{
            const wrapper = topics[0];
            const cwidth = wrapper.target.clientWidth;
            const tl = topicLengths;
            var runningWidth = 0;
            var elemsHold = 0;
            // on first run, all topics are displayed so we can loop through and get the lengths
            if (tl.length === 0) for (const topic of Array.from(wrapper.target.children)){
                const width = topic.scrollWidth;
                tl.push(width);
            }
            for(let i = 0; i < tl.length; i++){
                const width = topicLengths[i];
                if (runningWidth + width + $82ce7495e580fd3f$var$PADDING_BLOCK_END + $82ce7495e580fd3f$var$BUTTON_WIDTH <= cwidth) elemsHold += 1;
                runningWidth += width + $82ce7495e580fd3f$var$TOPIC_INLINE_SPACE;
            }
            setBreakElems(elemsHold);
            // on first run, save the topic lengths so we can reuse
            if (topicLengths.length === 0) setTopicLengths(tl);
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showTopics
    ]);
    return {
        breakElems: breakElems
    };
};

});

parcelRegister("bHyMQ", function(module, exports) {

$parcel$export(module.exports, "useRelatedTopics", () => $835a4feee30f76f5$export$977fb96428acdf48);

var $gwFzn = parcelRequire("gwFzn");

var $epS7s = parcelRequire("epS7s");

var $5NwX5 = parcelRequire("5NwX5");
var $ljjcE = parcelRequire("ljjcE");
const $835a4feee30f76f5$export$b08faa9b0d12bdd8 = 'atlassian.search-dialog.ai-topics-component';
const $835a4feee30f76f5$export$977fb96428acdf48 = ()=>{
    const [aiRelatedTopics, setAIRelatedTopics] = (0, $gwFzn.useState)([]);
    const [error, setError] = (0, $gwFzn.useState)('');
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const fetchRelatedTopics = async ({ entityId: entityId, cloudId: cloudId, principalEntityType: principalEntityType })=>{
        if (!entityId) {
            setAIRelatedTopics([]);
            return;
        }
        const cache = JSON.parse((0, $epS7s.getSessionItem)($835a4feee30f76f5$export$b08faa9b0d12bdd8) || '{}');
        if (cache?.entityId === entityId) setAIRelatedTopics(cache.topics);
        else {
            setAIRelatedTopics([]);
            (0, $epS7s.deleteSessionItem)($835a4feee30f76f5$export$b08faa9b0d12bdd8);
            setIsLoading(true);
            try {
                const { data: data } = await (0, $5NwX5.fetchRelatedEntities)({
                    entityId: entityId,
                    entityType: principalEntityType,
                    relatedEntityType: (0, $ljjcE.RelatedEntityType).TOPIC,
                    cloudId: cloudId,
                    first: 5
                });
                if (data.knowledgeDiscovery.__typename === (0, $ljjcE.RelatedEntitiesResult).QueryError) setError('REQUEST_ERROR');
                else if (data.knowledgeDiscovery.relatedEntities?.nodes) {
                    const entities = data.knowledgeDiscovery.relatedEntities.nodes;
                    setAIRelatedTopics(entities);
                    (0, $epS7s.setSessionItem)($835a4feee30f76f5$export$b08faa9b0d12bdd8, JSON.stringify({
                        entityId: entityId,
                        topics: entities
                    }));
                }
            } catch  {
                setError('NETWORK_ERROR');
            } finally{
                setIsLoading(false);
            }
        }
    };
    const resetTopics = (0, $gwFzn.useCallback)(()=>{
        setAIRelatedTopics([]);
    }, [
        setAIRelatedTopics
    ]);
    const showTopics = !isLoading && !error && aiRelatedTopics.length > 0;
    return {
        aiRelatedTopics: aiRelatedTopics,
        fetchRelatedTopics: fetchRelatedTopics,
        showTopics: showTopics,
        resetTopics: resetTopics
    };
};

});
parcelRegister("5NwX5", function(module, exports) {

$parcel$export(module.exports, "fetchRelatedEntities", () => $6ad9199244d74d2a$export$a6a63d73bee8e09d);

var $dwp40 = parcelRequire("dwp40");

var $f7lNm = parcelRequire("f7lNm");

var $KUYQ0 = parcelRequire("KUYQ0");
const $6ad9199244d74d2a$export$a6a63d73bee8e09d = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: (0, $KUYQ0.RelatedEntitiesQuery),
                variables: variables
            })
        },
        queryParams: {
            q: 'RelatedEntities'
        }
    };
    return (0, $dwp40.utils).requestService({
        url: (0, $f7lNm.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};

});
parcelRegister("KUYQ0", function(module, exports) {

$parcel$export(module.exports, "RelatedEntitiesQuery", () => $b2178040d9ade6ef$export$da4042a87a471c60);
const $b2178040d9ade6ef$export$da4042a87a471c60 = `
  query RelatedEntities(
    $entityId: String!
    $entityType: KnowledgeDiscoveryEntityType!
    $relatedEntityType: KnowledgeDiscoveryEntityType!
    $cloudId: String!
    $first: Int
    $after: String
  ) {
    knowledgeDiscovery {
      relatedEntities(
        entityId: $entityId
        entityType: $entityType
        relatedEntityType: $relatedEntityType
        cloudId: $cloudId
        first: $first
        after: $after
      ) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
        ... on KnowledgeDiscoveryRelatedEntityConnection {
          __typename
          nodes {
            ... on KnowledgeDiscoveryTopic {
              id
              name
              description
              documentCount
              updatedAt
              type
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
        ... on QueryError {
          message
        }
      }
    }
  }
`;

});






parcelRegister("3oSWM", function(module, exports) {

$parcel$export(module.exports, "SeparatorLine", () => $65205934451f1233$export$8be205ba9c2e6f62);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $65205934451f1233$var$Line = (0, $ecnYn.xcss)({
    height: '1px',
    width: '100%',
    background: "var(--ds-border, #091E4224)"
});
const $65205934451f1233$export$8be205ba9c2e6f62 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $65205934451f1233$var$Line
    });

});


parcelRegister("dUnDb", function(module, exports) {

$parcel$export(module.exports, "TeamKnowledgeCard", () => $2b91ccc1358d1d85$export$224d36db19d00a29);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $eRXI0 = parcelRequire("eRXI0");

var $jLyYG = parcelRequire("jLyYG");

var $5y8jR = parcelRequire("5y8jR");

var $cVtio = parcelRequire("cVtio");
var $4jIuc = parcelRequire("4jIuc");

var $8UaTW = parcelRequire("8UaTW");

var $6vDlQ = parcelRequire("6vDlQ");

var $fJBWn = parcelRequire("fJBWn");

var $61wSv = parcelRequire("61wSv");

var $3OmGD = parcelRequire("3OmGD");

var $hACT7 = parcelRequire("hACT7");

var $3oSWM = parcelRequire("3oSWM");

var $gsbO5 = parcelRequire("gsbO5");
const $2b91ccc1358d1d85$var$CardContainerStyles = (0, $ecnYn.xcss)({
    borderRadius: "var(--ds-border-radius-100, 4px)",
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $2b91ccc1358d1d85$export$224d36db19d00a29 = /*#__PURE__*/ (0, $gwFzn.memo)(()=>{
    const { commonAttributes: commonAttributes, userDetails: { id: currentUserId }, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { answerString: answerString, query: query } = commonAttributes;
    const data = (0, $5y8jR.getTypedJSONResultData)(answerString).parsedResult;
    const editDistanceRatio = (0, $61wSv.getEditDistanceRatio)(query, data.name);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    (0, $gwFzn.useEffect)(()=>{
        if (data.id) {
            fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardShown)({
                ...commonAttributes,
                cardType: (0, $gsbO5.KnowledgeCardsIntentType).TEAM,
                extraAttributes: {
                    editDistance: editDistanceRatio
                }
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return data.id ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                xcss: $2b91ccc1358d1d85$var$CardContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hACT7.KnowledgeCardsHeader), {
                        type: (0, $gsbO5.KnowledgeCardsIntentType).TEAM,
                        name: data.name,
                        avatarUrl: data.avatarUrl,
                        profileUrl: data.url
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3oSWM.SeparatorLine), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3OmGD.KnowledgeCardsBody), {
                        type: (0, $gsbO5.KnowledgeCardsIntentType).TEAM,
                        currentUserId: currentUserId || '',
                        recentActivity: data.recentActivity,
                        recommendedUsers: data.members,
                        profileUrl: data.url || '',
                        viewAllUrl: data.url || ''
                    })
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    }) : null;
});

});
parcelRegister("61wSv", function(module, exports) {

$parcel$export(module.exports, "getEditDistanceRatio", () => $543b523bba0606c4$export$ebacab8290144e11);
// Taken from https://gist.github.com/keesey/e09d0af833476385b9ee13b6d26a2b84 to avoid adding a package dependency for a single static function
function $543b523bba0606c4$var$getEditDistance(a, b) {
    const an = a ? a.length : 0;
    const bn = b ? b.length : 0;
    if (an === 0) return bn;
    if (bn === 0) return an;
    const matrix = new Array(bn + 1);
    for(let i = 0; i <= bn; ++i){
        let row = matrix[i] = new Array(an + 1);
        row[0] = i;
    }
    const firstRow = matrix[0];
    for(let j = 1; j <= an; ++j)firstRow[j] = j;
    for(let i = 1; i <= bn; ++i){
        for(let j = 1; j <= an; ++j)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1], matrix[i][j - 1], matrix[i - 1][j]) + 1;
    }
    return matrix[bn][an];
}
const $543b523bba0606c4$export$ebacab8290144e11 = (query, teamName)=>{
    return $543b523bba0606c4$var$getEditDistance(query, teamName) / query.length;
};

});



parcelRegister("kVdwy", function(module, exports) {

$parcel$export(module.exports, "fetchTeamKnowledgeCardDataWithRanking", () => $8cade13bd59126b4$export$1d3fe260188fa7d9);
$parcel$export(module.exports, "fetchTeamKnowledgeCardData", () => $8cade13bd59126b4$export$2dcdb800eebacd2c);

var $7Zbm6 = parcelRequire("7Zbm6");

var $9EFEY = parcelRequire("9EFEY");

var $5iH4l = parcelRequire("5iH4l");

var $2xvx8 = parcelRequire("2xvx8");
const $8cade13bd59126b4$var$NO_TEAM_MESSAGE = 'NO_TEAM';
const $8cade13bd59126b4$export$588cacdc66ef53ad = {
    team_metadata: {
        id: '',
        name: '',
        avatarUrl: null,
        url: null,
        memberCount: 0,
        members: [],
        recentActivity: []
    }
};
const $8cade13bd59126b4$export$1d3fe260188fa7d9 = ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct })=>{
    let teamResult;
    let teamData;
    let activityResult;
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    let actors = [];
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $2xvx8.KnowledgeCardTeamSearchRelevanceQuery),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $2xvx8.KNOWLEDGE_CARD_TEAM_SEARCH_RELEVANCE_OPERATION_NAME)
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (!errors && id) teamResult = id;
        else throw new Error($8cade13bd59126b4$var$NO_TEAM_MESSAGE);
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $2xvx8.KnowledgeCardTeamDataQuery),
            variables: {
                teamId: teamResult,
                siteId: siteId
            },
            operationName: (0, $2xvx8.KNOWLEDGE_CARD_TEAM_DATA_OPERATION_NAME)
        });
    }).then(({ data: data, errors: errors })=>{
        if (!errors && data?.team.teamV2?.id) teamData = data;
        else throw new Error($8cade13bd59126b4$var$NO_TEAM_MESSAGE);
        actors = teamData.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        return activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
    }).then((data)=>{
        if (data.workedOn && data.workedOn.length > 0) activityResult = data.workedOn;
        const filteredActivityResult = $8cade13bd59126b4$export$bd0b250fe24a4365(activityResult || [], actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? `/people/team/${(0, $5iH4l.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $8cade13bd59126b4$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $5iH4l.sanitizeAndMapRecentWorkActivity)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $8cade13bd59126b4$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify($8cade13bd59126b4$export$588cacdc66ef53ad),
                errorState: null,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        return Promise.reject(error);
    });
};
const $8cade13bd59126b4$export$2dcdb800eebacd2c = ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, tenantId: tenantId })=>{
    let teamResult;
    let activityResult;
    const onError = (error)=>{
        return Promise.reject(error);
    };
    try {
        let actors = [];
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $2xvx8.KnowledgeCardTeamSearchQuery),
            variables: {
                teamQuery: teamQuery,
                orgId: `ari:cloud:platform::org/${orgId}`,
                tenantId: tenantId
            },
            operationName: (0, $2xvx8.KNOWLEDGE_CARD_TEAM_SEARCH_OPERATION_NAME)
        }).then(({ data: data, errors: errors })=>{
            if (!errors && data?.team.teamSearchV2.nodes && data.team.teamSearchV2.nodes.length > 0 && data.team.teamSearchV2.nodes[0]) teamResult = data.team.teamSearchV2.nodes[0];
            else throw new Error('No team found');
            actors = teamResult?.team?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
            return activityClient.fetchActivities([
                100
            ], {
                limit: 100,
                actors: actors,
                rootContainerIds: [
                    `ari:cloud:platform::site/${tenantId}`
                ]
            }, [
                'workedOn'
            ], false);
        }, onError).then((data)=>{
            if (data.workedOn && data.workedOn.length > 0) activityResult = data.workedOn;
            const filteredActivityResult = $8cade13bd59126b4$export$bd0b250fe24a4365(activityResult || [], actors);
            const finalResult = {
                team_metadata: {
                    id: teamResult?.team?.id || '',
                    name: teamResult?.team?.displayName || '',
                    avatarUrl: teamResult?.team?.smallAvatarImageUrl || null,
                    url: teamResult?.team?.id ? `/people/team/${(0, $5iH4l.trimARI)(teamResult.team.id)}` : null,
                    memberCount: teamResult?.memberCount || 0,
                    members: teamResult?.team?.members?.nodes ? $8cade13bd59126b4$var$sanitizeAndMapTeamMembers(teamResult.team.members.nodes) : [],
                    recentActivity: filteredActivityResult ? (0, $5iH4l.sanitizeAndMapRecentWorkActivity)(filteredActivityResult) : []
                }
            };
            return {
                nlpSearch: {
                    nlpResult: JSON.stringify(finalResult),
                    uniqueSources: [],
                    disclaimer: null,
                    errorState: null,
                    format: (0, $7Zbm6.NLPSearchResultFormat).JSON
                }
            };
        }, onError);
    } catch (error) {
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $7Zbm6.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    }
};
const $8cade13bd59126b4$var$sanitizeAndMapTeamMembers = (members)=>{
    return members.reduce(function(result, memberNode) {
        if (!!memberNode.member) return result.concat({
            name: memberNode.member.name || '',
            picture: memberNode.member.picture || null,
            title: memberNode.member.extendedProfile?.jobTitle || null,
            url: !!memberNode.member.id ? `/people/${(0, $5iH4l.trimARI)(memberNode.member.id)}` : null,
            accountId: !!memberNode.member.id ? (0, $5iH4l.trimARI)(memberNode.member.id) : null,
            department: memberNode.member.extendedProfile?.department || null,
            email: memberNode.member.email || null
        });
        return result;
    }, []);
};
const $8cade13bd59126b4$var$excludedEventTypes = [
    'commented',
    'updated'
];
const $8cade13bd59126b4$export$bd0b250fe24a4365 = (activityResult, members)=>{
    const teamMemberSet = new Set(members);
    return activityResult.reduce((filtered, activity)=>{
        const involvedTeamMembers = activity.contributors.filter((contributor)=>teamMemberSet.has(`ari:cloud:identity::user/${contributor.accountId}`));
        if (involvedTeamMembers.length >= 1 && !$8cade13bd59126b4$var$excludedEventTypes.includes(activity.eventType)) filtered.push({
            ...activity,
            contributors: involvedTeamMembers
        });
        return filtered;
    }, []);
};

});
parcelRegister("2xvx8", function(module, exports) {

$parcel$export(module.exports, "KNOWLEDGE_CARD_TEAM_SEARCH_RELEVANCE_OPERATION_NAME", () => $0283d979c1b89f27$export$330a89c6d5120b7c);
$parcel$export(module.exports, "KnowledgeCardTeamSearchRelevanceQuery", () => $0283d979c1b89f27$export$f20269ab1c2af3aa);
$parcel$export(module.exports, "KNOWLEDGE_CARD_TEAM_DATA_OPERATION_NAME", () => $0283d979c1b89f27$export$1cc3d8f1a53775f);
$parcel$export(module.exports, "KnowledgeCardTeamDataQuery", () => $0283d979c1b89f27$export$b98556be52d17f2f);
$parcel$export(module.exports, "KNOWLEDGE_CARD_TEAM_SEARCH_OPERATION_NAME", () => $0283d979c1b89f27$export$ad033f83807dde4f);
$parcel$export(module.exports, "KnowledgeCardTeamSearchQuery", () => $0283d979c1b89f27$export$b0830e2a59ef23);
const $0283d979c1b89f27$export$330a89c6d5120b7c = 'KnowledgeCardTeamSearchQuery';
const $0283d979c1b89f27$export$f20269ab1c2af3aa = `
query ${$0283d979c1b89f27$export$330a89c6d5120b7c}($teamQuery: String!, $orgId: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchTeam (
        teamName: $teamQuery
        orgId: $orgId
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search Team"){
      ... on KnowledgeDiscoveryTeam {
        id
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $0283d979c1b89f27$export$1cc3d8f1a53775f = 'KnowledgeCardTeamDataQuery';
const $0283d979c1b89f27$export$b98556be52d17f2f = `
query ${$0283d979c1b89f27$export$1cc3d8f1a53775f}($teamId: ID!, $siteId: String!) {
    team {
      teamV2 (
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        id
        displayName
        smallAvatarImageUrl
        members {
          nodes {
            member {
              id
              accountId
              name
              picture
              ... on AtlassianAccountUser {
                email
                extendedProfile {
                  jobTitle
                  department
                }
              }
            }
            state
          }
        }
      }
    }
  }
`;
const $0283d979c1b89f27$export$ad033f83807dde4f = 'KnowledgeCardTeamSearchQuery';
const $0283d979c1b89f27$export$b0830e2a59ef23 = `
query ${$0283d979c1b89f27$export$ad033f83807dde4f}($teamQuery: String!, $orgId: ID!, $tenantId: String!) {
  team {
    teamSearchV2 (
      filter: {
        query: $teamQuery
      }
      first: 1
      organizationId: $orgId
      siteId: $tenantId
    ) @optIn(to: "Team-search-v2") {
      nodes {
        memberCount
        team {
          id
          displayName
          smallAvatarImageUrl
          members{
            nodes {
              member {
                id
                accountId
                name
                picture
                ... on AtlassianAccountUser {
                  email
                  extendedProfile {
                    jobTitle
                    department
                  }
                }
              }
              state
            }
          }
        }
      }
    }
  }
}
`;

});


parcelRegister("2u6da", function(module, exports) {

$parcel$export(module.exports, "AIAnswerDefaultLoadingWrapper", () => $c71e4c8897192027$export$476294a9cde8f045);
$parcel$export(module.exports, "AIAnswerSearchLoadingBorder", () => $c71e4c8897192027$export$1be966180e49de50);
$parcel$export(module.exports, "GeneratingContainer", () => $c71e4c8897192027$export$b6aef1fd050b8edc);
$parcel$export(module.exports, "GeneratingText", () => $c71e4c8897192027$export$636ea4c09615ceed);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $2azjJ = parcelRequire("2azjJ");

var $gwrgp = parcelRequire("gwrgp");
const $c71e4c8897192027$export$476294a9cde8f045 = (0, $gwrgp.default)("div", {
    target: "e1yvzew70"
})(({ isReadingAids: isReadingAids })=>isReadingAids ? `
        width: 100%;
				height: 92px;
        padding: ${"var(--ds-space-300, 24px)"};
        box-sizing: border-box;
      ` : `
		${''}
        width: ${0, $2azjJ.dialogWidth};
		${''}
        margin-top: ${(0, $2azjJ.grid).px};
        `);
const $c71e4c8897192027$export$1be966180e49de50 = (0, $gwrgp.default)("div", {
    target: "e1yvzew71"
})(({ isStreaming: isStreaming })=>({
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        borderRadius: "var(--ds-space-050, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: isStreaming ? `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} 0` : '0px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        zIndex: 3,
        boxShadow: `var(--ds-shadow-overlay, ${`0 ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-negative-025, -2px)"} ${0, $6fnsQ.N60A}, 0 0 1px ${0, $6fnsQ.N60A}`})`,
        '&::before': {
            content: "''",
            width: '1000vw',
            height: '1000vh',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: 'calc(-500vw + 50%)',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            top: 'calc(-500vh + 50%)',
            position: 'absolute',
            zIndex: -2,
            borderRadius: "var(--ds-space-050, 4px)",
            background: 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)',
            animation: 'rotate 2s infinite linear',
            filter: 'blur(25px)'
        },
        '&::after': {
            content: "''",
            width: `100% - ${"var(--ds-space-050, 4px)"}`,
            height: `100% - ${"var(--ds-space-050, 4px)"}`,
            inset: '1px',
            position: 'absolute',
            zIndex: -1,
            borderRadius: "var(--ds-space-050, 4px)",
            backgroundColor: `var(--ds-surface-overlay, ${0, $6fnsQ.N0})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes rotate': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            from: {
                transform: 'rotate(0deg)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            to: {
                transform: 'rotate(360deg)'
            }
        }
    }));
const $c71e4c8897192027$export$91478cb6ad63ea84 = (0, $gwrgp.default)("div", {
    target: "e1yvzew72"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '24px',
    gap: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c71e4c8897192027$export$a550342571a01571 = (0, $gwrgp.default)("div", {
    target: "e1yvzew73"
})({
    name: "h4986v",
    styles: "display:flex;flex-direction:column;margin-top:var(--ds-space-200, 16px);gap:var(--ds-space-100, 8px);"
});
const $c71e4c8897192027$export$61f15f4516003460 = (0, $gwrgp.default)("div", {
    target: "e1yvzew74"
})({
    display: 'flex',
    width: '100%',
    height: '16px',
    borderRadius: '8px',
    background: `var(--ds-skeleton, ${(0, $6fnsQ.N30)})`
});
const $c71e4c8897192027$export$90ec299a95f41a29 = (0, $gwrgp.default)("div", {
    target: "e1yvzew75"
})(({ width: width, height: height })=>({
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: width ? width : '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? height : '16px',
        borderRadius: '8px',
        background: `linear-gradient(to right, ${"var(--ds-background-neutral, rgba(240, 241, 244, 1))"}, ${"var(--ds-background-input-pressed, rgba(252, 252, 252, 1))"})`,
        animation: 'shimmer 1.5s linear infinite alternate',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes shimmer': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            from: {
                background: `linear-gradient(to right, ${"var(--ds-background-neutral, rgba(240, 241, 244, 1))"}, ${"var(--ds-background-input-pressed, rgba(252, 252, 252, 1))"})`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            to: {
                background: `linear-gradient(to right, ${"var(--ds-background-neutral, rgba(240, 241, 244, 1))"}, ${"var(--ds-background-input-pressed, rgba(252, 252, 252, 1))"})`
            }
        }
    }));
const $c71e4c8897192027$export$95fe272adfa518ad = (0, $gwrgp.default)("div", {
    target: "e1yvzew76"
})({
    background: `linear-gradient( 180deg, ${"var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))"} 0%, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`} 100% )`,
    height: "var(--ds-space-500, 40px)",
    width: '100%',
    position: 'relative',
    display: 'block',
    margin: `calc(${"var(--ds-space-500, 40px)"} * -1) 1px 0 1px`
});
const $c71e4c8897192027$export$b6aef1fd050b8edc = (0, $gwrgp.default)("div", {
    target: "e1yvzew77"
})({
    display: 'flex',
    height: '92px',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-300, 24px)"}`
});
const $c71e4c8897192027$export$636ea4c09615ceed = (0, $gwrgp.default)("div", {
    target: "e1yvzew78"
})({
    marginLeft: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});

parcelRegister("iSCyZ", function(module, exports) {

$parcel$export(module.exports, "DefinitionAnswerCard", () => $59e59815342d850f$export$d1b852cfff73cbe8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $fT2ta = parcelRequire("fT2ta");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $fYQcF = parcelRequire("fYQcF");

var $cNkxW = parcelRequire("cNkxW");
var $14qs9 = parcelRequire("14qs9");
var $cVtio = parcelRequire("cVtio");

var $4jIuc = parcelRequire("4jIuc");

var $2riIq = parcelRequire("2riIq");

var $bXlEj = parcelRequire("bXlEj");

var $bwqdG = parcelRequire("bwqdG");

var $eRXI0 = parcelRequire("eRXI0");

var $cGU6t = parcelRequire("cGU6t");

var $2szay = parcelRequire("2szay");

var $4xTru = parcelRequire("4xTru");

var $f29WH = parcelRequire("f29WH");

var $lJsaE = parcelRequire("lJsaE");

var $kvj1k = parcelRequire("kvj1k");

var $g3QIg = parcelRequire("g3QIg");
const $59e59815342d850f$var$sourcesContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: '0',
    paddingRight: 'space.300',
    paddingBottom: 'space.100',
    paddingLeft: 'space.300'
});
const $59e59815342d850f$var$openChatContainerStyles = (0, $ecnYn.xcss)({
    paddingBlockEnd: 'space.100',
    paddingInline: 'space.300'
});
const $59e59815342d850f$var$MAX_SOURCES = 4;
var $59e59815342d850f$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
const $59e59815342d850f$var$noop = ()=>{};
const $59e59815342d850f$var$OpenChat = ({ answerString: answerString, query: query })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    if (!(0, $dh538.fg)('kd_definitions_open_chat')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $59e59815342d850f$var$openChatContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2riIq.OpenChatButton), {
            prompt: formatMessage((0, $g3QIg.messages).definition_open_chat_user_initial_query, {
                // query only contains the highlighted word
                // we want to prefix the word "define" before
                // when a user's context is moved to chat
                term: query
            }),
            query: query,
            answerString: answerString,
            source: 'reading-aids'
        })
    });
};
const $59e59815342d850f$var$ReadingAidsPopupContent = ()=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps } = (0, $eRXI0.useAIAnswerContext)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const enableSmartLinkSources = readingAidsOptions?.enableSmartLinkSources;
    const { searchSessionId: searchSessionId, sources: sources, answerString: answerString, query: query } = commonAttributes;
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const sourceClickCallback = (0, $gwFzn.useCallback)((index, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            ...commonAttributes
        }));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        }) : trackAIResultAction((0, $4jIuc.SainAction).SOURCE_CLICKED);
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        trackAIResultAction
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fT2ta.default), {
        children: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $lJsaE.ReadingAidsWrapper), {
                onClick: (e)=>e.stopPropagation(),
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2szay.AIAnswerTitle), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {}),
                    editDefinitionEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kvj1k.EditDefinition), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $59e59815342d850f$var$sourcesContainerStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cNkxW.AISources), {
                            sources: sources,
                            searchSessionId: searchSessionId,
                            onClickHandler: sourceClickCallback,
                            limit: $59e59815342d850f$var$MAX_SOURCES,
                            verticalLayout: true,
                            enableSmartLinkSources: enableSmartLinkSources
                        })
                    }),
                    showChatFollowUps && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f29WH.ReadingAidsFollowUps), {})
                            }),
                            isAnswered && /*#__PURE__*/ (0, $7UHDa.jsx)($59e59815342d850f$var$OpenChat, {
                                answerString: answerString,
                                query: query
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerFooter), {})
                ]
            })
    });
};
const $59e59815342d850f$export$d1b852cfff73cbe8 = ()=>{
    const previousAnswerState = (0, $gwFzn.useRef)();
    const { loading: loading, commonAttributes: commonAttributes, partialResponse: partialResponse, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [continueLoadingAnimation, setContinueLoadingAnimation] = (0, $gwFzn.useState)(true);
    const { source: source } = commonAttributes;
    const isStreaming = !!partialResponse;
    const { onAnswerStateChange: onAnswerStateChange = $59e59815342d850f$var$noop } = readingAidsOptions || {};
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (!loading) {
            const countdownRemainingAnimation = setTimeout(()=>{
                setContinueLoadingAnimation(false);
            }, 3000);
            return ()=>clearTimeout(countdownRemainingAnimation);
        }
    }, [
        loading
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // update answer state for external consumers
        // using a previous answer state to prevent multiple duplicate calls,
        // especially in the case of loading && streaming
        if ((0, $dh538.fg)('kd_definitions_answer_state_signal')) {
            if (hasError && previousAnswerState.current !== "errored") {
                onAnswerStateChange("errored");
                previousAnswerState.current = "errored";
            } else if (isAnswered && previousAnswerState.current !== "answered") {
                onAnswerStateChange("answered");
                previousAnswerState.current = "answered";
            } else if ((loading || isStreaming) && previousAnswerState.current !== "loading") {
                onAnswerStateChange("loading");
                previousAnswerState.current = "loading";
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        loading,
        isStreaming,
        isAnswered,
        hasError
    ]);
    const onLoadingAnimationShown = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent
    ]);
    return loading || isStreaming ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bXlEj.DotAnimationLoader), {
        onAnimationShown: onLoadingAnimationShown,
        source: source,
        "data-testid": "ai-answer-animated-loader"
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lJsaE.ReadingAidsPopupContainer), {
        continueAnimation: continueLoadingAnimation,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lJsaE.ReadingAidsContainer), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($59e59815342d850f$var$ReadingAidsPopupContent, {})
        })
    });
};

});
parcelRegister("cNkxW", function(module, exports) {

$parcel$export(module.exports, "AISources", () => $7bc926104ea83677$export$bbbfd63fa7f32357);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $fk6ei = parcelRequire("fk6ei");

var $ldIK0 = parcelRequire("ldIK0");

var $7bZ3i = parcelRequire("7bZ3i");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $14qs9 = parcelRequire("14qs9");

var $16kBx = parcelRequire("16kBx");

var $hr3vG = parcelRequire("hr3vG");
const $7bc926104ea83677$var$cardTitleStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    color: 'color.text.subtlest',
    font: 'font.heading.xxsmall'
});
const $7bc926104ea83677$var$containerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    marginTop: 'space.075'
});
const $7bc926104ea83677$var$freeflowLinks = (0, $ecnYn.xcss)({
    display: 'inline',
    marginRight: 'space.075',
    lineHeight: 2
});
const $7bc926104ea83677$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    cursor: 'pointer'
});
const $7bc926104ea83677$var$Sources = ({ sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, allowFreeflowLayout: allowFreeflowLayout, verticalLayout: verticalLayout, enableSmartLinkSources: enableSmartLinkSources = true })=>{
    const [showAllSources, setShowAllSources] = (0, $gwFzn.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const canExpand = sources.length > 1 && verticalLayout;
    const visibleSources = showAllSources || !verticalLayout ? sources : sources.slice(0, 1);
    const onExpandButtonClick = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onExpandButtonClicked)({
            ...commonAttributes,
            expandButtonSource: 'sources'
        }));
        setShowAllSources(!showAllSources);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllSources
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: visibleSources.map((source, index)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                xcss: allowFreeflowLayout ? $7bc926104ea83677$var$freeflowLinks : null,
                space: "space.050",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hr3vG.SourceCard), {
                        index: index,
                        source: source,
                        searchSessionId: searchSessionId,
                        onClickHandler: onClickHandler,
                        enableSmartLinkSources: enableSmartLinkSources
                    }, `search-ai-answer-source-${index}`),
                    index === 0 && canExpand && // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $7bc926104ea83677$var$iconWrapperStyles,
                        onClick: onExpandButtonClick,
                        children: showAllSources ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))), {
                            color: "currentColor",
                            label: "",
                            testId: "collapse-sources-icon"
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldIK0))), {
                            color: "currentColor",
                            label: "",
                            testId: "expand-sources-icon"
                        })
                    })
                ]
            }, `ai-answer-source-${index}`))
    });
};
const $7bc926104ea83677$var$LayoutWrapper = (props)=>{
    if (props.allowFreeflowLayout) return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        children: props.children
    });
    else if (props.verticalLayout) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
        space: "space.075",
        children: props.children
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        space: "space.075",
        shouldWrap: true,
        children: props.children
    });
};
const $7bc926104ea83677$export$bbbfd63fa7f32357 = (props)=>{
    const { sources: ogSources, searchSessionId: searchSessionId, title: title, onClickHandler: onClickHandler = ()=>{}, allowFreeflowLayout: allowFreeflowLayout = false, verticalLayout: verticalLayout = false, limit: limit, enableSmartLinkSources: enableSmartLinkSources } = props;
    const sourcesTitle = title ?? (0, $16kBx.messages).sources_title;
    const sources = limit ? ogSources.slice(0, limit) : ogSources;
    const MaybeSmartCardProvider = enableSmartLinkSources !== false ? (0, $7bZ3i.SmartCardProvider) : (0, $gwFzn.Fragment);
    if (!sources.length) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $7bc926104ea83677$var$cardTitleStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...sourcesTitle,
                        values: {
                            numSources: sources.length
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $7bc926104ea83677$var$containerStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($7bc926104ea83677$var$LayoutWrapper, {
                        allowFreeflowLayout: allowFreeflowLayout,
                        verticalLayout: verticalLayout,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)(MaybeSmartCardProvider, {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($7bc926104ea83677$var$Sources, {
                                sources: sources,
                                searchSessionId: searchSessionId,
                                onClickHandler: onClickHandler,
                                allowFreeflowLayout: allowFreeflowLayout,
                                verticalLayout: verticalLayout,
                                enableSmartLinkSources: enableSmartLinkSources
                            })
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("16kBx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8d72635bfc0b232f$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $8d72635bfc0b232f$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    sources_title: {
        id: "search_ai.sources_label",
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    }
});

});

parcelRegister("hr3vG", function(module, exports) {

$parcel$export(module.exports, "SourceCard", () => $b578d109a323f8ce$export$c74cbf75d6285884);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2Nwuj = parcelRequire("2Nwuj");

var $dh538 = parcelRequire("dh538");

var $01aV7 = parcelRequire("01aV7");

var $14qs9 = parcelRequire("14qs9");

const $b578d109a323f8ce$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("geKHh")).then(({ Card: Card })=>({
            default: Card
        })));
const $b578d109a323f8ce$var$resolveUrlPlaceholder = (url)=>{
    const textFragmentRegex = new RegExp('#:~:text=.*$', 'g');
    const urlWithoutTextFragment = url?.replace(textFragmentRegex, '');
    const maxLength = 30;
    const truncatedUrl = urlWithoutTextFragment.length > maxLength ? urlWithoutTextFragment.slice(0, maxLength) + '...' : urlWithoutTextFragment;
    return truncatedUrl;
};
const $b578d109a323f8ce$var$fallbackComponent = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>()=>{
        return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__knowledge-disc') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
            href: `${source.url}?search_id=${searchSessionId}`,
            onClick: (e)=>onClickHandler(index, (0, $01aV7.extractUrlHostname)(source.url)),
            rel: "noopener noreferrer",
            target: "_blank",
            children: source.title ?? source.url
        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
            href: `${source.url}?search_id=${searchSessionId}`,
            onClick: (e)=>onClickHandler(index, (0, $01aV7.extractUrlHostname)(source.url)),
            rel: "noopener noreferrer",
            target: "_blank",
            children: source.title ?? source.url
        });
    };
const $b578d109a323f8ce$export$c74cbf75d6285884 = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler, enableSmartLinkSources: enableSmartLinkSources })=>{
    const SmartLinkSource = /*#__PURE__*/ (0, $7UHDa.jsx)($b578d109a323f8ce$var$Card, {
        appearance: "inline",
        url: source.url,
        removeTextHighlightingFromTitle: true,
        showHoverPreview: true,
        fallbackComponent: $b578d109a323f8ce$var$fallbackComponent({
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        }),
        onClick: (e)=>{
            onClickHandler(index, (0, $01aV7.extractUrlHostname)(source.url));
            e.preventDefault();
            window.open(`${source.url}?search_id=${searchSessionId}`, '_blank', 'noopener, noreferrer');
        },
        onError: ()=>{
        // Nothing for now
        },
        resolvingPlaceholder: $b578d109a323f8ce$var$resolveUrlPlaceholder(source.url),
        placeholder: $b578d109a323f8ce$var$resolveUrlPlaceholder(source.url)
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: enableSmartLinkSources ? SmartLinkSource : $b578d109a323f8ce$var$fallbackComponent({
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        })()
    });
};

});
parcelRegister("geKHh", function(module, exports) {

let $bd222d35cf80cb8d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bd222d35cf80cb8d$var$load("5SiDe"),
    $bd222d35cf80cb8d$var$load("MrUJ0"),
    $bd222d35cf80cb8d$var$load("lb9xb")
]).then(()=>parcelRequire('54RS5'));

});



parcelRegister("2riIq", function(module, exports) {

$parcel$export(module.exports, "OpenChatButton", () => $201eb101f1d7d1b2$export$dc40dedc9df6e59f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lBFuf = parcelRequire("lBFuf");

var $i25hX = parcelRequire("i25hX");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $14qs9 = parcelRequire("14qs9");

var $e0dFv = parcelRequire("e0dFv");
const $201eb101f1d7d1b2$export$dc40dedc9df6e59f = ({ prompt: prompt, answerString: answerString, query: query, source: source, experimentCohort: experimentCohort })=>{
    const { commonAttributes: commonAttributes, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const onOpenChatClick = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onOpenChatButtonClick)({
            ...commonAttributes,
            experimentCohort: experimentCohort
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).OPEN_CHAT_CLICKED
        });
        // callback is shared with followups
        // used in the issue model view to open up chat in a new tab
        // this is because we don't have access to dismiss the issue view modal
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(prompt);
            return;
        }
        publish({
            type: 'chat-new',
            source: source,
            data: {
                name: query.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: prompt
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                sourceId: commonAttributes.searchSessionId
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        onClose,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        prompt,
        source,
        readingAidsOptions,
        experimentCohort
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lBFuf.ChatPill), {
            onClick: onOpenChatClick,
            children: formatMessage((0, $e0dFv.messages).ai_answer_component_ai_answer_open_chat)
        })
    });
};

});
parcelRegister("e0dFv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $70755bd71f512b39$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $70755bd71f512b39$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    ai_answer_component_ai_answer_open_chat: {
        id: "search_ai.ai_answer_open_chat",
        defaultMessage: "Open chat"
    },
    ai_answer_component_ai_answer_ask_more_chat: {
        id: "search_ai.ai_answer_ask_more_chat",
        defaultMessage: "Ask more in Chat"
    },
    ai_answer_component_ai_answer_ask_more_chat_submit: {
        id: "search_ai.ai_answer_ask_more_chat",
        defaultMessage: "Submit"
    }
});

});


parcelRegister("bXlEj", function(module, exports) {

$parcel$export(module.exports, "DotAnimationLoader", () => $04174aaad1427a0e$export$1110722318fbbc6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d3o9E = parcelRequire("d3o9E");

var $kdgNh = parcelRequire("kdgNh");
const $04174aaad1427a0e$var$loadingAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: (0, (/*@__PURE__*/$parcel$interopDefault($kdgNh))),
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};
const $04174aaad1427a0e$var$loadingAnimationStyles = null;
const $04174aaad1427a0e$var$jiraOverrideStyles = null;
const $04174aaad1427a0e$export$1110722318fbbc6b = ({ onAnimationShown: onAnimationShown, source: source })=>{
    (0, $gwFzn.useEffect)(()=>{
        onAnimationShown?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3o9E)) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored because an external consumer needs to override the style with styled component. https://atlassian.slack.com/archives/C06K9T53N66/p1745962052140289?thread_ts=1745868665.350719&cid=C06K9T53N66
    ), {
        className: (0, $35pXk.default)([
            "_kqswstnw _154inicn _1ltv1q9q _1bsb12am _4t3i7vkz _t9ec2k2r",
            source === 'jira-highlight-actions' && "_154id439 _1ltv1vh9",
            "dot-animation-loader"
        ]),
        ...$04174aaad1427a0e$var$loadingAnimationOptions
    });
};

});
parcelRegister("kdgNh", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":29.9700012207031,\"ip\":0,\"op\":95.0000038694293,\"w\":1920,\"h\":1080,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Shape Layer 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[502.345,0,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.4,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":2,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":50.479,\"s\":[1486.1,615.223],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":63,\"s\":[1486.1,400],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":72.74,\"s\":[1486.1,575.917],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":79,\"s\":[1486.1,528.917],\"to\":[0,0],\"ti\":[0,0]},{\"t\":82.0000033399285,\"s\":[1486.1,615.223]}],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0.594,0.384,0.713,0.461,0.777,0.645,0.66,1,0.961,0.906,0.607],\"ix\":9}},\"s\":{\"a\":0,\"k\":[1244.484,582.344],\"ix\":5},\"e\":{\"a\":0,\"k\":[1727.031,624.016],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Shape Layer 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":20.479,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0.076},\"t\":21,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":33,\"s\":[1486.1,400,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":42.74,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":49,\"s\":[1486.1,528.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":52.0000021180034,\"s\":[1486.1,615.223,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.7,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.749019607843,0.388235294118,0.952941176471,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Shape Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[2454.1,1191.14,0],\"ix\":2,\"l\":2},\"a\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":1,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":8,\"s\":[1486.1,784.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":15,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":21.441,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":24.00000097754,\"s\":[1486.1,575.917,0]}],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":46.3,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":50,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0,0.396,1,0.724,0.182,0.396,1,1,0.364,0.396,1],\"ix\":9}},\"s\":{\"a\":0,\"k\":[0,0],\"ix\":5},\"e\":{\"a\":0,\"k\":[100,0],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[]}");

});


parcelRegister("bwqdG", function(module, exports) {

$parcel$export(module.exports, "AIAnswerBody", () => $900fa72344220951$export$e2b54fc495614d59);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $fYQcF = parcelRequire("fYQcF");

var $4jIuc = parcelRequire("4jIuc");

var $f7lNm = parcelRequire("f7lNm");

var $eRXI0 = parcelRequire("eRXI0");

var $7Zbm6 = parcelRequire("7Zbm6");

var $dp7uy = parcelRequire("dp7uy");
var $1B9Mx = parcelRequire("1B9Mx");
var $jfJyy = parcelRequire("jfJyy");
var $gjS7S = parcelRequire("gjS7S");

var $eyk5b = parcelRequire("eyk5b");
const $900fa72344220951$var$AIAnswerResult = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat } = commonAttributes;
    (0, $gwFzn.useEffect)(()=>{
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }) : trackAIResultView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const AIAnswerResultComponent = (0, $gwFzn.useMemo)(()=>{
        switch(answerFormat){
            case (0, $7Zbm6.NLPSearchResultFormat).ADF:
            case (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN:
                return 0, $gjS7S.RenderedResultComponent;
            case (0, $7Zbm6.NLPSearchResultFormat).JSON:
                return 0, $1B9Mx.JsonResultComponent;
            case (0, $7Zbm6.NLPSearchResultFormat).PLAINTEXT:
            default:
                return 0, $jfJyy.PlaintextResultComponent;
        }
    }, [
        answerFormat
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(AIAnswerResultComponent, {});
};
const $900fa72344220951$export$e2b54fc495614d59 = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $eRXI0.useAIAnswerContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyk5b.AIAnswerBodyWrapper), {
        isReadingAids: isReadingAids && cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT,
        children: isAnswered && !hasError ? /*#__PURE__*/ (0, $7UHDa.jsx)($900fa72344220951$var$AIAnswerResult, {}) : hasError ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyk5b.AIAnswerErrorWrapper), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dp7uy.AIAnswerError), {})
        }) : null
    });
};

});
parcelRegister("dp7uy", function(module, exports) {

$parcel$export(module.exports, "AIAnswerError", () => $e987865c989cf24e$export$ffa24cd7196ce1b0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $2Nwuj = parcelRequire("2Nwuj");

var $dh538 = parcelRequire("dh538");

var $fYQcF = parcelRequire("fYQcF");

var $f7lNm = parcelRequire("f7lNm");

var $7lL49 = parcelRequire("7lL49");

var $js43j = parcelRequire("js43j");

var $eRXI0 = parcelRequire("eRXI0");

var $7Zbm6 = parcelRequire("7Zbm6");

var $dIrGc = parcelRequire("dIrGc");
const $e987865c989cf24e$export$ffa24cd7196ce1b0 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { advancedSearchUrl: advancedSearchUrl, commonAttributes: { errorState: errorState, errorCode: errorCode }, isReadingAids: isReadingAids, brand: brand } = (0, $eRXI0.useAIAnswerContext)();
    const { trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)();
    (0, $gwFzn.useEffect)(()=>{
        if (errorState !== (0, $7Zbm6.NLPSearchErrorState).Default) trackAIResultError({
            aiErrorMessage: errorState || '',
            aiErrorCode: errorCode ?? 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const brandName = brand === (0, $f7lNm.AiBrand).ROVO ? 'Rovo' : 'Atlassian Intelligence';
    const errorMessage = (0, $gwFzn.useMemo)(()=>{
        switch(errorState){
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswer:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerHydration:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerRelevantContent:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_no_answer,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.InfoLink), {
                            href: (0, $f7lNm.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_onboarding_banner_tooltip_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_keyword,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.InfoLink), {
                            href: (0, $f7lNm.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_onboarding_banner_tooltip_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_acceptable_use,
                    values: {
                        brandName: brandName,
                        acceptableUseLink: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.InfoLink), {
                            href: (0, $f7lNm.ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_error_state_acceptable_use_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).SubjectiveQuery:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_subjective_query,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_open_ai_rate_limit_error,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.InfoLink), {
                            href: (0, $f7lNm.ATLASSIAN_AI_USAGE_LIMITS_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_support_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_no_who_is_answer,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NetworkError:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $7Zbm6.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_network,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.InfoLink), {
                            href: (0, $f7lNm.ATLASSIAN_AI_TROUBLESHOOT_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_support_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.InfoLink), {
                            href: (0, $f7lNm.ATLASSIAN_HIPAA_COMPLICANCE_LINK),
                            target: '_blank',
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_hipaa_compliance_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_component_result_error_text,
                    values: {
                        brandName: brandName,
                        advancedSearchLink: !!advancedSearchUrl ? (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__knowledge-disc') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            href: advancedSearchUrl,
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_result_error_advanced_search_link)
                        }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                            href: advancedSearchUrl,
                            children: formatMessage((0, $7lL49.messages).ai_answer_component_result_error_advanced_search_link)
                        }) : formatMessage((0, $7lL49.messages).ai_answer_component_result_error_advanced_search_link)
                    }
                });
        }
    }, [
        advancedSearchUrl,
        errorState,
        formatMessage,
        brandName
    ]);
    return isReadingAids ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $js43j.DefinitionError), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerResultSection), {
            isReadingAids: isReadingAids,
            isExpanded: true,
            children: errorMessage
        })
    });
};

});
parcelRegister("js43j", function(module, exports) {

$parcel$export(module.exports, "DefinitionError", () => $351ba46eec5db167$export$f874592093e19f27);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $6xdDU = parcelRequire("6xdDU");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");

var $eRXI0 = parcelRequire("eRXI0");

var $7Zbm6 = parcelRequire("7Zbm6");

var $f7lNm = parcelRequire("f7lNm");

var $gdLbU = parcelRequire("gdLbU");

var $a7RTn = parcelRequire("a7RTn");

var $jBpLK = parcelRequire("jBpLK");

var $48KYD = parcelRequire("48KYD");

var $gwrgp = parcelRequire("gwrgp");
const $351ba46eec5db167$var$InfoLink = (0, $gwrgp.default)("a", {
    target: "eylg5kv0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    color: `${`var(--ds-text-accent-blue, ${(0, $6fnsQ.B300)})`} !important`,
    textDecoration: 'underline'
});
const $351ba46eec5db167$var$ErrorPaddingStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.100'
});
const $351ba46eec5db167$var$ErrorMessageStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text'
});
const $351ba46eec5db167$export$f874592093e19f27 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { brand: brand, commonAttributes: { errorState: errorState }, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const createDefinitionEnabled = !!definitionCurationOptions;
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $gwFzn.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $gwFzn.useState)(false);
    const showAddDefinitionButton = createDefinitionEnabled && (errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswer || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerHydration || errorState === (0, $7Zbm6.NLPSearchErrorState).NoAnswerRelevantContent || errorState === (0, $7Zbm6.NLPSearchErrorState).Default);
    const errorMessage = (0, $gwFzn.useMemo)(()=>{
        switch(errorState){
            case (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $48KYD.messages).definition_no_answer_acceptable_use_error,
                    values: {
                        acceptableUseLink: /*#__PURE__*/ (0, $7UHDa.jsx)($351ba46eec5db167$var$InfoLink, {
                            href: (0, $gdLbU.ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK),
                            target: '_blank',
                            children: formatMessage((0, $48KYD.messages).definition_no_answer_acceptable_use_link)
                        }),
                        brand: brand === (0, $f7lNm.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NetworkError:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $7Zbm6.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $48KYD.messages).definition_no_answer_network_error,
                    values: {
                        brand: brand === (0, $f7lNm.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo',
                        supportLink: /*#__PURE__*/ (0, $7UHDa.jsx)($351ba46eec5db167$var$InfoLink, {
                            href: (0, $gdLbU.ATLASSIAN_AI_TROUBLESHOOT_LINK),
                            target: '_blank',
                            children: formatMessage((0, $48KYD.messages).definitions_support_link_text)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $48KYD.messages).definitions_no_answer_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ (0, $7UHDa.jsx)($351ba46eec5db167$var$InfoLink, {
                            href: (0, $gdLbU.ATLASSIAN_HIPAA_COMPLICANCE_LINK),
                            target: '_blank',
                            children: formatMessage((0, $48KYD.messages).definitions_no_answer_hipaa_compliance_link)
                        })
                    }
                });
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswer:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerHydration:
            case (0, $7Zbm6.NLPSearchErrorState).NoAnswerRelevantContent:
            case (0, $7Zbm6.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $48KYD.messages).definition_no_answer_error,
                    values: {
                        brand: brand === (0, $f7lNm.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
        }
    }, [
        errorState,
        formatMessage,
        brand
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $351ba46eec5db167$var$ErrorPaddingStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $351ba46eec5db167$var$ErrorMessageStyles,
                        children: errorMessage
                    }),
                    showAddDefinitionButton && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
                        justifyContent: "end",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            appearance: "default",
                            onClick: ()=>setShowEditDefinitionModal(true),
                            children: formatMessage((0, $48KYD.messages).definition_no_answer_add_definition_button)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: showEditDefinitionModal && showAddDefinitionButton && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jBpLK.EditDefinitionModal), {
                    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                    closeEditModal: ()=>setShowEditDefinitionModal(false),
                    isCreateDefinition: true,
                    onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7RTn.DefinitionUpdateConfirmationFlag), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};

});
parcelRegister("gdLbU", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_INTELLIGENCE_TRUST_LINK", () => $f444507c1ee2a540$export$59da2b3b71a076c7);
$parcel$export(module.exports, "ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK", () => $f444507c1ee2a540$export$96cc4126cdc27248);
$parcel$export(module.exports, "ATLASSIAN_AI_TROUBLESHOOT_LINK", () => $f444507c1ee2a540$export$50e6b843de210064);
$parcel$export(module.exports, "ATLASSIAN_ROVO_LINK", () => $f444507c1ee2a540$export$2c1028e1e7bf5557);
$parcel$export(module.exports, "ATLASSIAN_HIPAA_COMPLICANCE_LINK", () => $f444507c1ee2a540$export$dd87179defae3659);
$parcel$export(module.exports, "FEEDBACK_CONTEXT_CF", () => $f444507c1ee2a540$export$d04cd98bb7625919);
$parcel$export(module.exports, "FEEDBACK_ENTRYPOINT_ID_DEFINITIONS", () => $f444507c1ee2a540$export$dd6343c56092a345);
const $f444507c1ee2a540$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $f444507c1ee2a540$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $f444507c1ee2a540$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $f444507c1ee2a540$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $f444507c1ee2a540$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $f444507c1ee2a540$export$d04cd98bb7625919 = 'customfield_10047';
const $f444507c1ee2a540$export$dd6343c56092a345 = '3655ce1d-16b8-4630-9e93-6c39069625fa';

});

parcelRegister("a7RTn", function(module, exports) {

$parcel$export(module.exports, "DefinitionUpdateConfirmationFlag", () => $d3ceefd4d089bcb8$export$7475d9ffda76c69b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $aD1SW = parcelRequire("aD1SW");
var $6uGcC = parcelRequire("6uGcC");

var $aUEBE = parcelRequire("aUEBE");

var $7zbsd = parcelRequire("7zbsd");
const $d3ceefd4d089bcb8$export$7475d9ffda76c69b = ({ onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
        onDismissed: ()=>onDismissed(),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aD1SW.default), {
            id: "definition-update-success-adflag",
            title: formatMessage((0, $7zbsd.messages).edit_definition_update_confirmation_title),
            description: formatMessage((0, $7zbsd.messages).edit_definition_update_confirmation_description),
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aUEBE))), {
                label: "Success",
                color: "var(--ds-icon-success, #22A06B)"
            })
        })
    });
};

});
parcelRegister("7zbsd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $710a59a2e41f348f$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $710a59a2e41f348f$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    edit_definition_modal_header_edit: {
        id: "search_ai.edit_definition_modal_header_edit",
        defaultMessage: "Edit definition"
    },
    edit_definition_modal_header_create: {
        id: "search_ai.edit_definition_modal_header_create",
        defaultMessage: "Add a definition"
    },
    edit_definition_modal_subheader_text: {
        id: "search_ai.edit_definition_modal_subheader_text",
        defaultMessage: "You can edit definitions to help teammates better understand terms."
    },
    edit_definition_modal_subheader_link_text: {
        id: "search_ai.edit_definition_modal_subheader_link_text",
        defaultMessage: "More on editing definitions"
    },
    edit_definition_text_box_label: {
        id: "search_ai.edit_definition_text_box_label",
        defaultMessage: "Definition"
    },
    edit_definition_text_box_label_with_count: {
        id: "search_ai.edit_definition_text_box_label_with_count",
        defaultMessage: "Main definition content area, {count} of {max} characters used. Start typing to enter text."
    },
    edit_definition_no_definition: {
        id: "search_ai.edit_definition_no_definition",
        defaultMessage: "Enter definition"
    },
    edit_definition_source_label: {
        id: "search_ai.edit_definition_source_label",
        defaultMessage: "Source"
    },
    edit_definition_add_source_label: {
        id: "search_ai.edit_definition_add_source_label",
        defaultMessage: "Add a source (optional)"
    },
    edit_definition_restricted_to_label: {
        id: "search_ai.edit_definition_restricted_to_label",
        defaultMessage: "Show this definition"
    },
    edit_definition_restricted_to_space_subline: {
        id: "search_ai.edit_definition_restricted_to_space_subline",
        defaultMessage: "Previous definition will still show in other spaces."
    },
    edit_definition_restricted_to_site_subline: {
        id: "search_ai.edit_definition_restricted_to_site_subline",
        defaultMessage: "Previous definition will still show on other sites."
    },
    edit_definition_restricted_to_project_subline: {
        id: "search_ai.edit_definition_restricted_to_project_subline",
        defaultMessage: "Previous definition will still show in other projects."
    },
    edit_definition_restricted_to_page_subline: {
        id: "search_ai.edit_definition_restricted_to_page_subline",
        defaultMessage: "Previous definition will still show on other pages."
    },
    edit_definition_restricted_to_blogpost_subline: {
        id: "search_ai.edit_definition_restricted_to_blogpost_subline",
        defaultMessage: "Previous definition will still show on other blogposts."
    },
    edit_definition_source_search_box_placeholder: {
        id: "search_ai.edit_definition_source_search_box_placeholder",
        defaultMessage: "Search or paste a Confluence link"
    },
    edit_definition_back_button: {
        id: "search_ai.edit_definition_back_button",
        defaultMessage: "Back"
    },
    edit_definition_update_button: {
        id: "search_ai.edit_definition_update_button",
        defaultMessage: "Update"
    },
    edit_definition_source_option_metadata_updated_text: {
        id: "search_ai.edit_definition_source_option_metadata_updated_text",
        defaultMessage: "Updated"
    },
    edit_definition_update_confirmation_title: {
        id: "search_ai.edit_definition_update_confirmation_title",
        defaultMessage: "Definition updated \uD83C\uDF89"
    },
    edit_definition_update_confirmation_description: {
        id: "search_ai.edit_definition_update_confirmation_description",
        defaultMessage: "You've made work clearer for your teammates."
    }
});

});


parcelRegister("jBpLK", function(module, exports) {

$parcel$export(module.exports, "EditDefinitionModal", () => $0b273c023ce36571$export$ea8c8594ad1f3bf3);
/* edit-definition-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1o86H = parcelRequire("1o86H");

var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $bfgIy = parcelRequire("bfgIy");

var $bSmaw = parcelRequire("bSmaw");

var $2Nwuj = parcelRequire("2Nwuj");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $5n5ey = parcelRequire("5n5ey");
var $2gD2K = parcelRequire("2gD2K");

var $epS7s = parcelRequire("epS7s");

var $eRXI0 = parcelRequire("eRXI0");

var $3Opgu = parcelRequire("3Opgu");

var $9pwVP = parcelRequire("9pwVP");

var $xhg8G = parcelRequire("xhg8G");

var $9KkVf = parcelRequire("9KkVf");

var $ij0nG = parcelRequire("ij0nG");

var $7zbsd = parcelRequire("7zbsd");

var $62ot6 = parcelRequire("62ot6");

var $lfRXp = parcelRequire("lfRXp");

var $kvtjF = parcelRequire("kvtjF");

var $iu5DO = parcelRequire("iu5DO");

var $8cuJt = parcelRequire("8cuJt");
const $0b273c023ce36571$var$MAX_DEFINITION_LENGTH = 500;
const $0b273c023ce36571$var$editDefintionModalStyles = {
    editDefinitionTextboxLabelContainer: "_85i51b66",
    editDefinitionTextboxErrorMessageContainer: "_1q511b66",
    radialProgressBarContainer: "_85i5v77o",
    restrictionSelectSublineContainer: "_1q511b66"
};
const $0b273c023ce36571$export$ea8c8594ad1f3bf3 = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, closeEditModal: closeEditModal, openFeedbackOptionsModal: openFeedbackOptionsModal, isCreateDefinition: isCreateDefinition, onSaveEditModal: onSaveEditModal })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, setData: setData, answerEditor: answerEditor, additionalQueryContext: additionalQueryContext } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, query: keyPhrase } = commonAttributes;
    const [editedDefinition, setEditedDefinition] = (0, $gwFzn.useState)(answerString);
    const updateDefinitionDisabled = editedDefinition.trim() === '';
    const [charCount, setCharCount] = (0, $gwFzn.useState)(0);
    const [sourceSearchInput, setSourceSearchInput] = (0, $gwFzn.useState)('');
    const [source, setSource] = (0, $gwFzn.useState)(null);
    const { definitionRestrictionOptions: definitionRestrictionOptions } = curatedDefinitionScopeConfig;
    const defaultRestrictionOption = definitionRestrictionOptions[0];
    const [audienceRestriction, setAudienceRestriction] = (0, $gwFzn.useState)(defaultRestrictionOption.value);
    const [updateDefinitionLoading, setUpdateDefinitionLoading] = (0, $gwFzn.useState)(false);
    const setDefinition = (0, $gwFzn.useCallback)((value)=>{
        setEditedDefinition(value);
    }, [
        setEditedDefinition
    ]);
    const { searchSources: searchSources } = (0, $8cuJt.useSearchSourceSupplier)();
    const onSourceSearchInputChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') setSourceSearchInput(input);
    };
    const onSelectSource = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setSource(newValue);
    };
    const onSelectRestrictionOption = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setAudienceRestriction(newValue?.value || (0, $9KkVf.EditedDefinitionScope).ORGANIZATION);
    };
    const { createDefinition: createDefinition } = (0, $iu5DO.useCreateDefinitionSupplier)({
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const onUpdateDefinition = async ()=>{
        setUpdateDefinitionLoading(true);
        try {
            const updatedDefinition = await createDefinition({
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: audienceRestriction,
                referenceContentId: source ? source.id : null,
                referenceUrl: source ? source.url : null
            });
            setUpdateDefinitionLoading(false);
            setSource(null);
            fireAnalyticsEvent((0, $9pwVP.onCuratedDefinitionUpdateButtonClicked)({
                commonAttributes: commonAttributes,
                newDefinition: editedDefinition,
                restrictedScope: audienceRestriction,
                sourceSelected: !!source,
                aiDefinitionEdited: !!!answerEditor
            }));
            setData(updatedDefinition);
            (0, $epS7s.setSessionItem)((0, $3Opgu.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: keyPhrase,
                additionalContext: additionalQueryContext || '',
                data: updatedDefinition
            }));
            closeEditModal();
            onSaveEditModal?.();
        } catch (error) {
            fireAnalyticsEvent((0, $xhg8G.updateDefinitionErrorPayload)(error, commonAttributes));
            setUpdateDefinitionLoading(false);
        }
    };
    let conditionalSublineMessage;
    switch(audienceRestriction){
        case (0, $9KkVf.EditedDefinitionScope).SPACE:
            conditionalSublineMessage = (0, $7zbsd.messages).edit_definition_restricted_to_space_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).PROJECT:
            conditionalSublineMessage = (0, $7zbsd.messages).edit_definition_restricted_to_project_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).PAGE:
            conditionalSublineMessage = (0, $7zbsd.messages).edit_definition_restricted_to_page_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).BLOGPOST:
            conditionalSublineMessage = (0, $7zbsd.messages).edit_definition_restricted_to_space_subline;
            break;
        case (0, $9KkVf.EditedDefinitionScope).ORGANIZATION:
            conditionalSublineMessage = (0, $7zbsd.messages).edit_definition_restricted_to_site_subline;
            break;
        default:
            conditionalSublineMessage = (0, $7zbsd.messages).edit_definition_restricted_to_site_subline;
            break;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
        onClose: closeEditModal,
        shouldScrollInViewport: true,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                    children: formatMessage(isCreateDefinition ? (0, $7zbsd.messages).edit_definition_modal_header_create : (0, $7zbsd.messages).edit_definition_modal_header_edit)
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $iXCQx.default), {
                            as: "p",
                            color: "color.text.subtle",
                            children: [
                                formatMessage((0, $7zbsd.messages).edit_definition_modal_subheader_text),
                                ' ',
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                                    href: "https://support.atlassian.com/rovo/docs/add-or-edit-a-definition/",
                                    children: formatMessage((0, $7zbsd.messages).edit_definition_modal_subheader_link_text)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                                        alignBlock: "center",
                                        grow: "fill",
                                        spread: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                                xcss: $0b273c023ce36571$var$editDefintionModalStyles.editDefinitionTextboxLabelContainer,
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    weight: "bold",
                                                    size: "small",
                                                    children: formatMessage((0, $7zbsd.messages).edit_definition_text_box_label)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                                                alignBlock: "center",
                                                space: "space.075",
                                                children: [
                                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $iXCQx.default), {
                                                        as: "span",
                                                        size: "small",
                                                        color: "color.text.subtle",
                                                        children: [
                                                            charCount,
                                                            "/",
                                                            $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                                        xcss: $0b273c023ce36571$var$editDefintionModalStyles.radialProgressBarContainer,
                                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $62ot6.RadialProgressBar), {
                                                            current: charCount,
                                                            max: $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ij0nG.MarkdownEditor), {
                                    value: editedDefinition,
                                    setValue: setDefinition,
                                    setCharCount: setCharCount,
                                    maxCharacters: $0b273c023ce36571$var$MAX_DEFINITION_LENGTH,
                                    assistiveLabel: formatMessage((0, $7zbsd.messages).edit_definition_text_box_label_with_count, {
                                        count: charCount,
                                        max: $0b273c023ce36571$var$MAX_DEFINITION_LENGTH
                                    }),
                                    assistiveDescribedBy: "edit-definition-text-box-error-message"
                                }),
                                updateDefinitionDisabled && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                                    alignBlock: "center",
                                    space: "space.050",
                                    xcss: $0b273c023ce36571$var$editDefintionModalStyles.editDefinitionTextboxErrorMessageContainer,
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSmaw))), {
                                            label: "",
                                            LEGACY_size: "small",
                                            color: "var(--ds-text-danger, #AE2E24)"
                                        }),
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                            color: "color.text.danger",
                                            size: "small",
                                            id: "edit-definition-text-box-error-message",
                                            children: formatMessage((0, $7zbsd.messages).edit_definition_no_definition)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bfgIy.Label), {
                                    htmlFor: "edit-definition-source-select",
                                    children: formatMessage(source ? (0, $7zbsd.messages).edit_definition_source_label : (0, $7zbsd.messages).edit_definition_add_source_label)
                                }),
                                source ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kvtjF.SourceOption), {
                                    source: source,
                                    onClickSource: ()=>{
                                        window.open(source.url, '_blank')?.focus();
                                    },
                                    canClear: true,
                                    onRemoveSource: (e)=>{
                                        e.stopPropagation();
                                        setSource(null);
                                    }
                                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5n5ey.default), {
                                    components: {
                                        DropdownIndicator: ()=>null
                                    },
                                    loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($1o86H)))((input)=>searchSources(input), 500),
                                    formatOptionLabel: (sourceOption)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kvtjF.SourceOption), {
                                            source: sourceOption,
                                            canClear: false
                                        }),
                                    onChange: onSelectSource,
                                    inputValue: sourceSearchInput,
                                    onInputChange: onSourceSearchInputChange,
                                    placeholder: formatMessage((0, $7zbsd.messages).edit_definition_source_search_box_placeholder),
                                    menuPosition: "fixed",
                                    inputId: "edit-definition-source-select"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bfgIy.Label), {
                                    htmlFor: "edit-definition-restriction-select",
                                    children: formatMessage((0, $7zbsd.messages).edit_definition_restricted_to_label)
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gD2K.default), {
                                    options: definitionRestrictionOptions,
                                    defaultValue: defaultRestrictionOption,
                                    onChange: onSelectRestrictionOption,
                                    formatOptionLabel: (0, $lfRXp.restrictionOptionFormatter),
                                    isSearchable: false,
                                    menuPosition: "fixed",
                                    inputId: "edit-definition-restriction-select",
                                    descriptionId: "edit-definition-restriction-subline"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                    xcss: $0b273c023ce36571$var$editDefintionModalStyles.restrictionSelectSublineContainer,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                        color: "color.text.subtle",
                                        size: "small",
                                        children: formatMessage(conditionalSublineMessage)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8o1lj.default), {
                children: [
                    openFeedbackOptionsModal && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: ()=>{
                            closeEditModal();
                            openFeedbackOptionsModal();
                        },
                        children: formatMessage((0, $7zbsd.messages).edit_definition_back_button)
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        appearance: updateDefinitionDisabled ? 'default' : 'primary',
                        isLoading: updateDefinitionLoading,
                        onClick: onUpdateDefinition,
                        isDisabled: updateDefinitionDisabled,
                        children: formatMessage((0, $7zbsd.messages).edit_definition_update_button)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("ij0nG", function(module, exports) {

$parcel$export(module.exports, "MarkdownEditor", () => $b874189e677abb1d$export$18a9461578883ec4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $e6Iiv = parcelRequire("e6Iiv");

var $auTg8 = parcelRequire("auTg8");

var $gVoWJ = parcelRequire("gVoWJ");

var $1JdaQ = parcelRequire("1JdaQ");

var $aRZzN = parcelRequire("aRZzN");

var $8POG7 = parcelRequire("8POG7");

var $88OoA = parcelRequire("88OoA");

var $bGnP4 = parcelRequire("bGnP4");

var $fH5dz = parcelRequire("fH5dz");

var $gdv5Z = parcelRequire("gdv5Z");

var $b7FrM = parcelRequire("b7FrM");

var $6eZqW = parcelRequire("6eZqW");

var $ltX0q = parcelRequire("ltX0q");
const $b874189e677abb1d$export$18a9461578883ec4 = ({ value: value, setValue: setValue, setCharCount: setCharCount, maxCharacters: maxCharacters, assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy })=>{
    const { preset: preset } = (0, $1JdaQ.usePreset)(()=>(0, $gVoWJ.createDefaultPreset)({
            allowUndoRedoButtons: true,
            textFormatting: {
                responsiveToolbarMenu: true
            }
        }).add((0, $8POG7.indentationPlugin)).add((0, $88OoA.listPlugin)).add([
            (0, $fH5dz.toolbarListsIndentationPlugin),
            {
                showIndentationButtons: true,
                allowHeadingAndParagraphIndentation: false
            }
        ]).maybeAdd([
            (0, $bGnP4.maxContentSizePlugin),
            maxCharacters
        ], (0, $bGnP4.maxContentSizePlugin) !== undefined), []);
    const adfEncoder = (0, $gwFzn.useMemo)(()=>new (0, $b7FrM.ADFEncoder)((schema)=>new (0, $aRZzN.MarkdownTransformer)(schema)), []);
    const initializeEditor = (0, $gwFzn.useCallback)((actions)=>{
        const encodedValue = adfEncoder.encode(value);
        actions.replaceDocument(encodedValue);
    }, [
        value,
        adfEncoder
    ]);
    const onEditorChange = (0, $gwFzn.useCallback)((editorView)=>{
        const { markdown: markdown } = (0, $6eZqW.convertProsemirrorToMarkdown)({
            editorView: editorView,
            fragment: editorView.state.doc.content
        });
        // ? Editor component seems to add invisible characters in certain cases. Using this function to remove them and set back to the definition state.
        const markdownWithoutInvisibleChars = (0, $ltX0q.removeInvisibleCharacters)(markdown);
        setValue(markdownWithoutInvisibleChars);
        setCharCount?.(markdownWithoutInvisibleChars.length);
    }, [
        setValue,
        setCharCount
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auTg8.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e6Iiv.ComposableEditor), {
                    appearance: "comment",
                    preset: preset,
                    shouldFocus: true,
                    quickInsert: false,
                    minHeight: 170,
                    maxHeight: 90,
                    onEditorReady: initializeEditor,
                    onChange: onEditorChange,
                    assistiveLabel: assistiveLabel,
                    assistiveDescribedBy: assistiveDescribedBy
                })
            })
        })
    });
};

});
parcelRegister("ltX0q", function(module, exports) {

$parcel$export(module.exports, "getQuerySpecsPerEntity", () => $131be2c19d5d7968$export$3b4150834edadf59);
$parcel$export(module.exports, "getEntityIdInScope", () => $131be2c19d5d7968$export$248ff3a730ef0924);
$parcel$export(module.exports, "mapCreatedDefinitionToNLPSearchType", () => $131be2c19d5d7968$export$40e11c80593ec8d4);
$parcel$export(module.exports, "removeInvisibleCharacters", () => $131be2c19d5d7968$export$7f32babab6e8c339);

var $7Zbm6 = parcelRequire("7Zbm6");

var $9KkVf = parcelRequire("9KkVf");
const $131be2c19d5d7968$export$3b4150834edadf59 = (query)=>{
    const pageOrBlogRegex = /spaces\/.*\/(pages|blog)/;
    const spaceRegex = /https:\/\/[^\/]+\/wiki\/spaces\/(?!.*\/(pages|blog)).*/;
    const confluenceTinyRegex = RegExp("\\/wiki\\/x\\/(?<resourceId>[^\\/(?)]+)$");
    const queryParts = query.split('/');
    const queryParamsRemoved = query.split('?')[0];
    if (query.match(pageOrBlogRegex)) // e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
    return {
        searchQuery: queryParts[queryParts.length - 1],
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined
    };
    else if (query.match(spaceRegex)) {
        // e.g. https://hello.atlassian.net/wiki/spaces/SK1/overview
        const spacesIndex = queryParts.indexOf('spaces');
        return {
            searchQuery: '',
            entities: [
                'ati:cloud:confluence:space'
            ],
            spacesFilter: [
                spacesIndex > -1 ? queryParts[spacesIndex + 1] : ''
            ]
        };
    } else if (queryParamsRemoved.match(confluenceTinyRegex)) // e.g. https://hello.atlassian.net/wiki/x/4c942w
    return {
        searchQuery: '',
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined,
        needsLinkResolution: true
    };
    return {
        searchQuery: query,
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:space'
        ],
        spacesFilter: undefined
    };
};
const $131be2c19d5d7968$export$248ff3a730ef0924 = ({ selectedScope: selectedScope, productScopes: productScopes, cloudId: cloudId })=>{
    let contentARI = '';
    let spaceARI = '';
    let projectARI = '';
    if ('contentARI' in productScopes) {
        contentARI = productScopes.contentARI;
        spaceARI = productScopes.spaceARI;
    }
    if ('projectARI' in productScopes) projectARI = productScopes.projectARI;
    switch(selectedScope){
        case (0, $9KkVf.EditedDefinitionScope).PAGE:
        case (0, $9KkVf.EditedDefinitionScope).BLOGPOST:
            return contentARI;
        case (0, $9KkVf.EditedDefinitionScope).SPACE:
            return spaceARI;
        case (0, $9KkVf.EditedDefinitionScope).PROJECT:
            return projectARI;
        default:
            return cloudId;
    }
};
const $131be2c19d5d7968$export$40e11c80593ec8d4 = (definitionDetails)=>{
    const definitionReferenceDetails = definitionDetails.confluenceEntity;
    return {
        nlpResult: definitionDetails.definition,
        uniqueSources: definitionDetails.confluenceEntity ? [
            {
                id: definitionReferenceDetails?.id || '',
                title: definitionReferenceDetails?.title || '',
                url: definitionDetails.referenceUrl || '',
                type: definitionReferenceDetails?.type || '',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReferenceDetails?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: {
            name: definitionDetails.editor?.name || '',
            id: definitionDetails.editor?.accountId || ''
        },
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
    };
};
const $131be2c19d5d7968$export$7f32babab6e8c339 = (str)=>{
    return str.replace(/[\u200c]/g, '');
};

});


parcelRegister("62ot6", function(module, exports) {

$parcel$export(module.exports, "RadialProgressBar", () => $34a7854a5a3a66c0$export$a4badf890ec26dc0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gwrgp = parcelRequire("gwrgp");
const $34a7854a5a3a66c0$var$Wrapper = (0, $gwrgp.default)("div", {
    target: "e4ot31b0"
})({
    name: "1aeu6rd",
    styles: "position:relative;width:20px;height:20px;"
});
// We need to scale the canvas down to increase the sharpness of the circle
// Otherwise the graphics will be blurry
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34a7854a5a3a66c0$var$CanvasWrapper = (0, $gwrgp.default)("div", {
    target: "e4ot31b1"
})({
    name: "4qd1ft",
    styles: "position:absolute;width:200px;height:200px;top:-90px;left:-90px;transform:scale(0.1);"
});
const $34a7854a5a3a66c0$export$a4badf890ec26dc0 = ({ current: current, max: max })=>{
    const canvasRef = (0, $gwFzn.useRef)(null);
    // Draw the current circle progress bar
    (0, $gwFzn.useEffect)(()=>{
        const ctx = canvasRef.current?.getContext('2d');
        if (ctx) {
            if (current >= max) {
                ctx.beginPath();
                ctx.strokeStyle = '#E91618';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
            } else {
                ctx.beginPath();
                ctx.strokeStyle = '#DCDFE4';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = '#22A06B';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, -0.5 * Math.PI, 2 * Math.PI * (current / max) - 0.5 * Math.PI);
                ctx.stroke();
            }
        }
    }, [
        current,
        max
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($34a7854a5a3a66c0$var$Wrapper, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($34a7854a5a3a66c0$var$CanvasWrapper, {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("canvas", {
                ref: canvasRef,
                height: 200,
                width: 200
            })
        })
    });
};

});

parcelRegister("lfRXp", function(module, exports) {

$parcel$export(module.exports, "restrictionOptionFormatter", () => $543a21d2965741c7$export$66608c4e05327916);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");
const $543a21d2965741c7$var$optionWrapperStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $543a21d2965741c7$export$66608c4e05327916 = (option)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $543a21d2965741c7$var$optionWrapperStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.100",
            children: [
                option.icon,
                option.label
            ]
        })
    });
};

});

parcelRegister("kvtjF", function(module, exports) {

$parcel$export(module.exports, "SourceOption", () => $8705ac0bd6b28f92$export$bd0bc6e060a5a86f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $dQMPp = parcelRequire("dQMPp");

var $bueVT = parcelRequire("bueVT");

var $5yCDo = parcelRequire("5yCDo");

var $2hj6R = parcelRequire("2hj6R");

var $cHaKZ = parcelRequire("cHaKZ");

var $gj7hi = parcelRequire("gj7hi");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7zbsd = parcelRequire("7zbsd");
const $8705ac0bd6b28f92$var$SourceOptionWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.150',
    boxSizing: 'border-box',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        cursor: 'pointer'
    }
});
const $8705ac0bd6b28f92$var$SourceOptionTitleStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $8705ac0bd6b28f92$var$SourceOptionMetadataStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $8705ac0bd6b28f92$var$SourceOptionMetatadataSeparatorStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $8705ac0bd6b28f92$var$SourceImageContainerStyles = (0, $ecnYn.xcss)({
    height: '24px',
    width: '24px'
});
const $8705ac0bd6b28f92$var$SourceSpaceImage = ({ source: source })=>{
    return source.iconUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8705ac0bd6b28f92$var$SourceImageContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
            src: source.iconUrl,
            alt: ""
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: "",
        appearance: "blueBold",
        shape: "square",
        size: "24"
    });
};
const $8705ac0bd6b28f92$export$bd0bc6e060a5a86f = ({ source: source, canClear: canClear, onClickSource: onClickSource, onRemoveSource: onRemoveSource })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $dBxQj.default)();
    let sourceIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5yCDo.default), {
        label: ""
    });
    if (source.type === 'space') sourceIcon = /*#__PURE__*/ (0, $7UHDa.jsx)($8705ac0bd6b28f92$var$SourceSpaceImage, {
        source: source
    });
    else if (source.type === 'blogpost') sourceIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bueVT.default), {
        label: ""
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $8705ac0bd6b28f92$var$SourceOptionWrapperStyles,
        onClick: onClickSource,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                alignItems: "center",
                gap: "space.150",
                children: [
                    sourceIcon,
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $8705ac0bd6b28f92$var$SourceOptionTitleStyles,
                                children: source.title
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                                xcss: $8705ac0bd6b28f92$var$SourceOptionMetadataStyles,
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                        children: source.container
                                    }),
                                    source.lastModified && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                        xcss: $8705ac0bd6b28f92$var$SourceOptionMetatadataSeparatorStyles,
                                        children: `\u{2022}`
                                    }),
                                    source.lastModified && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                        children: `${formatMessage((0, $7zbsd.messages).edit_definition_source_option_metadata_updated_text)} ${formatDate(source.lastModified, {
                                            year: 'numeric',
                                            month: 'short',
                                            day: '2-digit'
                                        })}`
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            canClear ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                testId: `remove-source-${source.id}`,
                appearance: "subtle",
                onClick: onRemoveSource,
                label: "remove-source-option-button",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hj6R)))
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)("div", {})
        ]
    }));
};

});

parcelRegister("iu5DO", function(module, exports) {

$parcel$export(module.exports, "useCreateDefinitionSupplier", () => $219b0f3f8b8a9b06$export$4c5c8822f1a42b9f);

var $gwFzn = parcelRequire("gwFzn");

var $eRXI0 = parcelRequire("eRXI0");

var $7Zbm6 = parcelRequire("7Zbm6");

var $9EFEY = parcelRequire("9EFEY");

var $3DIgl = parcelRequire("3DIgl");

var $ltX0q = parcelRequire("ltX0q");
const $219b0f3f8b8a9b06$export$4c5c8822f1a42b9f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const createDefinition = (0, $gwFzn.useCallback)(async ({ keyPhrase: keyPhrase, editedDefinition: editedDefinition, scope: scope, referenceContentId: referenceContentId, referenceUrl: referenceUrl })=>{
        const { cloudId: cloudId } = commonAttributes;
        const { workspaceId: workspaceId, productScopes: productScopes } = curatedDefinitionScopeConfig;
        const entityIdInScope = (0, $ltX0q.getEntityIdInScope)({
            selectedScope: scope,
            cloudId: cloudId,
            productScopes: productScopes
        });
        // check needed to account for Spaces being added as sources and submitted
        const contentId = 'contentARI' in productScopes && referenceContentId === entityIdInScope ? productScopes.contentARI : referenceContentId;
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $3DIgl.CreateDefinitionMutation),
            variables: {
                workspaceId: workspaceId || '',
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: scope,
                entityIdInScope: entityIdInScope,
                referenceContentId: contentId,
                referenceUrl: referenceUrl
            }
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.createDefinition?.success) {
                const definitionDetails = response.data.knowledgeDiscovery.createDefinition.definitionDetails;
                return definitionDetails && (0, $ltX0q.mapCreatedDefinitionToNLPSearchType)(definitionDetails) || {
                    nlpResult: '',
                    format: (0, $7Zbm6.NLPSearchResultFormat).PLAINTEXT,
                    uniqueSources: [],
                    errorState: null,
                    disclaimer: null
                };
            } else throw new Error('createDefinition mutation unsuccessful');
        });
    }, [
        commonAttributes,
        curatedDefinitionScopeConfig
    ]);
    return {
        createDefinition: createDefinition
    };
};

});
parcelRegister("3DIgl", function(module, exports) {

$parcel$export(module.exports, "CreateDefinitionMutation", () => $c7ce0372232aad14$export$41f2c817c42b2303);
const $c7ce0372232aad14$export$41f2c817c42b2303 = `
	mutation CreateDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$editedDefinition: String!
		$scope: KnowledgeDiscoveryDefinitionScope!
		$entityIdInScope: String!
		$referenceContentId: String
		$referenceUrl: String
		) {
		knowledgeDiscovery {
			createDefinition(
				input: {
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				definition: $editedDefinition
				scope: $scope
				entityIdInScope: $entityIdInScope
				referenceContentId: $referenceContentId
				referenceUrl: $referenceUrl
				}
			) @optIn(to: "KnowledgeDiscovery Create definition") {
			success
			errors {
				message
			}
			definitionDetails {
				keyPhrase
				definition
				editor {
					... on User {
						name
						accountId
					}
				}
				referenceUrl
				confluenceEntity {
					... on ConfluencePage {
					id
					type
					title
					space {
						name
					}
					}
					... on ConfluenceBlogPost {
					id
					type
					title
					space {
						name
					}
					}
				}
			}
		}
	}
  }
`;

});


parcelRegister("8cuJt", function(module, exports) {

$parcel$export(module.exports, "useSearchSourceSupplier", () => $8ba66724c9ef875b$export$11c4e3b6769b440d);

var $gwFzn = parcelRequire("gwFzn");

var $eRXI0 = parcelRequire("eRXI0");

var $9EFEY = parcelRequire("9EFEY");

var $4lrdQ = parcelRequire("4lrdQ");

var $8Ww6H = parcelRequire("8Ww6H");

var $ltX0q = parcelRequire("ltX0q");
const $8ba66724c9ef875b$var$OBJECT_RESOLVE_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $8ba66724c9ef875b$export$11c4e3b6769b440d = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId, extraAttributes: extraAttributes } = commonAttributes;
    const { readingAidsSessionId: readingAidsSessionId } = extraAttributes;
    const searchSources = (0, $gwFzn.useCallback)(async (query)=>{
        const { searchQuery: searchQuery, entities: entities, spacesFilter: spacesFilter, needsLinkResolution: needsLinkResolution } = (0, $ltX0q.getQuerySpecsPerEntity)(query);
        let details;
        if (needsLinkResolution) details = await (0, $4lrdQ.fetchRestResponse)({
            url: $8ba66724c9ef875b$var$OBJECT_RESOLVE_ENDPOINT,
            body: [
                {
                    resourceUrl: query.split('?')[0]
                }
            ]
        });
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $8Ww6H.SearchSourceQuery),
            variables: {
                experience: 'curated-definition-source-search',
                analytics: {
                    searchSessionId: readingAidsSessionId
                },
                query: details?.[0]?.body?.data?.name ?? searchQuery,
                filters: {
                    entities: entities,
                    locations: [
                        cloudId ? `ari:cloud:confluence::site/${cloudId}` : ''
                    ],
                    confluenceFilters: {
                        titleMatchOnly: true,
                        spacesFilter: spacesFilter
                    }
                },
                first: 5
            }
        }).then((response)=>{
            if (response.data) return response.data.search.results.edges.map((edge)=>({
                    id: edge.node?.id || '',
                    type: edge.node?.type || '',
                    title: edge.node?.title || '',
                    container: edge.node?.space?.name || '',
                    url: edge.node?.url || '',
                    iconUrl: edge.node?.iconUrl || '',
                    lastModified: edge.node?.lastModified || ''
                }));
            return [];
        });
    }, [
        cloudId,
        readingAidsSessionId
    ]);
    return {
        searchSources: searchSources
    };
};

});
parcelRegister("4lrdQ", function(module, exports) {

$parcel$export(module.exports, "fetchRestResponse", () => $6cb082cfb14beb2a$export$ebe243ab960e089b);

var $dwp40 = parcelRequire("dwp40");
async function $6cb082cfb14beb2a$export$ebe243ab960e089b({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}

});

parcelRegister("8Ww6H", function(module, exports) {

$parcel$export(module.exports, "SearchSourceQuery", () => $51ed168a8de3aa85$export$beaccb66a6ac7cc5);
const $51ed168a8de3aa85$export$beaccb66a6ac7cc5 = `
	query ReadingAidsReferenceSearchQuery(
			$experience: String!
			$analytics: SearchAnalyticsInput
			$query: String!
			$filters: SearchFilterInput!
			$first: Int
		) {
		search {
			results: search(
				experience: $experience
				analytics: $analytics
				query: $query
				filters: $filters
				first: $first
			) {
				edges {
					node {
						type
						id
						title
						url
						iconUrl
						... on SearchConfluencePageBlogAttachment {
							lastModified
							space {
								name
							}
						}
						... on SearchConfluenceSpace {
							id
							title
							url
						}
					}
				}
			}
		}
	}
`;

});



parcelRegister("48KYD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3d203e0ef15a161e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $3d203e0ef15a161e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    definition_no_answer_error: {
        id: "search_ai.definition_no_answer_error",
        defaultMessage: "{brand} doesn\u2019t have enough data to provide a definition right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base."
    },
    definition_no_answer_acceptable_use_error: {
        id: "search_ai.definition_no_answer_acceptable_use_error",
        defaultMessage: "{brand} can\u2019t provide you with a definition, as it might go against {acceptableUseLink}"
    },
    definition_no_answer_acceptable_use_link: {
        id: "search_ai.definition_no_answer_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    definition_no_answer_network_error: {
        id: "search_ai.definition_no_answer_network_error",
        defaultMessage: "{brand} can't provide a definition right now. Read more in our {supportLink}"
    },
    definitions_support_link_text: {
        id: "search_ai.definitions_support_link_text",
        defaultMessage: "support documentation"
    },
    definition_no_answer_add_definition_button: {
        id: "search_ai.definition_no_answer_add_definition_button",
        defaultMessage: "Add definition"
    },
    definitions_no_answer_error_state_hipaa: {
        id: "search_ai.definitions_no_answer_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    definitions_no_answer_hipaa_compliance_link: {
        id: "search_ai.definitions_no_answer_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    }
});

});


parcelRegister("dIrGc", function(module, exports) {

$parcel$export(module.exports, "InfoLink", () => $cb9f1b890dd10de2$export$aef3857145d55f98);
$parcel$export(module.exports, "AIAnswerResultSection", () => $cb9f1b890dd10de2$export$d74b491f1ba95e72);
$parcel$export(module.exports, "AIAnswerResultBlurSection", () => $cb9f1b890dd10de2$export$95fe272adfa518ad);
$parcel$export(module.exports, "AIAnswerResultBlurSectionText", () => $cb9f1b890dd10de2$export$b67ed19cd3a08e2a);
$parcel$export(module.exports, "AIAnswerCloseLabelWrapper", () => $cb9f1b890dd10de2$export$855079ed5415eeab);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $f7lNm = parcelRequire("f7lNm");

var $gwrgp = parcelRequire("gwrgp");
const $cb9f1b890dd10de2$export$aef3857145d55f98 = (0, $gwrgp.default)("a", {
    target: "epe6nn80"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    color: `${`var(--ds-text-accent-blue, ${(0, $6fnsQ.B300)})`} !important`,
    textDecoration: 'underline'
});
const $cb9f1b890dd10de2$export$d74b491f1ba95e72 = (0, $gwrgp.default)("div", {
    target: "epe6nn81"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isReadingAids: isReadingAids, isExpanded: isExpanded })=>isReadingAids ? {
        font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: `var(--ds-text-accent-gray-bolder, ${0, $6fnsQ.N800})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${0, $f7lNm.READING_AIDS_DIALOG_WIDTH} - 40px)`,
        maxHeight: isExpanded ? 'fit-content' : '120px',
        overflowY: 'hidden'
    } : {
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: `var(--ds-text-accent-gray, ${0, $6fnsQ.N600})`,
        overflowY: 'auto',
        width: '100%'
    });
const $cb9f1b890dd10de2$export$95fe272adfa518ad = (0, $gwrgp.default)("div", {
    target: "epe6nn82"
})({
    background: `linear-gradient( 180deg, ${"var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))"} 0%, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`} 100% )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(${(0, $f7lNm.READING_AIDS_DIALOG_WIDTH)} - 48px)`,
    display: 'flex',
    justifyContent: 'end',
    position: 'absolute',
    top: '138px',
    cursor: 'pointer',
    paddingBottom: "var(--ds-space-050, 8px)",
    paddingTop: "var(--ds-space-200, 16px)",
    color: "var(--ds-text, #172B4D)"
});
const $cb9f1b890dd10de2$export$b67ed19cd3a08e2a = (0, $gwrgp.default)("div", {
    target: "epe6nn83"
})({
    display: 'flex',
    justifyContent: 'end',
    background: `linear-gradient( 90deg, ${"var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))"} 0%, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`} 100% )`,
    width: '75%',
    paddingRight: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $cb9f1b890dd10de2$export$44332785c3f496a = (0, $gwrgp.default)("div", {
    target: "epe6nn84"
})({
    display: 'flex',
    flexDirection: 'column',
    marginTop: "var(--ds-space-075, 6px)",
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    gap: "var(--ds-space-050, 4px)"
});
const $cb9f1b890dd10de2$export$9565d20b767b486c = (0, $gwrgp.default)("div", {
    target: "epe6nn85"
})({
    name: "b2molt",
    styles: "display:flex;font-style:italic;"
});
const $cb9f1b890dd10de2$export$91af142108bc801 = (0, $gwrgp.default)("div", {
    target: "epe6nn86"
})({
    name: "1mh6ko4",
    styles: "display:flex;align-items:center;gap:var(--ds-space-050, 4px);svg{width:16px;height:16px;}"
});
const $cb9f1b890dd10de2$export$98216a18f8eab723 = (0, $gwrgp.default)("div", {
    target: "epe6nn87"
})({
    width: '100%',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        marginTop: "var(--ds-space-075, 6px)",
        maxWidth: 'fit-content',
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isReadingAids: isReadingAids })=>isReadingAids ? `
    margin-top: ${"var(--ds-space-100, 8px)"};
    h2 ~ a {
      text-decoration: none !important;
    }
    ` : `
    margin-top: ${"var(--ds-space-150, 12px)"};
    `);
const $cb9f1b890dd10de2$export$8b7c724d5e9e5867 = (0, $gwrgp.default)("div", {
    target: "epe6nn88"
})("display:flex;justify-content:flex-start;align-items:center;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isReadingAids: isReadingAids })=>isReadingAids ? `
    &:hover,
    &:focus-within {
      background-color: ${"var(--ds-surface-hovered, #F1F2F4)"};
    }
    &:active {
      background-color: ${"var(--ds-surface-pressed, #DCDFE4)"};
    }
      border-radius: 3px;
      padding: ${"var(--ds-space-050, 4px)"};
    ` : `
      padding:
        ${"var(--ds-space-050, 4px)"}
        ${"var(--ds-space-0, 0px)"}
        ${"var(--ds-space-050, 4px)"}
        ${"var(--ds-space-025, 2px)"};
      &&:last-of-type {
        padding-bottom: ${"var(--ds-space-0, 0px)"};
      }
      `);
const $cb9f1b890dd10de2$export$1dbaa1694f314ea0 = (0, $gwrgp.default)("span", {
    target: "epe6nn89"
})({
    display: 'flex',
    flexGrow: 2,
    maxWidth: '50%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        a: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            textDecorationColor: `${`var(--ds-text-accent-blue, ${(0, $6fnsQ.B400)})`} !important`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'span:first-of-type': {
                marginRight: "var(--ds-space-050, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                svg: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                    height: '16px !important',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                    width: '16px !important'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'span:last-of-type': {
                font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-accent-blue, ${(0, $6fnsQ.B400)})`
            }
        }
    }
});
const $cb9f1b890dd10de2$export$71052642a2e14680 = (0, $gwrgp.default)("span", {
    target: "epe6nn810"
})({
    display: 'flex',
    alignItems: 'center',
    maxWidth: '50%',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            height: '16px',
            width: '16px',
            margin: "var(--ds-space-025, 2px)"
        }
    }
});
const $cb9f1b890dd10de2$export$c9da66979beaa252 = (0, $gwrgp.default)("span", {
    target: "epe6nn811"
})({
    margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
const $cb9f1b890dd10de2$export$aa7530cfcbaddfa5 = (0, $gwrgp.default)("span", {
    target: "epe6nn812"
})({
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
        display: 'inherit',
        cursor: 'pointer',
        color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
        },
        '&:visited': {
            color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
        }
    }
});
const $cb9f1b890dd10de2$export$253480f9791b8fdf = (0, $gwrgp.default)("div", {
    target: "epe6nn813"
})({
    name: "1pxenyc",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-bottom:var(--ds-space-050, 4px);"
});
const $cb9f1b890dd10de2$export$855079ed5415eeab = (0, $gwrgp.default)("div", {
    target: "epe6nn814"
})({
    display: 'flex',
    gap: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
        cursor: 'pointer'
    }
});
const $cb9f1b890dd10de2$export$e01bd8d6685b34a9 = (0, $gwrgp.default)("div", {
    target: "epe6nn815"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `calc(${(0, $f7lNm.READING_AIDS_DIALOG_WIDTH)} - 72px)`,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        textDecoration: 'none !important'
    }
});
const $cb9f1b890dd10de2$export$8e73118d396fafe3 = (0, $gwrgp.default)("div", {
    target: "epe6nn816"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `calc(${(0, $f7lNm.READING_AIDS_DIALOG_WIDTH)} - 72px)`,
    paddingLeft: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-accent-gray-bolder, ${(0, $6fnsQ.N800)})`,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $cb9f1b890dd10de2$export$45c571024fc5ff3e = (0, $gwrgp.default)("div", {
    target: "epe6nn817"
})({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(${(0, $f7lNm.READING_AIDS_DIALOG_WIDTH)} - 72px)`,
    paddingLeft: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $cb9f1b890dd10de2$export$e6c91310e7bd6430 = (0, $gwrgp.default)("div", {
    target: "epe6nn818"
})({
    name: "1m01c8l",
    styles: "height:24px;width:24px;"
});

});


parcelRegister("1B9Mx", function(module, exports) {

$parcel$export(module.exports, "JsonResultComponent", () => $284094860717141d$export$135cee1a1b919871);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dUnDb = parcelRequire("dUnDb");

var $eRXI0 = parcelRequire("eRXI0");

var $7Zbm6 = parcelRequire("7Zbm6");

var $5y8jR = parcelRequire("5y8jR");

var $7GyCF = parcelRequire("7GyCF");

var $1ubrN = parcelRequire("1ubrN");
const $284094860717141d$export$135cee1a1b919871 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const { parsedType: parsedType } = (0, $5y8jR.getTypedJSONResultDataAssistanceService)(answerString);
    switch(parsedType){
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WHO:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7GyCF.AIAnswerWhoResult), {});
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WORK:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1ubrN.AIAnswerWorkResult), {});
        case (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dUnDb.TeamKnowledgeCard), {});
        default:
            return null;
    }
};

});
parcelRegister("7GyCF", function(module, exports) {

$parcel$export(module.exports, "AIAnswerWhoResult", () => $f34f0937e021b65d$export$f11b3e733b5a589b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aK1zu = parcelRequire("aK1zu");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $5y8jR = parcelRequire("5y8jR");

var $khBdc = parcelRequire("khBdc");

var $2xz4a = parcelRequire("2xz4a");

var $4FOKW = parcelRequire("4FOKW");
const $f34f0937e021b65d$export$f11b3e733b5a589b = ()=>{
    const { commonAttributes: commonAttributes, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, cloudId: cloudId, sessionId: sessionId } = commonAttributes;
    const aiTopicsEnabled = isAdminHubAIEnabled;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const whoResult = {
        user_metadata: (0, $5y8jR.getTypedJSONResultDataAssistanceService)(answerString).parsedResult
    };
    const userResults = whoResult.user_metadata;
    // BE will always return first object as the primary user result
    const primaryUser = userResults[0];
    const frequentLocationsSection = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4FOKW.AIAnswerWhoSection), {
        sectionId: "frequent_locations",
        sectionHeader: (0, $7lL49.messages).ai_answer_who_questions_frequent_locations_header,
        sectionResults: primaryUser.containers,
        avatarAppearance: "square"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2xz4a.ProfileSection), {
                accountId: primaryUser.account_id,
                name: primaryUser.name,
                email: primaryUser.email,
                avatarUrl: primaryUser.avatar_url,
                profileUrl: primaryUser.profile_url,
                jobTitle: primaryUser.job_title,
                department: primaryUser.department,
                location: primaryUser.location,
                time: primaryUser.time
            }),
            aiTopicsEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aK1zu.AITopicsByPerson), {
                cloudId: cloudId,
                userId: primaryUser.account_id ?? '',
                userName: primaryUser.name,
                sessionId: sessionId,
                fallbackSection: frequentLocationsSection
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                children: frequentLocationsSection
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4FOKW.AIAnswerWhoSection), {
                sectionId: "frequent_collaborators",
                sectionHeader: (0, $7lL49.messages).ai_answer_who_questions_frequent_collaborators_header,
                sectionResults: primaryUser.collaborators?.slice(0, 3),
                avatarAppearance: "circle"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4FOKW.AIAnswerWhoSection), {
                sectionId: "teams",
                sectionHeader: (0, $7lL49.messages).ai_answer_who_questions_teams_header,
                sectionResults: primaryUser.teams,
                avatarAppearance: "square"
            }),
            primaryUser.recentActivity && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $khBdc.RecentWorkList), {
                name: primaryUser.name,
                activities: primaryUser.recentActivity,
                viewAllUrl: primaryUser.viewAllLink
            })
        ]
    });
};

});
parcelRegister("khBdc", function(module, exports) {

$parcel$export(module.exports, "RecentWorkList", () => $6aee33a7cff9d280$export$66aebd6b65f0e0cf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $epS7s = parcelRequire("epS7s");

var $eRXI0 = parcelRequire("eRXI0");

var $3Opgu = parcelRequire("3Opgu");

var $4xTru = parcelRequire("4xTru");

var $9zbJl = parcelRequire("9zbJl");

var $3pEZV = parcelRequire("3pEZV");

var $dcknD = parcelRequire("dcknD");
const $6aee33a7cff9d280$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER = 5;
const $6aee33a7cff9d280$export$66aebd6b65f0e0cf = ({ name: name, activities: activities, viewAllUrl: viewAllUrl })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const cachedExpanded = JSON.parse((0, $epS7s.getSessionItem)((0, $3Opgu.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}').recentWorkListExpanded;
    const [expanded, setExpanded] = (0, $gwFzn.useState)(cachedExpanded !== undefined ? cachedExpanded : false);
    const { updateContextCache: updateContextCache, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const expandRecentWorkList = (0, $gwFzn.useCallback)(()=>{
        setExpanded(true);
        updateContextCache({
            recentWorkListExpanded: true
        });
    }, [
        updateContextCache
    ]);
    const onLinkClick = (0, $gwFzn.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkLinkClick)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const onLinkContextMenuClick = (0, $gwFzn.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkLinkContextMenuClick)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const showExpandedItems = activities.length > $6aee33a7cff9d280$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER ? expanded : true;
    const shownActivities = showExpandedItems ? activities : activities.slice(0, $6aee33a7cff9d280$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER);
    if (activities.length === 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.EmptyStateTextWrapper), {
        children: formatMessage((0, $9zbJl.messages).no_activity_error_text, {
            user: name
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkListTitle), {
                children: formatMessage((0, $9zbJl.messages).recentWorkListTitle)
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkListWrapper), {
                children: shownActivities.map((activity, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3pEZV.RecentWorkItem), {
                        index: index,
                        title: activity.title,
                        iconUrl: activity.iconUrl,
                        url: activity.url,
                        container: activity.containerName,
                        event: activity.event,
                        contributors: activity.contributors,
                        timestamp: activity.timestamp,
                        othersCount: activity.othersCount
                    }, `recent-work-item-${index}`))
            }),
            showExpandedItems ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.LinkWrapper), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                    appearance: 'link',
                    href: viewAllUrl,
                    onClick: onLinkClick,
                    onContextMenu: onLinkContextMenuClick,
                    children: formatMessage((0, $9zbJl.messages).viewAllLink)
                })
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                children: !!viewAllUrl && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.LinkWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                        appearance: "link",
                        onClick: expandRecentWorkList,
                        children: formatMessage((0, $9zbJl.messages).showMore)
                    })
                })
            })
        ]
    });
};

});
parcelRegister("9zbJl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $81113bb4df4a7cc5$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $81113bb4df4a7cc5$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    recentWorkListTitle: {
        id: "search_ai.ai_answer_dialog.recent_work_list.title",
        defaultMessage: "Recently worked on"
    },
    viewAllLink: {
        id: "search_ai.ai_answer_dialog.recent_work_list.view_all_link",
        defaultMessage: "View all"
    },
    showMore: {
        id: "search_ai.ai_answer_dialog.recent_work_list.show_more",
        defaultMessage: "Show more"
    },
    no_activity_error_text: {
        id: "search_ai.ai_answer_dialog.recent_work_list.no_activity_error_text",
        defaultMessage: "Atlassian Intelligence doesn\u2019t have enough data to provide a response right now. This may be because {user} is new and they haven't interacted with Confluence yet. In the meantime, try asking a different question."
    }
});

});

parcelRegister("3pEZV", function(module, exports) {

$parcel$export(module.exports, "RecentWorkItem", () => $f1355db5a929751d$export$9adc0410c9970c44);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $5dK2X = parcelRequire("5dK2X");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $i6OUY = parcelRequire("i6OUY");

var $dcknD = parcelRequire("dcknD");
const $f1355db5a929751d$export$9adc0410c9970c44 = ({ index: index, title: title, iconUrl: iconUrl, url: url, container: container, event: event, contributors: contributors, timestamp: timestamp, othersCount: othersCount })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $dBxQj.default)();
    const { userDetails: { id: currentUserId }, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const description = (0, $i6OUY.descriptionHelper)({
        currentUserId: !!currentUserId ? currentUserId : '',
        event: event,
        contributors: contributors,
        othersCount: othersCount,
        formatMessage: formatMessage,
        formatDate: formatDate,
        timestamp: new Date(timestamp)
    });
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkItemClick)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    const onContextMenuClick = (0, $gwFzn.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4xTru.onRecentWorkItemContextMenuClick)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkItemLink), {
        href: url,
        onClick: onClick,
        onContextMenu: onContextMenuClick,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcknD.RecentWorkItemWrapper), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkItemIcon), {
                    src: iconUrl,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcknD.RecentWorkItemBody), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkItemTitle), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                as: "p",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcknD.RecentWorkItemByline), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkItemContainer), {
                                    children: container
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcknD.RecentWorkItemDescription), {
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("dcknD", function(module, exports) {

$parcel$export(module.exports, "RecentWorkListTitle", () => $c074d3e7482ed959$export$9a485269bf2c8987);
$parcel$export(module.exports, "RecentWorkListWrapper", () => $c074d3e7482ed959$export$3c95e3d61376d5b6);
$parcel$export(module.exports, "RecentWorkItemLink", () => $c074d3e7482ed959$export$df8ab4b5e2ff1243);
$parcel$export(module.exports, "RecentWorkItemWrapper", () => $c074d3e7482ed959$export$246596915c6a37b0);
$parcel$export(module.exports, "RecentWorkItemIcon", () => $c074d3e7482ed959$export$c779e0225c7a4abb);
$parcel$export(module.exports, "RecentWorkItemBody", () => $c074d3e7482ed959$export$37f6bd651093c20a);
$parcel$export(module.exports, "RecentWorkItemTitle", () => $c074d3e7482ed959$export$398e991be65309e3);
$parcel$export(module.exports, "RecentWorkItemByline", () => $c074d3e7482ed959$export$6a9e1330548eac8);
$parcel$export(module.exports, "RecentWorkItemContainer", () => $c074d3e7482ed959$export$6e18a3d821f78b73);
$parcel$export(module.exports, "RecentWorkItemDescription", () => $c074d3e7482ed959$export$a644bde83ad79b45);
$parcel$export(module.exports, "LinkWrapper", () => $c074d3e7482ed959$export$ce4b6a469c26f53f);
$parcel$export(module.exports, "EmptyStateTextWrapper", () => $c074d3e7482ed959$export$73d0188d97126121);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $c074d3e7482ed959$export$9a485269bf2c8987 = (0, $gwrgp.default)("h5", {
    target: "evun5jv0"
})({
    name: "k008qs",
    styles: "display:flex;"
});
const $c074d3e7482ed959$export$3c95e3d61376d5b6 = (0, $gwrgp.default)("div", {
    target: "evun5jv1"
})({
    name: "9whsf3",
    styles: "max-width:100%;"
});
const $c074d3e7482ed959$export$df8ab4b5e2ff1243 = (0, $gwrgp.default)("a", {
    target: "evun5jv2"
})({
    position: 'relative',
    margin: 0,
    overflow: 'hidden',
    display: 'block',
    paddingLeft: "var(--ds-space-100, 10px)",
    paddingRight: "var(--ds-space-100, 10px)",
    borderRadius: "var(--ds-border-radius-100, 3px)",
    '&:hover': {
        background: `var(--ds-background-neutral-subtle-hovered, ${(0, $6fnsQ.N10)})`,
        textDecoration: 'none'
    },
    '&:focus': {
        outline: 0,
        boxShadow: `0 0 0 ${"var(--ds-space-025, 2px)"} ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`}`
    }
});
const $c074d3e7482ed959$export$246596915c6a37b0 = (0, $gwrgp.default)("div", {
    target: "evun5jv3"
})({
    name: "k008qs",
    styles: "display:flex;"
});
const $c074d3e7482ed959$export$c779e0225c7a4abb = (0, $gwrgp.default)("img", {
    target: "evun5jv4"
})({
    name: "1nkvxb9",
    styles: "border-radius:var(--ds-border-radius-100, 3px);display:flex;flex-shrink:0;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-top:var(--ds-space-100, 8px);margin-bottom:var(--ds-space-100, 8px);"
});
const $c074d3e7482ed959$export$37f6bd651093c20a = (0, $gwrgp.default)("div", {
    target: "evun5jv5"
})({
    name: "1kgkocw",
    styles: "display:flex;flex-direction:column;margin-left:var(--ds-space-200, 16px);justify-content:center;min-width:0;"
});
const $c074d3e7482ed959$export$398e991be65309e3 = (0, $gwrgp.default)("div", {
    target: "evun5jv6"
})({
    paddingRight: "var(--ds-space-100, 10px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    p: {
        display: 'inline-block',
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        margin: 0,
        color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
});
const $c074d3e7482ed959$export$6a9e1330548eac8 = (0, $gwrgp.default)("p", {
    target: "evun5jv7"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N90)})`,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: "var(--ds-space-100, 10px)",
    minWidth: 0
});
const $c074d3e7482ed959$export$6e18a3d821f78b73 = (0, $gwrgp.default)("span", {
    target: "evun5jv8"
})({
    name: "vv6r2c",
    styles: "&:after{content:'\\00B7';padding-right:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);}"
});
const $c074d3e7482ed959$export$a644bde83ad79b45 = (0, $gwrgp.default)("span", {
    target: "evun5jv9"
})({
    name: "0",
    styles: ""
});
const $c074d3e7482ed959$export$ce4b6a469c26f53f = (0, $gwrgp.default)("div", {
    target: "evun5jv10"
})({
    display: 'flex',
    marginLeft: "var(--ds-space-100, 10px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'button, a, span': {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        height: 'unset !important'
    }
});
const $c074d3e7482ed959$export$73d0188d97126121 = (0, $gwrgp.default)("div", {
    target: "evun5jv11"
})({
    marginTop: "var(--ds-space-200, 16px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-accent-gray, ${(0, $6fnsQ.N600)})`
});

});



parcelRegister("2xz4a", function(module, exports) {

$parcel$export(module.exports, "ProfileSection", () => $ad3ad4c3f9dfb105$export$cf8aeccda7668aa5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $2sbaw = parcelRequire("2sbaw");

var $2Nwuj = parcelRequire("2Nwuj");

var $6fnsQ = parcelRequire("6fnsQ");

var $f7lNm = parcelRequire("f7lNm");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $kPlEv = parcelRequire("kPlEv");

var $9IOMW = parcelRequire("9IOMW");
const $ad3ad4c3f9dfb105$export$cf8aeccda7668aa5 = ({ accountId: accountId, name: name, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const profileLink = commonAttributes.brand === (0, $f7lNm.AiBrand).AI ? `/wiki/people/${accountId}` : profileUrl;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPlEv.ProfileSectionPrimaryWrapper), {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kPlEv.ProfileSectionPrimaryUserWrapper), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPlEv.ProfileSectionPrimaryUserImg), {
                    src: avatarUrl || '',
                    alt: name
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kPlEv.ProfileSectionPrimaryUserInfoWrapper), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kPlEv.ProfileSectionPrimaryUserHeader), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPlEv.ProfileSectionPrimaryUserName), {
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kPlEv.ProfileSectionPrimaryViewProfileLinkWrapper), {
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2sbaw))), {
                                            spacing: "spacious",
                                            label: "",
                                            color: `var(--ds-text-accent-blue, ${(0, $6fnsQ.B400)})`
                                        }),
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                                            href: profileLink || '',
                                            onClick: (event)=>{
                                                onNavigate(event);
                                                fireAnalyticsEvent((0, $4xTru.onWhoPrimaryViewProfileClick)({
                                                    ...commonAttributes,
                                                    primaryUserName: name
                                                }));
                                            },
                                            onContextMenu: (event)=>{
                                                onNavigate(event);
                                                fireAnalyticsEvent((0, $4xTru.onWhoPrimaryViewProfileContextMenuClick)({
                                                    ...commonAttributes,
                                                    primaryUserName: name
                                                }));
                                            },
                                            children: formatMessage((0, $7lL49.messages).ai_answer_who_questions_view_profile)
                                        })
                                    ]
                                })
                            ]
                        }),
                        (jobTitle || department) && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kPlEv.ProfileSectionPrimaryUserInfoTextWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9IOMW.ProfileSectionUserInfo), {
                                    userInfo: jobTitle || '',
                                    userInfoType: (0, $9IOMW.UserInfoTypeFormat).JOBTITLE
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9IOMW.ProfileSectionUserInfo), {
                                    userInfo: department || '',
                                    userInfoType: (0, $9IOMW.UserInfoTypeFormat).DEPARTMENT
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $kPlEv.ProfileSectionPrimaryUserInfoTextWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9IOMW.ProfileSectionUserInfo), {
                                    userInfo: location || '',
                                    userInfoType: (0, $9IOMW.UserInfoTypeFormat).LOCATION
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9IOMW.ProfileSectionUserInfo), {
                                    userInfo: time || '',
                                    userInfoType: (0, $9IOMW.UserInfoTypeFormat).TIME,
                                    applyAdditionalTopIconPadding: true
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9IOMW.ProfileSectionUserInfo), {
                                    userInfo: email || '',
                                    userInfoType: (0, $9IOMW.UserInfoTypeFormat).EMAIL,
                                    applyAdditionalTopIconPadding: true
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("kPlEv", function(module, exports) {

$parcel$export(module.exports, "ProfileSectionPrimaryWrapper", () => $ab263af7a0246d6d$export$32d100979bcc384a);
$parcel$export(module.exports, "ProfileSectionPrimaryUserWrapper", () => $ab263af7a0246d6d$export$455d3c20a8814267);
$parcel$export(module.exports, "ProfileSectionPrimaryUserInfoWrapper", () => $ab263af7a0246d6d$export$509293bf46c921a);
$parcel$export(module.exports, "ProfileSectionPrimaryUserImg", () => $ab263af7a0246d6d$export$dbd921847e022785);
$parcel$export(module.exports, "ProfileSectionPrimaryUserHeader", () => $ab263af7a0246d6d$export$255011ab851083fa);
$parcel$export(module.exports, "ProfileSectionPrimaryUserName", () => $ab263af7a0246d6d$export$2561140795d9b6bc);
$parcel$export(module.exports, "ProfileSectionPrimaryUserInfoTextWrapper", () => $ab263af7a0246d6d$export$4748d4ea7eaeeee9);
$parcel$export(module.exports, "ProfileSectionPrimaryUserInfo", () => $ab263af7a0246d6d$export$6703f231e80ecbdc);
$parcel$export(module.exports, "ProfileSectionPrimaryUserInfoText", () => $ab263af7a0246d6d$export$56b2c11ed41d99f1);
$parcel$export(module.exports, "ProfileSectionPrimaryUserAddtlIconPadding", () => $ab263af7a0246d6d$export$83dd167b9bbf48eb);
$parcel$export(module.exports, "ProfileSectionPrimaryViewProfileLinkWrapper", () => $ab263af7a0246d6d$export$bb93002cdcc6fd86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $ab263af7a0246d6d$export$32d100979bcc384a = (0, $gwrgp.default)("div", {
    target: "e9uzeua0"
})({
    name: "nb2z2f",
    styles: "display:flex;justify-content:space-between;align-items:center;width:100%;"
});
const $ab263af7a0246d6d$export$455d3c20a8814267 = (0, $gwrgp.default)("div", {
    target: "e9uzeua1"
})({
    name: "1k0s06o",
    styles: "display:flex;justify-content:flex-start;align-items:center;width:100%;"
});
const $ab263af7a0246d6d$export$509293bf46c921a = (0, $gwrgp.default)("div", {
    target: "e9uzeua2"
})({
    name: "5lr5tv",
    styles: "display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;height:100%;width:100%;margin-left:var(--ds-space-200, 16px);"
});
const $ab263af7a0246d6d$export$dbd921847e022785 = (0, $gwrgp.default)("img", {
    target: "e9uzeua3"
})({
    name: "188zwzi",
    styles: "width:72px;height:72px;border-radius:13px;"
});
const $ab263af7a0246d6d$export$255011ab851083fa = (0, $gwrgp.default)("div", {
    target: "e9uzeua4"
})({
    name: "z7mtfw",
    styles: "display:flex;justify-content:space-between;width:100%;"
});
const $ab263af7a0246d6d$export$2561140795d9b6bc = (0, $gwrgp.default)("span", {
    target: "e9uzeua5"
})({
    name: "1kze9a4",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);"
});
const $ab263af7a0246d6d$export$4748d4ea7eaeeee9 = (0, $gwrgp.default)("span", {
    target: "e9uzeua6"
})({
    name: "7jgdv8",
    styles: "margin-top:var(--ds-space-025, 2px);display:flex;flex-wrap:wrap;align-items:center;width:100%;"
});
const $ab263af7a0246d6d$export$6703f231e80ecbdc = (0, $gwrgp.default)("span", {
    target: "e9uzeua7"
})({
    name: "1i7ryl3",
    styles: "display:flex;align-items:center;margin-right:var(--ds-space-100, 8px);"
});
const $ab263af7a0246d6d$export$56b2c11ed41d99f1 = (0, $gwrgp.default)("span", {
    target: "e9uzeua8"
})({
    name: "1jp98lm",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #626F86);margin-left:var(--ds-space-025, 2px);"
});
const $ab263af7a0246d6d$export$83dd167b9bbf48eb = (0, $gwrgp.default)("span", {
    target: "e9uzeua9"
})({
    name: "4qh8qq",
    styles: "& > *{padding-top:var(--ds-space-050, 4px);}"
});
const $ab263af7a0246d6d$export$bb93002cdcc6fd86 = (0, $gwrgp.default)("div", {
    target: "e9uzeua10"
})({
    name: "105ss32",
    styles: "display:flex;align-items:center;gap:var(--ds-space-050, 4px);"
});

});

parcelRegister("9IOMW", function(module, exports) {

$parcel$export(module.exports, "UserInfoTypeFormat", () => $c25514636e607d9b$export$70291e6ea210ef9);
$parcel$export(module.exports, "ProfileSectionUserInfo", () => $c25514636e607d9b$export$aaf1b21561a4fb8b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3MAnl = parcelRequire("3MAnl");

var $aEOt2 = parcelRequire("aEOt2");

var $crcDg = parcelRequire("crcDg");

var $5GDNB = parcelRequire("5GDNB");

var $7vcce = parcelRequire("7vcce");

var $dcJ7R = parcelRequire("dcJ7R");

var $3gadb = parcelRequire("3gadb");

var $7lL49 = parcelRequire("7lL49");

var $kPlEv = parcelRequire("kPlEv");
var $c25514636e607d9b$export$70291e6ea210ef9 = /*#__PURE__*/ function(UserInfoTypeFormat) {
    UserInfoTypeFormat["JOBTITLE"] = "JOB_TITLE";
    UserInfoTypeFormat["DEPARTMENT"] = "DEPARTMENT";
    UserInfoTypeFormat["LOCATION"] = "LOCATION";
    UserInfoTypeFormat["TIME"] = "TIME";
    UserInfoTypeFormat["EMAIL"] = "EMAIL";
    return UserInfoTypeFormat;
}({});
const $c25514636e607d9b$var$userInfoTypeMapper = {
    ["JOB_TITLE"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_role_icon,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3MAnl))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-suitcase-icon"
        })
    },
    ["DEPARTMENT"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_department_icon,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($crcDg))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-department-icon"
        })
    },
    ["LOCATION"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_location_icon,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7vcce))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-location-icon"
        })
    },
    ["TIME"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_local_time_icon,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEOt2))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-emoji-frequent-icon"
        })
    },
    ["EMAIL"]: {
        tooltipMessage: (0, $7lL49.messages).ai_answer_who_questions_hover_email_icon,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5GDNB))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-text-subtlest, #626F86)",
            testId: "primary-user-email-icon"
        })
    }
};
const $c25514636e607d9b$export$aaf1b21561a4fb8b = ({ userInfo: userInfo, userInfoType: userInfoType, applyAdditionalTopIconPadding: applyAdditionalTopIconPadding })=>{
    return userInfo ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPlEv.ProfileSectionPrimaryUserInfo), {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            space: "space.075",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                    position: "top",
                    content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...$c25514636e607d9b$var$userInfoTypeMapper[userInfoType].tooltipMessage
                    }),
                    children: applyAdditionalTopIconPadding ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPlEv.ProfileSectionPrimaryUserAddtlIconPadding), {
                        children: $c25514636e607d9b$var$userInfoTypeMapper[userInfoType].icon
                    }) : $c25514636e607d9b$var$userInfoTypeMapper[userInfoType].icon
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPlEv.ProfileSectionPrimaryUserInfoText), {
                    children: userInfo
                })
            ]
        })
    }) : null;
};

});
parcelRegister("crcDg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61b69757778da2d771dbef5df6aae1a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90e1ce2e3ef66e77$var$_react = $90e1ce2e3ef66e77$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $90e1ce2e3ef66e77$var$_department = $90e1ce2e3ef66e77$var$_interopRequireDefault((parcelRequire("7O0l1")));

var $90e1ce2e3ef66e77$var$_department2 = $90e1ce2e3ef66e77$var$_interopRequireDefault((parcelRequire("ak2ew")));
function $90e1ce2e3ef66e77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DepartmentIcon.
 * This component is DepartmentIcon, with `UNSAFE_fallbackIcon` set to "DepartmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90e1ce2e3ef66e77$var$DepartmentIcon = (props)=>/*#__PURE__*/ $90e1ce2e3ef66e77$var$_react.default.createElement($90e1ce2e3ef66e77$var$_department.default, Object.assign({
        LEGACY_fallbackIcon: $90e1ce2e3ef66e77$var$_department2.default
    }, props));
$90e1ce2e3ef66e77$var$DepartmentIcon.Name = 'DepartmentIconMigration';
var $90e1ce2e3ef66e77$var$_default = module.exports.default = $90e1ce2e3ef66e77$var$DepartmentIcon;

});



parcelRegister("4FOKW", function(module, exports) {

$parcel$export(module.exports, "AIAnswerWhoSection", () => $c1ec86efaaa8b92c$export$2fdd09f06ec66b1);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $esRft = parcelRequire("esRft");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $7Zbm6 = parcelRequire("7Zbm6");

var $5ZjPR = parcelRequire("5ZjPR");
const $c1ec86efaaa8b92c$var$WHO_SECTION_MAX_ITEMS = 3;
const $c1ec86efaaa8b92c$export$2fdd09f06ec66b1 = ({ sectionId: sectionId, sectionHeader: sectionHeader, sectionResults: sectionResults, avatarAppearance: avatarAppearance })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const getSectionResultMetadata = (sectionResult)=>{
        if ('containerType' in sectionResult) switch(sectionResult.containerType){
            case (0, $7Zbm6.NLPSearchResultContainerDataTypeContainerType).ConfluenceSpace:
                return 'Confluence';
            case (0, $7Zbm6.NLPSearchResultContainerDataTypeContainerType).JiraProject:
                return 'Jira Software';
            default:
                return '';
        }
        if ('title' in sectionResult) return sectionResult.title || '';
        if ('memberCount' in sectionResult) return formatMessage((0, $7lL49.messages).ai_answer_who_question_team_section_member_count, {
            count: sectionResult.memberCount
        });
        return '';
    };
    return sectionResults && sectionResults.length ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5ZjPR.AIWhoAnswerSectionWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerSectionHeader), {
                children: formatMessage(sectionHeader)
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerSectionResultsWrapper), {
                children: sectionResults.slice(0, $c1ec86efaaa8b92c$var$WHO_SECTION_MAX_ITEMS).map((sectionResult)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5ZjPR.AIWhoAnswerSectionResult), {
                        href: sectionResult.url || undefined,
                        onClick: (event)=>{
                            onNavigate(event);
                            fireAnalyticsEvent((0, $4xTru.onWhoPrimaryCoordinationPillClick)({
                                ...commonAttributes,
                                resultSection: sectionId,
                                resultTitle: sectionResult.name
                            }));
                        },
                        onContextMenu: ()=>{
                            fireAnalyticsEvent((0, $4xTru.onWhoPrimaryCoordinationPillContextMenuClick)({
                                ...commonAttributes,
                                resultSection: sectionId,
                                resultTitle: sectionResult.name
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                                appearance: avatarAppearance,
                                src: sectionResult.iconUrl || sectionResult.picture || sectionResult.avatarUrl || undefined,
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5ZjPR.AIWhoAnswerSectionResultInfoWrapper), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerSectionResultInfoHeader), {
                                        children: sectionResult.name
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerSectionResultMetadata), {
                                        children: getSectionResultMetadata(sectionResult)
                                    })
                                ]
                            })
                        ]
                    }, sectionResult.name))
            })
        ]
    }) : null;
};

});
parcelRegister("5ZjPR", function(module, exports) {

$parcel$export(module.exports, "AIWhoAnswerSectionWrapper", () => $9c08bd9e3182a321$export$cc8053471b180c28);
$parcel$export(module.exports, "AIWhoAnswerSectionHeader", () => $9c08bd9e3182a321$export$8d7f456736fee90f);
$parcel$export(module.exports, "AIWhoAnswerSectionResultsWrapper", () => $9c08bd9e3182a321$export$39edbe3e7f6a9ca1);
$parcel$export(module.exports, "AIWhoAnswerSectionResult", () => $9c08bd9e3182a321$export$d0be8a9d033ca7b8);
$parcel$export(module.exports, "AIWhoAnswerSectionResultInfoWrapper", () => $9c08bd9e3182a321$export$e739e9e96a0d2dd9);
$parcel$export(module.exports, "AIWhoAnswerSectionResultInfoHeader", () => $9c08bd9e3182a321$export$790f6d80b0f65f30);
$parcel$export(module.exports, "AIWhoAnswerSectionResultMetadata", () => $9c08bd9e3182a321$export$7b9fc87d1d9e8ecd);
$parcel$export(module.exports, "AIWhoAnswerFooter", () => $9c08bd9e3182a321$export$8aac4e350897fa7);
$parcel$export(module.exports, "AIWhoAnswerFooterHeader", () => $9c08bd9e3182a321$export$12179e87966a5f65);
$parcel$export(module.exports, "AIWhoAnswerFooterResultsWrapper", () => $9c08bd9e3182a321$export$ca13badcf6359d46);
$parcel$export(module.exports, "AIWhoAnswerFooterResult", () => $9c08bd9e3182a321$export$e2651635b6d243b0);
$parcel$export(module.exports, "AIWhoAnswerFooterResultInfoWrapper", () => $9c08bd9e3182a321$export$da4b6fad053f23b9);
$parcel$export(module.exports, "AIWhoAnswerFooterResultInfoHeader", () => $9c08bd9e3182a321$export$a9060ca8bb68e9b6);
$parcel$export(module.exports, "AIWhoAnswerFooterResultMetadata", () => $9c08bd9e3182a321$export$eadd90c494f8440c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $9c08bd9e3182a321$export$cc8053471b180c28 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e10"
})({
    name: "ahpc7o",
    styles: "display:flex;flex-direction:column;align-items:flex-start;margin-top:var(--ds-space-200, 16px);width:100%;"
});
const $9c08bd9e3182a321$export$8d7f456736fee90f = (0, $gwrgp.default)("h5", {
    target: "e1j7i5e11"
})({
    name: "1com33v",
    styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);"
});
const $9c08bd9e3182a321$export$39edbe3e7f6a9ca1 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e12"
})({
    name: "vv17md",
    styles: "display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:var(--ds-space-100, 8px);width:100%;height:56px;margin-top:var(--ds-space-100, 8px);"
});
const $9c08bd9e3182a321$export$d0be8a9d033ca7b8 = (0, $gwrgp.default)("a", {
    target: "e1j7i5e13"
})({
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-150, 12px)",
    border: `solid ${`var(--ds-border, ${(0, $6fnsQ.N40)})`} 1px`,
    borderRadius: '6px',
    boxSizing: 'border-box',
    '&:hover': {
        textDecoration: 'none',
        boxShadow: "var(--ds-shadow-overlay, 0px 0px 8px 0px rgba(9, 30, 66, 0.16), 0px 0px 1px 0px rgba(9, 30, 66, 0.12))"
    }
});
const $9c08bd9e3182a321$export$e739e9e96a0d2dd9 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e14"
})({
    name: "5yle2i",
    styles: "display:flex;flex-direction:column;justify-content:space-evenly;align-items:flex-start;height:100%;width:100%;margin-left:var(--ds-space-100, 8px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
});
const $9c08bd9e3182a321$export$790f6d80b0f65f30 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e15"
})({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $9c08bd9e3182a321$export$7b9fc87d1d9e8ecd = (0, $gwrgp.default)("div", {
    target: "e1j7i5e16"
})({
    name: "14k4vkt",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #626F86);width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
});
const $9c08bd9e3182a321$export$8aac4e350897fa7 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e17"
})({
    padding: "var(--ds-space-300, 24px)",
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`,
    boxSizing: 'border-box'
});
const $9c08bd9e3182a321$export$12179e87966a5f65 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e18"
})({
    name: "14c7ubj",
    styles: "font:var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #626F86);"
});
const $9c08bd9e3182a321$export$ca13badcf6359d46 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e19"
})({
    name: "vv17md",
    styles: "display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:var(--ds-space-100, 8px);width:100%;height:56px;margin-top:var(--ds-space-100, 8px);"
});
const $9c08bd9e3182a321$export$e2651635b6d243b0 = (0, $gwrgp.default)("a", {
    target: "e1j7i5e110"
})({
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-150, 12px)",
    border: `solid ${`var(--ds-border, ${(0, $6fnsQ.N40)})`} 1px`,
    borderRadius: '6px',
    boxSizing: 'border-box',
    background: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
    '&:hover': {
        textDecoration: 'none',
        boxShadow: "var(--ds-shadow-overlay, 0px 0px 8px 0px rgba(9, 30, 66, 0.16), 0px 0px 1px 0px rgba(9, 30, 66, 0.12))"
    }
});
const $9c08bd9e3182a321$export$da4b6fad053f23b9 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e111"
})({
    name: "5yle2i",
    styles: "display:flex;flex-direction:column;justify-content:space-evenly;align-items:flex-start;height:100%;width:100%;margin-left:var(--ds-space-100, 8px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
});
const $9c08bd9e3182a321$export$a9060ca8bb68e9b6 = (0, $gwrgp.default)("div", {
    target: "e1j7i5e112"
})({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text, ${(0, $6fnsQ.N800)})`,
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $9c08bd9e3182a321$export$eadd90c494f8440c = (0, $gwrgp.default)("div", {
    target: "e1j7i5e113"
})({
    name: "14k4vkt",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #626F86);width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
});

});



parcelRegister("1ubrN", function(module, exports) {

$parcel$export(module.exports, "AIAnswerWorkResult", () => $2133918edead0ea4$export$ff8068fc50f478b4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eRXI0 = parcelRequire("eRXI0");

var $5y8jR = parcelRequire("5y8jR");

var $khBdc = parcelRequire("khBdc");

var $2xz4a = parcelRequire("2xz4a");
const $2133918edead0ea4$export$ff8068fc50f478b4 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const workResult = {
        user_metadata_with_activity: (0, $5y8jR.getTypedJSONResultDataAssistanceService)(answerString).parsedResult
    };
    const userWorkResult = workResult.user_metadata_with_activity[0];
    const activities = userWorkResult.recentActivity;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2xz4a.ProfileSection), {
                name: userWorkResult.name,
                email: userWorkResult.email,
                avatarUrl: userWorkResult.avatar_url,
                profileUrl: userWorkResult.profile_url,
                jobTitle: userWorkResult.job_title,
                department: userWorkResult.department,
                location: userWorkResult.location,
                time: userWorkResult.time
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $khBdc.RecentWorkList), {
                name: userWorkResult.name,
                activities: activities,
                viewAllUrl: userWorkResult.viewAllLink
            })
        ]
    });
};

});


parcelRegister("jfJyy", function(module, exports) {

$parcel$export(module.exports, "PlaintextResultComponent", () => $c81f62ac06382b4f$export$f8279a5be196ce2f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $f7lNm = parcelRequire("f7lNm");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $dIrGc = parcelRequire("dIrGc");
const $c81f62ac06382b4f$export$f8279a5be196ce2f = ()=>{
    const [isResultOverflow, setResultOverflow] = (0, $gwFzn.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $gwFzn.useState)(false);
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const contentRef = (0, $gwFzn.useRef)(null);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const onCloseDialog = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerReturnLinkClick)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const enableShowMoreBlur = cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT && isReadingAids;
    (0, $gwFzn.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dIrGc.AIAnswerResultSection), {
                isReadingAids: isReadingAids && cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT,
                ref: wrapperRef,
                isExpanded: isResultExpanded,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        ref: contentRef,
                        children: answerString
                    }),
                    enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerResultBlurSection), {
                        onClick: ()=>setResultExpanded(true),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerResultBlurSectionText), {
                            children: formatMessage((0, $7lL49.messages).ai_answer_expand_button_label)
                        })
                    })
                ]
            }),
            !isReadingAids && onClose && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerCloseLabelWrapper), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_dialog_cancel_label,
                    values: {
                        searchResultsLink: // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                            onClick: onCloseDialog,
                            children: formatMessage((0, $7lL49.messages).ai_answer_dialog_search_results_label)
                        })
                    }
                })
            })
        ]
    });
};

});

parcelRegister("gjS7S", function(module, exports) {

$parcel$export(module.exports, "RenderedResultComponent", () => $26d84f90c8afc6f6$export$b6ab675c6c26c40f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $7bZ3i = parcelRequire("7bZ3i");

var $dh538 = parcelRequire("dh538");

var $j1gOA = parcelRequire("j1gOA");

var $f7lNm = parcelRequire("f7lNm");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $7Zbm6 = parcelRequire("7Zbm6");

var $dIrGc = parcelRequire("dIrGc");

var $cXwl9 = parcelRequire("cXwl9");

const $26d84f90c8afc6f6$var$ReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("c7KWS")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));

const $26d84f90c8afc6f6$var$MarkdownRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("dzIFl")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $26d84f90c8afc6f6$export$b6ab675c6c26c40f = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isResultOverflow, setResultOverflow] = (0, $gwFzn.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $gwFzn.useState)(false);
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const contentRef = (0, $gwFzn.useRef)(null);
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, answerFormat: answerFormat } = commonAttributes;
    const onCloseDialog = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerReturnLinkClick)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const enableShowMoreBlur = cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT && isReadingAids;
    (0, $gwFzn.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    const docContent = (0, $gwFzn.useMemo)(()=>(0, $j1gOA.encodeAdf)(answerString, false), [
        answerString
    ]);
    const FormattedResult = (0, $gwFzn.useMemo)(()=>{
        let content;
        switch(answerFormat){
            case (0, $7Zbm6.NLPSearchResultFormat).ADF:
                content = /*#__PURE__*/ (0, $7UHDa.jsx)($26d84f90c8afc6f6$var$ReactRenderer, {
                    document: JSON.parse(answerString),
                    nodeComponents: {
                        // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                        // Followup ticket to re-enable image rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                        media: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                        mediaSingle: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {})
                    }
                });
                break;
            case (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN:
                if (!isReadingAids && ((0, $dh538.fg)('kd_smart_answers_use_adf_encoder') || (0, $dh538.fg)('kd_smart_answers_use_adf_encoder_jira'))) {
                    content = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)($26d84f90c8afc6f6$var$ReactRenderer, {
                            document: docContent,
                            nodeComponents: {
                                status: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $cXwl9.StatusCitation), {
                                        ...props
                                    }),
                                // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                                // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                                media: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                                mediaSingle: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {})
                            }
                        })
                    });
                    break;
                }
                // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                content = /*#__PURE__*/ (0, $7UHDa.jsx)($26d84f90c8afc6f6$var$MarkdownRenderer, {
                    disallowedElements: [
                        'img'
                    ],
                    children: answerString
                });
                break;
            default:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {});
        }
        return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            ref: contentRef,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                children: content
            })
        });
    }, [
        answerFormat,
        answerString,
        contentRef,
        docContent,
        isReadingAids
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerResultSection), {
                id: "ai-answer-result-section",
                ref: wrapperRef,
                isReadingAids: isReadingAids && cardTemplate === (0, $f7lNm.CardTemplate).DEFAULT,
                isExpanded: isResultExpanded,
                children: FormattedResult
            }),
            enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerResultBlurSection), {
                onClick: ()=>setResultExpanded(true),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerResultBlurSectionText), {
                    children: formatMessage((0, $7lL49.messages).ai_answer_expand_button_label)
                })
            }),
            !isReadingAids && onClose && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dIrGc.AIAnswerCloseLabelWrapper), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_dialog_cancel_label,
                    values: {
                        searchResultsLink: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                        /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                            onClick: onCloseDialog,
                            children: formatMessage((0, $7lL49.messages).ai_answer_dialog_search_results_label)
                        })
                    }
                })
            })
        ]
    });
};

});
parcelRegister("cXwl9", function(module, exports) {

$parcel$export(module.exports, "StatusCitation", () => $3574ef4ffa67c8f4$export$21553c57082a6434);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $90Y9A = parcelRequire("90Y9A");

var $fYQcF = parcelRequire("fYQcF");

var $4jIuc = parcelRequire("4jIuc");

var $01aV7 = parcelRequire("01aV7");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");
const $3574ef4ffa67c8f4$var$convertColorAppearance = (color)=>{
    switch(color){
        case 'blue':
            return 'inprogress';
        case 'green':
            return 'success';
        case 'red':
            return 'removed';
        case 'yellow':
            return 'moved';
        case 'purple':
            return 'new';
        default:
            return 'default';
    }
};
const $3574ef4ffa67c8f4$var$citationStyles = (0, $ecnYn.xcss)({
    border: 'none',
    background: 'none',
    padding: 'space.0',
    ':hover': {
        cursor: 'pointer'
    }
});
const $3574ef4ffa67c8f4$export$21553c57082a6434 = ({ localId: localId, text: text, color: color = 'blue' })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    const sources = commonAttributes.sources;
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { source: source, idx: idx } = (0, $gwFzn.useMemo)(()=>{
        if (!localId.includes('citation')) return {};
        const idx = parseInt(localId.split('-')?.[1]);
        return {
            source: sources[idx - 1],
            idx: idx
        };
    }, [
        localId,
        sources
    ]);
    const handleClick = (0, $gwFzn.useCallback)((source, idx)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: idx,
            isCitation: true,
            hostname: (0, $01aV7.extractUrlHostname)(source.url),
            ...commonAttributes
        }));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        }) : trackAIResultAction((0, $4jIuc.SainAction).SOURCE_CLICKED);
        window.open(source.url, '_blank', 'noopener, noreferrer');
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        trackAIResultAction
    ]);
    if (!!source) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $90Y9A.StandaloneHoverCard), {
        url: source.url,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            xcss: $3574ef4ffa67c8f4$var$citationStyles,
            onClick: ()=>{
                handleClick(source, idx);
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                appearance: "inprogress",
                children: idx
            })
        })
    });
    // Standard lozenge for status nodes
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
        appearance: $3574ef4ffa67c8f4$var$convertColorAppearance(color),
        children: text
    });
};

});

parcelRegister("c7KWS", function(module, exports) {

let $8d3a8e82ce578b7e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8d3a8e82ce578b7e$var$load("6qah4"),
    $8d3a8e82ce578b7e$var$load("iBa9k"),
    $8d3a8e82ce578b7e$var$load("cPSQq")
]).then(()=>parcelRequire('fLCGB'));

});

parcelRegister("dzIFl", function(module, exports) {

let $9e2130f6d16c88c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9e2130f6d16c88c8$var$load("9tyrK").then(()=>parcelRequire('bM5QZ'));

});


parcelRegister("eyk5b", function(module, exports) {

$parcel$export(module.exports, "AIAnswerBodyWrapper", () => $e289d21f2bc4318a$export$373eea644718ed14);
$parcel$export(module.exports, "AIAnswerErrorWrapper", () => $e289d21f2bc4318a$export$106e8178ce804384);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $e289d21f2bc4318a$export$373eea644718ed14 = (0, $gwrgp.default)("div", {
    target: "e4t9yx60"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: props.isReadingAids ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-050, 4px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-300, 24px)"}`
    }));
const $e289d21f2bc4318a$export$106e8178ce804384 = (0, $gwrgp.default)("div", {
    target: "e4t9yx61"
})({
    paddingRight: `${"var(--ds-space-300, 24px)"}`
});

});


parcelRegister("cGU6t", function(module, exports) {

$parcel$export(module.exports, "AIAnswerContentWarningAndBrandSection", () => $536772676f624703$export$9e8b51119c9a7742);
$parcel$export(module.exports, "SearchPageSmartAnswerFooter", () => $536772676f624703$export$74b8b3463af67a4d);
$parcel$export(module.exports, "AIAnswerFooter", () => $536772676f624703$export$37858bd8fa3d5915);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7gpC4 = parcelRequire("7gpC4");

var $c6GJD = parcelRequire("c6GJD");

var $6uGcC = parcelRequire("6uGcC");

var $l6Qdw = parcelRequire("l6Qdw");

var $1niwh = parcelRequire("1niwh");

var $2Nwuj = parcelRequire("2Nwuj");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $eLJ6t = parcelRequire("eLJ6t");

var $2riIq = parcelRequire("2riIq");

var $5cDZV = parcelRequire("5cDZV");

var $f7lNm = parcelRequire("f7lNm");

var $7lL49 = parcelRequire("7lL49");

var $ddpm5 = parcelRequire("ddpm5");

var $lQaNB = parcelRequire("lQaNB");

var $eRXI0 = parcelRequire("eRXI0");

var $7Zbm6 = parcelRequire("7Zbm6");

var $10T8p = parcelRequire("10T8p");

var $aOj19 = parcelRequire("aOj19");

var $aCewN = parcelRequire("aCewN");

const $536772676f624703$var$AkFeedbackCollector = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i8OiN")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $536772676f624703$var$AkFeedbackFlag = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i8OiN")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $536772676f624703$var$chatInputContainerStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
var $536772676f624703$var$ExperimentCohort = /*#__PURE__*/ function(ExperimentCohort) {
    ExperimentCohort["CONTROL"] = "control";
    ExperimentCohort["DEFAULT"] = "default";
    ExperimentCohort["TEST"] = "test";
    return ExperimentCohort;
}($536772676f624703$var$ExperimentCohort || {});
const $536772676f624703$export$9e8b51119c9a7742 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { brand: brand, cardTemplate: cardTemplate, sourceProduct: sourceProduct } = (0, $eRXI0.useAIAnswerContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aCewN.AIAnswerContentBrandWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aCewN.AIAnswerFooterInformationContentVary), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6Qdw))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #626F86)",
                        LEGACY_size: "small"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.AIAnswerFooterInformationContentVaryLinkText), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: sourceProduct === 'sac' ? (0, $f7lNm.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK) : (0, $f7lNm.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                            children: formatMessage(cardTemplate === (0, $f7lNm.CardTemplate).RIGHT_PANEL ? (0, $7lL49.messages).ai_answer_dialog_footer_content_quality_short : (0, $7lL49.messages).ai_answer_dialog_footer_content_quality_long)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.AIAnswerFooterPoweredBy), {
                children: brand === (0, $f7lNm.AiBrand).ROVO ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: (0, $f7lNm.ATLASSIAN_ROVO_LINK),
                            children: "Rovo"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1niwh.default), {
                            label: "",
                            primaryColor: "var(--ds-icon-subtle, #626F86)"
                        })
                    ]
                }) : sourceProduct !== 'sac' && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aCewN.AIAnswerFooterPoweredByAIWrapper), {
                    children: [
                        formatMessage((0, $7lL49.messages).ai_answer_dialog_loaded_footer),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eLJ6t.default), {
                            greyed: true,
                            size: 'large'
                        })
                    ]
                })
            })
        ]
    });
};
const $536772676f624703$export$3553ee90c7edebc9 = ({ showOpenChat: showOpenChat })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query, answerString: answerString } = commonAttributes;
    const experimentCohort = (0, $dh538.fg)('kd_sain_chat_interaction_exp_gate') ? (0, $c6GJD.default).getExperimentValue('kd_sain_chat_interaction_exp', 'cohort', "default") : "default";
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aCewN.AIAnswerFooterWrapper), {
        children: [
            showOpenChat && (experimentCohort === "test" ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $536772676f624703$var$chatInputContainerStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5cDZV.ChatFollowupInput), {
                    query: query,
                    answerString: answerString,
                    source: 'sain',
                    experimentCohort: experimentCohort
                })
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2riIq.OpenChatButton), {
                prompt: query,
                query: query,
                answerString: answerString,
                source: 'sain',
                experimentCohort: experimentCohort
            })),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aOj19.FollowUpSuggestionFooter), {})
        ]
    });
};
const $536772676f624703$var$AIAnswerBaseFooter = ({ showWhoAnswer: showWhoAnswer, showOpenChat: showOpenChat })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, userDetails: { name: name, id: id }, readingAidsOptions: readingAidsOptions, loading: loading, brand: brand, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const { errorState: errorState, answerFormat: answerFormat, followUps: followUps } = commonAttributes;
    const [showFeedbackModal, setFeedbackModal] = (0, $gwFzn.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const [hasConsent, setConsent] = (0, $gwFzn.useState)(false);
    const [topicsNotRelevant, setTopicsNotRelevant] = (0, $gwFzn.useState)(false);
    const feedbackContextObject = {
        searchSessionId: commonAttributes.searchSessionId,
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        topicsNotRelevant: topicsNotRelevant ? true : undefined
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $gwFzn.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const toggleTopicsNotRelevantCheckbox = (0, $gwFzn.useCallback)(()=>{
        setTopicsNotRelevant(!topicsNotRelevant);
    }, [
        topicsNotRelevant
    ]);
    const topicsEnabled = (0, $dh538.fg)('kd_topics_in_person_card');
    const brandName = brand === (0, $f7lNm.AiBrand).ROVO ? 'Rovo' : 'Atlassian Intelligence';
    const renderOpenChatButton = showOpenChat && showChatFollowUps && !loading && isAnswered && (0, $dh538.fg)('kd_smart_answers_open_chat');
    return showBookends ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            showWhoAnswer && answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lQaNB.AIAnswerWhoFooter), {}),
            (renderOpenChatButton || followUps.length > 0) && /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$export$3553ee90c7edebc9, {
                showOpenChat: renderOpenChatButton
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            showWhoAnswer && answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lQaNB.AIAnswerWhoFooter), {}),
            !loading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.AIAnswerFeedbackWrapper), {
                isCompact: true,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $10T8p.FeedbackButtons), {
                    setDisplayFlag: setDisplayFlag,
                    setFeedbackModal: setFeedbackModal
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$export$9e8b51119c9a7742, {}),
            (renderOpenChatButton || followUps.length > 0) && /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$export$3553ee90c7edebc9, {
                showOpenChat: renderOpenChatButton
            }),
            showFeedbackModal ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setFeedbackModal(false),
                    onSubmit: ()=>{
                        setDisplayFlag(true);
                    },
                    customContent: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $7lL49.messages).ai_answer_component_report_consent_checkbox_label),
                                onChange: toggleConsentCheckbox,
                                isChecked: hasConsent
                            }),
                            topicsEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $7lL49.messages).ai_answer_component_topics_not_relevant_checkbox_label),
                                onChange: toggleTopicsNotRelevantCheckbox,
                                isChecked: topicsNotRelevant
                            })
                        ]
                    }),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: (0, $f7lNm.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    additionalFields: [
                        {
                            id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ],
                    feedbackTitle: formatMessage((0, $7lL49.messages).ai_answer_component_report_modal_title, {
                        brandName: brandName
                    }),
                    feedbackTitleDetails: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.AIAnswerReportDescriptionWrapper), {
                        children: formatMessage((0, $7lL49.messages).ai_answer_component_report_summary_label)
                    }),
                    feedbackGroupLabels: {
                        empty: {
                            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_empty_option_share_label)
                        },
                        question: {
                            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_relevance_option_label)
                        },
                        comment: {
                            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_inaccurate_option_label)
                        },
                        bug: {
                            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_offensive_option_label)
                        },
                        suggestion: {
                            fieldLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $7lL49.messages).ai_answer_component_report_other_option_label)
                        }
                    },
                    summaryPlaceholder: formatMessage((0, $7lL49.messages).ai_answer_component_summary_placeholder_label)
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $7lL49.messages).ai_answer_component_feedback_flag_description)
                    })
                })
            })
        ]
    });
};
const $536772676f624703$export$74b8b3463af67a4d = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$var$AIAnswerBaseFooter, {
        showOpenChat: true
    });
};
const $536772676f624703$var$AIAnswerDialogFooter = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$var$AIAnswerBaseFooter, {
        showWhoAnswer: true
    });
};
const $536772676f624703$export$37858bd8fa3d5915 = ()=>{
    const { isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $eRXI0.useAIAnswerContext)();
    switch(cardTemplate){
        case (0, $f7lNm.CardTemplate).SMART_ANSWER:
            return /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$export$74b8b3463af67a4d, {});
        default:
            return isReadingAids ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ddpm5.DefinitionFooter), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($536772676f624703$var$AIAnswerDialogFooter, {});
    }
};

});
parcelRegister("1niwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd520e3be20e6b6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $edd520e3be20e6b6$var$RovoIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.7752 5.21224C12.3029 4.93307 11.7214 4.92931 11.2462 5.20093C11.2394 5.20599 11.2323 5.21073 11.2248 5.21512L11.2248 5.21516L11.2237 5.21577C10.9177 5.39703 10.6863 5.67726 10.5594 6.00375C10.4892 6.18616 10.4517 6.38319 10.4517 6.58598V8.68258L13.0149 10.1983L13.0151 10.1984C13.6446 10.5693 14.0306 11.255 14.0306 11.9985V17.4111C14.0306 17.6539 13.989 17.8909 13.9111 18.1129L17.3498 16.0786L17.3502 16.0784C17.8304 15.7955 18.125 15.2727 18.125 14.7048V9.29226C18.125 8.72659 17.8287 8.20154 17.3499 7.91852L17.3498 7.91848L12.7752 5.21224Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5483 17.4141C13.5483 17.6172 13.5107 17.8144 13.4403 17.9971C13.3132 18.3236 13.0816 18.6038 12.7752 18.7849L12.7751 18.785C12.7677 18.7893 12.7606 18.7941 12.7538 18.7991C12.2786 19.0708 11.6971 19.067 11.2249 18.7879L11.2248 18.7878L6.65013 16.0816L6.65006 16.0816C6.17129 15.7985 5.875 15.2735 5.875 14.7078L5.875 9.29525C5.875 8.72734 6.16955 8.20457 6.64975 7.92169L10.0889 5.88721C10.0109 6.10916 9.96935 6.34615 9.96935 6.58897V12.0015C9.96935 12.745 10.3553 13.4307 10.9847 13.8016L10.985 13.8018L13.5483 15.3175V17.4141Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __RovoIcon__
 */ const $edd520e3be20e6b6$var$RovoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $edd520e3be20e6b6$var$RovoIconGlyph
    });
var $edd520e3be20e6b6$export$2e2bcd8739ae039 = $edd520e3be20e6b6$var$RovoIcon;

});

parcelRegister("eLJ6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af0d4a8e674c639$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $4af0d4a8e674c639$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.5 15.3L17.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.5 15.3L6.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.5 10.3L6.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.5 10.3L17.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0001 16.8V19.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.00012 12.8L5.00012 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0001 8.80003L12.0001 5.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.0002 12.8L19.0002 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            })
        ]
    });
var $4af0d4a8e674c639$export$2e2bcd8739ae039 = $4af0d4a8e674c639$export$eaf821108be3620b;

});

parcelRegister("5cDZV", function(module, exports) {

$parcel$export(module.exports, "ChatFollowupInput", () => $f8e21b81545de5a6$export$78cc4bc285078898);
/* chat-followup-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $fzqvY = parcelRequire("fzqvY");
var $fb3kw = parcelRequire("fb3kw");

var $4fdTR = parcelRequire("4fdTR");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $i25hX = parcelRequire("i25hX");

var $4noo5 = parcelRequire("4noo5");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $14qs9 = parcelRequire("14qs9");

var $e0dFv = parcelRequire("e0dFv");
const $f8e21b81545de5a6$var$containerStyles = (0, $ecnYn.xcss)({
    borderRadius: '3px',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    padding: 'space.100'
});
const $f8e21b81545de5a6$var$inputFieldContainerStyles = (0, $ecnYn.xcss)({
    flex: 1
});
const $f8e21b81545de5a6$var$textFieldStyles = null;
const $f8e21b81545de5a6$export$78cc4bc285078898 = ({ answerString: answerString, query: query, source: source, experimentCohort: experimentCohort })=>{
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const sendToChat = (0, $gwFzn.useCallback)((formData)=>{
        if (!Boolean(formData.followupQuery)) return;
        fireAnalyticsEvent((0, $4xTru.onOpenChatButtonClick)({
            ...commonAttributes,
            experimentCohort: experimentCohort
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).OPEN_CHAT_CLICKED
        });
        publish({
            type: 'chat-new',
            source: source,
            data: {
                name: query.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: formData.followupQuery,
                sourceId: commonAttributes.searchSessionId
            }
        });
        formData.followupQuery = '';
    }, [
        query,
        answerString,
        publish,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        source,
        experimentCohort
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $f8e21b81545de5a6$var$containerStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fzqvY.default), {
                onSubmit: sendToChat,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)("form", {
                        ...formProps,
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                            grow: "fill",
                            spread: "space-between",
                            alignBlock: "center",
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                    xcss: $f8e21b81545de5a6$var$inputFieldContainerStyles,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
                                        name: "followupQuery",
                                        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                                                autoComplete: "off",
                                                placeholder: formatMessage((0, $e0dFv.messages).ai_answer_component_ai_answer_ask_more_chat),
                                                appearance: "none",
                                                testId: "ai-answer-chat-followup-input",
                                                ...fieldProps,
                                                className: (0, $35pXk.default)([
                                                    "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1pfhx0bf _12qbidpf _1f5xidpf _15eiidpf _1pxmidpf"
                                                ])
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                    label: formatMessage((0, $e0dFv.messages).ai_answer_component_ai_answer_ask_more_chat_submit),
                                    type: "submit",
                                    testId: "ai-answer-chat-followup-input-submit",
                                    spacing: "compact"
                                })
                            ]
                        })
                    })
            })
        })
    });
};

});

parcelRegister("ddpm5", function(module, exports) {

$parcel$export(module.exports, "DefinitionFooter", () => $16f998d00c2c3aa2$export$9de8ba80314e4213);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7gpC4 = parcelRequire("7gpC4");

var $6uGcC = parcelRequire("6uGcC");

var $6xdDU = parcelRequire("6xdDU");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $epS7s = parcelRequire("epS7s");

var $eRXI0 = parcelRequire("eRXI0");

var $9pwVP = parcelRequire("9pwVP");

var $a7RTn = parcelRequire("a7RTn");

var $jBpLK = parcelRequire("jBpLK");

var $1uG1A = parcelRequire("1uG1A");

var $xhg8G = parcelRequire("xhg8G");

var $5XnQI = parcelRequire("5XnQI");

var $3022Y = parcelRequire("3022Y");

var $fRx7P = parcelRequire("fRx7P");

var $50wuq = parcelRequire("50wuq");

var $esgBr = parcelRequire("esgBr");

var $kDGJp = parcelRequire("kDGJp");

const $16f998d00c2c3aa2$var$AkFeedbackFlag = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i8OiN")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $16f998d00c2c3aa2$var$FeedbackButtonWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    marginBottom: 'space.050',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.accent.gray',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $16f998d00c2c3aa2$export$9de8ba80314e4213 = ()=>{
    const { answerEditor: answerEditor, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled } = (0, $eRXI0.useAIAnswerContext)();
    const { query: keyPhrase, workspaceId: workspaceId } = commonAttributes;
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $gwFzn.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $gwFzn.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $gwFzn.useState)(false);
    const [showEditHistoryModal, setShowEditHistoryModal] = (0, $gwFzn.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $gwFzn.useState)(false);
    const cachedTermDefinitionDisabled = JSON.parse((0, $epS7s.getSessionItem)($16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [termDefinitionDisabled, setTermDefinitionDisabled] = (0, $gwFzn.useState)(cachedTermDefinitionDisabled.keyPhrase === keyPhrase);
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { toggleDefinition: toggleDefinition } = (0, $kDGJp.useToggleDefinitionSupplier)();
    const onToggleDefinitionDisable = async ()=>{
        try {
            setTermDefinitionDisabled((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !termDefinitionDisabled
            });
            if (termDefinitionDisabled) (0, $epS7s.deleteSessionItem)($16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $9pwVP.onClickDisableDefinition)(commonAttributes));
                (0, $epS7s.setSessionItem)($16f998d00c2c3aa2$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setTermDefinitionDisabled((current)=>!current);
            fireAnalyticsEvent((0, $xhg8G.toggleDefinitionErrorPayload)(error, commonAttributes));
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            !hasError && isAnswered && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                justifyContent: "space-between",
                xcss: $16f998d00c2c3aa2$var$FeedbackButtonWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5XnQI.FeedbackButtons), {
                            setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
                            setDisplayFlag: setDisplayFlag
                        })
                    }),
                    definitionToggleEnabled && (0, $dh538.fg)('kd_definitions_toggle_definition') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                        isChecked: termDefinitionDisabled,
                        label: (0, $esgBr.messages).definition_footer_hide_term_definition_message.defaultMessage,
                        value: (0, $esgBr.messages).definition_footer_hide_term_definition_message.defaultMessage,
                        onChange: onToggleDefinitionDisable
                    })
                ]
            }),
            answerEditor ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $50wuq.EditedDefinitionFooterSection), {
                setShowEditHistoryModal: setShowEditHistoryModal
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $50wuq.AIDefinitionFooterSection), {}),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6xdDU.default), {
                children: [
                    showEditHistoryModal && editDefinitionEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1uG1A.DefinitionEditHistory), {
                        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                        onClose: ()=>setShowEditHistoryModal(false)
                    }),
                    showFeedbackOptionsModal && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fRx7P.FeedbackOptionsModal), {
                        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
                        setShowEditDefinitionModal: setShowEditDefinitionModal,
                        setShowFeedbackModal: setShowFeedbackModal,
                        editDefinitionEnabled: editDefinitionEnabled
                    }),
                    showFeedbackModal && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3022Y.FeedbackModal), {
                        setFeedbackModal: setShowFeedbackModal,
                        isCuratedDefinition: !!answerEditor,
                        setDisplayFlag: setDisplayFlag
                    }),
                    showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jBpLK.EditDefinitionModal), {
                        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                        closeEditModal: ()=>setShowEditDefinitionModal(false),
                        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
                        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                    })
                ]
            }),
            displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($16f998d00c2c3aa2$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $esgBr.messages).definition_footer_feedback_flag_description)
                    })
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7RTn.DefinitionUpdateConfirmationFlag), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};

});
parcelRegister("1uG1A", function(module, exports) {

$parcel$export(module.exports, "DefinitionEditHistory", () => $d30730e216903aee$export$6c43ad171ca78b4f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $abC4X = parcelRequire("abC4X");

var $hxQwS = parcelRequire("hxQwS");

var $13WX1 = parcelRequire("13WX1");

var $eG1e2 = parcelRequire("eG1e2");

var $1jfCH = parcelRequire("1jfCH");

var $kd3D9 = parcelRequire("kd3D9");

var $hYhtq = parcelRequire("hYhtq");

var $iky1p = parcelRequire("iky1p");

var $am4ic = parcelRequire("am4ic");

var $7BsZq = parcelRequire("7BsZq");

var $2Nwuj = parcelRequire("2Nwuj");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $d8eRd = parcelRequire("d8eRd");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $3qWFS = parcelRequire("3qWFS");

var $eRXI0 = parcelRequire("eRXI0");

var $9KkVf = parcelRequire("9KkVf");

var $84LcG = parcelRequire("84LcG");

var $73WiV = parcelRequire("73WiV");

const $d30730e216903aee$var$MarkdownRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("dzIFl")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $d30730e216903aee$var$loadingSpinnerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    width: '100%'
});
const $d30730e216903aee$var$editHistoryModalStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingTop: 'space.300',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    paddingBottom: 'space.100',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative'
});
const $d30730e216903aee$var$editHistoryWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.250',
    gap: 'space.200',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $d30730e216903aee$var$editHistoryDescriptionStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    gap: 'space.050'
});
const $d30730e216903aee$var$editedDefinitionCardContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.100'
});
const $d30730e216903aee$var$editedDefinitionScopeTextStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $d30730e216903aee$var$editedDefinitionCardStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: 'space.200',
    borderRadius: "var(--ds-space-100, 8px)",
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    gap: 'space.200'
});
const $d30730e216903aee$var$editedDefinitionAvatarStyles = (0, $ecnYn.xcss)({
    borderRadius: '64%'
});
const $d30730e216903aee$var$editedDefinitionCardBodyStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: 'space.150'
});
const $d30730e216903aee$var$editedDefinitionCardHeaderWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.0'
});
const $d30730e216903aee$var$editedDefinitionCardHeaderSpacerStyles = {
    width: '100%',
    color: "var(--ds-border, #F0F0F3)",
    marginTop: 3,
    marginBottom: 0
};
const $d30730e216903aee$var$editedDefinitionCardHeaderStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.050',
    color: 'color.text.subtle',
    marginBottom: 'space.100'
});
const $d30730e216903aee$var$editedDefinitionCardEditorStyles = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    color: 'color.text'
});
const $d30730e216903aee$var$editedDefinitionCardReferenceStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $d30730e216903aee$var$editedDefinitionCardReferenceTitleStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050'
});
const $d30730e216903aee$var$ScopeDescription = ({ scope: scope })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    let scopeDescription = '';
    let ScopeIcon;
    switch(scope){
        case (0, $9KkVf.EditedDefinitionScope).ORGANIZATION:
            scopeDescription = formatMessage((0, $84LcG.messages).readingAidsEditHistoryVisibilityTextOrg);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($hYhtq)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).SPACE:
            scopeDescription = formatMessage((0, $84LcG.messages).readingAidsEditHistoryVisibilitySpace);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iky1p)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).PAGE:
            scopeDescription = formatMessage((0, $84LcG.messages).readingAidsEditHistoryVisibilityPage);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kd3D9)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).BLOGPOST:
            scopeDescription = formatMessage((0, $84LcG.messages).readingAidsEditHistoryVisibilityBlog);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($am4ic)));
            break;
        case (0, $9KkVf.EditedDefinitionScope).PROJECT:
            scopeDescription = formatMessage((0, $84LcG.messages).readingAidsEditHistoryVisibilityProject);
            ScopeIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                    color: "var(--ds-icon, #44546F)",
                    label: "",
                    LEGACY_fallbackIcon: (0, $7BsZq.default),
                    LEGACY_size: "medium",
                    LEGACY_margin: `0 0 0 ${"var(--ds-space-negative-050, -4px)"}`
                });
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        xcss: $d30730e216903aee$var$editedDefinitionScopeTextStyles,
        space: "space.050",
        children: [
            scopeDescription,
            " ",
            /*#__PURE__*/ (0, $7UHDa.jsx)(ScopeIcon, {
                label: ""
            })
        ]
    });
};
const $d30730e216903aee$export$6c43ad171ca78b4f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { commonAttributes: { query: query } } = (0, $eRXI0.useAIAnswerContext)();
    const { definitions: definitions, loading: loading } = (0, $73WiV.useDefinitionEditHistory)({
        query: query,
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const hasError = definitions.length === 0 && !loading;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ekolh.default), {
        onClose: onClose,
        height: 600,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $d30730e216903aee$var$editHistoryModalStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                        children: formatMessage((0, $84LcG.messages).readingAidsEditHistoryHeader)
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jfCH))),
                        label: "",
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                    xcss: $d30730e216903aee$var$editHistoryWrapperStyles,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                            xcss: $d30730e216903aee$var$editHistoryDescriptionStyles,
                            children: formatMessage((0, $84LcG.messages).readingAidsEditHistoryDescription, {
                                queryText: /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                                    children: query
                                })
                            })
                        }),
                        hasError || loading ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                            xcss: $d30730e216903aee$var$loadingSpinnerStyles,
                            children: [
                                loading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                                    size: "large",
                                    testId: "definition-history-loading-spinner"
                                }),
                                hasError && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $abC4X.default), {
                                    header: formatMessage((0, $84LcG.messages).readingAidsEditHistoryCardErrorText)
                                })
                            ]
                        }) : definitions.map((item, index)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                                xcss: $d30730e216903aee$var$editedDefinitionCardContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)($d30730e216903aee$var$ScopeDescription, {
                                        scope: item.scope
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                                        xcss: $d30730e216903aee$var$editedDefinitionCardStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                xcss: $d30730e216903aee$var$editedDefinitionAvatarStyles,
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                                                    src: item.editor?.picture || '',
                                                    width: "32px",
                                                    height: "32px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                                                xcss: $d30730e216903aee$var$editedDefinitionCardBodyStyles,
                                                children: [
                                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                                                        xcss: $d30730e216903aee$var$editedDefinitionCardHeaderWrapperStyles,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                                                                xcss: $d30730e216903aee$var$editedDefinitionCardHeaderStyles,
                                                                children: [
                                                                    formatMessage((0, $84LcG.messages).readingAidsEditHistoryCardEdited, {
                                                                        editorName: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                                                                            xcss: $d30730e216903aee$var$editedDefinitionCardEditorStyles,
                                                                            children: item.editor?.name || ''
                                                                        })
                                                                    }),
                                                                    " \u2219 ",
                                                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3qWFS.default), {
                                                                        date: Number(item.createdAt) * 1000
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7UHDa.jsx)("hr", {
                                                                role: "presentation",
                                                                style: $d30730e216903aee$var$editedDefinitionCardHeaderSpacerStyles
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                                        "data-testid": `rendered-markdown-definition-${index}`,
                                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                                                            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($d30730e216903aee$var$MarkdownRenderer, {
                                                                disallowedElements: [
                                                                    'img'
                                                                ],
                                                                children: item.definition
                                                            })
                                                        })
                                                    }),
                                                    item.referenceUrl && item.confluenceEntity?.title && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                        xcss: $d30730e216903aee$var$editedDefinitionCardReferenceStyles,
                                                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2Nwuj.default), {
                                                            appearance: "subtle",
                                                            target: "_blank",
                                                            href: item.referenceUrl,
                                                            children: [
                                                                item.confluenceEntity.type === 'BLOG_POST' ? // TODO : https://product-fabric.atlassian.net/browse/DSP-20772
                                                                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hxQwS.default), {
                                                                    label: ""
                                                                }) : // TODO : https://product-fabric.atlassian.net/browse/DSP-20772
                                                                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $13WX1.default), {
                                                                    label: ""
                                                                }),
                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                                                                    xcss: $d30730e216903aee$var$editedDefinitionCardReferenceTitleStyles,
                                                                    children: item.confluenceEntity.title || ''
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, `edited-definition-history-card-${index}`))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8o1lj.default), {})
        ]
    });
};

});
parcelRegister("iky1p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9b9cd277a5f67bd48c0d2d43a0af7c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5847c3f4be2701b$var$_react = $d5847c3f4be2701b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $d5847c3f4be2701b$var$_pages = $d5847c3f4be2701b$var$_interopRequireDefault((parcelRequire("bTdbD")));

var $d5847c3f4be2701b$var$_documents = $d5847c3f4be2701b$var$_interopRequireDefault((parcelRequire("6NyjW")));
function $d5847c3f4be2701b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PagesIcon.
 * This component is PagesIcon, with `UNSAFE_fallbackIcon` set to "DocumentsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5847c3f4be2701b$var$PagesIcon = (props)=>/*#__PURE__*/ $d5847c3f4be2701b$var$_react.default.createElement($d5847c3f4be2701b$var$_pages.default, Object.assign({
        LEGACY_fallbackIcon: $d5847c3f4be2701b$var$_documents.default
    }, props));
$d5847c3f4be2701b$var$PagesIcon.Name = 'PagesIconMigration';
var $d5847c3f4be2701b$var$_default = module.exports.default = $d5847c3f4be2701b$var$PagesIcon;

});

parcelRegister("7BsZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde1b1e667ccd8d5$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $dde1b1e667ccd8d5$var$OpenFolderIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M5.659 20C4.91228 20 4.23261 19.5847 3.88908 18.9314L3.8207 18.7878L1.67785 13.7878C1.24274 12.7726 1.71304 11.5968 2.7283 11.1617C2.92746 11.0764 3.13883 11.0241 3.35409 11.0066L3.51614 11H3.99862L3.9996 6C3.9996 4.94564 4.81548 4.08183 5.85034 4.00549L5.9996 4H9.9996C10.2206 4 10.4341 4.07316 10.6076 4.20608L10.7067 4.29289L12.4146 6H17.9996C19.054 6 19.9178 6.81588 19.9941 7.85074L19.9996 8V18C19.9996 19.1046 19.1042 20 17.9996 20H5.659ZM13.6808 13H3.5156L5.659 18H16.4826L14.6 13.6061C14.4739 13.3119 14.2173 13.1005 13.9149 13.0277L13.7995 13.007L13.6808 13ZM9.5846 6H5.9996L5.99863 11H13.6808C14.8142 11 15.8446 11.6379 16.3539 12.638L16.4382 12.8182L17.9986 16.46L17.9996 8H11.9996C11.7786 8 11.5651 7.92684 11.3916 7.79392L11.2925 7.70711L9.5846 6Z",
            fill: "currentColor"
        })
    });
/**
 * __OpenFolderIcon__
 */ const $dde1b1e667ccd8d5$var$OpenFolderIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $dde1b1e667ccd8d5$var$OpenFolderIconGlyph,
        ...props
    });
var $dde1b1e667ccd8d5$export$2e2bcd8739ae039 = $dde1b1e667ccd8d5$var$OpenFolderIcon;

});

parcelRegister("3qWFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6771c3a2a278459$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $hrzSy = parcelRequire("hrzSy");

var $ixYgS = parcelRequire("ixYgS");

var $3ryTa = parcelRequire("3ryTa");

var $jihLw = parcelRequire("jihLw");
const $b6771c3a2a278459$var$SECOND = 1;
const $b6771c3a2a278459$var$MINUTE = 60;
const $b6771c3a2a278459$var$HOUR = $b6771c3a2a278459$var$MINUTE * 60;
const $b6771c3a2a278459$var$DAY = $b6771c3a2a278459$var$HOUR * 24;
const $b6771c3a2a278459$var$WEEK = $b6771c3a2a278459$var$DAY * 7;
const $b6771c3a2a278459$var$MONTH = $b6771c3a2a278459$var$WEEK * 4.345;
const $b6771c3a2a278459$var$YEAR = $b6771c3a2a278459$var$MONTH * 12;
const $b6771c3a2a278459$var$units = [
    [
        'year',
        $b6771c3a2a278459$var$YEAR
    ],
    [
        'month',
        $b6771c3a2a278459$var$MONTH
    ],
    [
        'week',
        $b6771c3a2a278459$var$WEEK
    ],
    [
        'day',
        $b6771c3a2a278459$var$DAY
    ],
    [
        'hour',
        $b6771c3a2a278459$var$HOUR
    ],
    [
        'minute',
        $b6771c3a2a278459$var$MINUTE
    ],
    [
        'second',
        $b6771c3a2a278459$var$SECOND
    ]
];
const $b6771c3a2a278459$var$getRelativeTimeProps = (timeDifferenceInSeconds)=>{
    const relevantUnit = $b6771c3a2a278459$var$units.find((unit)=>{
        return timeDifferenceInSeconds >= unit[1];
    }) || $b6771c3a2a278459$var$units[0];
    let props = {
        value: -Math.floor(timeDifferenceInSeconds / relevantUnit[1]),
        unit: relevantUnit[0]
    };
    // Only create the update interval if time difference in seconds, minutes or hours
    // FormattedRelativeTime no longer supports higher than 'hour' for interval update
    // read "Limitation" on https://formatjs.io/docs/react-intl/components/#formattedrelativetime
    if ([
        'second',
        'minute',
        'hour'
    ].includes(relevantUnit[0])) return {
        ...props,
        updateIntervalInSeconds: 60
    };
    return props;
};
const $b6771c3a2a278459$var$TimeAgo = ({ date: date })=>{
    const differenceInSeconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    const isLessThanOneMinuteAgo = differenceInSeconds < 60;
    const [showJustNow, setShowJustNow] = (0, $gwFzn.useState)(isLessThanOneMinuteAgo);
    (0, $gwFzn.useEffect)(()=>{
        let timeout;
        if (isLessThanOneMinuteAgo) {
            setShowJustNow(true);
            // gonna refresh only once after difference time has passed
            const refreshTime = (60 - differenceInSeconds) * 1000;
            timeout = setTimeout(()=>{
                setShowJustNow(false);
            }, refreshTime);
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        differenceInSeconds,
        isLessThanOneMinuteAgo
    ]);
    if (showJustNow) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $jihLw.messages).justNow
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        numeric: "always",
        ...$b6771c3a2a278459$var$getRelativeTimeProps(differenceInSeconds)
    });
};
var $b6771c3a2a278459$export$2e2bcd8739ae039 = (0, $ixYgS.WithCustomIntlProvider)($b6771c3a2a278459$var$TimeAgo, (0, $3ryTa.fetchLanguageFile));

});
parcelRegister("ixYgS", function(module, exports) {

$parcel$export(module.exports, "WithCustomIntlProvider", () => $1f21b79a6ec763c8$export$45d3ca664b6e3027);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $8sYvv = parcelRequire("8sYvv");
function $1f21b79a6ec763c8$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $gwFzn.useState)({});
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = (0, $8sYvv.getCodesFromLocale)(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const languageFile = await fetchLanguageFile(finalLocale);
                const newMessages = languageFile.default || languageFile;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        fetchLanguageFile,
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $1f21b79a6ec763c8$var$WithMessages = ({ children: children, fetchLanguageFile: fetchLanguageFile })=>{
    const intl = (0, $dBxQj.default)();
    const { messages: messages } = $1f21b79a6ec763c8$export$5ac26fa9b941854e(intl.locale, fetchLanguageFile);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        messages: messages,
        locale: intl.locale,
        children: children
    });
};
function $1f21b79a6ec763c8$export$45d3ca664b6e3027(Component, fetchLanguageFile) {
    return (props)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)($1f21b79a6ec763c8$var$WithMessages, {
            fetchLanguageFile: fetchLanguageFile,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    };
}

});
parcelRegister("8sYvv", function(module, exports) {

$parcel$export(module.exports, "getCodesFromLocale", () => $12d864bdedc72b33$export$4d25b49b6dc1b540);
const $12d864bdedc72b33$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};

});


parcelRegister("3ryTa", function(module, exports) {

$parcel$export(module.exports, "fetchLanguageFile", () => $78d46856006a28da$export$c08b58fa4727b0d2);

























function $78d46856006a28da$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("69AaK"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("jObBR"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("eDrby"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("dvNYG"));
        case 'et-EE':
        case 'et':
            return (parcelRequire("5EC7P"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("1yGga"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("cy8ZS"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("jbt5g"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("2YfnE"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("7GMde"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("AmDac"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("c7nRq"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("58Osv"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("hf7B8"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("5lsgF"));
        case 'pt-PT':
            return (parcelRequire("lf86h"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("8bHCz"));
        case 'sk-SK':
        case 'sk':
            return (parcelRequire("5zjq1"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("2dwPO"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("i6HzJ"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("7kLZc"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("6Xew7"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("9txer"));
        case 'zh-TW':
        case 'zh-HK':
        case 'zh':
            return (parcelRequire("kF1Xu"));
        case 'zh-ZH':
        case 'zh-CN':
            return (parcelRequire("c1xTV"));
    }
    return Promise.resolve({
        default: {}
    });
}

});
parcelRegister("69AaK", function(module, exports) {

let $47afa46efe41ce61$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $47afa46efe41ce61$var$load("6PtxN").then(()=>parcelRequire('9cUZf'));

});

parcelRegister("jObBR", function(module, exports) {

let $e6bbb13f873b2881$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6bbb13f873b2881$var$load("8RKtn").then(()=>parcelRequire('cS5ft'));

});

parcelRegister("eDrby", function(module, exports) {

let $aa79cba8df9a9ace$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aa79cba8df9a9ace$var$load("fCIoO").then(()=>parcelRequire('l3Frt'));

});

parcelRegister("dvNYG", function(module, exports) {

let $9d64f02d6cb66c81$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9d64f02d6cb66c81$var$load("1geBW").then(()=>parcelRequire('9pPbe'));

});

parcelRegister("5EC7P", function(module, exports) {

let $41de4313a675ccbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $41de4313a675ccbf$var$load("5WU5D").then(()=>parcelRequire('70wEJ'));

});

parcelRegister("1yGga", function(module, exports) {

let $1229bf597065f22c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1229bf597065f22c$var$load("i1Uow").then(()=>parcelRequire('ens8B'));

});

parcelRegister("cy8ZS", function(module, exports) {

let $922fa3a13a2419c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $922fa3a13a2419c7$var$load("3ZuKT").then(()=>parcelRequire('lTWYv'));

});

parcelRegister("jbt5g", function(module, exports) {

let $df759ae0edab45e0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $df759ae0edab45e0$var$load("5nJlY").then(()=>parcelRequire('httMJ'));

});

parcelRegister("2YfnE", function(module, exports) {

let $229d1d9bbbb90666$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $229d1d9bbbb90666$var$load("Uq5C2").then(()=>parcelRequire('cJNTM'));

});

parcelRegister("7GMde", function(module, exports) {

let $5991da9d50e0c665$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5991da9d50e0c665$var$load("9TzAL").then(()=>parcelRequire('kwZvX'));

});

parcelRegister("AmDac", function(module, exports) {

let $06d4eae334dfa5ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $06d4eae334dfa5ef$var$load("oPAjm").then(()=>parcelRequire('3VJvn'));

});

parcelRegister("c7nRq", function(module, exports) {

let $8d28a5b96eaea3e7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8d28a5b96eaea3e7$var$load("3fvcK").then(()=>parcelRequire('h3moD'));

});

parcelRegister("58Osv", function(module, exports) {

let $3be4d72bc6490293$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3be4d72bc6490293$var$load("iMYDs").then(()=>parcelRequire('jvfqc'));

});

parcelRegister("hf7B8", function(module, exports) {

let $c8d9bb2a4e49acd9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c8d9bb2a4e49acd9$var$load("jPHqC").then(()=>parcelRequire('jSIPf'));

});

parcelRegister("5lsgF", function(module, exports) {

let $3e44d7508e9507fa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3e44d7508e9507fa$var$load("3saM6").then(()=>parcelRequire('7zudc'));

});

parcelRegister("lf86h", function(module, exports) {

let $f771483e8a860f1e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f771483e8a860f1e$var$load("4hCdo").then(()=>parcelRequire('hhvtx'));

});

parcelRegister("8bHCz", function(module, exports) {

let $5f61300b37ec8125$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5f61300b37ec8125$var$load("78gs3").then(()=>parcelRequire('dTaKK'));

});

parcelRegister("5zjq1", function(module, exports) {

let $40df48cda4ea28dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $40df48cda4ea28dc$var$load("2XhMA").then(()=>parcelRequire('85LXv'));

});

parcelRegister("2dwPO", function(module, exports) {

let $19d643ef95c2b822$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $19d643ef95c2b822$var$load("f7Egw").then(()=>parcelRequire('lvHbY'));

});

parcelRegister("i6HzJ", function(module, exports) {

let $d2ea96b50f69f7e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2ea96b50f69f7e4$var$load("aiZUj").then(()=>parcelRequire('fXIaw'));

});

parcelRegister("7kLZc", function(module, exports) {

let $556f9fb6ccc53e96$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $556f9fb6ccc53e96$var$load("6rH3p").then(()=>parcelRequire('eOYcj'));

});

parcelRegister("6Xew7", function(module, exports) {

let $510383927393745d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $510383927393745d$var$load("lS1VG").then(()=>parcelRequire('9Em42'));

});

parcelRegister("9txer", function(module, exports) {

let $6e6099af03a37e0f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6e6099af03a37e0f$var$load("fFbe4").then(()=>parcelRequire('724Re'));

});

parcelRegister("kF1Xu", function(module, exports) {

let $f0a927e09ec695ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0a927e09ec695ef$var$load("7JTjB").then(()=>parcelRequire('5AG9d'));

});

parcelRegister("c1xTV", function(module, exports) {

let $8c0fe0166865ad36$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8c0fe0166865ad36$var$load("dMjyc").then(()=>parcelRequire('9G0tf'));

});


parcelRegister("jihLw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $484a81e8faa8c222$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $484a81e8faa8c222$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    justNow: {
        id: "com.atlassian.migrations-platform.mpt-timeago.ui.just-now",
        defaultMessage: "just now"
    }
});

});


parcelRegister("84LcG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7f9955248cded24a$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $7f9955248cded24a$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    readingAidsEditHistoryHeader: {
        id: "contextual-reading-aids.edit-history.header.text",
        defaultMessage: "Edit History"
    },
    readingAidsEditHistoryDescription: {
        id: "contextual-reading-aids.edit-history.description.text",
        defaultMessage: "See all the edits for {queryText}"
    },
    readingAidsEditHistoryCardEdited: {
        id: "contextual-reading-aids.edit-history.card.edited",
        defaultMessage: "{editorName} edited"
    },
    readingAidsEditHistoryCardErrorText: {
        id: "contextual-reading-aids.edit-history.card.error-text",
        defaultMessage: "An error has occurred. Please try again later."
    },
    readingAidsEditHistoryVisibilityTextOrg: {
        id: "contextual-reading-aids.edit-history.visibility.text.org",
        defaultMessage: "This definition is visible to anyone in the entire organization"
    },
    readingAidsEditHistoryVisibilitySpace: {
        id: "contextual-reading-aids.edit-history.visibility.text.space",
        defaultMessage: "This definition is visible to anyone in this space"
    },
    readingAidsEditHistoryVisibilityPage: {
        id: "contextual-reading-aids.edit-history.visibility.text.page",
        defaultMessage: "This definition is visible to anyone viewing this page"
    },
    readingAidsEditHistoryVisibilityBlog: {
        id: "contextual-reading-aids.edit-history.visibility.text.blog",
        defaultMessage: "This definition is visible to anyone viewing this blog"
    },
    readingAidsEditHistoryVisibilityProject: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project",
        defaultMessage: "This definition is visible to anyone viewing this project"
    }
});

});

parcelRegister("73WiV", function(module, exports) {

$parcel$export(module.exports, "useDefinitionEditHistory", () => $a1d51587e7cd682a$export$584199b95393a773);

var $gwFzn = parcelRequire("gwFzn");

var $9EFEY = parcelRequire("9EFEY");

var $fxwBK = parcelRequire("fxwBK");

var $lVkHE = parcelRequire("lVkHE");
const $a1d51587e7cd682a$export$584199b95393a773 = ({ query: query, curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const [data, setData] = (0, $gwFzn.useState)(undefined);
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    const loading = data === undefined && error === undefined;
    const scopeIds = (0, $lVkHE.getProductScope)(curatedDefinitionScopeConfig.productScopes);
    (0, $gwFzn.useEffect)(()=>{
        const fireRequest = async ()=>{
            try {
                const res = await (0, $9EFEY.fetchAggResponse)({
                    graphQuery: (0, $fxwBK.DefinitionEditHistoryGQL).query,
                    operationName: (0, $fxwBK.DefinitionEditHistoryGQL).operationName,
                    variables: {
                        workspaceId: curatedDefinitionScopeConfig.workspaceId,
                        keyPhrase: query,
                        ...scopeIds
                    }
                });
                const { data: data, errors: errors } = res;
                if (!errors && !!data) setData(data);
                else throw new Error(errors?.map((e)=>e.message).join(', '));
            } catch (e) {
                setError(e);
            }
        };
        fireRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const definitions = !error && !data?.knowledgeDiscovery?.definitionHistory?.message ? data?.knowledgeDiscovery?.definitionHistory?.definitions || [] : [];
    return {
        definitions: definitions,
        loading: loading
    };
};

});
parcelRegister("fxwBK", function(module, exports) {

$parcel$export(module.exports, "DefinitionEditHistoryGQL", () => $e50b8914515d41cb$export$9ad350b72fa486e);
const $e50b8914515d41cb$var$DefinitionEditHistoryQuery = `
query DefinitionEditHistoryQuery(
  $workspaceId: String!
  $keyPhrase: String!
	$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
	$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
) {
  knowledgeDiscovery {
    definitionHistory(
      workspaceId: $workspaceId
      keyPhrase: $keyPhrase
      confluenceScopeId: $confluenceScopeId
			jiraScopeId: $jiraScopeId
    ) @optIn(to: "KnowledgeDiscovery Get definition history") {
      __typename
      ... on KnowledgeDiscoveryDefinitionList {
        definitions {
          keyPhrase
          definition
          createdAt
          scope
          editor {
            name
            accountId
            picture
          }
          referenceUrl
          confluenceEntity {
            ... on ConfluencePage {
              id
              type
              title
            }
            ... on ConfluenceBlogPost {
              id
              type
              title
            }
          }
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $e50b8914515d41cb$export$9ad350b72fa486e = {
    operationName: 'DefinitionEditHistoryQuery',
    query: $e50b8914515d41cb$var$DefinitionEditHistoryQuery
};

});

parcelRegister("lVkHE", function(module, exports) {

$parcel$export(module.exports, "getProductScope", () => $74ea6a75ef49310d$export$fd57168bc668244);
const $74ea6a75ef49310d$export$fd57168bc668244 = (productScopes)=>{
    if ('contentARI' in productScopes) return {
        confluenceScopeId: {
            contentId: productScopes.contentARI,
            spaceId: productScopes.spaceARI
        }
    };
    else return {
        jiraScopeId: {
            projectId: productScopes.projectARI
        }
    };
};

});



parcelRegister("5XnQI", function(module, exports) {

$parcel$export(module.exports, "FeedbackButtons", () => $8428b38cee92438f$export$c633fc044a8b8981);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $9FnLD = parcelRequire("9FnLD");

var $cquOf = parcelRequire("cquOf");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");

var $3gadb = parcelRequire("3gadb");

var $fYQcF = parcelRequire("fYQcF");

var $eRXI0 = parcelRequire("eRXI0");

var $4jIuc = parcelRequire("4jIuc");

var $9pwVP = parcelRequire("9pwVP");

var $esgBr = parcelRequire("esgBr");

var $1610O = parcelRequire("1610O");
const $8428b38cee92438f$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        position: 'top',
        content: tooltipContent,
        children: ({ onClick: onClick, ...tooltipProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                "aria-label": tooltipContent,
                spacing: 'none',
                appearance: isDisabled ? 'subtle-link' : 'subtle',
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1610O.FeedbackButtonIconWrapper), {
                    active: active,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        cursor: 'pointer'
                    },
                    ...testId && {
                        'data-testid': testId
                    },
                    isDisabled: isDisabled || false,
                    children: icon
                }),
                ...!isDisabled && {
                    onClick: onClickHandler
                },
                ...tooltipProps
            })
    });
};
const $8428b38cee92438f$export$c633fc044a8b8981 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $9pwVP.onLikeButtonClick)(commonAttributes));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        }) : trackAIFeedbackSubmit('up');
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent,
        trackAIFeedbackSubmit
    ]);
    const dislikeButtonCallback = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setShowFeedbackOptionsModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $9pwVP.onDislikeButtonClick)(commonAttributes));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        }) : trackAIFeedbackSubmit('down');
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setShowFeedbackOptionsModal,
        fireSAINUsageEvent,
        trackAIFeedbackSubmit
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($8428b38cee92438f$var$FeedbackButton, {
                active: liked === true,
                onClick: likeButtonCallback,
                tooltipContent: formatMessage((0, $esgBr.messages).definition_footer_like_button_tooltip),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                    label: "",
                    spacing: "spacious",
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                    LEGACY_fallbackIcon: (0, $cquOf.default)
                }),
                isDisabled: liked && likesDisabled,
                testId: "definition-footer-like-button"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($8428b38cee92438f$var$FeedbackButton, {
                active: liked === false,
                onClick: dislikeButtonCallback,
                tooltipContent: formatMessage((0, $esgBr.messages).definition_footer_dislike_button_tooltip),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1610O.Rotate180IconWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                        label: "",
                        spacing: "spacious",
                        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                        LEGACY_fallbackIcon: (0, $cquOf.default)
                    })
                }),
                isDisabled: !liked && likesDisabled,
                testId: "definition-footer-dislike-button"
            })
        ]
    });
};

});
parcelRegister("esgBr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2284517eed0ad738$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $2284517eed0ad738$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    definition_footer_defined_by_text: {
        id: "search_ai.definition_footer_defined_by_text",
        defaultMessage: "Defined by"
    },
    definition_footer_see_edit_history: {
        id: "search_ai.definition_footer_see_edit_history",
        defaultMessage: "See all edit history"
    },
    definition_footer_like_button_tooltip: {
        id: "search_ai.definition_footer_like_button_tooltip",
        defaultMessage: "Good response"
    },
    definition_footer_dislike_button_tooltip: {
        id: "search_ai.definition_footer_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    definition_footer_hide_term_definition_message: {
        id: "search_ai.definition_footer_hide_term_definition_message",
        defaultMessage: "Don't define this again"
    },
    definition_footer_beta_status_label: {
        id: "search_ai.definition_footer.beta_status_label",
        defaultMessage: "Beta"
    },
    definition_footer_content_quality_short: {
        id: "search_ai.definition_footer_content_quality_short",
        defaultMessage: "Content quality may vary"
    },
    definition_footer_powered_by_AI: {
        id: "search_ai.definition_footer_powered_by_AI",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    definition_footer_feedback_options_modal_header_feedback_only: {
        id: "search_ai.definition_footer_feedback_options_modal_header_feedback_only",
        defaultMessage: "Leave feedback"
    },
    definition_footer_feedback_options_modal_header: {
        id: "search_ai.definition_footer_feedback_options_modal_header",
        defaultMessage: "Correct definition or leave feedback"
    },
    definition_footer_feedback_options_edit_definition_option: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option",
        defaultMessage: "I want to edit this definition"
    },
    definition_footer_feedback_options_edit_definition_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option_subtext",
        defaultMessage: "Update the definition."
    },
    definition_footer_feedback_options_leave_feedback_option: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option",
        defaultMessage: "I want to leave feedback about this feature"
    },
    definition_footer_feedback_options_leave_feedback_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option_subtext",
        defaultMessage: "Share your feedback so we can improve these experiences."
    },
    definition_footer_feedback_modal_header: {
        id: "search_ai.definition_footer_feedback_modal_header",
        defaultMessage: "Help us improve Definitions"
    },
    definition_footer_feedback_consent_checkbox_label: {
        id: "search_ai.definition_footer_feedback_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    definition_footer_feedback_report_label: {
        id: "search_ai.definition_footer_feedback_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    definition_footer_feedback_report_details_label: {
        id: "search_ai.definition_footer_feedback_report_details_label",
        defaultMessage: "Describe the issue"
    },
    definition_footer_feedback_report_empty_option_share_label: {
        id: "search_ai.definition_footer_feedback_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    definition_footer_feedback_report_relevance_option_label: {
        id: "search_ai.definition_footer_feedback_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    definition_footer_feedback_report_inaccurate_option_label: {
        id: "search_ai.definition_footer_feedback_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    definition_footer_feedback_report_offensive_option_label: {
        id: "search_ai.definition_footer_feedback_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    definition_footer_feedback_report_other_option_label: {
        id: "search_ai.definition_footer_feedback_report_other_option_label",
        defaultMessage: "Something else"
    },
    definition_footer_feedback_summary_placeholder_label: {
        id: "search_ai.definition_footer_feedback_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    definition_footer_feedback_flag_description: {
        id: "search_ai.definition_footer_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    }
});

});

parcelRegister("1610O", function(module, exports) {

$parcel$export(module.exports, "FeedbackButtonIconWrapper", () => $987ad772240399b4$export$5d384d799a8fb604);
$parcel$export(module.exports, "Rotate180IconWrapper", () => $987ad772240399b4$export$8b5c58bc12f52d53);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $987ad772240399b4$export$5d384d799a8fb604 = (0, $gwrgp.default)("span", {
    target: "e17ycdzr0"
})(({ active: active, isDisabled: isDisabled })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: active ? (0, $6fnsQ.B300) : `${`var(--ds-text-subtlest, ${0, $6fnsQ.N200})`} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'default'
    }));
const $987ad772240399b4$export$8b5c58bc12f52d53 = (0, $gwrgp.default)("span", {
    target: "e17ycdzr1"
})({
    name: "fn70mm",
    styles: "svg{transform:rotate(180deg);}"
});

});


parcelRegister("3022Y", function(module, exports) {

$parcel$export(module.exports, "FeedbackModal", () => $b9e065a1f0645f46$export$5efdacda4e928df9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7gpC4 = parcelRequire("7gpC4");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $eRXI0 = parcelRequire("eRXI0");

var $gdLbU = parcelRequire("gdLbU");

var $esgBr = parcelRequire("esgBr");

const $b9e065a1f0645f46$var$AkFeedbackCollector = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("i8OiN")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $b9e065a1f0645f46$var$ReportDescriptionWrapperStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.200'
});
const $b9e065a1f0645f46$export$5efdacda4e928df9 = ({ setFeedbackModal: setFeedbackModal, isCuratedDefinition: isCuratedDefinition, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, userDetails: { name: name, id: id } } = (0, $eRXI0.useAIAnswerContext)();
    const { errorState: errorState } = commonAttributes;
    const [hasConsent, setConsent] = (0, $gwFzn.useState)(false);
    const feedbackContextObject = {
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        isCuratedDefinition: isCuratedDefinition
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $gwFzn.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($b9e065a1f0645f46$var$AkFeedbackCollector, {
                locale: locale,
                onClose: ()=>setFeedbackModal(false),
                onSubmit: ()=>{
                    setDisplayFlag(true);
                },
                customContent: isCuratedDefinition ? undefined : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                    label: formatMessage((0, $esgBr.messages).definition_footer_feedback_consent_checkbox_label),
                    onChange: toggleConsentCheckbox,
                    isChecked: hasConsent
                }),
                atlassianAccountId: id,
                name: name,
                entrypointId: (0, $gdLbU.FEEDBACK_ENTRYPOINT_ID_DEFINITIONS),
                additionalFields: [
                    {
                        id: (0, $gdLbU.FEEDBACK_CONTEXT_CF),
                        value: feedbackContext
                    }
                ],
                feedbackTitle: formatMessage((0, $esgBr.messages).definition_footer_feedback_modal_header),
                feedbackTitleDetails: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $b9e065a1f0645f46$var$ReportDescriptionWrapperStyles,
                    children: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_label)
                }),
                feedbackGroupLabels: {
                    empty: {
                        fieldLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_empty_option_share_label)
                    },
                    question: {
                        fieldLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_relevance_option_label)
                    },
                    comment: {
                        fieldLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_inaccurate_option_label)
                    },
                    bug: {
                        fieldLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_offensive_option_label)
                    },
                    suggestion: {
                        fieldLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_details_label),
                        selectOptionLabel: formatMessage((0, $esgBr.messages).definition_footer_feedback_report_other_option_label)
                    }
                },
                summaryPlaceholder: formatMessage((0, $esgBr.messages).definition_footer_feedback_summary_placeholder_label)
            })
        })
    });
};

});

parcelRegister("fRx7P", function(module, exports) {

$parcel$export(module.exports, "FeedbackOptionsModal", () => $784f31c0b8c9f08d$export$dc5d3996368c6525);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $2hj6R = parcelRequire("2hj6R");

var $3QhJU = parcelRequire("3QhJU");

var $gMgiH = parcelRequire("gMgiH");

var $ekolh = parcelRequire("ekolh");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $esgBr = parcelRequire("esgBr");
const $784f31c0b8c9f08d$var$FeedbackOptionsModalWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    padding: 'space.300'
});
const $784f31c0b8c9f08d$var$FeedbackOptionsModalHeaderStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 'space.250'
});
const $784f31c0b8c9f08d$var$FeedbackOptionsModalHeaderTextStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $784f31c0b8c9f08d$var$FeedbackOptionsWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.200'
});
const $784f31c0b8c9f08d$var$FeedbackOptionStyles = (0, $ecnYn.xcss)({
    borderRadius: '3px',
    width: '100%',
    height: '56px',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $784f31c0b8c9f08d$var$FeedbackOptionIconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '2px',
    height: '32px',
    width: '32px'
});
const $784f31c0b8c9f08d$var$FeedbackOptionTextStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text'
});
const $784f31c0b8c9f08d$var$FeedbackOptionSubTextStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});
const $784f31c0b8c9f08d$export$dc5d3996368c6525 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setShowEditDefinitionModal: setShowEditDefinitionModal, setShowFeedbackModal: setShowFeedbackModal, editDefinitionEnabled: editDefinitionEnabled })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
        shouldReturnFocus: false,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: $784f31c0b8c9f08d$var$FeedbackOptionsModalWrapperStyles,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $784f31c0b8c9f08d$var$FeedbackOptionsModalHeaderStyles,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $784f31c0b8c9f08d$var$FeedbackOptionsModalHeaderTextStyles,
                            children: formatMessage(editDefinitionEnabled ? (0, $esgBr.messages).definition_footer_feedback_options_modal_header : (0, $esgBr.messages).definition_footer_feedback_options_modal_header_feedback_only)
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            onClick: ()=>setShowFeedbackOptionsModal(false),
                            label: "close-feedback-options-modal",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hj6R)))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $784f31c0b8c9f08d$var$FeedbackOptionsWrapperStyles,
                    children: [
                        editDefinitionEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                            xcss: $784f31c0b8c9f08d$var$FeedbackOptionStyles,
                            onClick: ()=>{
                                setShowFeedbackOptionsModal(false);
                                setShowEditDefinitionModal(true);
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                                gap: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                        backgroundColor: "color.background.accent.blue.subtle",
                                        xcss: $784f31c0b8c9f08d$var$FeedbackOptionIconWrapperStyles,
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QhJU))), {
                                            LEGACY_size: "medium",
                                            spacing: "spacious",
                                            label: "",
                                            color: "var(--ds-icon-inverse, #FFFFFF)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                                        direction: "column",
                                        gap: "space.025",
                                        alignItems: "start",
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                xcss: $784f31c0b8c9f08d$var$FeedbackOptionTextStyles,
                                                children: formatMessage((0, $esgBr.messages).definition_footer_feedback_options_edit_definition_option)
                                            }),
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                xcss: $784f31c0b8c9f08d$var$FeedbackOptionSubTextStyles,
                                                children: formatMessage((0, $esgBr.messages).definition_footer_feedback_options_edit_definition_option_subtext)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                            xcss: $784f31c0b8c9f08d$var$FeedbackOptionStyles,
                            onClick: ()=>{
                                setShowFeedbackOptionsModal(false);
                                setShowFeedbackModal(true);
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                                gap: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                        backgroundColor: "color.background.accent.blue.subtle",
                                        xcss: $784f31c0b8c9f08d$var$FeedbackOptionIconWrapperStyles,
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMgiH))), {
                                            LEGACY_size: "medium",
                                            spacing: "spacious",
                                            label: "",
                                            color: "var(--ds-icon-inverse, #FFFFFF)"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                                        direction: "column",
                                        gap: "space.025",
                                        alignItems: "start",
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                xcss: $784f31c0b8c9f08d$var$FeedbackOptionTextStyles,
                                                children: formatMessage((0, $esgBr.messages).definition_footer_feedback_options_leave_feedback_option)
                                            }),
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                xcss: $784f31c0b8c9f08d$var$FeedbackOptionSubTextStyles,
                                                children: formatMessage((0, $esgBr.messages).definition_footer_feedback_options_leave_feedback_option_subtext)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("50wuq", function(module, exports) {

$parcel$export(module.exports, "AIDefinitionFooterSection", () => $2d509230fe7bac35$export$8c09939f07ae58e2);
$parcel$export(module.exports, "EditedDefinitionFooterSection", () => $2d509230fe7bac35$export$686a5e20bce13f8f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lM0k7 = parcelRequire("lM0k7");

var $l6Qdw = parcelRequire("l6Qdw");

var $1niwh = parcelRequire("1niwh");

var $2Nwuj = parcelRequire("2Nwuj");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $2W0qg = parcelRequire("2W0qg");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7c52C = parcelRequire("7c52C");

var $8j9VY = parcelRequire("8j9VY");

var $6fnsQ = parcelRequire("6fnsQ");

var $eRXI0 = parcelRequire("eRXI0");

var $f7lNm = parcelRequire("f7lNm");

var $9pwVP = parcelRequire("9pwVP");

var $gdLbU = parcelRequire("gdLbU");

var $dhoxt = parcelRequire("dhoxt");

var $esgBr = parcelRequire("esgBr");
const $2d509230fe7bac35$var$AIFooterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`,
    width: '100%'
});
const $2d509230fe7bac35$var$ContentMayVaryWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $2d509230fe7bac35$var$BrandWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $2d509230fe7bac35$export$8c09939f07ae58e2 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { brand: brand } = (0, $eRXI0.useAIAnswerContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $2d509230fe7bac35$var$AIFooterStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $2d509230fe7bac35$var$ContentMayVaryWrapperStyles,
                children: [
                    brand === (0, $f7lNm.AiBrand).ROVO && (0, $dh538.fg)('platform_search_ai_rovo_beta_label_off') ? null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                        children: formatMessage((0, $esgBr.messages).definition_footer_beta_status_label)
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l6Qdw))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #626F86)",
                        LEGACY_size: "small"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                        rel: "noopener noreferrer",
                        appearance: "subtle",
                        href: (0, $gdLbU.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
                        children: formatMessage((0, $esgBr.messages).definition_footer_content_quality_short)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2d509230fe7bac35$var$BrandWrapperStyles,
                children: brand === (0, $f7lNm.AiBrand).ROVO ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.025",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            rel: "noopener noreferrer",
                            appearance: "subtle",
                            href: (0, $gdLbU.ATLASSIAN_ROVO_LINK),
                            children: "Rovo"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1niwh.default), {
                            label: "",
                            primaryColor: "var(--ds-icon-subtle, #626F86)"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.025",
                    children: [
                        formatMessage((0, $esgBr.messages).definition_footer_powered_by_AI),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dhoxt.AtlassianIntelligenceIcon), {
                            greyed: true,
                            size: "large"
                        })
                    ]
                })
            })
        ]
    });
};
const $2d509230fe7bac35$var$EditedByFooterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`
});
const $2d509230fe7bac35$var$EditedByWrapper = (0, $ecnYn.xcss)({
    display: 'flex',
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N900)})`,
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderRadius: '24px',
    marginLeft: 'space.050',
    cursor: 'pointer',
    ':hover': {
        background: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N700)})`
    }
});
const $2d509230fe7bac35$var$DefinedByWrapper = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $2d509230fe7bac35$var$ActiveEditedByWrapper = (0, $ecnYn.xcss)({
    display: 'flex',
    background: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N700)})`,
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderRadius: '24px',
    marginLeft: 'space.050',
    cursor: 'pointer'
});
const $2d509230fe7bac35$var$EditHistoryWrapper = (0, $ecnYn.xcss)({
    display: 'flex',
    font: 'font.body.small',
    color: 'color.link',
    paddingLeft: 'space.300',
    cursor: 'pointer',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $2d509230fe7bac35$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT = '/gateway/api/directory/graphql';
const $2d509230fe7bac35$var$profileClient = new (0, $7c52C.default)({
    url: $2d509230fe7bac35$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT
});
const $2d509230fe7bac35$export$686a5e20bce13f8f = ({ setShowEditHistoryModal: setShowEditHistoryModal })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [editorActive, setEditorActive] = (0, $gwFzn.useState)(false);
    const { answerEditor: answerEditor, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    const { cloudId: cloudId } = commonAttributes;
    if (!answerEditor) return null; // This line should not be reachable since the component is only rendered when answerEditor is defined
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $2d509230fe7bac35$var$EditedByFooterStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            gap: "space.100",
            alignItems: "start",
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lM0k7))), {
                            label: "",
                            color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $2d509230fe7bac35$var$DefinedByWrapper,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                                children: formatMessage((0, $esgBr.messages).definition_footer_defined_by_text)
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8j9VY.default), {
                            userId: answerEditor.id,
                            cloudId: cloudId,
                            resourceClient: $2d509230fe7bac35$var$profileClient,
                            trigger: "click",
                            onVisibilityChange: setEditorActive,
                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                                xcss: editorActive ? $2d509230fe7bac35$var$ActiveEditedByWrapper : $2d509230fe7bac35$var$EditedByWrapper,
                                children: [
                                    "@",
                                    answerEditor.name
                                ]
                            })
                        })
                    ]
                }),
                (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                    backgroundColor: "color.background.neutral.subtle",
                    xcss: $2d509230fe7bac35$var$EditHistoryWrapper,
                    onClick: ()=>{
                        fireAnalyticsEvent((0, $9pwVP.onCuratedDefinitionSeeEditHistoryButtonClicked)(commonAttributes));
                        setShowEditHistoryModal(true);
                    },
                    children: formatMessage((0, $esgBr.messages).definition_footer_see_edit_history)
                }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $2d509230fe7bac35$var$EditHistoryWrapper,
                    onClick: ()=>{
                        fireAnalyticsEvent((0, $9pwVP.onCuratedDefinitionSeeEditHistoryButtonClicked)(commonAttributes));
                        setShowEditHistoryModal(true);
                    },
                    children: formatMessage((0, $esgBr.messages).definition_footer_see_edit_history)
                })
            ]
        })
    });
};

});
parcelRegister("lM0k7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e70be7cdea3a7aa6f27de03bc870785>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd9e54e9a7d9c520$var$_react = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $fd9e54e9a7d9c520$var$_baseNew = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fd9e54e9a7d9c520$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd9e54e9a7d9c520$var$PenIcon = (props)=>/*#__PURE__*/ $fd9e54e9a7d9c520$var$_react.default.createElement($fd9e54e9a7d9c520$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.22.22A.75.75 0 0 1 .936.023l9.96 2.548.142.042a2 2 0 0 1 1.336 1.568l.643 3.858a.75.75 0 0 1 .763.18l2 2a.75.75 0 0 1 0 1.061l-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1-.18-.763l-3.86-.643a2 2 0 0 1-1.567-1.336l-.042-.142L.023.936A.75.75 0 0 1 .22.22m9.59 13.03.94.94 3.44-3.44-.94-.94zM8 7.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m1.5 0a2 2 0 1 1-3.842-.781L2.154 3.215l1.87 7.31.024.07a.5.5 0 0 0 .379.3l4.815.801 2.454-2.454-.801-4.815a.5.5 0 0 0-.3-.38l-.07-.023-7.31-1.87 3.504 3.504A2 2 0 0 1 9.5 7.5"/>`
    }, props));
$fd9e54e9a7d9c520$var$PenIcon.displayName = 'PenIcon';
var $fd9e54e9a7d9c520$var$_default = module.exports.default = $fd9e54e9a7d9c520$var$PenIcon;

});

parcelRegister("dhoxt", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceIcon", () => $cfdb019f175cb54a$export$eaf821108be3620b);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $cfdb019f175cb54a$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.5 15.3L17.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.5 15.3L6.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.5 10.3L6.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.5 10.3L17.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0001 16.8V19.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.00012 12.8L5.00012 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0001 8.80003L12.0001 5.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.0002 12.8L19.0002 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            })
        ]
    });

});


parcelRegister("kDGJp", function(module, exports) {

$parcel$export(module.exports, "useToggleDefinitionSupplier", () => $d491ddb6c5306e7b$export$6e73bcf8826d31a5);

var $gwFzn = parcelRequire("gwFzn");

var $9EFEY = parcelRequire("9EFEY");

var $7BIyr = parcelRequire("7BIyr");
const $d491ddb6c5306e7b$export$6e73bcf8826d31a5 = ()=>{
    const toggleDefinition = (0, $gwFzn.useCallback)(async ({ workspaceId: workspaceId, keyPhrase: keyPhrase, isDisabled: isDisabled })=>{
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $7BIyr.ToggleDefinitionMutation),
            variables: {
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: isDisabled
            }
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.updateUserKeyPhraseInteraction?.success) return {
                toggleDefinitionSuccess: true
            };
            else throw new Error('toggleDefinition mutation unsuccessful');
        });
    }, []);
    return {
        toggleDefinition: toggleDefinition
    };
};

});
parcelRegister("7BIyr", function(module, exports) {

$parcel$export(module.exports, "ToggleDefinitionMutation", () => $bccd8fae77123cba$export$8a69382ce91c952a);
const $bccd8fae77123cba$export$8a69382ce91c952a = `
	mutation ToggleDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$isDisabled: Boolean
		) {
		knowledgeDiscovery {
			updateUserKeyPhraseInteraction(
				input: {
					workspaceId: $workspaceId
					keyPhrase: $keyPhrase
					isDisabled: $isDisabled
				}
			) @optIn(to: "KnowledgeDiscovery Update User KeyPhrase Interaction") {
				success
				errors {
					message
				}
			}
		}
	}
`;

});



parcelRegister("lQaNB", function(module, exports) {

$parcel$export(module.exports, "AIAnswerWhoFooter", () => $b5c07244ed83c859$export$b03d109098afe32f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $esRft = parcelRequire("esRft");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $5y8jR = parcelRequire("5y8jR");

var $5ZjPR = parcelRequire("5ZjPR");
const $b5c07244ed83c859$export$b03d109098afe32f = ()=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const { parsedResult: parsedResult } = (0, $5y8jR.getTypedJSONResultDataAssistanceService)(answerString);
    const additionalUserResults = parsedResult.slice(1);
    const numAdditionalUserResults = additionalUserResults.length;
    return numAdditionalUserResults ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5ZjPR.AIWhoAnswerFooter), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerFooterHeader), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $7lL49.messages).ai_answer_who_questions_footer_header,
                    values: {
                        numMatches: numAdditionalUserResults
                    }
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerFooterResultsWrapper), {
                children: additionalUserResults.map((userResult)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5ZjPR.AIWhoAnswerFooterResult), {
                        href: userResult.profile_url || undefined,
                        onClick: (event)=>{
                            onNavigate(event);
                            fireAnalyticsEvent((0, $4xTru.onWhoAdditionalMatchProfileClick)({
                                ...commonAttributes,
                                additionalMatchUserName: userResult.name,
                                additionalMatchTitle: userResult.job_title || ''
                            }));
                        },
                        onContextMenu: (event)=>{
                            onNavigate(event);
                            fireAnalyticsEvent((0, $4xTru.onWhoAdditionalMatchProfileContextMenuClick)({
                                ...commonAttributes,
                                additionalMatchUserName: userResult.name,
                                additionalMatchTitle: userResult.job_title || ''
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                                src: userResult.avatar_url || undefined,
                                size: "medium",
                                testId: userResult.name
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5ZjPR.AIWhoAnswerFooterResultInfoWrapper), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerFooterResultInfoHeader), {
                                        children: userResult.name
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZjPR.AIWhoAnswerFooterResultMetadata), {
                                        children: userResult.job_title
                                    })
                                ]
                            })
                        ]
                    }, userResult.name))
            })
        ]
    }) : null;
};

});

parcelRegister("10T8p", function(module, exports) {

$parcel$export(module.exports, "FeedbackButtons", () => $26b8fa5a51a5ded2$export$c633fc044a8b8981);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $9FnLD = parcelRequire("9FnLD");

var $cquOf = parcelRequire("cquOf");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");

var $3gadb = parcelRequire("3gadb");

var $fYQcF = parcelRequire("fYQcF");

var $4jIuc = parcelRequire("4jIuc");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $aCewN = parcelRequire("aCewN");
const $26b8fa5a51a5ded2$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon, isReadingAids: isReadingAids })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        position: 'top',
        content: tooltipContent,
        children: ({ onClick: onClick, ...tooltipProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                "aria-label": tooltipContent,
                spacing: 'none',
                appearance: isDisabled ? 'subtle-link' : 'subtle',
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.FeedbackButtonIconWrapper), {
                    active: active,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        cursor: 'pointer'
                    },
                    ...testId && {
                        'data-testid': testId
                    },
                    isDisabled: isDisabled || false,
                    isReadingAids: isReadingAids || false,
                    children: icon
                }),
                ...!isDisabled && {
                    onClick: onClickHandler
                },
                ...tooltipProps
            })
    });
};
const $26b8fa5a51a5ded2$export$c633fc044a8b8981 = ({ setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled, isReadingAids: isReadingAids } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $4xTru.onLikeButtonClick)(commonAttributes));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        }) : trackAIFeedbackSubmit('up');
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent,
        trackAIFeedbackSubmit
    ]);
    const dislikeButtonCallback = (0, $gwFzn.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $4xTru.onDislikeButtonClick)(commonAttributes));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        }) : trackAIFeedbackSubmit('down');
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setFeedbackModal,
        fireSAINUsageEvent,
        trackAIFeedbackSubmit
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($26b8fa5a51a5ded2$var$FeedbackButton, {
                active: liked === true,
                onClick: likeButtonCallback,
                tooltipContent: formatMessage((0, $7lL49.messages).ai_answer_component_like_button_tooltip),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                    label: "",
                    spacing: "spacious",
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                    LEGACY_fallbackIcon: (0, $cquOf.default)
                }),
                isDisabled: liked && likesDisabled,
                testId: "ai-answer-like-button",
                isReadingAids: isReadingAids
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($26b8fa5a51a5ded2$var$FeedbackButton, {
                active: liked === false,
                onClick: dislikeButtonCallback,
                tooltipContent: formatMessage((0, $7lL49.messages).ai_answer_component_dislike_button_tooltip),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.Rotate180IconWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                        label: "",
                        spacing: "spacious",
                        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
                        LEGACY_fallbackIcon: (0, $cquOf.default)
                    })
                }),
                isDisabled: !liked && likesDisabled,
                testId: "ai-answer-dislike-button",
                isReadingAids: isReadingAids
            })
        ]
    });
};

});
parcelRegister("aCewN", function(module, exports) {

$parcel$export(module.exports, "AIAnswerContentBrandWrapper", () => $21c70bc822f819a6$export$f32f097f63664c4b);
$parcel$export(module.exports, "AIAnswerFooterWrapper", () => $21c70bc822f819a6$export$89b1508f9c43b29e);
$parcel$export(module.exports, "AIAnswerFeedbackWrapper", () => $21c70bc822f819a6$export$71c5dacfc0533c82);
$parcel$export(module.exports, "AIAnswerReportDescriptionWrapper", () => $21c70bc822f819a6$export$8b91051e793e6316);
$parcel$export(module.exports, "FeedbackButtonIconWrapper", () => $21c70bc822f819a6$export$5d384d799a8fb604);
$parcel$export(module.exports, "Rotate180IconWrapper", () => $21c70bc822f819a6$export$8b5c58bc12f52d53);
$parcel$export(module.exports, "AIAnswerFollowUpPill", () => $21c70bc822f819a6$export$ff0eb486c968b1bb);
$parcel$export(module.exports, "AIAnswerFollowUpPillText", () => $21c70bc822f819a6$export$5d787e808dded622);
$parcel$export(module.exports, "AIAnswerFooterInformationContentVary", () => $21c70bc822f819a6$export$573f5509d5798c1e);
$parcel$export(module.exports, "AIAnswerFooterInformationContentVaryLinkText", () => $21c70bc822f819a6$export$bc95f3ac1425888f);
$parcel$export(module.exports, "AIAnswerFooterPoweredBy", () => $21c70bc822f819a6$export$2b5d58c880974a8a);
$parcel$export(module.exports, "AIAnswerFooterPoweredByAIWrapper", () => $21c70bc822f819a6$export$ef38e90ca3d2a41d);
// eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $afneb = parcelRequire("afneb");

var $gwrgp = parcelRequire("gwrgp");
const $21c70bc822f819a6$export$f32f097f63664c4b = (0, $gwrgp.default)("div", {
    target: "e15k4c240"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-300, 24px)"}`,
    justifyContent: 'space-between'
});
const $21c70bc822f819a6$export$89b1508f9c43b29e = (0, $gwrgp.default)("div", {
    target: "e15k4c241"
})({
    display: 'flex',
    flexDirection: 'row',
    gap: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`,
    flexWrap: 'wrap'
});
const $21c70bc822f819a6$export$71c5dacfc0533c82 = (0, $gwrgp.default)("div", {
    target: "e15k4c242"
})(({ isReadingAids: isReadingAids, isCompact: isCompact })=>({
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: !isReadingAids ? "var(--ds-space-100, 8px)" : 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBottom: !isReadingAids ? "var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: `var(--ds-text-accent-gray, ${0, $6fnsQ.N200})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: isCompact ? `0px ${"var(--ds-space-300, 24px)"}` : 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingLeft: isReadingAids ? "var(--ds-space-250, 20px)" : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingRight: isReadingAids ? "var(--ds-space-250, 20px)" : undefined
    }));
const $21c70bc822f819a6$export$3ecfdaeafbf376d = (0, $gwrgp.default)("div", {
    target: "e15k4c243"
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-250, 20px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`
});
const $21c70bc822f819a6$export$67e0ee90a7929c = (0, $gwrgp.default)("div", {
    target: "e15k4c244"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $21c70bc822f819a6$export$8b91051e793e6316 = (0, $gwrgp.default)("div", {
    target: "e15k4c245"
})({
    name: "etaml6",
    styles: "padding-bottom:var(--ds-space-200, 16px);"
});
const $21c70bc822f819a6$export$5d384d799a8fb604 = (0, $gwrgp.default)("span", {
    target: "e15k4c246"
})(({ active: active, isDisabled: isDisabled })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: active ? (0, $6fnsQ.B300) : `${`var(--ds-text-subtlest, ${0, $6fnsQ.N200})`} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'default'
    }));
const $21c70bc822f819a6$export$8b5c58bc12f52d53 = (0, $gwrgp.default)("span", {
    target: "e15k4c247"
})({
    name: "fn70mm",
    styles: "svg{transform:rotate(180deg);}"
});
const $21c70bc822f819a6$export$5f010f0938bf2ddf = (0, $gwrgp.default)("div", {
    target: "e15k4c248"
})({
    display: 'flex',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $21c70bc822f819a6$export$4748ec30b6814a73 = /*#__PURE__*/ (0, $gwrgp.default)((0, $afneb.default), {
    target: "e15k4c249"
})({
    background: `var(--ds-surface-raised, ${(0, $6fnsQ.N0)})`,
    padding: "var(--ds-space-100, 8px)",
    borderRadius: '3px',
    border: `1px solid ${`var(--ds-border-information, ${(0, $6fnsQ.N40A)})`}`,
    boxShadow: `0 8px 12px 0 ${`var(--ds-shadow-overlay, ${(0, $6fnsQ.N40)})`}, 0 0 1px 0 ${`var(--ds-shadow-overlay, ${(0, $6fnsQ.N60)})`}`
});
const $21c70bc822f819a6$export$3ace3579ea4ef5c6 = `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`;
const $21c70bc822f819a6$export$36d7978a35f7466a = (0, $gwrgp.default)("div", {
    target: "e15k4c2410"
})({
    name: "k008qs",
    styles: "display:flex;"
});
const $21c70bc822f819a6$export$88cbb6347ed48127 = (0, $gwrgp.default)("a", {
    target: "e15k4c2411"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    color: `${`var(--ds-text-accent-blue, ${(0, $6fnsQ.B300)})`} !important`
});
const $21c70bc822f819a6$export$e7c72fdbfb487eeb = (0, $gwrgp.default)("div", {
    target: "e15k4c2412"
})({
    name: "1jf954",
    styles: "display:flex;flex-direction:row;align-items:center;gap:var(--ds-space-100, 8px);"
});
const $21c70bc822f819a6$export$ff0eb486c968b1bb = (0, $gwrgp.default)("div", {
    target: "e15k4c2413"
})({
    display: 'flex',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    borderRadius: '35px',
    backgroundColor: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
    border: `1px solid ${`var(--ds-border-input, ${(0, $6fnsQ.N40)})`}`,
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $6fnsQ.N20)})`,
        border: `1px solid ${`var(--ds-border-input, ${(0, $6fnsQ.N40)})`}`
    },
    justifyContent: 'flex-start',
    alignItems: 'center'
});
const $21c70bc822f819a6$export$5d787e808dded622 = (0, $gwrgp.default)("div", {
    target: "e15k4c2414"
})({
    name: "z0txda",
    styles: "margin-left:var(--ds-space-050, 4px);"
});
const $21c70bc822f819a6$export$5aea7b80ea7787ea = (0, $gwrgp.default)("div", {
    target: "e15k4c2415"
})(({ isEdited: isEdited })=>({
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        flexDirection: isEdited ? 'row' : 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: `1px solid ${`var(--ds-border, ${0, $6fnsQ.N40A})`}`,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: isEdited ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-250, 20px)"}` : '0'
    }));
const $21c70bc822f819a6$export$e0e6dbd6257adb05 = (0, $gwrgp.default)("div", {
    target: "e15k4c2416"
})({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-250, 20px)"}`,
    width: '100%'
});
const $21c70bc822f819a6$export$573f5509d5798c1e = (0, $gwrgp.default)("div", {
    target: "e15k4c2417"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $21c70bc822f819a6$export$bc95f3ac1425888f = (0, $gwrgp.default)("div", {
    target: "e15k4c2418"
})({
    name: "gwsqts",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);"
});
const $21c70bc822f819a6$export$2b5d58c880974a8a = (0, $gwrgp.default)("div", {
    target: "e15k4c2419"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    flexWrap: 'wrap'
});
const $21c70bc822f819a6$export$ef38e90ca3d2a41d = (0, $gwrgp.default)("div", {
    target: "e15k4c2420"
})({
    name: "1sxst94",
    styles: "display:flex;flex-direction:row;align-items:center;gap:var(--ds-space-025, 4px);"
});
const $21c70bc822f819a6$export$9377d0e011027754 = (0, $gwrgp.default)("div", {
    target: "e15k4c2421"
})({
    display: 'flex',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N400)})`
});
const $21c70bc822f819a6$export$ee9b6f758b162cc4 = (0, $gwrgp.default)("div", {
    target: "e15k4c2422"
})({
    name: "k1bxw3",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtle, #44546F);margin-right:var(--ds-space-100, 8px);"
});
const $21c70bc822f819a6$export$3f6bc9710e818ab5 = /*#__PURE__*/ (0, $gwrgp.default)((0, $afneb.default), {
    target: "e15k4c2423"
})({
    background: `var(--ds-background-neutral-bold, ${(0, $6fnsQ.N800)})`,
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
    borderRadius: '3px',
    color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    width: '213px',
    height: '48px'
});
const $21c70bc822f819a6$export$71a80749568094e9 = "var(--ds-icon, #44546F)";
const $21c70bc822f819a6$export$fd834bc8ea5358c5 = (0, $gwrgp.default)("div", {
    target: "e15k4c2424"
})({
    display: 'flex',
    background: `var(--ds-background-accent-purple-subtlest, ${(0, $6fnsQ.P50)})`,
    flexDirection: 'column',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-500, 36px)"}`
});
const $21c70bc822f819a6$export$70b847c9bb1b1c9e = (0, $gwrgp.default)("div", {
    target: "e15k4c2425"
})({
    display: 'flex',
    color: `var(--ds-text-accent-purple, ${(0, $6fnsQ.P300)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    alignItems: 'center',
    marginLeft: "var(--ds-space-negative-300, -24px)"
});
const $21c70bc822f819a6$export$fd9c97770e8fad3 = (0, $gwrgp.default)("div", {
    target: "e15k4c2426"
})({
    display: 'flex',
    color: `var(--ds-icon-accent-purple, ${(0, $6fnsQ.P200)})`
});
const $21c70bc822f819a6$export$1a4c6f3bcc66a8b8 = (0, $gwrgp.default)("div", {
    target: "e15k4c2427"
})({
    name: "6n7j50",
    styles: "display:inline;"
});
const $21c70bc822f819a6$export$777bfb96ccd0b774 = (0, $gwrgp.default)("div", {
    target: "e15k4c2428"
})({
    name: "uerz5h",
    styles: "display:flex;flex-direction:column;align-items:flex-start;gap:var(--ds-space-100, 8px);"
});
const $21c70bc822f819a6$export$80e5eaef663e340d = (0, $gwrgp.default)("span", {
    target: "e15k4c2429"
})({
    display: 'flex',
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N900)})`,
    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    borderRadius: '24px'
});
const $21c70bc822f819a6$export$39639e0da97de75b = (0, $gwrgp.default)("div", {
    target: "e15k4c2430"
})({
    name: "1qp6ym5",
    styles: "display:flex;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-link, #0C66E4);padding-left:var(--ds-space-300, 28px);cursor:pointer;&:hover{text-decoration:underline;}"
});

});


parcelRegister("aOj19", function(module, exports) {

$parcel$export(module.exports, "FollowUpSuggestionFooter", () => $2be0e2e39d556c55$export$f087ce3403d54eb5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jluld = parcelRequire("jluld");

var $dcJ7R = parcelRequire("dcJ7R");

var $i25hX = parcelRequire("i25hX");

var $6fnsQ = parcelRequire("6fnsQ");

var $ab1fW = parcelRequire("ab1fW");

var $4jIuc = parcelRequire("4jIuc");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $aCewN = parcelRequire("aCewN");
const $2be0e2e39d556c55$export$f087ce3403d54eb5 = ()=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, setQuery: setQuery, updateContextCache: updateContextCache, onClose: onClose, closeParentDialog: closeParentDialog, callbacks: callbacks, showChatFollowUps: showChatFollowUps } = (0, $eRXI0.useAIAnswerContext)();
    const { followUps: followUps, query: query, answerString: answerString, searchSessionId: searchSessionId } = commonAttributes;
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const visibleFollowUps = followUps.slice(0, 2);
    const onPillClick = (0, $gwFzn.useCallback)((followUp)=>{
        if (showChatFollowUps) publish({
            type: 'chat-new',
            source: 'sain',
            data: {
                name: followUp.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp,
                sourceId: searchSessionId
            }
        });
        else {
            setQuery(followUp);
            updateContextCache({
                fromFollowUp: true
            });
        }
        fireAnalyticsEvent((0, $4xTru.onFollowUpSuggestionClick)({
            ...commonAttributes,
            followUpString: followUp
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).FOLLOWUP_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
        callbacks?.onFollowUpSuggestionClick?.();
    }, [
        fireSAINUsageEvent,
        fireAnalyticsEvent,
        commonAttributes,
        onClose,
        closeParentDialog,
        callbacks,
        publish,
        query,
        answerString,
        searchSessionId,
        setQuery,
        updateContextCache,
        showChatFollowUps
    ]);
    return followUps.length > 0 ? visibleFollowUps.map((followUp, index)=>{
        if (showChatFollowUps) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
            space: "space.050",
            alignBlock: "center",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ab1fW.FollowUpButton), {
                onClick: ()=>onPillClick(followUp),
                followUpText: followUp,
                followUpIndex: index,
                followUpType: "UNAVAILABLE",
                experienceId: "sain"
            })
        }, followUp);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
            space: "space.050",
            alignBlock: "center",
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aCewN.AIAnswerFollowUpPill), {
                onClick: ()=>onPillClick(followUp),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        label: "",
                        LEGACY_size: "small",
                        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aCewN.AIAnswerFollowUpPillText), {
                        children: followUp
                    })
                ]
            })
        }, followUp);
    }) : null;
};

});
parcelRegister("ab1fW", function(module, exports) {

$parcel$export(module.exports, "FollowUpButton", () => $de70ae3c39f94954$export$668058776bea98f5);
$parcel$export(module.exports, "ChatPill", () => (parcelRequire("lBFuf")).ChatPill);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lBFuf = parcelRequire("lBFuf");

var $jA9SA = parcelRequire("jA9SA");
var $kIvLT = parcelRequire("kIvLT");
const $de70ae3c39f94954$export$668058776bea98f5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const analyticsPropertiesRef = (0, $gwFzn.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $gwFzn.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $gwFzn.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lBFuf.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref,
        children: followUpText
    });
});

});



parcelRegister("2szay", function(module, exports) {

$parcel$export(module.exports, "AIAnswerTitle", () => $6f2f2b7b6a18595d$export$20a48ed23bb601ed);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $eRXI0 = parcelRequire("eRXI0");

var $f1Vnt = parcelRequire("f1Vnt");
const $6f2f2b7b6a18595d$var$TitleWrapperStyles = (0, $ecnYn.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '52px'
});
const $6f2f2b7b6a18595d$var$DefinitionTitleStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text',
    marginTop: 'space.250',
    marginLeft: 'space.300'
});
const $6f2f2b7b6a18595d$export$20a48ed23bb601ed = ()=>{
    const { commonAttributes: commonAttributes, baseQuery: baseQuery } = (0, $eRXI0.useAIAnswerContext)();
    const { query: query } = commonAttributes;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
        xcss: $6f2f2b7b6a18595d$var$TitleWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $6f2f2b7b6a18595d$var$DefinitionTitleStyles,
                children: baseQuery ? baseQuery : query
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f1Vnt.ReadingAidsOptions), {})
        ]
    });
};

});
parcelRegister("f1Vnt", function(module, exports) {

$parcel$export(module.exports, "ReadingAidsOptions", () => $af71153c0679ef22$export$77d2212db482996b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $2gCko = parcelRequire("2gCko");

var $gd5mK = parcelRequire("gd5mK");

var $hUTos = parcelRequire("hUTos");
const $af71153c0679ef22$export$77d2212db482996b = ()=>{
    const platformDisableOn = (0, $dh538.fg)('kd_definitions_confluence_enable_platform');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUTos.ReadingAidsOptionsWrapper), {
        children: platformDisableOn ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gCko.DisableDefinitionsMenu), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gd5mK.ReadingAidsMenuButton), {})
    });
};

});
parcelRegister("2gCko", function(module, exports) {

$parcel$export(module.exports, "DisableDefinitionsMenu", () => $6780a693da5d102f$export$a025edc19ca0650a);
/* DisableDefinitionMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $8JHjV = parcelRequire("8JHjV");

var $82gXq = parcelRequire("82gXq");

var $3gadb = parcelRequire("3gadb");

var $eRXI0 = parcelRequire("eRXI0");
const $6780a693da5d102f$var$messages = (0, $2nPZH.defineMessages)({
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    }
});
const $6780a693da5d102f$var$DisableDefinitionMenuWrapper = null;
const $6780a693da5d102f$var$DisableDefinitionMenuTextWrapper = null;
const $6780a693da5d102f$var$DisableDefinitionMenuHeaderStyles = null;
const $6780a693da5d102f$var$DisableDefinitionMenuDescriptionStyles = null;
const $6780a693da5d102f$var$DisableDefinitionMenuToggleWrapper = null;
const $6780a693da5d102f$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8JHjV))), {
        label: "reading-aids-menu-button-icon",
        color: "var(--ds-icon-subtle, #626F86)"
    });
const $6780a693da5d102f$export$a025edc19ca0650a = ()=>{
    const { readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const [menuOpen, setMenuOpen] = (0, $gwFzn.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks;
    return disableDefinitionsCallbacks ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        position: "bottom",
        content: formatMessage($6780a693da5d102f$var$messages.disable_definitions_more_icon_tooltip),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
            isOpen: menuOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    ...props,
                    appearance: "subtle",
                    icon: $6780a693da5d102f$var$MoreIconStyled,
                    ref: triggerRef,
                    onClick: ()=>{
                        setMenuOpen(!menuOpen);
                    },
                    testId: "definitions-menu-button",
                    label: "definitions-menu-button"
                }),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                className: (0, $35pXk.default)([
                    "_zulpv47k _1e0c1txw _1bsbnklw _2lx2vrvc _1bah1yb4 _1pbykb7n _19pkpxbi _n3tdpxbi _19bvutpp _2hwx12x7"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                        className: (0, $35pXk.default)([
                            "_zulp1b66 _1e0c1txw _2lx21bp4 _1bsbohmy"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                className: (0, $35pXk.default)([
                                    "_11c82smr _syaz1fxt"
                                ]),
                                children: formatMessage($6780a693da5d102f$var$messages.disable_definitions_header)
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                className: (0, $35pXk.default)([
                                    "_11c81o8v _syaz131l"
                                ]),
                                children: formatMessage($6780a693da5d102f$var$messages.disable_definitions_description)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            "_1e0c1txw _1bsb1ns9"
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $82gXq.default), {
                            onChange: ()=>{
                                if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
                                else disableDefinitionsCallbacks.onDisableDefinitions();
                                setDisableDefinitions(!disableDefinitions);
                            },
                            isChecked: disableDefinitions,
                            testId: "definitions-toggle-disable"
                        })
                    })
                ]
            })
        })
    }) : null;
};

});

parcelRegister("gd5mK", function(module, exports) {

$parcel$export(module.exports, "ReadingAidsMenuButton", () => $50ff7986b8457dc6$export$77d203904974193c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $8JHjV = parcelRequire("8JHjV");

var $6fnsQ = parcelRequire("6fnsQ");

var $82gXq = parcelRequire("82gXq");

var $3gadb = parcelRequire("3gadb");

var $eRXI0 = parcelRequire("eRXI0");

var $hUTos = parcelRequire("hUTos");
const $50ff7986b8457dc6$var$messages = (0, $2nPZH.defineMessages)({
    definition_more_icon_tooltip: {
        id: "search_ai.definition_more_icon_tooltip",
        defaultMessage: "See more actions"
    }
});
const $50ff7986b8457dc6$var$renderOptionsMenuControl = ({ onChange: onChange, type: type, isChecked: isChecked })=>{
    switch(type){
        case 'toggle':
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $82gXq.default), {
                onChange: onChange,
                isChecked: isChecked,
                testId: "ai-answer-options-menu-toggle"
            });
        default:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    }
};
const $50ff7986b8457dc6$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8JHjV))), {
        label: "reading-aids-menu-button-icon",
        color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
    });
const $50ff7986b8457dc6$var$AIOptionsMenuOption = ({ header: header, description: description, onChange: onChange, type: type, isChecked: isChecked })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hUTos.AIOptionsMenuOptionWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hUTos.AIOptionsMenuOptionText), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUTos.AIOptionsMenuOptionHeader), {
                        children: header
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUTos.AIOptionsMenuOptionDescription), {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUTos.AIOptionsMenuOptionToggleWrapper), {
                children: $50ff7986b8457dc6$var$renderOptionsMenuControl({
                    onChange: onChange,
                    type: type,
                    isChecked: isChecked
                })
            })
        ]
    });
};
const $50ff7986b8457dc6$export$77d203904974193c = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isMenuOpen, setMenuOpen] = (0, $gwFzn.useState)(false);
    const { readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const { menuOptions: menuOptions } = readingAidsOptions || {};
    const toggleMenuOpen = (0, $gwFzn.useCallback)(()=>{
        setMenuOpen(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    return !!menuOptions?.length ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        position: "bottom",
        content: formatMessage($50ff7986b8457dc6$var$messages.definition_more_icon_tooltip),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
            isOpen: isMenuOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    ...props,
                    appearance: "subtle",
                    icon: $50ff7986b8457dc6$var$MoreIconStyled,
                    ref: triggerRef,
                    onClick: toggleMenuOpen,
                    testId: "reading-aids-menu-button",
                    label: "reading-aids-menu-button"
                }),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUTos.AIOptionsMenuWrapper), {
                onClick: (e)=>e.stopPropagation(),
                children: menuOptions?.length && menuOptions.map((menuOption, index)=>{
                    return /*#__PURE__*/ (0, $7UHDa.jsx)($50ff7986b8457dc6$var$AIOptionsMenuOption, {
                        header: formatMessage(menuOption.label),
                        description: menuOption.description && formatMessage(menuOption.description),
                        onChange: menuOption.onChange,
                        isChecked: menuOption.toggleState,
                        type: menuOption.type
                    }, index);
                })
            })
        })
    }) : null;
};

});
parcelRegister("hUTos", function(module, exports) {

$parcel$export(module.exports, "ReadingAidsOptionsWrapper", () => $c4d9cbf994fc14f9$export$206d383e26348657);
$parcel$export(module.exports, "AIOptionsMenuWrapper", () => $c4d9cbf994fc14f9$export$e20ae3fbb1f307c3);
$parcel$export(module.exports, "AIOptionsMenuOptionWrapper", () => $c4d9cbf994fc14f9$export$fb2fc14fe9185637);
$parcel$export(module.exports, "AIOptionsMenuOptionText", () => $c4d9cbf994fc14f9$export$7f1bcad9bf8084f8);
$parcel$export(module.exports, "AIOptionsMenuOptionHeader", () => $c4d9cbf994fc14f9$export$9a3438b6f4e139e4);
$parcel$export(module.exports, "AIOptionsMenuOptionDescription", () => $c4d9cbf994fc14f9$export$db2baac4fa175461);
$parcel$export(module.exports, "AIOptionsMenuOptionToggleWrapper", () => $c4d9cbf994fc14f9$export$832fe7bd333fb9fe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $c4d9cbf994fc14f9$export$206d383e26348657 = (0, $gwrgp.default)("span", {
    target: "eknyhvt0"
})({
    name: "1v3yabe",
    styles: "z-index:1;right:0;display:flex;padding-top:var(--ds-space-250, 20px);padding-right:var(--ds-space-300, 24px);min-height:var(--ds-space-400, 32px);"
});
const $c4d9cbf994fc14f9$export$e20ae3fbb1f307c3 = (0, $gwrgp.default)("div", {
    target: "eknyhvt1"
})({
    name: "oesmr9",
    styles: "display:flex;padding-top:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-200, 16px);gap:var(--ds-space-250, 20px);"
});
const $c4d9cbf994fc14f9$export$fb2fc14fe9185637 = (0, $gwrgp.default)("div", {
    target: "eknyhvt2"
})({
    name: "9nw42q",
    styles: "padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-075, 6px);width:320px;display:flex;flex-direction:row;gap:var(--ds-space-250, 20px);justify-content:space-between;"
});
const $c4d9cbf994fc14f9$export$7f1bcad9bf8084f8 = (0, $gwrgp.default)("div", {
    target: "eknyhvt3"
})({
    name: "1jt6jc4",
    styles: "display:flex;flex-direction:column;gap:var(--ds-space-050, 4px);width:244px;"
});
const $c4d9cbf994fc14f9$export$9a3438b6f4e139e4 = (0, $gwrgp.default)("div", {
    target: "eknyhvt4"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text, ${(0, $6fnsQ.N800)})`
});
const $c4d9cbf994fc14f9$export$db2baac4fa175461 = (0, $gwrgp.default)("div", {
    target: "eknyhvt5"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c4d9cbf994fc14f9$export$832fe7bd333fb9fe = (0, $gwrgp.default)("div", {
    target: "eknyhvt6"
})({
    name: "16hxjyz",
    styles: "display:flex;width:fit-content;"
});

});




parcelRegister("f29WH", function(module, exports) {

$parcel$export(module.exports, "ReadingAidsFollowUps", () => $8ee4ea5909e3a3b6$export$b5da368bdedbbfc7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $fk6ei = parcelRequire("fk6ei");

var $ldIK0 = parcelRequire("ldIK0");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $i25hX = parcelRequire("i25hX");

var $ab1fW = parcelRequire("ab1fW");

var $cVtio = parcelRequire("cVtio");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $j6cGp = parcelRequire("j6cGp");
const $8ee4ea5909e3a3b6$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center'
});
const $8ee4ea5909e3a3b6$export$b5da368bdedbbfc7 = ()=>{
    const { commonAttributes: commonAttributes, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { query: query, answerString: answerString, followUps: followUps } = commonAttributes;
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [showAllFollowUps, setShowAllFollowups] = (0, $gwFzn.useState)(false);
    const canExpand = followUps.length > 1;
    const visibleFollowUps = showAllFollowUps ? followUps : followUps.slice(0, 1);
    const onFollowupsExpand = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onExpandButtonClicked)({
            ...commonAttributes,
            expandButtonSource: 'follow-ups'
        }));
        setShowAllFollowups(!showAllFollowUps);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllFollowUps
    ]);
    const onFollowUpClick = (0, $gwFzn.useCallback)((followUp)=>{
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(followUp);
            return;
        }
        fireAnalyticsEvent((0, $4xTru.onFollowUpSuggestionClick)({
            ...commonAttributes,
            followUpString: followUp
        }));
        publish({
            type: 'chat-new',
            source: 'reading-aids',
            data: {
                name: followUp.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: formatMessage((0, $j6cGp.messages).reading_aids_follow_ups_user_initial_query, {
                                // query only contains the word that user asked
                                // we want to add the word "define" before it so it makes sense
                                // when this is moved to the chat
                                term: query
                            })
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        formatMessage,
        onClose,
        readingAidsOptions,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!followUps?.length) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        paddingInline: "space.300",
        paddingBlockEnd: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
            space: "space.075",
            children: visibleFollowUps.map((followUp, index)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ab1fW.FollowUpButton), {
                            followUpIndex: index,
                            followUpText: followUp,
                            followUpType: "UNAVAILABLE",
                            experienceId: "reading-aids",
                            onClick: ()=>onFollowUpClick(followUp)
                        }, followUp),
                        index === 0 && canExpand && // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $8ee4ea5909e3a3b6$var$iconWrapperStyles,
                            onClick: onFollowupsExpand,
                            children: showAllFollowUps ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))), {
                                color: "currentColor",
                                label: "",
                                testId: "collapse-follow-ups-icon"
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldIK0))), {
                                color: "currentColor",
                                label: "",
                                testId: "expand-follow-ups-icon"
                            })
                        })
                    ]
                }))
        })
    });
};

});
parcelRegister("j6cGp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4b04b2dbf66c72a0$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $4b04b2dbf66c72a0$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    reading_aids_follow_ups_user_initial_query: {
        id: "search_ai.reading_aids_follow_ups_initial_query",
        defaultMessage: "Define {term}"
    }
});

});


parcelRegister("kvj1k", function(module, exports) {

$parcel$export(module.exports, "EditDefinition", () => $28923582fdd5ddfd$export$86ebf34eb079ac26);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iPfZG = parcelRequire("iPfZG");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $1Zr9M = parcelRequire("1Zr9M");

var $6xdDU = parcelRequire("6xdDU");

var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");

var $6fnsQ = parcelRequire("6fnsQ");

var $a7RTn = parcelRequire("a7RTn");
var $jBpLK = parcelRequire("jBpLK");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $lJsaE = parcelRequire("lJsaE");
const $28923582fdd5ddfd$var$messages = (0, $2nPZH.defineMessages)({
    edit_definition_icon_tooltip: {
        id: "search_ai.curated-definition-edit-def-icon-tooltip",
        defaultMessage: "Edit definition"
    },
    edit_definition_prompt_text: {
        id: "search_ai.edit_definition_prompt_text",
        defaultMessage: "Not quite right? Edit this definition"
    }
});
const $28923582fdd5ddfd$var$EditIconStyled = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`,
        label: ""
    });
const $28923582fdd5ddfd$export$86ebf34eb079ac26 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editButtonSpotlightId = 'ai-definitions-edit-button';
    const [showEditModal, setShowEditModal] = (0, $gwFzn.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $gwFzn.useState)(false);
    const closeEditModal = (0, $gwFzn.useCallback)(()=>setShowEditModal(false), []);
    const openEditModal = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onCuratedDefinitionEditButtonClicked)(commonAttributes));
        setShowEditModal(true);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isAnswered) fireAnalyticsEvent((0, $4xTru.onCuratedDefinitionEditButtonShown)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            !hasError && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6cnUO.default), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5izcQ.default), {
                        name: editButtonSpotlightId,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lJsaE.EditDefinitionWrapper), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                iconBefore: $28923582fdd5ddfd$var$EditIconStyled,
                                onClick: openEditModal,
                                children: formatMessage($28923582fdd5ddfd$var$messages.edit_definition_prompt_text)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iPfZG.EngagementSpotlight), {
                        engagementId: editButtonSpotlightId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: showEditModal && definitionCurationOptions && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jBpLK.EditDefinitionModal), {
                    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
                    closeEditModal: closeEditModal,
                    onSaveEditModal: ()=>setDisplaySuccessFlag(true)
                })
            }),
            displaySuccessFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7RTn.DefinitionUpdateConfirmationFlag), {
                onDismissed: ()=>setDisplaySuccessFlag(false)
            })
        ]
    });
};

});

parcelRegister("g3QIg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $76f820f7a10733b3$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $76f820f7a10733b3$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    definition_open_chat_user_initial_query: {
        id: "search_ai.definitions_open_chat_initial_query",
        defaultMessage: "Define {term}"
    }
});

});


parcelRegister("1Kp2F", function(module, exports) {

$parcel$export(module.exports, "aiAnswerDialogMetric", () => $d3c4f32cc234b266$export$a83a35d6598a5fb6);
$parcel$export(module.exports, "MarkAIAnswerDialogMetricEnd", () => $d3c4f32cc234b266$export$6220c1b7224eb2a2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kyiqo = parcelRequire("kyiqo");

var $eRXI0 = parcelRequire("eRXI0");
const $d3c4f32cc234b266$export$a83a35d6598a5fb6 = (0, $kyiqo.metrics).pageSegmentLoad({
    key: 'ai-search-dialog'
}); // Product is automatically prepended to the key
const $d3c4f32cc234b266$export$6220c1b7224eb2a2 = ()=>{
    const { isReadingAids: isReadingAids, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { source: source } = commonAttributes;
    (0, $gwFzn.useEffect)(()=>{
        $d3c4f32cc234b266$export$a83a35d6598a5fb6.stop({
            customData: {
                isReadingAids: !!isReadingAids,
                source: source
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {});
};

});

parcelRegister("9Fnx1", function(module, exports) {

$parcel$export(module.exports, "LegacySmartAnswerCard", () => $d7d3009f3793d049$export$cf72ef8498afcbc2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $fYQcF = parcelRequire("fYQcF");

var $cNkxW = parcelRequire("cNkxW");
var $cVtio = parcelRequire("cVtio");

var $4jIuc = parcelRequire("4jIuc");

var $8UaTW = parcelRequire("8UaTW");

var $6vDlQ = parcelRequire("6vDlQ");

var $bwqdG = parcelRequire("bwqdG");

var $eRXI0 = parcelRequire("eRXI0");

var $cGU6t = parcelRequire("cGU6t");

var $CSN6u = parcelRequire("CSN6u");

var $4xTru = parcelRequire("4xTru");

var $7Zbm6 = parcelRequire("7Zbm6");

var $8FKDJ = parcelRequire("8FKDJ");

var $h3cV0 = parcelRequire("h3cV0");

var $jLyYG = parcelRequire("jLyYG");
const $d7d3009f3793d049$var$MAX_SOURCES = 4;
const $d7d3009f3793d049$var$spacerStyles = (0, $ecnYn.xcss)({
    height: '14px',
    paddingTop: 'space.250'
});
const $d7d3009f3793d049$var$errorContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.200'
});
const $d7d3009f3793d049$var$sourcesContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: '0',
    paddingRight: 'space.300',
    paddingBottom: 'space.100',
    paddingLeft: 'space.300'
});
const $d7d3009f3793d049$export$cf72ef8498afcbc2 = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { query: query } = commonAttributes;
    const { answerFormat: answerFormat } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $gwFzn.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    // reset on each new query
    (0, $gwFzn.useEffect)(()=>{
        setCollapsed(true);
    }, [
        query
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $gwFzn.useCallback)((index, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            ...commonAttributes
        }));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        }) : trackAIResultAction((0, $4jIuc.SainAction).SOURCE_CLICKED);
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        trackAIResultAction
    ]);
    if (loading) return /*#__PURE__*/ (0, $7UHDa.jsx)(LoadingWrapper, {
        children: // disable collapse/expand when streaming for quick search
        isQuickSearch ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $CSN6u.AIAnswerLoadingDialog), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $CSN6u.AIAnswerLoadingDialog), {
            collapsed: collapsed,
            toggleCollapsedState: toggleCollapsedState,
            callbacks: analyticsCallbacks
        })
    });
    let aiAnswerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    if (hasError) aiAnswerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d7d3009f3793d049$var$errorContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    else if (isQuickSearch || answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $d7d3009f3793d049$var$spacerStyles
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)(DialogWrapper, {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: false,
                isStreaming: false,
                children: [
                    aiAnswerContent,
                    !hasError && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $d7d3009f3793d049$var$sourcesContainerStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cNkxW.AISources), {
                            sources: commonAttributes.sources,
                            searchSessionId: commonAttributes.searchSessionId,
                            onClickHandler: sourceClickCallback,
                            limit: $d7d3009f3793d049$var$MAX_SOURCES,
                            enableSmartLinkSources: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerFooter), {})
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};

});
parcelRegister("CSN6u", function(module, exports) {

$parcel$export(module.exports, "AIAnswerLoadingDialog", () => $f6bf768beba90733$export$73cae3a70b740900);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $7bZ3i = parcelRequire("7bZ3i");

var $iA4lt = parcelRequire("iA4lt");

var $7lL49 = parcelRequire("7lL49");

var $eRXI0 = parcelRequire("eRXI0");

var $cGU6t = parcelRequire("cGU6t");

var $4xTru = parcelRequire("4xTru");

var $8FKDJ = parcelRequire("8FKDJ");

var $7Zbm6 = parcelRequire("7Zbm6");

var $eE9gI = parcelRequire("eE9gI");

var $dz78P = parcelRequire("dz78P");

var $2u6da = parcelRequire("2u6da");
const $f6bf768beba90733$export$73cae3a70b740900 = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $eRXI0.useAIAnswerContext)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($f6bf768beba90733$var$LegacySmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    });
};
const $f6bf768beba90733$var$LegacySmartAnswerLoadingDialog = ({ collapsed: collapsed = true, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { partialResponse: partialResponse, showBookends: showBookends, queryReasoning: queryReasoning } = (0, $eRXI0.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    });
    if (!partialResponse || partialResponse?.format !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2u6da.AIAnswerSearchLoadingBorder), {
        isStreaming: false,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2u6da.GeneratingContainer), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dz78P.default), {
                        alt: formatMessage((0, $7lL49.messages).ai_answer_generating_icon_alt_text)
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2u6da.GeneratingText), {
                        children: serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $7lL49.messages).ai_answer_generating_rovo
                        })
                    })
                ]
            }),
            !showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerContentWarningAndBrandSection), {}) : null
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2u6da.AIAnswerSearchLoadingBorder), {
        isStreaming: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7bZ3i.SmartCardProvider), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
                        collapsed: collapsed,
                        isLoading: true,
                        isStreaming: true,
                        expandWhenClickedAnywhere: true,
                        toggleCollapsedState: toggleCollapsedState,
                        callbacks: callbacks,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eE9gI.AIAnswerLoadingStream), {
                            markdown: partialResponse.partialNlpResult
                        })
                    }),
                    !showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerContentWarningAndBrandSection), {}) : null
                ]
            })
        })
    });
};

});
parcelRegister("8FKDJ", function(module, exports) {

$parcel$export(module.exports, "Collapse", () => $a42449dc4c4689f6$export$78768a9af065a7b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $dBxQj = parcelRequire("dBxQj");

var $jfOH7 = parcelRequire("jfOH7");

var $f9qTu = parcelRequire("f9qTu");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $l4qdx = parcelRequire("l4qdx");

var $h3cV0 = parcelRequire("h3cV0");
var $a42449dc4c4689f6$var$EXPANSION_STATE = /*#__PURE__*/ function(EXPANSION_STATE) {
    EXPANSION_STATE[EXPANSION_STATE["LOADING"] = 1] = "LOADING";
    // still computing if the threshold is crossed
    EXPANSION_STATE[EXPANSION_STATE["COLLAPSED"] = 2] = "COLLAPSED";
    // threshold crossed, render component collapsed
    EXPANSION_STATE[EXPANSION_STATE["EXPANDED"] = 3] = "EXPANDED"; // below threshold, render exanded without collapse option
    return EXPANSION_STATE;
}($a42449dc4c4689f6$var$EXPANSION_STATE || {});
const $a42449dc4c4689f6$var$containerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative'
});
const $a42449dc4c4689f6$var$expandedStyles = (0, $ecnYn.xcss)({
    height: 'auto'
});
const $a42449dc4c4689f6$var$collapsedStyles = (0, $ecnYn.xcss)({
    height: '150px'
});
const $a42449dc4c4689f6$var$pointerCursorStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $a42449dc4c4689f6$var$titleContainer = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.UNSAFE_small',
    fontWeight: 'font.weight.semibold',
    paddingTop: 'space.200',
    paddingRight: 'space.300',
    paddingBottom: 'space.0',
    paddingLeft: 'space.300'
});
const $a42449dc4c4689f6$var$titleStyles = (0, $ecnYn.xcss)({
    alignContent: 'center',
    height: '26px'
});
const $a42449dc4c4689f6$export$78768a9af065a7b = ({ children: children, collapsed: collapsed, isLoading: isLoading, toggleCollapsedState: toggleCollapsedState = ()=>{}, expandWhenClickedAnywhere: expandWhenClickedAnywhere = false, isStreaming: isStreaming = false, disableCollapse: disableCollapse = false, callbacks: callbacks })=>{
    const [initialExpansionState, setInitialExpansionState] = (0, $gwFzn.useState)(1);
    const threshold = 150;
    const collapseableContainerRef = (0, $gwFzn.useCallback)((node)=>{
        if (!node || disableCollapse) return;
        const resizeObserver = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            // delay computation to ensure the observed node has rendered and the height reported is accurate
            setTimeout(()=>{
                const childHeight = node.getBoundingClientRect().height;
                if (isStreaming || isLoading || !Boolean(childHeight)) return;
                // checking if the length of the answer is smaller than the collapse threshold
                if (childHeight <= threshold && initialExpansionState !== 3) setInitialExpansionState(3);
                else setInitialExpansionState(2);
            }, 100);
        }, 100));
        resizeObserver.observe(node);
    }, // make sure the dependancy array is empty,
    // this is to ensure the resizeObserver is registered just once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $gwFzn.useEffect)(()=>{
        /**
     * if the answer has finished isLoading and the container is too small to collapse,
     * toggle collapsed state to false
     * this helps external components watching the boolean to know the actual state
     */ if (initialExpansionState === 3 && !isLoading && !isStreaming && collapsed || disableCollapse) {
            toggleCollapsedState();
            callbacks?.onExpandedByDefault?.();
        }
    }, [
        initialExpansionState,
        isLoading,
        isStreaming,
        collapsed,
        callbacks,
        toggleCollapsedState,
        disableCollapse
    ]);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const tooltipText = formatMessage(collapsed ? (0, $l4qdx.messages).ai_answer_expand_tooltip : (0, $l4qdx.messages).ai_answer_collapse_tooltip);
    // allow whole container clicks to expand when enabled
    const onContainerClickHandler = ()=>{
        if (expandWhenClickedAnywhere && collapsed) {
            callbacks?.onExpandClicked?.();
            toggleCollapsedState();
        }
    };
    const onClickHandler = (e)=>{
        // stop container click from being called
        e.stopPropagation();
        if (collapsed) callbacks?.onExpandClicked?.();
        else callbacks?.onCollapseClicked?.();
        toggleCollapsedState();
    };
    /**
   * render the non collapsable version
   * - child container's height is lesser than the threshold
   * - collapsed card is externally disabled, ex: for a person card
   */ if (initialExpansionState === 3 || disableCollapse) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            $a42449dc4c4689f6$var$containerStyles,
            $a42449dc4c4689f6$var$expandedStyles
        ],
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            children: [
                !isLoading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    alignBlock: "center",
                    xcss: $a42449dc4c4689f6$var$titleContainer,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $a42449dc4c4689f6$var$titleStyles,
                        children: formatMessage((0, $l4qdx.messages).title_label)
                    })
                }),
                children
            ]
        })
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $a42449dc4c4689f6$var$containerStyles,
            collapsed ? $a42449dc4c4689f6$var$collapsedStyles : $a42449dc4c4689f6$var$expandedStyles,
            expandWhenClickedAnywhere && collapsed && $a42449dc4c4689f6$var$pointerCursorStyles
        ],
        onClick: onContainerClickHandler,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                spread: 'space-between',
                xcss: $a42449dc4c4689f6$var$titleContainer,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $a42449dc4c4689f6$var$titleStyles,
                        children: formatMessage((0, $l4qdx.messages).title_label)
                    }),
                    initialExpansionState === 2 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                        position: 'bottom',
                        content: tooltipText,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.ToggleButton), {
                            onClick: onClickHandler,
                            "data-testid": "expand-collapse-toggle",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.ButtonIcon), {
                                children: collapsed ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jfOH7))), {
                                    color: "currentColor",
                                    spacing: "spacious",
                                    label: formatMessage((0, $l4qdx.messages).expand_label)
                                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f9qTu))), {
                                    color: "currentColor",
                                    spacing: "spacious",
                                    label: formatMessage((0, $l4qdx.messages).collapse_label)
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                ref: collapseableContainerRef,
                children: children
            }),
            initialExpansionState === 2 && collapsed && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.Blur), {})
        ]
    }));
};

});
parcelRegister("l4qdx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1bc91a785c030963$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $1bc91a785c030963$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    title_label: {
        id: "search_ai.smart_answer_card_title",
        defaultMessage: "Answer"
    },
    expand_label: {
        id: "search_ai.smart_answer_expand_label",
        defaultMessage: "Expand"
    },
    collapse_label: {
        id: "search_ai.smart_answer_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_answer_generating_icon_alt_text: {
        id: "search_ai.ai_answer_generating_icon_alt_text",
        defaultMessage: "Generating icon"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_expand_tooltip: {
        id: "search_ai.ai_answer_expand_tooltip",
        defaultMessage: "Expand"
    },
    ai_answer_collapse_tooltip: {
        id: "search_ai.ai_answer_collapse_tooltip",
        defaultMessage: "Collapse"
    }
});

});

parcelRegister("h3cV0", function(module, exports) {

$parcel$export(module.exports, "AIAnswerSearchBorder", () => $32dccc1d32edcb4a$export$f2207ab910ac3fa8);
$parcel$export(module.exports, "GeneratingContainer", () => $32dccc1d32edcb4a$export$b6aef1fd050b8edc);
$parcel$export(module.exports, "GeneratingText", () => $32dccc1d32edcb4a$export$636ea4c09615ceed);
$parcel$export(module.exports, "ToggleButton", () => $32dccc1d32edcb4a$export$d2b052e7b4be1756);
$parcel$export(module.exports, "ButtonIcon", () => $32dccc1d32edcb4a$export$e1c22a2ee2645e36);
$parcel$export(module.exports, "Blur", () => $32dccc1d32edcb4a$export$975a268f2c733e4);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $32dccc1d32edcb4a$export$f2207ab910ac3fa8 = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg0"
})(({ isLoading: isLoading, isStreaming: isStreaming })=>({
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        borderRadius: `${"var(--ds-space-050, 4px)"}`,
        border: `1px solid ${`var(--ds-border, ${0, $6fnsQ.N40})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: '0',
        boxSizing: 'border-box',
        overflow: 'hidden',
        zIndex: 3,
        '&::before': {
            content: "''",
            width: '1000vw',
            height: '1000vh',
            left: 'calc(-500vw + 50%)',
            top: 'calc(-500vh + 50%)',
            position: 'absolute',
            zIndex: -2,
            borderRadius: "var(--ds-space-050, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: isLoading || isStreaming ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : `var(--ds-surface-overlay, ${0, $6fnsQ.N0})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            animation: isLoading || isStreaming ? 'rotate 3s infinite linear' : 'rotate-end 3s 1 linear',
            filter: 'blur(25px)'
        },
        '&::after': {
            content: "''",
            width: `100% - ${"var(--ds-space-050, 4px)"}`,
            height: `100% - ${"var(--ds-space-050, 4px)"}`,
            inset: '1px',
            position: 'absolute',
            zIndex: -1,
            borderRadius: "var(--ds-space-050, 4px)",
            backgroundColor: `var(--ds-surface-overlay, ${0, $6fnsQ.N0})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes rotate': {
            from: {
                transform: 'rotate(0deg)'
            },
            to: {
                transform: 'rotate(360deg)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes rotate-end': {
            from: {
                transform: 'rotate(0deg)',
                background: 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)'
            },
            to: {
                transform: 'rotate(360deg)',
                background: 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)'
            }
        }
    }));
const $32dccc1d32edcb4a$export$a550342571a01571 = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg1"
})({
    name: "n9n6h6",
    styles: "display:flex;flex-direction:column;margin-top:var(--ds-space-200, 16px);gap:var(--ds-space-100, 8px);width:100%;"
});
const $32dccc1d32edcb4a$export$90ec299a95f41a29 = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg2"
})(({ width: width, height: height })=>({
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: width ? width : '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? height : '16px',
        borderRadius: '8px',
        background: `linear-gradient(to right, ${"var(--ds-background-neutral, rgba(240, 241, 244, 1))"}, ${"var(--ds-background-input-pressed, rgba(252, 252, 252, 1))"})`,
        animation: 'shimmer 1.5s linear infinite alternate',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes shimmer': {
            from: {
                background: `linear-gradient(to right, ${"var(--ds-background-neutral, rgba(240, 241, 244, 1))"}, ${"var(--ds-background-input-pressed, rgba(252, 252, 252, 1))"})`
            },
            to: {
                background: `linear-gradient(to right, ${"var(--ds-background-neutral, rgba(240, 241, 244, 1))"}, ${"var(--ds-background-input-pressed, rgba(252, 252, 252, 1))"})`
            }
        }
    }));
const $32dccc1d32edcb4a$export$b6aef1fd050b8edc = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg3"
})({
    display: 'flex',
    height: '92px',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-300, 24px)"}`
});
const $32dccc1d32edcb4a$export$636ea4c09615ceed = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg4"
})({
    marginLeft: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $32dccc1d32edcb4a$export$d2b052e7b4be1756 = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg5"
})({
    name: "501625",
    styles: "cursor:pointer;display:block;"
});
const $32dccc1d32edcb4a$export$e1c22a2ee2645e36 = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg6"
})({
    name: "18icosq",
    styles: "display:block;transform:rotate(135deg);"
});
const $32dccc1d32edcb4a$export$975a268f2c733e4 = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg7"
})({
    background: `linear-gradient( 180deg, ${"var(--ds-UNSAFE-transparent, rgba(255, 255, 255, 0))"} 0%, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`} 100% )`,
    bottom: '0',
    display: 'block',
    height: "var(--ds-space-500, 40px)",
    margin: '0 1px',
    position: 'sticky'
});
const $32dccc1d32edcb4a$export$f243da7eac28085c = (0, $gwrgp.default)("div", {
    target: "e1uzmlcg8"
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: "var(--ds-space-100, 8px)",
    padding: `0 ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`
});

});


parcelRegister("eE9gI", function(module, exports) {

$parcel$export(module.exports, "AIAnswerLoadingStream", () => $1b01177f202b870e$export$9799dac43580176f);
// vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $j1gOA = parcelRequire("j1gOA");

var $cXwl9 = parcelRequire("cXwl9");
const $1b01177f202b870e$var$containerStyles = (0, $ecnYn.xcss)({
    minHeight: '106px',
    paddingTop: 'space.100',
    paddingRight: 'space.300',
    paddingBottom: 'space.100',
    paddingLeft: 'space.300'
});
const $1b01177f202b870e$var$containerStylesWithoutStreamingExpand = (0, $ecnYn.xcss)({
    maxHeight: '160px',
    overflow: 'hidden'
});

const $1b01177f202b870e$var$ReactRenderer = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("c7KWS")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));

const $1b01177f202b870e$var$MarkdownRenderer = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dzIFl")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $1b01177f202b870e$export$9799dac43580176f = ({ markdown: markdown })=>{
    const docContent = (0, $gwFzn.useMemo)(()=>(0, $j1gOA.encodeAdf)(markdown, false), [
        markdown
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            $1b01177f202b870e$var$containerStyles,
            !(0, $dh538.fg)('kd_sain_enable_expand_when_streaming') && $1b01177f202b870e$var$containerStylesWithoutStreamingExpand
        ],
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
            children: (0, $dh538.fg)('kd_smart_answers_use_adf_encoder') || (0, $dh538.fg)('kd_smart_answers_use_adf_encoder_jira') ? /*#__PURE__*/ (0, $7UHDa.jsx)($1b01177f202b870e$var$ReactRenderer, {
                document: docContent,
                nodeComponents: {
                    status: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $cXwl9.StatusCitation), {
                            ...props
                        }),
                    // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                    // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                    media: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                    mediaSingle: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {})
                }
            }) : // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
            /*#__PURE__*/ (0, $7UHDa.jsx)($1b01177f202b870e$var$MarkdownRenderer, {
                disallowedElements: [
                    'img'
                ],
                children: markdown
            })
        })
    });
};

});

parcelRegister("dz78P", function(module, exports) {

$parcel$export(module.exports, "default", () => $720cf18cfdb27493$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
// vendored from packages/editor/editor-plugin-ai/src/ui/modal/styles.tsx
const $720cf18cfdb27493$var$GeneratingAnimation = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: props.alt
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #0C66E4)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #0C66E4)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #0C66E4)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $720cf18cfdb27493$export$2e2bcd8739ae039 = $720cf18cfdb27493$var$GeneratingAnimation;

});



parcelRegister("hv755", function(module, exports) {

$parcel$export(module.exports, "LegacySmartAnswerCardWithoutStreamingExpand", () => $111129b397a148b4$export$b054d5cce3d1302d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $fYQcF = parcelRequire("fYQcF");

var $cNkxW = parcelRequire("cNkxW");
var $cVtio = parcelRequire("cVtio");

var $4jIuc = parcelRequire("4jIuc");

var $8UaTW = parcelRequire("8UaTW");

var $6vDlQ = parcelRequire("6vDlQ");

var $bwqdG = parcelRequire("bwqdG");

var $eRXI0 = parcelRequire("eRXI0");

var $cGU6t = parcelRequire("cGU6t");

var $CSN6u = parcelRequire("CSN6u");

var $4xTru = parcelRequire("4xTru");

var $7Zbm6 = parcelRequire("7Zbm6");

var $8FKDJ = parcelRequire("8FKDJ");

var $h3cV0 = parcelRequire("h3cV0");

var $jLyYG = parcelRequire("jLyYG");
const $111129b397a148b4$var$MAX_SOURCES = 4;
const $111129b397a148b4$var$spacerStyles = (0, $ecnYn.xcss)({
    height: '14px',
    paddingTop: 'space.250'
});
const $111129b397a148b4$var$errorContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.200'
});
const $111129b397a148b4$var$sourcesContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: '0',
    paddingRight: 'space.300',
    paddingBottom: 'space.100',
    paddingLeft: 'space.300'
});
const $111129b397a148b4$export$b054d5cce3d1302d = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $gwFzn.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    // reset on each new query
    (0, $gwFzn.useEffect)(()=>{
        setCollapsed(true);
    }, [
        query
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $gwFzn.useCallback)((index, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            ...commonAttributes
        }));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        }) : trackAIResultAction((0, $4jIuc.SainAction).SOURCE_CLICKED);
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        trackAIResultAction
    ]);
    if (loading) return /*#__PURE__*/ (0, $7UHDa.jsx)(LoadingWrapper, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $CSN6u.AIAnswerLoadingDialog), {})
    });
    let aiAnswerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    if (hasError) aiAnswerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $111129b397a148b4$var$errorContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    else if (isQuickSearch || answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $111129b397a148b4$var$spacerStyles
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)(DialogWrapper, {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: false,
                isStreaming: false,
                children: [
                    aiAnswerContent,
                    !hasError && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $111129b397a148b4$var$sourcesContainerStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cNkxW.AISources), {
                            sources: commonAttributes.sources,
                            searchSessionId: commonAttributes.searchSessionId,
                            onClickHandler: sourceClickCallback,
                            limit: $111129b397a148b4$var$MAX_SOURCES,
                            enableSmartLinkSources: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerFooter), {})
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};

});

parcelRegister("4EDeh", function(module, exports) {

$parcel$export(module.exports, "SmartAnswerCard", () => $13ed9f6890732b8d$export$827de04ba3667da0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $7bZ3i = parcelRequire("7bZ3i");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $fYQcF = parcelRequire("fYQcF");

var $iA4lt = parcelRequire("iA4lt");

var $cNkxW = parcelRequire("cNkxW");
var $cVtio = parcelRequire("cVtio");

var $4jIuc = parcelRequire("4jIuc");

var $8UaTW = parcelRequire("8UaTW");

var $6vDlQ = parcelRequire("6vDlQ");

var $89DQL = parcelRequire("89DQL");

var $4nYJN = parcelRequire("4nYJN");

var $f7lNm = parcelRequire("f7lNm");

var $dsGxu = parcelRequire("dsGxu");
var $dUnDb = parcelRequire("dUnDb");

var $g5CvN = parcelRequire("g5CvN");

var $bbTLj = parcelRequire("bbTLj");

var $bwqdG = parcelRequire("bwqdG");

var $eRXI0 = parcelRequire("eRXI0");

var $cGU6t = parcelRequire("cGU6t");

var $cGU6t = parcelRequire("cGU6t");

var $eE9gI = parcelRequire("eE9gI");

var $dz78P = parcelRequire("dz78P");

var $4xTru = parcelRequire("4xTru");

var $7Zbm6 = parcelRequire("7Zbm6");

var $8FKDJ = parcelRequire("8FKDJ");

var $l4qdx = parcelRequire("l4qdx");

var $h3cV0 = parcelRequire("h3cV0");

var $jLyYG = parcelRequire("jLyYG");
const $13ed9f6890732b8d$var$MAX_SOURCES = 4;
const $13ed9f6890732b8d$var$spacerStyles = (0, $ecnYn.xcss)({
    height: '14px',
    paddingTop: 'space.250'
});
const $13ed9f6890732b8d$var$errorContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $13ed9f6890732b8d$var$sourcesContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: '0',
    paddingRight: 'space.300',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300'
});
const $13ed9f6890732b8d$var$SmartAnswerLoadingDialog = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, showBookends: showBookends, queryReasoning: queryReasoning, smartAnswersRoute: smartAnswersRoute } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    });
    // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN || smartAnswersRoute === (0, $f7lNm.QueryIntent).DATE || smartAnswersRoute === (0, $f7lNm.QueryIntent).LOCATION) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: false
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: true,
                isStreaming: false,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.GeneratingContainer), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dz78P.default), {
                                alt: formatMessage((0, $l4qdx.messages).ai_answer_generating_icon_alt_text)
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.GeneratingText), {
                                children: serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...(0, $l4qdx.messages).ai_answer_generating_rovo
                                })
                            })
                        ]
                    }),
                    !showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerContentWarningAndBrandSection), {}) : null
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: false
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: true,
                isStreaming: true,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7bZ3i.SmartCardProvider), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
                                collapsed: collapsed,
                                isLoading: true,
                                isStreaming: true,
                                expandWhenClickedAnywhere: true,
                                toggleCollapsedState: toggleCollapsedState,
                                callbacks: callbacks,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eE9gI.AIAnswerLoadingStream), {
                                    markdown: partialResponse.partialNlpResult
                                })
                            }),
                            !showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerContentWarningAndBrandSection), {}) : null
                        ]
                    })
                })
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};
// TODO: Remove KnowledgeCard block when cleaning kd_smart_answers_render_by_experience fg
const $13ed9f6890732b8d$var$KnowledgeCard = ()=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { smartAnswersRoute: smartAnswersRoute, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }) : trackAIResultView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).TEAM:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dUnDb.TeamKnowledgeCard), {});
        case (0, $f7lNm.QueryIntent).PERSON:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dsGxu.PersonKnowledgeCard), {});
        default:
            return null;
    }
};
const $13ed9f6890732b8d$export$827de04ba3667da0 = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, smartAnswersRoute: smartAnswersRoute, loading: loading, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const { answerFormat: answerFormat, answerString: answerString, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [collapsed, setCollapsed] = (0, $gwFzn.useState)(false);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    // reset on each new query
    (0, $gwFzn.useEffect)(()=>{
        setCollapsed(true);
    }, [
        query
    ]);
    const toggleCollapsedState = ()=>{
        setCollapsed(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>{
            fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $gwFzn.useCallback)((index, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            ...commonAttributes
        }));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        }) : trackAIResultAction((0, $4jIuc.SainAction).SOURCE_CLICKED);
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        trackAIResultAction
    ]);
    if (loading) return /*#__PURE__*/ (0, $7UHDa.jsx)($13ed9f6890732b8d$var$SmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: analyticsCallbacks
    });
    // TODO: Remove block when cleaning kd_smart_answers_render_by_experience fg
    if (isAnswered && !hasError && (smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON || smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM)) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: false
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)($13ed9f6890732b8d$var$KnowledgeCard, {}),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
    // TODO: Remove block when cleaning kd_smart_answers_render_by_experience fg
    // if there is no team found (either the team or its data)
    // don't render a smart answer card or an error state
    if (!!hasError && smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    let answerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    if (hasError) answerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $13ed9f6890732b8d$var$errorContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    else if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $13ed9f6890732b8d$var$spacerStyles
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
        ]
    });
    const dateInAnswer = (0, $89DQL.extractDate)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $f7lNm.QueryIntent).DATE && dateInAnswer) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: false,
                isStreaming: false,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g5CvN.DateCard), {
                    date: dateInAnswer
                })
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
    const locationInAnswer = (0, $4nYJN.extractLocation)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $f7lNm.QueryIntent).LOCATION && locationInAnswer) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: false,
                isStreaming: false,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bbTLj.LocationCard), {
                    location: locationInAnswer
                })
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: false,
                isStreaming: false,
                children: [
                    answerContent,
                    !hasError && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $13ed9f6890732b8d$var$sourcesContainerStyles,
                        testId: "ai-answer-sources",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cNkxW.AISources), {
                            sources: commonAttributes.sources,
                            searchSessionId: commonAttributes.searchSessionId,
                            onClickHandler: sourceClickCallback,
                            allowFreeflowLayout: true,
                            limit: $13ed9f6890732b8d$var$MAX_SOURCES
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.SearchPageSmartAnswerFooter), {})
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};

});
parcelRegister("89DQL", function(module, exports) {

$parcel$export(module.exports, "extractDate", () => $f5159735ac7dbad3$export$22fa983d82ded8f8);
const $f5159735ac7dbad3$export$22fa983d82ded8f8 = (text)=>{
    if (!text || typeof text !== 'string') return null;
    // Normalize the text by trimming extra whitespace
    const normalizedText = text.trim();
    // Regular expressions to match various date formats, including day of the week
    const datePatterns = [
        // Date ranges (e.g., "May 5th to May 7th, 2025")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\s+to\s+(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)?\s*\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}\b/i,
        // Day of the week with full date (e.g., "Monday, May 26th")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Full dates with year (e.g., "May 26, 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s+\d{4}\b/i,
        // Dates with ordinals (e.g., "June 30th")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Month and year formats (e.g., "March 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{4}\b/i,
        // Year (e.g., "2001")
        /\b\d{4}\b/
    ];
    // Loop through patterns and try to find a match
    for (const pattern of datePatterns){
        const match = normalizedText.match(pattern);
        if (match) return match[0]; // Return the matched date or date range
    }
    // If no date is found, return null
    return null;
};

});

parcelRegister("4nYJN", function(module, exports) {

$parcel$export(module.exports, "extractLocation", () => $5079ddf97186ff6e$export$9df94c77b0746c3c);
const $5079ddf97186ff6e$export$9df94c77b0746c3c = (answerStr)=>{
    if (!answerStr || typeof answerStr !== 'string') return null;
    // Remove extra whitespace and normalize
    const normalizedText = answerStr.trim().replace(/\s+/g, ' ');
    // Too short to be an address
    if (normalizedText.length < 5) return null;
    // Comprehensive address pattern
    // This pattern supports:
    // - Street numbers and names
    // - Unit numbers (e.g., #123, Apt 123, Suite 123)
    // - City/region/state names
    // - Optional state abbreviations (e.g., CA, TX, NSW)
    // - Optional postal/ZIP codes
    // - Optional country names
    const addressPattern = /\b\d{1,5}\s+[\w\s\.,\-#]+(?:#\d+|,\s*(?:Apt|Suite|Unit|Room|Fl|Floor)?\s*\d+)?\s*,\s*[\w\s]+,\s*[A-Z]{2,3}(?:\s*\d{4,5}(?:-\d{4})?)?(?:,\s*[A-Za-z\s]+)?\b/i;
    // Match the address in the text
    const match = normalizedText.match(addressPattern);
    if (match) return match[0]; // Return the matched address
    // If no match is found, return null
    return null;
};

});

parcelRegister("g5CvN", function(module, exports) {

$parcel$export(module.exports, "DateCard", () => $4b07b5ddc921c6c4$export$94bf83cfe2387066);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gj7hi = parcelRequire("gj7hi");

var $f2rud = parcelRequire("f2rud");

var $1Wrxh = parcelRequire("1Wrxh");

var $1gx0m = parcelRequire("1gx0m");
const $4b07b5ddc921c6c4$var$messages = (0, $2nPZH.defineMessages)({
    knowledge_card_date_category: {
        id: "search_ai_knowledge_card_date_category",
        defaultMessage: "Date"
    }
});
const $4b07b5ddc921c6c4$export$94bf83cfe2387066 = ({ date: date })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1gx0m.StandardActionsKnowledgeCard), {
        name: "smart-answer-date-knowledge-card",
        category: formatMessage($4b07b5ddc921c6c4$var$messages.knowledge_card_date_category),
        primaryDescription: date,
        media: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1Wrxh))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($f2rud)))
        }),
        size: "full"
    });
};

});
parcelRegister("f2rud", function(module, exports) {
module.exports = new URL("calendar-dark.a0ed3c18.svg", import.meta.url).toString();

});

parcelRegister("1Wrxh", function(module, exports) {
module.exports = new URL("calendar-light.caa4677f.svg", import.meta.url).toString();

});

parcelRegister("1gx0m", function(module, exports) {

$parcel$export(module.exports, "StandardActionsKnowledgeCard", () => $43d5fc8d61a9e32c$export$ecbf022f1f5d6f16);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $df7ed = parcelRequire("df7ed");

var $3Fkbp = parcelRequire("3Fkbp");

var $2o5zB = parcelRequire("2o5zB");

var $We4jX = parcelRequire("We4jX");

var $7Sjzc = parcelRequire("7Sjzc");

var $fiGfg = parcelRequire("fiGfg");

var $fhCP1 = parcelRequire("fhCP1");
const $43d5fc8d61a9e32c$export$ecbf022f1f5d6f16 = ({ name: name, actions: actions, category: category, media: media, primaryDescription: primaryDescription, secondaryDescription: secondaryDescription, size: size, primaryDescriptionColor: primaryDescriptionColor })=>{
    const isCardCompact = size === 'compact';
    const actionsToDisplay = isCardCompact && actions && actions.length > 1 ? [
        actions[0]
    ] : actions;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $df7ed.KnowledgeCard), {
        name: name,
        space: isCardCompact ? 'space.150' : 'space.250',
        size: size,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7Sjzc.KnowledgeCardMedia), {
                size: size,
                children: media
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $We4jX.KnowledgeCardContent), {
                space: isCardCompact ? 'space.100' : 'space.200',
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $We4jX.KnowledgeCardContent), {
                        space: 'space.100',
                        children: [
                            size === 'full' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2o5zB.KnowledgeCardCategory), {
                                children: category
                            }) : null,
                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $We4jX.KnowledgeCardContent), {
                                space: isCardCompact ? 'space.0' : 'space.050',
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fiGfg.KnowledgeCardPrimaryDescription), {
                                        size: size,
                                        color: primaryDescriptionColor,
                                        children: primaryDescription
                                    }),
                                    secondaryDescription ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fhCP1.KnowledgeCardSecondaryDescription), {
                                        color: isCardCompact ? 'color.text.subtlest' : 'color.text.subtle',
                                        children: secondaryDescription
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    actionsToDisplay && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Fkbp.KnowledgeCardActions), {
                        children: actionsToDisplay.map((action, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                                children: action
                            }, `displayed-action-${index}`))
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("df7ed", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCard", () => $cdd630add952c875$export$ab2444a256fc8a9b);
/* KnowledgeCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $hnvzE = parcelRequire("hnvzE");
const $cdd630add952c875$var$knowledgeCardStyles = {
    default: "_2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej",
    compact: "_ca0qutpp _u5f3utpp _19bvutpp _n3tdutpp",
    full: "_ca0qpxbi _u5f3pxbi _19bvpxbi _n3tdpxbi"
};
const $cdd630add952c875$var$defaultInlineProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.050'
};
const $cdd630add952c875$export$ab2444a256fc8a9b = ({ name: name, size: size, children: children, ...inlineProps })=>{
    const knowledgeCardProps = {
        ...$cdd630add952c875$var$defaultInlineProps,
        ...inlineProps
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hnvzE.default), {
        name: name,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            as: "section",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                ...knowledgeCardProps,
                xcss: (0, $1Whri.cx)($cdd630add952c875$var$knowledgeCardStyles.default, size === 'full' ? $cdd630add952c875$var$knowledgeCardStyles.full : $cdd630add952c875$var$knowledgeCardStyles.compact),
                children: children
            })
        })
    });
};

});

parcelRegister("3Fkbp", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardActions", () => $b4d33197c0e90546$export$cb4f4efd621b33bb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $u9agA = parcelRequire("u9agA");
const $b4d33197c0e90546$var$defaultKnowledgeCardActionsProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.100'
};
const $b4d33197c0e90546$export$cb4f4efd621b33bb = (props)=>{
    const knowledgeCardActionsProps = {
        ...$b4d33197c0e90546$var$defaultKnowledgeCardActionsProps,
        ...props
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        ...knowledgeCardActionsProps
    });
};

});

parcelRegister("2o5zB", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardCategory", () => $1f9c8fbf9f23ff99$export$d7852a48c1d6ef5b);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $iXCQx = parcelRequire("iXCQx");
const $1f9c8fbf9f23ff99$export$d7852a48c1d6ef5b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
        color: "color.text.subtle",
        children: children
    });
};

});

parcelRegister("We4jX", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardContent", () => $4a590dcfe386729d$export$ea5f007cec623a83);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eyWa4 = parcelRequire("eyWa4");
const $4a590dcfe386729d$export$ea5f007cec623a83 = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
        ...props
    });
};

});

parcelRegister("7Sjzc", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardMedia", () => $be05d3862719a1d1$export$71b41532401d47f7);
/* KnowledgeCardMedia.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $gdv5Z = parcelRequire("gdv5Z");
const $be05d3862719a1d1$var$knowledgeCardMediaStyles = {
    default: "_2rkoiti9 _189eidpf _1e0c1txw _4cvr1h6o",
    compact: "_4t3izwfg _1bsbzwfg",
    full: "_4t3iys9h _1bsbys9h"
};
const $be05d3862719a1d1$export$71b41532401d47f7 = ({ children: children, size: size })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be05d3862719a1d1$var$knowledgeCardMediaStyles.default, size === 'compact' ? $be05d3862719a1d1$var$knowledgeCardMediaStyles.compact : $be05d3862719a1d1$var$knowledgeCardMediaStyles.full),
        children: children
    });
};

});

parcelRegister("fiGfg", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardPrimaryDescription", () => $0091e8c9fcec1593$export$74276a28ff67aa9f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7hXDW = parcelRequire("7hXDW");

var $iXCQx = parcelRequire("iXCQx");
const $0091e8c9fcec1593$export$74276a28ff67aa9f = ({ children: children, size: size, color: color = 'color.text.brand' })=>{
    return size === 'compact' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        as: "h2",
        size: "xsmall",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            color: color,
            weight: "medium",
            children: children
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
        as: "h2",
        size: "medium",
        children: children
    });
};

});

parcelRegister("fhCP1", function(module, exports) {

$parcel$export(module.exports, "KnowledgeCardSecondaryDescription", () => $950c09f64becb12e$export$663c4a200ce34343);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $iXCQx = parcelRequire("iXCQx");
const $950c09f64becb12e$export$663c4a200ce34343 = ({ children: children, color: color = 'color.text.subtle', ...textProps })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
        color: color,
        ...textProps,
        children: children
    });
};

});



parcelRegister("bbTLj", function(module, exports) {

$parcel$export(module.exports, "LocationCard", () => $9c2103741083fc2f$export$52cbb82455de8553);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");
var $7p4As = parcelRequire("7p4As");

var $2MuFw = parcelRequire("2MuFw");

var $gj7hi = parcelRequire("gj7hi");

var $eRXI0 = parcelRequire("eRXI0");

var $4xTru = parcelRequire("4xTru");

var $4jIuc = parcelRequire("4jIuc");
var $cVtio = parcelRequire("cVtio");

var $fKLZr = parcelRequire("fKLZr");

var $65jtS = parcelRequire("65jtS");

var $1gx0m = parcelRequire("1gx0m");
const $9c2103741083fc2f$var$messages = (0, $2nPZH.defineMessages)({
    knowledge_card_location_category: {
        id: "search_ai_knowledge_card_location_category",
        defaultMessage: "Location"
    },
    knowledge_card_location_google_maps_action: {
        id: "search_ai_knowledge_card_location_google_maps_action",
        defaultMessage: "Show on Google Maps"
    }
});
const $9c2103741083fc2f$var$generateGoogleMapsLink = (location)=>{
    const encodedAddress = encodeURIComponent(location);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
const $9c2103741083fc2f$var$copyLocation = async (location)=>{
    await navigator.clipboard.writeText(location);
};
const $9c2103741083fc2f$export$52cbb82455de8553 = ({ location: location })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { brand: brand, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { answerString: answerString, query: query, queryHash: queryHash, searchSessionId: searchSessionId } = commonAttributes;
    const onClickGoogleMaps = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $4xTru.onNonGenerativeAIAnswerResultShown)({
            answerString: answerString,
            brand: brand,
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            source: 'location_knowledge_card'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SHOW_ON_GOOGLE_MAPS_CLICKED
        });
    }, [
        answerString,
        brand,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        query,
        queryHash,
        searchSessionId
    ]);
    const googleMapsLink = $9c2103741083fc2f$var$generateGoogleMapsLink(location);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1gx0m.StandardActionsKnowledgeCard), {
        name: "smart-answer-location-knowledge-card",
        category: formatMessage($9c2103741083fc2f$var$messages.knowledge_card_location_category),
        primaryDescription: location,
        actions: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                href: googleMapsLink,
                onClick: onClickGoogleMaps,
                children: formatMessage($9c2103741083fc2f$var$messages.knowledge_card_location_google_maps_action)
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
                label: "copy",
                onClick: ()=>$9c2103741083fc2f$var$copyLocation(location)
            })
        ],
        media: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($65jtS))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($fKLZr)))
        }),
        size: "full"
    });
};

});
parcelRegister("fKLZr", function(module, exports) {
module.exports = new URL("location-dark.395fc7dc.svg", import.meta.url).toString();

});

parcelRegister("65jtS", function(module, exports) {
module.exports = new URL("location-light.9d9cfd0a.svg", import.meta.url).toString();

});



parcelRegister("dncbJ", function(module, exports) {

$parcel$export(module.exports, "SmartAnswerCardWithoutStreamingExpand", () => $d27ad07bc57b7433$export$7d8a07a50ae14953);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $7bZ3i = parcelRequire("7bZ3i");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $fYQcF = parcelRequire("fYQcF");

var $iA4lt = parcelRequire("iA4lt");

var $cNkxW = parcelRequire("cNkxW");
var $cVtio = parcelRequire("cVtio");

var $4jIuc = parcelRequire("4jIuc");

var $8UaTW = parcelRequire("8UaTW");

var $6vDlQ = parcelRequire("6vDlQ");

var $f7lNm = parcelRequire("f7lNm");

var $dsGxu = parcelRequire("dsGxu");
var $dUnDb = parcelRequire("dUnDb");

var $bwqdG = parcelRequire("bwqdG");

var $eRXI0 = parcelRequire("eRXI0");

var $cGU6t = parcelRequire("cGU6t");

var $cGU6t = parcelRequire("cGU6t");

var $eE9gI = parcelRequire("eE9gI");

var $dz78P = parcelRequire("dz78P");

var $4xTru = parcelRequire("4xTru");

var $7Zbm6 = parcelRequire("7Zbm6");

var $8FKDJ = parcelRequire("8FKDJ");

var $l4qdx = parcelRequire("l4qdx");

var $h3cV0 = parcelRequire("h3cV0");

var $jLyYG = parcelRequire("jLyYG");
const $d27ad07bc57b7433$var$MAX_SOURCES = 4;
const $d27ad07bc57b7433$var$spacerStyles = (0, $ecnYn.xcss)({
    height: '14px',
    paddingTop: 'space.250'
});
const $d27ad07bc57b7433$var$errorContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $d27ad07bc57b7433$var$sourcesContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: '0',
    paddingRight: 'space.300',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300'
});
const $d27ad07bc57b7433$var$SmartAnswerLoadingDialog = ()=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, showBookends: showBookends, queryReasoning: queryReasoning } = (0, $eRXI0.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerLoadingDialogShown)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    });
    // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: false
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: true,
                isStreaming: false,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.GeneratingContainer), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dz78P.default), {
                                alt: formatMessage((0, $l4qdx.messages).ai_answer_generating_icon_alt_text)
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.GeneratingText), {
                                children: serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...(0, $l4qdx.messages).ai_answer_generating_rovo
                                })
                            })
                        ]
                    }),
                    !showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerContentWarningAndBrandSection), {}) : null
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: false
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7bZ3i.SmartCardProvider), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3cV0.AIAnswerSearchBorder), {
                    isLoading: true,
                    isStreaming: true,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Suspense), {
                        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
                                collapsed: true,
                                isLoading: true,
                                isStreaming: true,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eE9gI.AIAnswerLoadingStream), {
                                    markdown: partialResponse.partialNlpResult
                                })
                            }),
                            !showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.AIAnswerContentWarningAndBrandSection), {}) : null
                        ]
                    })
                })
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};
// TODO: Remove KnowledgeCard block when cleaning kd_smart_answers_render_by_experience fg
const $d27ad07bc57b7433$var$KnowledgeCard = ()=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { smartAnswersRoute: smartAnswersRoute, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }) : trackAIResultView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    switch(smartAnswersRoute){
        case (0, $f7lNm.QueryIntent).TEAM:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dUnDb.TeamKnowledgeCard), {});
        case (0, $f7lNm.QueryIntent).PERSON:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dsGxu.PersonKnowledgeCard), {});
        default:
            return null;
    }
};
const $d27ad07bc57b7433$var$AnswerCard = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, smartAnswersRoute: smartAnswersRoute, showBookends: showBookends } = (0, $eRXI0.useAIAnswerContext)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [collapsed, setCollapsed] = (0, $gwFzn.useState)(true);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    // reset on each new query
    (0, $gwFzn.useEffect)(()=>{
        setCollapsed(true);
    }, [
        query
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandShown)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerExpandClicked)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $4xTru.aiAnswerCollapseClicked)(commonAttributes))
    };
    const sourceClickCallback = (0, $gwFzn.useCallback)((index, hostname)=>{
        fireAnalyticsEvent((0, $4xTru.onAIAnswerSourceClick)({
            sourceIndex: index,
            hostname: hostname,
            ...commonAttributes
        }));
        (0, $dh538.fg)('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        }) : trackAIResultAction((0, $4jIuc.SainAction).SOURCE_CLICKED);
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        trackAIResultAction
    ]);
    // TODO: Remove block when cleaning kd_smart_answers_render_by_experience fg
    if (isAnswered && !hasError && (smartAnswersRoute === (0, $f7lNm.QueryIntent).PERSON || smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM)) return /*#__PURE__*/ (0, $7UHDa.jsx)($d27ad07bc57b7433$var$KnowledgeCard, {});
    // TODO: Remove block when cleaning kd_smart_answers_render_by_experience fg
    // if there is no team found (either the team or its data)
    // don't render a smart answer card or an error state
    if (!!hasError && smartAnswersRoute === (0, $f7lNm.QueryIntent).TEAM) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    let answerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8FKDJ.Collapse), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    if (hasError) answerContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d27ad07bc57b7433$var$errorContainerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
    });
    else if (answerFormat === (0, $7Zbm6.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $d27ad07bc57b7433$var$spacerStyles
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bwqdG.AIAnswerBody), {})
        ]
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6vDlQ.AIAnswerTopBookend), {
                showFeedbackButtons: true,
                feedbackOptions: feedbackOptions
            }) : null,
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h3cV0.AIAnswerSearchBorder), {
                isLoading: false,
                isStreaming: false,
                children: [
                    answerContent,
                    !hasError && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $d27ad07bc57b7433$var$sourcesContainerStyles,
                        testId: "ai-answer-sources",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cNkxW.AISources), {
                            sources: commonAttributes.sources,
                            searchSessionId: commonAttributes.searchSessionId,
                            onClickHandler: sourceClickCallback,
                            allowFreeflowLayout: true,
                            limit: $d27ad07bc57b7433$var$MAX_SOURCES
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGU6t.SearchPageSmartAnswerFooter), {})
                ]
            }),
            showBookends ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UaTW.AIAnswerBottomBookend), {}) : null
        ]
    });
};
const $d27ad07bc57b7433$export$7d8a07a50ae14953 = ()=>{
    const { loading: loading } = (0, $eRXI0.useAIAnswerContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: loading ? /*#__PURE__*/ (0, $7UHDa.jsx)($d27ad07bc57b7433$var$SmartAnswerLoadingDialog, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($d27ad07bc57b7433$var$AnswerCard, {})
    });
};

});

parcelRegister("5jr3C", function(module, exports) {

$parcel$export(module.exports, "fetchAIAnswer", () => $eaa7b2059700e470$export$6dbb893b575831e8);

var $epS7s = parcelRequire("epS7s");

var $3Opgu = parcelRequire("3Opgu");

var $8sTJd = parcelRequire("8sTJd");

var $7Zbm6 = parcelRequire("7Zbm6");
const $eaa7b2059700e470$export$6dbb893b575831e8 = async ({ cloudId: cloudId, locale: locale, query: query, additional_context: additional_context, source: source, followUpsEnabled: followUpsEnabled = false, getAIAnswer: getAIAnswer, setLoading: setLoading, partialResponse: partialResponse, partialResponseAbortControllerRef: partialResponseAbortControllerRef, setPartialResponse: setPartialResponse, setData: setData, setAnswerStreamed: setAnswerStreamed, parsedFilters: parsedFilters, selectedProduct: selectedProduct, isReadingAids: isReadingAids, fireAnalyticsEvent: fireAnalyticsEvent, setQueryReasoning: setQueryReasoning })=>{
    if (partialResponse?.partialNlpResult) // clean up any old partial responses
    setPartialResponse(undefined);
    // end any old partial response streams
    partialResponseAbortControllerRef.current?.abort();
    const abortController = new AbortController();
    partialResponseAbortControllerRef.current = abortController;
    // For graphQL getAIAnswer fns we expect each product to pass their own cloudIdARI in order for this component to be more product agnostic
    const aiAnswer = getAIAnswer({
        variables: {
            query: query,
            additional_context: additional_context,
            locale: locale,
            filters: parsedFilters,
            selectedProduct: selectedProduct,
            experience: isReadingAids ? 'readingAids' : source,
            followUpsEnabled: followUpsEnabled
        }
    });
    const processStreamResponse = async (answer)=>{
        try {
            let next = await answer.stream.next();
            let answerFormat;
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if (streamEvent.type === (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) {
                    setPartialResponse(undefined);
                    setData(streamEvent.message);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
                throw 'Aborted';
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
            throw streamEnd;
            if (streamEnd.state === 'complete') {
                setPartialResponse(undefined);
                setData(streamEnd.value.message);
                (0, $epS7s.setSessionItem)((0, $3Opgu.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEnd.value.message
                }));
            } else {
                if (streamEnd.reason === 'timeout') {
                    setPartialResponse(undefined);
                    setData({
                        errorState: (0, $7Zbm6.NLPSearchErrorState).TimeoutError,
                        errorCode: 0,
                        format: null,
                        disclaimer: null,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                } else throw streamEnd;
            }
        } catch (error) {
            fireAnalyticsEvent((0, $8sTJd.getStreamFetchErrorEventPayload)(error, source));
            if (error === 'Aborted') return;
            setPartialResponse(undefined);
            setData({
                errorState: typeof error === 'object' && error !== null && 'details' in error && error?.details === (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $7Zbm6.NLPSearchErrorState).HIPAAError : (0, $7Zbm6.NLPSearchErrorState).NetworkError,
                errorCode: error?.errorCode ? error.errorCode : 0,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null
            });
        } finally{
            setAnswerStreamed(true);
            setLoading(false);
        }
    };
    // If aiAnswer is an object with a type property -- it's a getAIAnswer
    // and we need to handle the new streaming response
    if ('type' in aiAnswer) {
        processStreamResponse(aiAnswer);
        return;
    }
    await aiAnswer.then((data)=>{
        if ('type' in data) {
            processStreamResponse(data);
            return;
        }
        setData(data?.nlpSearch || (0, $3Opgu.DEFAULT_EMPTY_NLP_SEARCH_STATE));
        (0, $epS7s.setSessionItem)((0, $3Opgu.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            data: data?.nlpSearch || (0, $3Opgu.DEFAULT_EMPTY_NLP_SEARCH_STATE)
        }));
        setLoading(false);
    }).catch((error)=>{
        fireAnalyticsEvent((0, $8sTJd.getNonStreamFetchErrorEventPayload)(error, source));
        setData({
            errorState: error instanceof DOMException && error.name === 'TimeoutError' ? (0, $7Zbm6.NLPSearchErrorState).TimeoutError : (0, $7Zbm6.NLPSearchErrorState).NetworkError,
            format: null,
            disclaimer: null,
            nlpResults: [],
            uniqueSources: [],
            nlpFollowUpResults: null
        });
        setLoading(false);
    });
};

});
parcelRegister("8sTJd", function(module, exports) {

$parcel$export(module.exports, "getStreamFetchErrorEventPayload", () => $be55ba5576248393$export$ee4edf16a7c39598);
$parcel$export(module.exports, "getNonStreamFetchErrorEventPayload", () => $be55ba5576248393$export$13b0ccf9f6015e4c);

var $cqFuK = parcelRequire("cqFuK");
const $be55ba5576248393$export$ee4edf16a7c39598 = (error, source)=>{
    if (error instanceof Error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1) || ''
        }
    };
    if (error instanceof Object && 'error' in error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.error instanceof Error ? error.error.name : '',
            errorMessage: error.error instanceof Error ? error.error.message : typeof error === 'string' ? error : '',
            errorStack: error.error instanceof Error ? error.error.stack?.split('\n').at(1) : '',
            reason: 'reason' in error ? error.reason : '',
            details: 'details' in error ? error.details : ''
        }
    };
    return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            reason: error instanceof Object && 'reason' in error ? error.reason : '',
            details: error instanceof Object && 'details' in error ? error.details : ''
        }
    };
};
const $be55ba5576248393$export$13b0ccf9f6015e4c = (error, source)=>({
        action: 'failed',
        actionSubject: 'aiAnswerDialogNonStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    });
const $be55ba5576248393$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};

});


parcelRegister("EQFBW", function(module, exports) {

$parcel$export(module.exports, "getKnowledgeCardResultCount", () => $87da9ac7d025ec54$export$e25821f3420be6ad);

var $7Zbm6 = parcelRequire("7Zbm6");

var $5y8jR = parcelRequire("5y8jR");
const $87da9ac7d025ec54$export$e25821f3420be6ad = ({ answerString: answerString })=>{
    if (!answerString) return 0;
    const { parsedResult: parsedResult, parsedType: parsedType } = (0, $5y8jR.getTypedJSONResultData)(answerString);
    switch(parsedType){
        case (0, $7Zbm6.NLPSearchJSONResultFormat).TEAM:
            return 'id' in parsedResult && parsedResult.id ? 1 : 0;
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WHO:
        case (0, $7Zbm6.NLPSearchJSONResultFormat).PERSON:
        case (0, $7Zbm6.NLPSearchJSONResultFormat).WORK:
            return Array.isArray(parsedResult) ? parsedResult.length : 0;
        default:
            return 0;
    }
};

});



//# sourceMappingURL=CommentEditor.e7728eae.js.map
